import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewChildren, QueryList, ElementRef, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { of } from 'rxjs';
import { ChatbotService } from './../../common/services/chatbot.service';
import { InsightsModel, results } from 'src/app/common/models/common.model';
import { TableOuputComponent } from 'src/app/common/shared/table-ouput/table-ouput.component';
import { CrosstabService } from '../../common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { ExportDownloadServices } from 'src/app/common/services/exports-downloads.service';
import { SharedChatService } from 'src/app/common/services/shared-chat.service';
import { Subscription, switchMap, take, tap, firstValueFrom, from, catchError, throwError, forkJoin, map, Observable, shareReplay, finalize, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  DataObject, checkboxSelection, checkboxSelectionWithParent, OutputDataObject,
  CrossTabOutputItem, StackChart, LineChart, GroupBarChart
} from 'src/app/common/models/crosstab.model';
import { Feature } from 'src/app/common/models/usermanagement.model';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import {
  fomData, StudyData, DiagnosticData, ChatListDocument, ChatHistoryDocument,
  ChatAnswerDocument, UserIdentityDocument, SaveChatResponseRequest
} from 'src/app/common/models/chatbotexpand.model';
import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import * as XLSX from 'xlsx';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../snapshot/Services/customsnapshot.service';
import { SnapshotService } from '../snapshot/Services/snapshot.service';
import { CommonChartmoduleService } from '../snapshot/Services/common-chartmodule.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { FilesWithIdentifiers } from 'src/app/common/models/configurations.model';
import { exceptionMessage } from 'src/app/common/constants/common-constants';
import { IndexedDBService } from 'src/app/common/services/askme_indexeddb.service';
import { protectedResources } from 'src/app/auth.config';
import { DiagnosticViewerHelper } from './diagnostic-viewer/diagnostic-viewer.helper';
import { ExportHandlerHelper } from './helpers/export-handler/export-handler.helper';
import { InsightsGeneratorHelper } from 'src/app/modules/chatbotexpand/helpers/insights-generator/insights-generator.helper';
import { ChartUtilitiesHelper } from './helpers/chart-utilities/chart-utilities.helper';
import { SelectionSummaryHelper } from './helpers/selection-summary/selection-summary.helper';
import { ChatHistoryHelper } from './helpers/chat-history/chat-history.helper';
import { TableOutputProcessorHelper } from './helpers/table-output-processor/table-output-processor.helper';
import { MarkdownPayloadHelper } from './helpers/markdown-payload/markdown-payload.helper';
import { FormattersHelper } from './helpers/formatters/formatters.helper';
import { DataTransformersHelper } from './helpers/data-transformers/data-transformers.helper';

const BASE_TYPES = {
  TOTAL: 'Total Base',
  ANSWER: 'Answer Base'
} as const;

const DEFAULT_VALUES = {
  NONE: 'None',
  DATA: 'Data'
} as const;

const SNAPSHOT_TYPES = {
  SINGLE_BRAND: 'Single Brand'
} as const;

const CHART_TYPES = {
  COLUMN: 'column',
  BAR: 'bar'
} as const;

const CALCULATION_TYPES = {
  RESP_GRP: 'RespGrp',
  MEAN: 'mean'
} as const;

interface Config {
  key: string;
  value: boolean;
}

interface VariableList {
  Level0: string;
  isEntryPoint: boolean;
  hasOnlyBrandIndependentChildren: boolean;
  hasOnlyBrandDependentChildren: boolean;
  hasSomeBrandDependentChildrenNotAll: boolean;
  Level1: {
    Level1_value: string;
    is_derived: string;
    is_brand_analysis: number;
    calc_type: string;
    tooltip: string;
    hasNextLevel: boolean;
    data_variable_code: string;
    response_code: string;
    sort_id: string;
    is_multi_punch: string;
    date: string;
    year_code: string;
    is_dimension: string;
    isCustomGrpPresent: string;
    isCustomCalcPresent: string;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    is_time_Period_Present: string;
  }[];
}

interface ListItem {
  Level0: string;
  Level1: string;
  tooltip: string;
  has_nextLevel: boolean;
  sortId: number;
  is_Derived: string;
  is_calc_type: string;
  data_variable_code: string;
  data_response_code: string;
  data_sort_id: string;
  data_is_multi_punch: string;
  data_date: string;
  data_year_code: string;
  is_dimension: boolean;
  is_custmGrpPresent: boolean;
  is_custmCalcPresent: boolean;
  kibanaFilterScript: string;
  customGroupId: string;
  customCalculationId: string;
  dataYearCode: string;
  isSelectAllMetrics: boolean;
  isSelectAllMetricsCount: number;
  is_entrypoint?: boolean;
}

@Component({
  selector: 'app-chatbotexpand',
  templateUrl: './chatbotexpand.component.html',
  styleUrls: ['./chatbotexpand.component.css'],
})
export class ChatbotexpandComponent implements OnInit, AfterViewInit, OnDestroy {
  private _isHistorySaving: boolean = false;
  get isHistorySaving(): boolean { return this._isHistorySaving; }
  set isHistorySaving(val: boolean) {
    if (this._isHistorySaving && !val) {
      this.triggerTabEnabledAnimation();
    }
    this._isHistorySaving = val;
  }
  isWaitingForFinalSave: boolean = false;
  isTabJustEnabled: boolean = false;
  private tabEnableTimeout: any;
  
  // --- Multi-Question State ---
  isMultiQuestionMode: boolean = false;
  multiQuestionList: string[] = [''];
  queuedQuestions: string[] = [];
  isProcessingQueue: boolean = false;
  unreadNotificationCount: number = 0;
  baseFaviconHref: string = '';
  
  triggerTabEnabledAnimation() {
    if (this.tabEnableTimeout) {
      return; // Already animating, ignore subsequent triggers
    }
    this.isTabJustEnabled = true;
    this.tabEnableTimeout = setTimeout(() => {
      this.isTabJustEnabled = false;
      this.tabEnableTimeout = null;
    }, 1200); // Animation duration is 1.2s
  }
  public console = console;
  // @ViewChild & @ViewChildren DECORATORS
  @ViewChild('summaryText') summaryText: ElementRef | undefined;
  @ViewChild('tableOutputComponent') tableOutputComponent!: TableOuputComponent;

  hasSnapshotActive: boolean = false;
  hasBrandAnalysisActive: boolean = false;
  hasCrosstabActive: boolean = false;
  @ViewChild('SidePanel') SidePanel: ElementRef | undefined;
  @ViewChild('inforRibbon', { static: false }) inforRibbon: ElementRef | undefined;
  @ViewChild('chatHistoryScroll') chatHistoryScroll: ElementRef | undefined;
  @ViewChildren('insightsContainer') insightsContainers!: QueryList<ElementRef>;
  @ViewChild('likeInput') likeInput: ElementRef | undefined;
  @ViewChild('likeFeedbackBox') likeFeedbackBox: ElementRef | undefined;
  @ViewChild('dislikeInput') dislikeInput: ElementRef | undefined;
  @ViewChild('dislikeFeedbackBox') dislikeFeedbackBox: ElementRef | undefined;
  @ViewChild('deleteConfirmBox') deleteConfirmBox: ElementRef | undefined;
  @ViewChild('outputArea') outputArea: ElementRef | undefined;
  @ViewChild('exportsPopup', { static: false }) exportsPopupRef: ElementRef | undefined;

  // @Input DECORATORS
  errorHeader: string = '';
  @Input() exportDownloads: boolean = true;
  @Input() pptExport: boolean = true;
  @Input() isIndex: boolean = false;
  @Input() landingdata: any;

  private isPreFetchingAnswers = false;
  private pendingMessageId: string | null = null;
  isScrollingToTarget = false;

  // PRIVATE PROPERTIES
  private tooltipStates = { stack: false, line: false, bar: false };
  private subscriptions: Subscription = new Subscription();


  // FORM & SEARCH PROPERTIES
  searchForm!: FormGroup;
  searchText: string = '';
  searchTextLevel1: string = '';
  searchQuery: string = '';
  inputValue: any = '';
  existingquery: any = '';

  chatSearchText: string = '';
  chatNestedSearchText: string = '';
  isNestedSearchVisible: boolean = false;
  primaryFilteredCount: number = 0;
  starredSearchText: string = '';
  scrollSpacerHeight: number = 0;

  // USER & SESSION MANAGEMENT
  userId: string = '';
  guidChatId: string = '';
  validatedSessionId: string | null = null;
  selectedChatId: string | null = null;
  selectedMessageId: string | null = null;
  newChatId: any;
  isNewChatStarted: boolean = false;
  abandoningSessionId: string = '';

  // STUDY & CLIENT CONFIGURATION
  selected_study: any;
  selected_client: any;
  studyname: string = '';
  clientcode: any;
  receivedData: StudyData[] = [];
  filteredlist: StudyData | undefined;
  filteredStudies: string[] = [];
  logo_url: string = '';
  isDemoStudy: boolean = false;
  arktabaccess: boolean = false;
  private multiViewInsightsCache: { [messageId: string]: { [mcode: number]: { insightsVal: any, qnaText: string, rawInsights?: string, standard_insights?: string, trend_insights?: string } } } = {};
  private multiViewDataCache: { [messageId: string]: { [mcode: number]: any } } = {};
  private inFlightPreFetches: { [messageId: string]: Set<number> } = {};
  private inFlightInsights: { [messageId: string]: Set<number> } = {};
  modulesAccess: any = null;
  isCacheGenerated: boolean = false;
  streamStatusText: string = '';
  isStreamFinished: boolean = false;
  statusQueue: string[] = [];
  private isProcessingStatusQueue: boolean = false;
  chatPayload: any = null;
  parallelChatPayload: any = null;
  private currentOrchToken: string = '';

  // Multi-View Support
  availableViews: any[] = [];
  activeView: any = null;
  allMemberResponses: any = null;
  orchestrationRawData: any = null;

  // CHAT & CONVERSATION PROPERTIES
  private _currentView: 'landing' | 'chat' | 'loading' = 'landing';
  get currentView(): 'landing' | 'chat' | 'loading' { return this._currentView; }
  set currentView(value: 'landing' | 'chat' | 'loading') {
    if (this._currentView !== value) {
      this._currentView = value;
      this.isMultiQuestionMode = false;
    }
  }
  isChatHistoryOpen: boolean = false;
  isSavedQuestionsOpen: boolean = false;
  isChatAreaVisible: boolean = false;
  private currentTrendlineResponse: any = null;
  private currentRowPayloadTrendline: any = null;
  private currentCustomizationTrendline: any = null;
  private metadataFetchPromise: Promise<void> | null = null;
  hasPendingQuery: boolean = false;
  currentQueryForStream: string = '';
  isAnalysisSwitching: boolean = false;
  isTrendAvailable: boolean = false;
  isTrendActive: boolean = false;

  setTrendAvailable(event: boolean) {
    setTimeout(() => {
      this.isTrendAvailable = event;
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit(): void {
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      if (this.isSpeechSupported) {
        this.toggleDictation('main');
      }
    }
    
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'b') {
      event.preventDefault();
      this.toggleMultiQuestionMode();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as Node;

    // 1. Handle Exports Popup
    if (this.isExportspopup) {
      const popupEl = this.exportsPopupRef && this.exportsPopupRef.nativeElement as Node;
      if (popupEl && !popupEl.contains(target)) {
        this.isExportspopup = false;
      }
    }

    const activeExportBlock = this.chatPreviewBlocks?.find(c => c.isExportspopup);
    if (activeExportBlock) {
      const targetEl = event.target as HTMLElement;
      if (!targetEl.closest('.exports-popup-container')) {
        activeExportBlock.isExportspopup = false;
      }
    }

    // 2. Handle Like Feedback Box
    const activeLikeChat = this.chatPreviewBlocks.find(c => c.showLikeInput);
    if (activeLikeChat) {
      const boxEl = this.likeFeedbackBox && this.likeFeedbackBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeLikeChat.showLikeInput = false;
        activeLikeChat.likeReason = '';
      }
    }

    // 3. Handle Dislike Feedback Box
    const activeDislikeChat = this.chatPreviewBlocks.find(c => c.showDislikeInput);
    if (activeDislikeChat) {
      const boxEl = this.dislikeFeedbackBox && this.dislikeFeedbackBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeDislikeChat.showDislikeInput = false;
        activeDislikeChat.dislikeReason = '';
      }
    }

    // 4. Handle Delete Confirm Box
    const activeDeleteChat = this.chatPreviewBlocks.find(c => c.showDeleteConfirm);
    if (activeDeleteChat) {
      const boxEl = this.deleteConfirmBox && this.deleteConfirmBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeDeleteChat.showDeleteConfirm = false;
      }
    }

    // 5. Handle Chatbot Output Dropdowns (Click outside to close)
    const targetEl = target as HTMLElement;
    let anyDropdownClosed = false;
    this.chatPreviewBlocks.forEach(block => {
      const blockEl = targetEl.closest('#message-' + block.messageId);

      if (block.sampleSizeDropdown && (!blockEl || !targetEl.closest('.significanceMainContainer'))) {
        block.sampleSizeDropdown = false;
        anyDropdownClosed = true;
      }
      if (block.confidenceLevelDropDown && (!blockEl || !targetEl.closest('.confidenceLevelMainContainer'))) {
        block.confidenceLevelDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.referenceLevelDropDown && (!blockEl || !targetEl.closest('.ReferenceLevelMainContainer'))) {
        block.referenceLevelDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.dataDropDown && (!blockEl || !targetEl.closest('.dataMainContainer'))) {
        block.dataDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.weightDropDown && (!blockEl || !targetEl.closest('.weightMainContainer'))) {
        block.weightDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.baseDropDown && (!blockEl || !targetEl.closest('.BaseMainContainer'))) {
        block.baseDropDown = false;
        anyDropdownClosed = true;
      }
    });

    if (anyDropdownClosed) {
    }
  }

  setSampleSizeChange(event: boolean) {
    setTimeout(() => {
      this.isSampleSize = event;
      this.cdr.markForCheck();
    });
  }

  onTrendToggle(block: any) {
    if (!block) return;

    block.isTrendActive = !block.isTrendActive;
    this.isSampleSize = false; // Reset sample size state when toggling view

    // Sync global state and update insights only if this is the currently selected active message
    if (block.messageId === this.selectedMessageId) {
      this.isTrendActive = block.isTrendActive;
      const targetText = this.isTrendActive ? this.snapshotinsights_trendline_text : this.snapshotinsights_standard_text;
      if (targetText) {
        this.insightsStreamingText = targetText;
        this.insightsStreamingPoints = this.formatInsightsIntoPoints(targetText);

        this.InsightsResponse = {
          header: this.isTrendActive ? 'Trendline Insights' : 'Snapshot Insights',
          message: targetText,
          show: true
        };
        this._insightsSerive.showInisghts(this.InsightsResponse);
      }
    }
  }

  isNewChatSession: boolean = false;
  isClosing: boolean = false;
  chatList: ChatListDocument[] = [];
  allChatList: ChatListDocument[] = [];
  chatHistory: ChatHistoryDocument[] = [];
  recentChats: ChatListDocument[] = [];
  olderChats: ChatListDocument[] = [];

  // Speech Recognition (Dictation) Feature
  isSpeechSupported: boolean = false;
  isDictating: boolean = false;
  activeDictationTarget: 'main' | 'chatSearch' | 'nestedSearch' | null = null;
  speechRecognition: any;
  baseInputValue: string = '';

  // Chat Search Feature
  isChatSearchOpen: boolean = false;
  chatSearchQuery: string = '';
  filteredSearchChats: any[] = [];
  searchDebounce$ = new Subject<string>();
  searchSelectedIndex: number = -1;

  chatResponse: { [key: string]: string }[] = [];
  chatAccordions: any[] = [];
  chatPreviewBlocks: {
    question: string;
    response: string;
    messageId?: string;
    isTemp?: boolean; // Temporary flag for newly sent questions
    isStarred?: boolean;
    isLiked?: boolean | null;
    feedbackSaved?: boolean;
    showLikeInput?: boolean;
    likeReason?: string;
    showDislikeInput?: boolean;
    dislikeReason?: string;
    showDeleteConfirm?: boolean;
    QuestionAnswer?: string;
    fullAnswer?: any;
    parsedData?: any;
    mcode?: number;
    analyticalData?: any;
    insights?: string[];
    insightsTrend?: string[];
    isTrendActive?: boolean;
    isTrendAvailable?: boolean;
    failedCase?: boolean;
    builtTableData?: any;
    builtCustomData?: any;
    isInsightsOverflowing?: boolean;
    isAtTop?: boolean;
    isAtBottom?: boolean;
    // Isolated UI State Flags
    isExportspopup?: boolean;
    sampleSizeDropdown?: boolean;
    confidenceLevelDropDown?: boolean;
    referenceLevelDropDown?: boolean;
    baseDropDown?: boolean;
    weightDropDown?: boolean;
    isReference?: boolean;
    // Isolated Analytical Parameters
    isSig?: boolean;
    isIndex?: boolean;
    DefaultSampleSize?: string;
    SignificanceVsReference?: string;
    DefaultConfidenceLevel?: string;
    DefaultReferenceLevel?: string;
    selectedWeight?: string;
    DefaultWeight?: string;
    DefaultBase?: string;
    isTotalBase?: boolean;
    isAnswerBase?: boolean;
    isTranspose?: boolean;
    isHideNA?: boolean;
    isTotal?: boolean;
    isSampleSize?: boolean;
    isWeightedLabel?: boolean;
    isWeightedNumerator?: boolean;
    isUnWeightedNumerator?: boolean;
    isSampleSizeBlock?: boolean;
    isWeightedSampleBlock?: boolean;
    isPairWise?: boolean;
    isDisablePairWise?: boolean;
    isDisableReference?: boolean;
    is_confidenceLevel?: any;
    is_TransposeBtn?: boolean;
    threshold?: string;
    selectedIndex?: string;
    is_sigtesting?: boolean;
    is_Time_Period_Present?: boolean;
    dataDropDown?: boolean;
    DefaultDataDropDown?: string;
    isTableClick?: boolean;
    isVerticalStackChartClick?: boolean;
    isVerticalBarChartClick?: boolean;
    isVerticalGroupBarChartClick?: boolean;
    isLineChartClick?: boolean;
    isChartView?: boolean;
    disableStackChart?: boolean;
    disableLineChart?: boolean;
    showStackTooltip?: boolean;
    showLineTooltip?: boolean;
    showBarTooltip?: boolean;
    showMainTooltip?: boolean;
    StackFlag?: boolean;
    displayTable?: boolean;
    isTableClosing?: boolean;
    isChartClosing?: boolean;
    isBrandAnalysis?: boolean;
    isAnalysisSwitching?: boolean;
    selectedDataFormat?: string;
    selectionSummary?: string;
    insightsVal?: any;
    // Isolated Chart Objects
    StackChart?: StackChart;
    LineChart?: LineChart;
    BarChart?: GroupBarChart;
    // Isolated Data Storage
    OutputdataObject?: DataObject;
    CrossTabOutPutData?: CrossTabOutputItem[];
    CrossTabOutPutEntireData?: any[];
    dataObject?: any;
    IndexData?: any[];
    WeightDropDownList?: any[];
    SampleSizeList?: any[];
    variableTabData?: any[];
    // Isolated View Switcher State
    availableViews?: any[];
    activeView?: any;
    searchTextLevel1?: string;
    userSelectedMcode?: boolean;
  }[] = [];
  private defaultQuestions: string[] = [
    'Brand funnel of Bluehold?',
    'compare the mean brand power grid and consideration for Bluehold Financial and Guardia Funds in Q3 2023 in Market 01?',
    'Familiarity of Silveridge among females?',
    'Among male respondents aged 25–34 in Market 01, what is the awareness of Sproutvest Finance?'
  ];

  private optusQuestions: string[] = [
    'Unaided awareness of Vodafone and Optus?'
  ];

  get questions(): string[] {
    if (this.selected_client?.toLowerCase() === 'optus') {
      return this.optusQuestions;
    }
    return this.defaultQuestions;
  }

  defaultQuestionAnswer: string = 'Answering question...';

  // STARRED/SAVED QUESTIONS
  starredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string; QuestionAnswer?: string; AnswerPreview?: string }[] = [];
  filteredStarredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string; QuestionAnswer?: string; AnswerPreview?: string }[] = [];
  isLoadingStarredMessages: boolean = false;
  inFlightLazyFetches: Set<string> = new Set<string>();

  // UI DISPLAY FLAGS - GENERAL
  displayTable: boolean = false;
  isTableView: boolean = false;
  isChartView: boolean = true;
  private maxRowsPerSlide = 15;
  private maxColumnsPerSlide = 28;
  isTableClick: boolean = false;
  isListView: boolean = true;
  showSnapshot: boolean = false;
  snapshotConfiguration: any = null;
  showExtraSelections: boolean = false;
  showModuleDropdown: boolean = true;
  showDropdown: boolean = false;
  showCustomMetricsPopup: boolean = false;
  showToastNotification: boolean = false;
  showOutput: boolean = true;
  askMeLanding: boolean = true;
  isHidden: boolean = true;

  noContentFlag: boolean = false;
  isInsightspopupOpen: boolean = false;
  isExportspopup: boolean = false;
  isCreateBtnClick: boolean = false;
  isInsightsBtnEnabled: boolean = false;
  isselectionsummarycollapse: boolean = false;
  isselectionsummarycollapse2: boolean = false;
  issavedselectionblock: boolean = false;
  isSaveSelectionClick: boolean = false;
  isSaveCustomGroupSelectionClick: boolean = false;
  isSaveCustomCalculationSelectionClick: boolean = false;
  isDiagnosticAnimating: boolean = false;
  isDiagnostic: boolean = false;
  moduleSelectionToggle: boolean = false;
  failedCase: boolean = false;

  // UI DISPLAY FLAGS - PANELS
  sidePanelDisplay: boolean = false;
  sidePanelNestingDisplay: boolean = false;
  columnPanelDisplay: boolean = false;
  columnNestingPanelDispaly: boolean = false;
  filterPanelDisplay: boolean = false;
  FooterNote: boolean = false;
  filteringAnsBlock: boolean = false;
  AnsBaseBlock: boolean = false;

  // UI DISPLAY FLAGS - DROPDOWNS  
  weightDropDown: boolean = false;
  dataDropDown: boolean = false;
  confidenceLevelDropDown: boolean = false;
  referenceLevelDropDown: boolean = false;
  sampleSizeDropdown: boolean = false;
  ConfidenceLevelDropDownToggle: boolean = false;
  BaseDropDownToggle: boolean = false;
  weightDropDownToggle: boolean = false;
  SampleSizeContainer: boolean = false;

  // CHART & VISUALIZATION  
  isTranspose: boolean = false;
  isHideNA: boolean = false;
  isTotal: boolean = false;
  chartType = this.isTranspose ? CHART_TYPES.BAR : CHART_TYPES.COLUMN;
  is_TransposeBtn: boolean = false;
  is_chart_visualization: boolean = false;
  isVerticalBarChartClick: boolean = false;
  isLineChartClick: boolean = false;
  isVerticalStackChartClick: boolean = false;
  isVerticalGroupBarChartClick: boolean = false;
  disableStackChart: boolean = false;
  disableLineChart: boolean = false;
  StackFlag: boolean = false;
  showBarTooltip: boolean = false;
  showStackTooltip: boolean = false;
  showLineTooltip: boolean = false;
  showMainTooltip: boolean = false;
  public LineChart: LineChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public StackChart: StackChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public BarChart: GroupBarChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  GeneralToolTip: string[] = [
    "<ul>Charts are automatically disabled under the following conditions:<li>Indexing or nesting is applied </li><li>More than 15 options are selected in Rows</li> <li>Metrics from both percentage and mean logic are selected at the same time</li></ul>"
  ];
  StackChartToolTip: string[] = [
    "Stack Chart is enabled only when a single metric group is selected with all its options, and the number of rows does not exceed 15. It won’t work for multipunch variables or if nesting is applied."
  ];
  LineChartToolTip: string[] = [
    "Trend Line is available only when one Time Period Group is in Columns, with each Row option plotted as separate trend. A maximum of 15 options is allowed in Rows; charting is disabled for multipunch variables, multiple metrics, or when row/column nesting is applied."
  ];
  BarChartToolTip: string[] = [
    "Bar Chart allows up to 15 options in Rows. Charting is disabled if multiple metrics are selected or if row/column nesting is applied."
  ];

  // DATA ARRAYS & LISTS
  dataArray: any[] = [];
  fomDataArray: any[] = [];
  leftpanelDataArray: any[] = [];
  leftPanelData: any = {};
  loadData: any[] = [];
  listAItemsList: ListItem[] = [];
  listBItemsList: ListItem[] = [];
  listCItemsList: ListItem[] = [];
  listDItemsList: ListItem[] = [];
  listEItemsList: ListItem[] = [];
  entryList: any[] = [];
  entryPanel: { Level1: string }[] = [];
  variableList: VariableList[] = [];
  SampleSizeList: any = [];
  aggregatedVariables: any = [];
  is_confidenceLevel: any = [];
  WeightDropDownList: { Label: string; responseCode: string; tooltip: string }[] = [];
  dataDropDownList: string[] = ['Data', 'Sample Size', 'Weighted Sample', 'Weighted Numerator', 'Unweighted Numerator'];
  titleSection: { key: string; value: string }[] = [];
  entryPoints: { key: string; value: string }[] = [];
  selections: { key: string; value: string }[] = [];
  Columnselections: any = [];
  Rowselections: any = [];
  AllSelections: any = [];
  moduleseSelections = [
    { key: 'Snapshot', value: true, isSelected: true },
    { key: 'Crosstab', value: true, isSelected: false }
  ];
  snapshotWidgetData: any = [];
  snapshotDataModel: any = [];
  moduleList: any = [];
  indexVsBrandReference: any = [];
  significanceVsBrandReference: any = [];
  subSectionNames: any = [];
  weight: any = [];
  base = [
    { key: 'Total Base', selected: true },
    { key: 'Answer Base', selected: false }
  ];
  base2 = [{ key: 'Total Base', selected: true }];
  vsBrandArray: any[] = [];
  selectedSigType: any[] = [];
  significanceTypes: any[] = [];
  significanceVal: any[] = [];

  // DATA OBJECTS & COMPLEX STRUCTURES
  previewDataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: []
  };
  FinalOutputdataObject: OutputDataObject = {
    Row: [],
    Column: []
  };
  public OutputdataObject: OutputDataObject = {
    Row: [],
    Column: [],
  };
  public dataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: [],
  };
  public fomData: fomData = {
    Header: '',
    Level1: '',
    Level2: '',
    MetricOption: '',
    data_variable_code: '',
    response_code: '',
    derived_metric_calculation: '',
    Level0: '',
    Level3: '',
    Level4: '',
    Level5: '',
    Level6: '',
    sort_id: 0,
    level1_sort_id: 0,
    is_multi_punch: 0,
    is_derived_variable: false,
    is_dimension: false,
    calculation_type: '',
    url_logo: '',
    tooltip: '',
    year_code: '',
    year_label: '',
    date: '',
    isActive: false,
    is_CustomGroup: false,
    customGroupQuery: '',
    is_CustomCalculation: false,
    customCalculationQuery: '',
    dataYearCode: '',
    is_time_Period_Present: false,
    is_dimension_Present: false,
    is_shared: false,
    user_name: '',
    customGroupId: '',
    customCalculationId: '',
    is_brandanalysis: 0,
    variable_code: '',
    is_aggregated_data: 0,
    is_semi_aggregated_data: 0,
    is_snapshot: 0,
    sequence: 0,
  };
  widegtconfigdetails: any = {
    section: '',
    subSection: '',
    snapshotType: '',
    snapshotName: '',
    clientName: '',
    study: '',
    IsCustomSnapshot: false
  };
  output_details: any = {};
  weightFilter: { [key: string]: string } = {};

  // CONFIGURATION & SETTINGS
  variableTabData: any;
  configWeights: any;
  configweights: any;
  DefaultConfidenceLevel: string = DEFAULT_VALUES.NONE;
  DefaultSampleSize: string = DEFAULT_VALUES.NONE;
  DefaultDataDropDown: string = DEFAULT_VALUES.DATA;
  DefaultReferenceLevel: string = DEFAULT_VALUES.NONE;
  DefaultWeight: string = '';
  DefaultBase: string = 'Total Base';
  selectedDataFormat: string = '';
  selectedWeight: string = '';
  selectedIndex: string = '';
  threshold: string = '';
  isData: boolean = true;
  isWeightedLabel: boolean = false;
  isSampleSize: boolean = false;
  isSampleSizeBlock: boolean = false;
  isWeightedSampleBlock: boolean = false;
  isWeightedBase: boolean = false;
  isWeightedNumerator: boolean = false;
  isUnWeightedNumerator: boolean = false;
  isTotalBase: boolean = false;
  isTotalBaseFromPrompt: string = 'false';
  isAnswerBase: boolean = false;
  isFilteringActive: boolean = true;
  isRowNesting: boolean = false;
  isColumnNesting: boolean = false;
  isSelectAllMetricsLevel: boolean = false;
  isSelectAllMetrics: any;
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;
  enableAnswerBase: boolean = true;
  isWeigthedBtn: boolean = true;
  isExistingDataPresent: boolean = false;
  columnLength: number = 0;

  is_sticky_selection: boolean = false;
  isRespondentLevel: boolean = true;

  // SIGNIFICANCE TESTING & STATISTICAL
  isPairWise: boolean = false;
  isReference: boolean = false;
  isDisablePairWise: boolean = true;
  isDisableReference: boolean = true;
  isSignificanceContainerDisabled: boolean = false;
  is_sigtesting: boolean = false;
  isSig: boolean = true;
  isSigSelected: any = true;
  SignificanceVsReference: string = '';
  significance: string = 'None';
  displaySignificance: any = 'None';
  displayConfidenceLevel: string = '';
  displayReference: any = 'None';
  confidenceLevelSelectedValue: string = '';
  significanceSelectedValue: string = 'None';
  selectedSignificance: any;
  selectedSigBrand: any;
  stacticText: string = '';

  // WEIGHT & INDEX CONFIGURATION
  is_indexing: boolean = false;
  is_indexingShow: boolean = false;
  isIndexSelected: any;
  IndexData: any;
  weightColumnName: string = '';
  weightSelectedValue: any = 'Total Population';
  sortToggle: boolean = true;

  // SNAPSHOT & WIDGET CONFIGURATION
  snapshotName: string = '';
  selectedType: any = 'Single Brand';
  filteredWidgetSelection: any;
  pageData: any;
  widgetData: any;
  baseselected: string = 'Total Base';
  outputData: any;
  item: any;
  items: any;
  itemWithoutTrend: any;
  itemWithoutTrendItems: any;
  lastCrosstabPayload: any;
  lastSnapshotPayload: any;
  lastBrandAnalysisPayload: any;
  MainResult: any;
  masterStudyConfig: any = null;
  filteredWidgetData: any;
  filteredWidgetID: any;
  selectedWidgetName: any;
  selectedWidgetID: any;
  WidgetId: any;
  Widget_Id: any;
  widget_Name: any;
  widget_Id: any;
  displayModuleSelected: string = 'Snapshot';
  selectedSection: string = '';
  selectedSubSection: string = 'NA';
  selectedcompareacrossOption: string = '';
  SaveSelectiontext: string = '';
  isselectionHeader: string = '';

  // EXPORT & DOWNLOAD PROPERTIES
  excelExport: boolean = false;
  CrossTabOutPutData: any;
  Snapshotdataforexport: any;
  CrossTabOutPutEntireData: any;
  OutputData: any;
  passOutputData: any;
  ImageURL: string = '';

  // BRAND ANALYSIS
  is_brand_analysis: boolean = false;
  isBrandAnalysis: boolean = false;
  isBoostFactor: boolean = false;
  ShareColumn: any;
  BaseColumn: any;
  selectedBrands: any[] = [];
  referenceBrand: string = '';
  allbrands: any;
  allSigBrands: any;

  // TOAST NOTIFICATIONS
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'info' = 'success';
  toastTimeoutId: any;
  isToastHovered: boolean = false;
  toastRemainingTime: number = 3000;
  toastStartTime: number = 0;

  // INSIGHTS & ANALYTICS
  copiedInsightsId: string | null = null;
  copiedResponseId: string | null = null;

  // DIAGNOSTIC & ICONS
  diagnosticIcon: string = 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';

  // SELECTION & SUMMARY
  selectionSummary: string = '';
  selectionSummaryTitle: string = '';
  summaryTitle: any;
  additionalList: any;

  // INSIGHTS
  insightsVal: any = '';
  InsightsResponse: any = '';
  public insights_payload: any = null;
  public snapshotinsights_payload: any = null;
  public snapshotinsights_trend_payload: any = null;
  public snapshotinsights_standard_text: string = '';
  public snapshotinsights_trendline_text: string = '';
  public insightsStreamingText: string = '';
  public insightsStreamingPoints: string[] = []; // Formatted streaming points
  clientLogo: string | null = null;
  isBrandingLoaded: boolean = false;
  private insightsScrollInterval: any = null;
  private isInsightsScrolling: boolean = false;
  public isInsightsStreaming: boolean = false; // Flag to handle auto-scroll during generation
  private qnaFirstChunkTime: number = 0;
  
  // COPY PROPERTIES
  copiedChartId: any = null;
  isCopyingId: any = null;

  // MISCELLANEOUS/LEGACY PROPERTIES
  is_Transpose: any;
  is_ranking: any;
  isFilterToggle: any;
  isAnswerToggle: any;
  comparisionpoint: any;
  confidenceLevel: any;
  repository: any;
  lowBaseIdentifier: any;
  is_AI_Integration: any;
  is_StoryBoard: any;
  is_Column_Row_Percentage: any;
  insufficentBase: any;
  insufficientBase: any;
  lowBase: any;
  LowBase: any;
  iscustomgrp: any;
  iscustomCalc: any;
  iscustomreport: any;
  changeEntryPoint: any;
  is_reset_selection: any;
  dataexists: any;
  newdataexists: any;
  strdata: any;
  serviceVariable: any;
  mcode: any;
  promptData: any;
  mandatoryVariableMapping: any;
  is_dimension_Present: boolean = false;
  is_Time_Period_Present: boolean = true;
  istimePeriodWave: boolean = false;

  // SUBSCRIPTIONS
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  $unSubscribeSubmitData3!: Subscription;
  $unSubscribeSubmitData4!: Subscription;
  $unSubscribeSubmitData5!: Subscription;
  $unSubscribeSubmitData6!: Subscription;
  $unSubscribeSubmitData7!: Subscription;
  $unSubscribeSubmitData8!: Subscription;
  $unSubscribeSubmitData9!: Subscription;

  goToWelcomeSection(): void {
    this.currentView = 'landing';
  }

  goToLandingPage(): void {
    this.router.navigateByUrl('/landing');
  }

  onChartIconMouseOver(tooltipType: 'stack' | 'line' | 'bar', event: MouseEvent, block: any = null): void {
    const target = block || this;
    this.tooltipStates[tooltipType] = true;
    this.updateChartDisablingFlags(block);
    this.updateTooltipFlags(block);

    if (!target.isIndex && target.isChartView) {
      target.showMainTooltip = false;
      event.stopPropagation();
    } else {
      target.showMainTooltip = true;
    }
  }

  private updateChartDisablingFlags(block: any = null): void {
    const target = block || this;
    const mcode = this.getMcode(target);
    const blockData = target.messageId ? this.getOutputData(target) : (this.OutputdataObject?.Row?.length > 0 ? this.OutputdataObject : this.dataObject);
    const blockDataObject = target.dataObject || this.dataObject;

    let rowdata: any[] = (blockData?.Row || []) as any[];
    let columndata: any[] = (blockData?.Column || []) as any[];
    let rowNestData = blockData?.RowNesting || blockDataObject?.RowNesting || [];
    let colNestData = blockData?.ColNesting || blockDataObject?.ColNesting || [];

    if (target.isTranspose) {
      const tempRow = rowdata;
      rowdata = columndata;
      columndata = tempRow;

      const tempNest = rowNestData;
      rowNestData = colNestData;
      colNestData = tempNest;
    }

    const rowDataLength: number = rowdata.length > 0 ? (rowdata[0].Data?.length || 0) : 0;

    const colDataLength: number = columndata.length;
    const colNestLength: number = colNestData.length;
    const singleColChildLength: number = (columndata && columndata[0]?.Data?.length) || 0;

    const isPairwiseAllowed = colDataLength === 1 && colNestLength === 0 && singleColChildLength >= 2 && singleColChildLength <= 10;
    target.isDisablePairWise = !isPairwiseAllowed;
    target.isDisableReference = colDataLength > 1;

    // 1. isChartView Logic
    const hasDataSelected = !target.DefaultDataDropDown || target.DefaultDataDropDown === 'Data';
    const hasRowNestedArray = rowdata.length > 0 && rowdata[0]?.Data?.length > 0 && (rowdata[0].Data[0].NestedArray?.length > 0);
    const hasColNestedArray = columndata.length > 0 && columndata[0]?.Data?.length > 0 && (columndata[0].Data[0].NestedArray?.length > 0);
    
    target.isChartView = (
      rowNestData.length > 0 ||
      colNestData.length > 0 ||
      hasRowNestedArray ||
      hasColNestedArray ||
      rowdata.length < 1 ||
      rowDataLength > this.maxColumnsPerSlide ||
      target.isIndex ||
      !hasDataSelected
    ) ? false : true;


    if (target.isChartView) {
      const isMultiPunchRow = this.filterDataByCalculationType(rowdata as any, 'multipunch');

      const hasMean = rowdata.some((parent: any) =>
        (parent.Data || []).some((child: any) => child.CalculationType?.toLowerCase() === 'mean')
      );
      const hasPercentage = rowdata.some((parent: any) =>
        (parent.Data || []).some((child: any) =>
          ['share', 'respgrp', 'percentage'].includes(child.CalculationType?.toLowerCase())
        )
      );

      // Disable all charts if mixed Mean and Percentage metrics are present
      if (hasMean && hasPercentage) {
        target.isChartView = false;
        target.disableStackChart = true;
        target.disableLineChart = true;
        return;
      }

      const isShareMetric = rowdata.filter((parent: any) => {
        return (parent.Data || []).some((child: any) => ['share', 'respgrp', 'percentage'].includes(child.CalculationType?.toLowerCase()));
      });

      const isMeanMetric = rowdata.filter((parent: any) => {
        return (parent.Data || []).some((child: any) => child.CalculationType?.toLowerCase() === 'mean');
      });

      const isDefaultRespGrp = rowdata.filter((parent: any) => {
        return (parent.Data || []).some((child: any) => child.CalculationType?.toLowerCase() === 'respgrp' && child.isDerviedVariable === true);
      });

      // 2. disableLineChart Logic
      const TimePeriodinColumn = columndata.filter((parent: any) =>
        (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true') ||
        parent.Parent?.toLowerCase().includes('time period') ||
        parent.Parent?.toLowerCase().includes('year') ||
        parent.Parent?.toLowerCase().includes('month') ||
        parent.Parent?.toLowerCase().includes('quarter') ||
        parent.Parent?.toLowerCase().includes('wave') ||
        parent.Parent?.toLowerCase().includes('mma')
      );

      const TimePeriodinRow = rowdata.filter((parent: any) =>
        (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true') ||
        parent.Parent?.toLowerCase().includes('time period') ||
        parent.Parent?.toLowerCase().includes('year') ||
        parent.Parent?.toLowerCase().includes('month') ||
        parent.Parent?.toLowerCase().includes('quarter') ||
        parent.Parent?.toLowerCase().includes('wave') ||
        parent.Parent?.toLowerCase().includes('mma')
      );

      const rowDataLengthForTrend = this.getDistinctChildValues(rowdata as any);

        // 3. disableStackChart Logic
        if (rowdata.length === 1) {
          let filteredData: any = [];
          const disctinctRowValues = this.getDistinctChildValues(rowdata as any);
          const pipeParts = this.getDistinctPipeParts(disctinctRowValues);
          target.StackFlag = this.calculateStackFlag(pipeParts);

          if (target.StackFlag) {
            rowdata[0].Data.forEach((item: any) => {
              const pipeCount = (item.Child.match(/\|/g) || []).length;
              if (pipeCount === 1) {
                const [level1] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) => x.Level1 === level1 && x.Header == 'VariableList'
                );
              } else if (pipeCount === 2) {
                const [level1, level2] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 3) {
                const [level1, level2, level3] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 4) {
                const [level1, level2, level3, level4] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.level4 == level4 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 5) {
                const [level1, level2, level3, level4, level5] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.level4 == level4 &&
                    x.level5 == level5 &&
                    x.Header == 'VariableList'
                );
              }
            });
          } else {
            target.StackFlag = false;
          }

          let isStackChartAvailable = false;
          if (isMultiPunchRow.length > 0 || isDefaultRespGrp.length > 0 || isMeanMetric.length > 0) {
            isStackChartAvailable = false;
          } else {
            isStackChartAvailable = rowdata[0].Data.length === filteredData.length;
          }
          
          target.disableStackChart = !isStackChartAvailable;
        } else {
          target.disableStackChart = true; // Multiple metrics selected
        }

      // disableLineChart Logic specialized by Mcode (matching parent components)
      if (target.isTranspose) {
        target.disableLineChart = true;
      } else {
        const activeTimePeriod = TimePeriodinColumn; // When not transposed, time period is in columns
        if (mcode === 2) {
          // Brand Analysis Line Chart condition: purely based on time period in columns
          const isLineChartAvailable = activeTimePeriod.length === 1;
          target.disableLineChart = !isLineChartAvailable;
        } else {
          // Crosstab (mcode 3) Line Chart condition
          const isLineChartAvailable = activeTimePeriod.length === 1 &&
            ((isShareMetric.length > 0 || isMeanMetric.length > 0) && rowDataLengthForTrend.length <= this.maxRowsPerSlide);
          target.disableLineChart = !isLineChartAvailable;
          
          console.log('[DEBUG LINE CHART] mcode 3 variables:', {
            activeTimePeriodLength: activeTimePeriod.length,
            isShareMetricLength: isShareMetric.length,
            isMeanMetricLength: isMeanMetric.length,
            rowDataLengthForTrendLength: rowDataLengthForTrend.length,
            maxRowsPerSlide: this.maxRowsPerSlide,
            isLineChartAvailable,
            rowdataLength: rowdata.length,
            disableStackChart: target.disableStackChart,
            TimePeriodinColumn
          });
        }
      }

      // Additional safety: if more than 15 rows (standard chart limit), disable stack & line chart
      if (rowDataLength > this.maxRowsPerSlide) {
        target.disableStackChart = true;
        target.disableLineChart = true;
      }
    } else {
      target.disableStackChart = true;
      target.disableLineChart = true;
    }
  }

  onChartIconMouseLeave(tooltipType: 'stack' | 'line' | 'bar', block: any = null): void {
    const target = block || this;
    this.tooltipStates[tooltipType] = false;
    this.updateTooltipFlags(block);
  }

  private updateTooltipFlags(block: any = null): void {
    const target = block || this;
    target.showStackTooltip = this.tooltipStates.stack;
    target.showLineTooltip = this.tooltipStates.line;
    target.showBarTooltip = this.tooltipStates.bar;
  }

  fallbackMessage(): string {
    const clientName = this.selected_client || '';
    const studyName = this.selected_study || '';

    return exceptionMessage
      .replace(/{{client}}/g, clientName)
      .replace(/{{study}}/g, studyName);
  }

  onHover(isHovering: boolean): void {
    this.diagnosticIcon = isHovering
      ? 'assets/imageChatbot/Diagnostic_Left_Icon_Hover.svg'
      : 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  closeDropdown(): void {
    this.showDropdown = false;
  }

  viewOnline(): void {
    this.isDiagnosticAnimating = true;
    const animationPromise = new Promise(resolve => setTimeout(resolve, 1000));
    const diagnosticPromise = Promise.resolve(this.fetchDiagnostic()).catch(() => { });

    Promise.all([animationPromise, diagnosticPromise])
      .finally(() => {
        this.isDiagnosticAnimating = false;
        this._loaderService.hideLoader();
        this.closeDropdown();
      });
  }

  exportToExcel(): void {
    this.apiService.downloadDiagnosticsExcel().subscribe((blob: Blob) => {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '');
      const client = this.selected_client && this.selected_client.trim() !== '' ? this.selected_client : '';
      const snapshot = this.snapshotName && this.snapshotName.trim() !== '' ? this.snapshotName : 'Excel';
      const fileName = `${client}-${snapshot}-${formattedDate}.xlsx`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      this.closeDropdown();
    });
  }

  handleConfig(eventData: any): void {
    if (eventData) {
      this.isWeigthedBtn = eventData.weighted_btns;
    }
    if (eventData.configweights && eventData.configweights.length > 0) {
      this.configWeights = eventData.configweights;

      if (this.variableTabData && this.variableTabData.length > 0) {
        this.populateWeightDropdown();
      }
    }
  }

  getBearerToken(): Promise<string> {
    return new Promise((resolve) => {
      let account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          account = accounts[0];
          this.msalService.instance.setActiveAccount(account);
        }
      }
      if (!account) {
        resolve('');
        return;
      }
      this.msalService.instance.acquireTokenSilent({
        scopes: protectedResources.Api.scopes.read,
        account: account
      }).then(tokenResponse => {
        resolve(`Bearer ${tokenResponse.accessToken}`);
      }).catch(error => {
        console.error('Token acquisition failed in chatbotexpand', error);
        resolve('');
      });
    });
  }

  get currentQuestion(): string {
    if (!this.selectedMessageId || this.chatPreviewBlocks.length === 0) {
      return this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question
        : '';
    }

    const selectedBlock = this.chatPreviewBlocks.find(
      block => block.messageId === this.selectedMessageId
    );

    return selectedBlock
      ? selectedBlock.question
      : (this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question
        : '');
  }

  get currentAnswer(): string {
    if (!this.selectedMessageId || this.chatPreviewBlocks.length === 0) {
      return this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].QuestionAnswer || ''
        : '';
    }

    const selectedBlock = this.chatPreviewBlocks.find(
      block => block.messageId === this.selectedMessageId
    );

    return selectedBlock
      ? (selectedBlock.QuestionAnswer || '')
      : (this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].QuestionAnswer || ''
        : '');
  }

  isSummaryForSnapshot: boolean = false;

  get isAnyLoaderActive(): boolean {
    return this.arktabaccess || this.isScrollingToTarget || this.isInsightsStreaming;
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public _loaderService: LoaderService,
    private _exportDownloads: ExportDownloadServices,
    private apiService: ChatbotService,
    private crossTabService: CrosstabService,
    private _insightsSerive: InsightspopupService,
    private _usermanagementService: UserProjectManagementService,
    private _configCustomService: CustomsnapshotService,
    public _configService: SnapshotService,
    private _configurationService: ConfigurationService,
    private sharedChatService: SharedChatService,
    private commonchartmodules: CommonChartmoduleService,
    private indexedDBService: IndexedDBService,
    private msalService: MsalService,
    private cdr: ChangeDetectorRef
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
    if (this.landingdata == undefined) {
      this.router.navigateByUrl('landing');
    }
    this.searchForm = this.fb.group({
      query: ['']
    });

    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';
    if (fromLandingPage) {
      // If there's already an input question from the landing page, go directly to chat view
      this.currentView = this.landingdata?.inputValue ? 'chat' : 'landing';
    } else {
      this.currentView = 'chat';
    }
  }

  formatMarkdown(text: any, isInsights: boolean = false): string {
    if (Array.isArray(text)) {
      text = text[0] || '';
    }
    if (typeof text !== 'string') {
      return '';
    }
    return FormattersHelper.formatMarkdown(text, isInsights);
  }

  subscribeToVariableData(): void {
    this.$unSubscribeSubmitData3 =
      this.crossTabService.variableTabData$.subscribe(({ data }) => {
        if (data !== null && data !== undefined) {
          this.variableTabData = data;
          this.isAggregatedData = data[0].is_aggregated_data == 1;
          this.isSemiAggregatedData = data[0].is_semi_aggregated_data == 1;
          if (this.configWeights && this.configWeights.length > 0) {
            this.populateWeightDropdown();
          }
        }
      });
  }

  // --- Speech Recognition (Dictation) Methods ---
  initSpeechRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.isSpeechSupported = true;
      this.speechRecognition = new SpeechRecognition();
      this.speechRecognition.continuous = true;
      this.speechRecognition.interimResults = true;
      this.speechRecognition.lang = 'en-US';

      this.speechRecognition.onstart = () => {
        this.isDictating = true;
      };

      this.speechRecognition.onresult = (event: any) => {
        let sessionTranscript = '';

        // Iterate over all results in the current session
        for (let i = 0; i < event.results.length; ++i) {
          let phrase = event.results[i][0].transcript;
          if (sessionTranscript && !sessionTranscript.endsWith(' ') && !phrase.startsWith(' ')) {
            sessionTranscript += ' ';
          }
          sessionTranscript += phrase;
        }

        if (sessionTranscript) {
          sessionTranscript = sessionTranscript.replace(/[\.\?]/g, ' ').replace(/\s+/g, ' ');
          
          let newValue = this.baseInputValue.replace(/\?$/, '').trim();
          newValue = newValue ? newValue + ' ' + sessionTranscript.trim() : sessionTranscript.trim();
          
          if (this.activeDictationTarget === 'main') {
            newValue = newValue + '?';
            this.searchForm.patchValue({ query: newValue });
            setTimeout(() => {
              const inputEl = document.querySelector('input[formControlName="query"]') as HTMLInputElement;
              if (inputEl) inputEl.scrollLeft = inputEl.scrollWidth;
            }, 0);
          } else if (this.activeDictationTarget === 'chatSearch') {
            this.chatSearchText = newValue;
            setTimeout(() => {
              const inputEl = document.querySelector('.chat-search-input') as HTMLInputElement;
              if (inputEl) inputEl.scrollLeft = inputEl.scrollWidth;
            }, 0);
            // Fire search automatically only when a segment is finalized
            if (event.results[event.results.length - 1].isFinal) {
              this.onChatSearch();
            }
          } else if (this.activeDictationTarget === 'nestedSearch') {
            this.chatNestedSearchText = newValue;
            setTimeout(() => {
              const inputEl = document.querySelector('.chat-nested-input') as HTMLInputElement;
              if (inputEl) inputEl.scrollLeft = inputEl.scrollWidth;
            }, 0);
            if (event.results[event.results.length - 1].isFinal) {
              this.onChatSearch();
            }
          }
        }
      };

      this.speechRecognition.onerror = (event: any) => {
        console.error('Speech recognition error', event.error);
        this.isDictating = false;
        if (event.error === 'not-allowed') {
          this.showToast('Microphone access denied. Please allow microphone permissions.', 'error');
        }
      };

      this.speechRecognition.onend = () => {
        this.isDictating = false;
        this.activeDictationTarget = null;
      };
    } else {
      this.isSpeechSupported = false;
      console.warn('Speech Recognition API is not supported in this browser.');
    }
  }

  toggleDictation(target: 'main' | 'chatSearch' | 'nestedSearch'): void {
    if (!this.isSpeechSupported) return;

    if (this.isDictating) {
      if (this.activeDictationTarget === target) {
        this.stopDictation();
        this.activeDictationTarget = null;
      } else {
        this.stopDictation();
        setTimeout(() => {
          this.activeDictationTarget = target;
          this.captureBaseValue(target);
          this.startDictation();
        }, 100);
      }
    } else {
      this.activeDictationTarget = target;
      this.captureBaseValue(target);
      this.startDictation();
    }
  }

  captureBaseValue(target: 'main' | 'chatSearch' | 'nestedSearch'): void {
    if (target === 'main') {
      this.baseInputValue = this.searchForm.get('query')?.value || '';
    } else if (target === 'chatSearch') {
      this.baseInputValue = this.chatSearchText || '';
    } else if (target === 'nestedSearch') {
      this.baseInputValue = this.chatNestedSearchText || '';
    }
  }

  startDictation(): void {
    if (this.speechRecognition && !this.isDictating) {
      try {
        this.speechRecognition.start();
      } catch (e) {
        console.error('Failed to start dictation:', e);
      }
    }
  }

  stopDictation(): void {
    if (this.speechRecognition && this.isDictating) {
      try {
        this.speechRecognition.stop();
      } catch (e) {
        console.error('Failed to stop dictation:', e);
      }
    }
  }
  // ----------------------------------------------

  async ngOnInit(): Promise<void> {
    let session_id_from_storage = sessionStorage.getItem('session_id');

    if (this.landingdata && this.landingdata.guidChatId) {
      this.guidChatId = this.landingdata.guidChatId;
      this.validatedSessionId = this.guidChatId;
      this.modulesAccess = this.landingdata.modules_access;
    } else if (session_id_from_storage) {
      this.guidChatId = session_id_from_storage;
      this.validatedSessionId = this.guidChatId;
    }

    this.selected_study = this.landingdata?.study || null;
    this.selected_client = this.landingdata?.client_code || null;
    this._configService.clientName = this.selected_client;
    this._configService.selectedStudy = this.selected_study;

    this.preFetchMetadata();
    this.setupSearchDebounce();
    this.initSpeechRecognition();

    // Only call access-check if not already validated for this session
    if (!this.validatedSessionId || this.validatedSessionId !== this.guidChatId) {
      this.getBearerToken().then(token => {
        this.apiService.accessCheck(
          this.selected_client || '',
          this.selected_study || '',
          token,
          this.guidChatId || ''
        ).subscribe({
          next: (res: any) => {
            if (res && res.session_id) {
              this.guidChatId = res.session_id;
              this.modulesAccess = res.modules_access;
              this.isCacheGenerated = false; // Reset cache flag as we have fresh modules_access
            }
            this.validatedSessionId = this.guidChatId;
          },
          error: (err) => {
            console.error('[ACCESS-CHECK] ❌ Init access-check failed:', err);
          }
        });
      });
    } else {
    }

    this.askMeLanding = true;
    this.selected_study = this.landingdata?.study || null;
    this.selected_client = this.landingdata?.client_code || null;

    if (this.selected_client) {
      try {
        forkJoin([
          this._configurationService.getLogo(this.selected_client).pipe(catchError(() => of(null))),
          this._configurationService.getLogoFiles(this.selected_client).pipe(catchError(() => of([])))
        ]).subscribe({
          next: ([logoRes, filesRes]: [any, any]) => {

            let finalLogo: string | null = null;
            let finalLogoUrl: string = this.logo_url;

            // 1. Check Files for _askme.png (Highest Priority)
            if (filesRes && filesRes.length > 0) {
              const askme = filesRes.find((f: any) => f.fileName && f.fileName.toLowerCase().endsWith('_askme.png'));
              const normal = filesRes.find((f: any) => f.fileName && !f.fileName.toLowerCase().endsWith('_askme.png'));

              if (askme?.url) {
                finalLogo = askme.url;
                finalLogoUrl = askme.url;
              } else if (normal?.url) {
                finalLogo = normal.url;
                finalLogoUrl = normal.url;
              }
            }

            // 2. Fallback to getLogo result if no askme found yet
            if (!finalLogo && logoRes) {
              if (logoRes.url) {
                finalLogo = logoRes.url;
              } else if (logoRes.HasValidData && logoRes.Data) {
                try {
                  const parsed = JSON.parse(logoRes.Data);
                  finalLogo = parsed.url || parsed;
                } catch (e) {
                  finalLogo = logoRes.Data;
                }
              }
            }

            this.clientLogo = finalLogo;
            this.logo_url = finalLogoUrl || this.logo_url;
            this.isBrandingLoaded = true;
          },
          error: (err) => {
            console.warn('[LOGO-DEBUG] Branding orchestration error:', err);
            this.isBrandingLoaded = true; // Unblock UI even on error
          }
        });
      } catch (e) {
        console.warn('[LOGO-DEBUG] Exception during branding setup:', e);
        this.isBrandingLoaded = true;
      }
    } else {
      this.isBrandingLoaded = true;
    }

    this.commonchartmodules.colortemplate(this.selected_client);
    this.ShareColumn = this.landingdata?.shareColumn || null;
    this.BaseColumn = this.landingdata?.baseColumn || null;
    this.displayTable = false;
    this.subscribeToVariableData();
    
    // Perform non-critical operations asynchronously
    setTimeout(() => {
      this.indexedDBService.clearExpiredCache().catch((err: any) =>
        console.error('Error clearing expired cache:', err)
      );
      this.getChatListData();
      this.initializeUserIdentity();
    }, 0);

    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';
    if (!this.selected_study || !this.selected_client) {
      this.router.navigateByUrl('/landing');
      return;
    }

    // Load massive study payload asynchronously without blocking component initialization
    this.fetchStudyDataAsync(fromLandingPage);
    this.summaryTitle = this.Summary();
  }

  private async fetchStudyDataAsync(fromLandingPage: boolean) {
    let result: results | null = await this.indexedDBService.getClientStudyData(
      this.selected_client,
      this.selected_study,
      this.isBrandAnalysis
    );

    if (!result) {
      try {
        result = await firstValueFrom(
          this.crossTabService.getClientStudyData(
            {
              client_code: this.selected_client,
              study: this.selected_study,
            },
            this.isBrandAnalysis
          )
        );

        if (result && result.HasValidData) {
          await this.indexedDBService.cacheClientStudyData(
            this.selected_client,
            this.selected_study,
            this.isBrandAnalysis,
            result
          );
        }
      } catch (err) {
        console.error("Failed to load study data:", err);
      }
    }

    if (result && result.HasValidData) {
      const studyData: StudyData = {
        study: this.selected_study,
        client_name: this.selected_client,
        url_logo: this.filteredlist?.url_logo || '',
      };
      this.receivedData = JSON.parse(result.Data);
      this.clientcode = this.selected_client;
      this.filteredlist = this.receivedData.find(
        (u: StudyData) =>
          u.study === this.selected_study &&
          u.client_name === this.selected_client
      );

      this.logo_url = this.filteredlist?.url_logo || '';

      if (this.selected_client === 'PMI') {
        this.configChanges(this.receivedData, this.selected_study);
      }

      if (fromLandingPage) {
        this.processSendMessageRequest();
      } else {
        this.loadLatestChatIfExists();
      }
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

  /**
   * Pre-fetches master study configuration metadata to ensure that analytical dropdowns
   * are populated faster. This replicates a portion of the popup's own initialization logic.
   * Returns a promise that resolves when metadata is ready.
   */
  preFetchMetadata(): Promise<void> {
    if (this.metadataFetchPromise) return this.metadataFetchPromise;

    const client = this.selected_client || '';
    const study = this.selected_study || '';

    if (client && study) {
      this.metadataFetchPromise = new Promise((resolve) => {
        this._configService.getGeneralConfigData({
          study: study,
          client_name: client,
          client_code: client,
          isBrandAnalysis: true
        }).subscribe({
          next: (res: any) => {
            if (res) {
              this.handleMetadataPreFetchResponse(res);
            }
            resolve();
          },
          error: (err: any) => {
            console.error('[ACCESS-CHECK] ❌ Metadata Pre-fetch Error:', err);
            resolve(); // Resolve anyway to unblock UI
          }
        });
      });
      return this.metadataFetchPromise;
    }
    return Promise.resolve();
  }

  /**
   * Processes the pre-fetched metadata response and stores it in the service
   * so the output popup can pick it up immediately.
   */
  handleMetadataPreFetchResponse(data: any): void {
    if (!data) return;

    let parsedData: any = null;
    try {
      if (data.Data && data.Data !== '') {
        parsedData = (typeof data.Data === 'string') ? JSON.parse(data.Data) : data.Data;
      } else if (data.Config && data.Config !== '') {
        parsedData = (typeof data.Config === 'string') ? JSON.parse(data.Config) : data.Config;
      } else {
        parsedData = data;
      }
    } catch (e) {
      parsedData = data.Data || data;
    }

    if (parsedData && parsedData.configData) {
      parsedData = parsedData.configData;
    }

    // Write to shared service property
    this._configService.outputSnapshotData = parsedData;
    this.masterStudyConfig = parsedData; // Store master config for explicit passing via Input

    // Fallback for client logo from master config if not already set
    if (parsedData.custom_logo_path && !this.clientLogo) {
      this.clientLogo = parsedData.custom_logo_path;
    }

    // Map specific properties to the service (Matches Popup Ref)
    if (parsedData.brandMetadata) this._configService.brandData = parsedData.brandMetadata;
    else if (parsedData.brand_metadata) this._configService.brandData = parsedData.brand_metadata;

    const weightsRaw = parsedData.weight || parsedData.weights;
    if (weightsRaw && Array.isArray(weightsRaw) && weightsRaw.length > 0) {
      this._configService.weights = weightsRaw;
      this.configWeights = weightsRaw;

      this.populateWeightDropdown();

      // Derive the display label for the first selected weight (matches output-popup mapping)
      const selectedWeights = Array.isArray(weightsRaw)
        ? weightsRaw.filter((w: any) => w.is_selected || w.isSelected)
        : [];
      const firstWeight = selectedWeights.length > 0 ? selectedWeights[0]
        : (Array.isArray(weightsRaw) ? weightsRaw[0] : null);
      if (firstWeight) {
        const allSelected = selectedWeights.length > 0 ? selectedWeights : (Array.isArray(weightsRaw) ? weightsRaw : []);
        const idx = allSelected.indexOf(firstWeight);
        const label = idx === 0 ? 'Primary Weight'
          : idx === 1 ? 'Secondary Weight'
            : (firstWeight.variable_label || firstWeight.key || `Weight ${idx + 1}`);
        this._configService.weightLabel = label;
        if (!this.DefaultWeight) {
          this.DefaultWeight = label;
        }
      }
    }

  }

  private userIdentityPromise: Promise<void> | null = null;

  initializeUserIdentity(): Promise<void> {
    if (!this.userIdentityPromise) {
      this.userIdentityPromise = this._initializeUserIdentityCore().catch(error => {
        console.error('[User Identity] Initialization failed:', error);
        this.userIdentityPromise = null; // Allow retry on failure
      });
    }
    return this.userIdentityPromise;
  }

  private async _initializeUserIdentityCore(): Promise<void> {
    try {
      const storedUserId = sessionStorage.getItem('arkUserId');

      if (storedUserId) {
        const response = await firstValueFrom(this.apiService.getUserIdentity(storedUserId));
        const apiResponse = JSON.parse(response);

        if (apiResponse.HasValidData && apiResponse.Data) {
          const userData = JSON.parse(apiResponse.Data);
          this.userId = userData.UserId;
          return;
        }
      }
      await this.createNewUserIdentity();
    } catch (error) {
      console.warn('[User Identity] Failed to fetch stored user, creating new one...', error);
      await this.createNewUserIdentity();
    }
  }

  async createNewUserIdentity(): Promise<void> {
    try {
      const userDoc: UserIdentityDocument = {
        UserId: '',
      };

      const response = await firstValueFrom(this.apiService.saveUserIdentity(userDoc));
      const apiResponse = JSON.parse(response);

      if (apiResponse.HasValidData && apiResponse.Data) {
        this.userId = apiResponse.Data;
        sessionStorage.setItem('arkUserId', this.userId);
      } else {
        console.error('[User Identity] API responded with invalid data when creating new user.');
      }
    } catch (error) {
      console.error('[User Identity] Critical Error creating new user identity:', error);
    }
  }

  processSendMessageRequest(): void {
    this.subscriptions.add(
      this.sharedChatService.sendMessageRequest$.pipe(take(1)).subscribe(payload => {
        if (payload && payload.inputValue && payload.inputValue.trim() !== '') {
          // Guard: Prevent sending new message while previous question is still processing
          if (this.arktabaccess) {
            console.warn('[SEND GUARD] Cannot send message from landing page - previous question still processing');
            this.sharedChatService.clearRequest();
            return;
          }

          this.inputValue = payload.inputValue.trim();
          this.selectedMessageId = null; // Clear selected message for new question
          if (payload.guidChatId) {
            this.guidChatId = payload.guidChatId;
            this.validatedSessionId = payload.guidChatId;
          } else {
            console.warn('[RECEIVE-MESSAGE] Fallback triggered: No guidChatId in payload!');
          }
          if (payload.modulesAccess) {
            this.modulesAccess = payload.modulesAccess;
          }
          this.sendInputMessage();
          this.sharedChatService.clearRequest();
        } else {
          if (payload) {
            this.landingdata = {
              ...this.landingdata,
              client_code: payload.clientCode,
              study: payload.study,
              dataArray: payload.dataArray || [],
              landingData: payload.landingData || {},
              guidChatId: payload.guidChatId,
              modules_access: payload.modulesAccess
            };
            if (payload.guidChatId) {
              this.guidChatId = payload.guidChatId;
              this.validatedSessionId = payload.guidChatId;
            } else {
              console.warn('[RECEIVE-MESSAGE] (Fallback Block) Fallback triggered: No guidChatId in payload!');
            }
            this.selected_study = payload.study;
            this.selected_client = payload.clientCode;
            this.loadData = payload.dataArray || [];
            this.leftPanelData = payload.landingData || {};
          }
          this.arktabaccess = false;
          this.currentView = 'landing';
          this.chatPreviewBlocks = [];
          this.isNewChatSession = true;
        }
      })
    );
  }

  ngOnDestroy() {
    try {
      document.removeEventListener('click', this.onDocumentClick, true);
    } catch (e) {
      // ignore
    }
    this.subscriptions.unsubscribe();
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    if (this.$unSubscribeSubmitData3) {
      this.$unSubscribeSubmitData3.unsubscribe();
    }
    if (this.$unSubscribeSubmitData4) {
      this.$unSubscribeSubmitData4.unsubscribe();
    }
    if (this.$unSubscribeSubmitData5) {
      this.$unSubscribeSubmitData5.unsubscribe();
    }
    if (this.$unSubscribeSubmitData6) {
      this.$unSubscribeSubmitData6.unsubscribe();
    }
    if (this.$unSubscribeSubmitData8) {
      this.$unSubscribeSubmitData8.unsubscribe();
    }
    if (this.$unSubscribeSubmitData9) {
      this.$unSubscribeSubmitData9.unsubscribe();
    }
    this.stopInsightsAutoScroll();
    sessionStorage.removeItem('isarkTabAccessed');
  }

  toggleChatHistory(): void {
    if (this.isSavedQuestionsOpen) {
      this.isSavedQuestionsOpen = false;
    }
    this.isChatHistoryOpen = !this.isChatHistoryOpen;
  }

  toggleSavedSelections(): void {
    if (this.isChatHistoryOpen) {
      this.isChatHistoryOpen = false;
    }
    this.isSavedQuestionsOpen = !this.isSavedQuestionsOpen;

    if (this.isSavedQuestionsOpen) {
      this.loadStarredMessages();
    }
  }

  loadStarredMessages(): void {
    this.isLoadingStarredMessages = true;
    this.apiService.getStarredMessages(this.selected_client, this.selected_study).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const parsedData = JSON.parse(apiResponse.Data);
          this.starredMessages = parsedData.map((msg: any) => {
            let answer = msg.QuestionAnswer;
            if (!answer) {
              const chat = this.allChatList.find(c => c.ChatId === msg.ChatId);
              if (chat && chat.ChatHistory) {
                const historyItem = chat.ChatHistory.find(h => h.MessageId === msg.MessageId);
                if (historyItem) {
                  answer = historyItem.QuestionAnswer;
                }
              }
            }
            return {
              ...msg,
              QuestionAnswer: answer,
              AnswerPreview: ChatHistoryHelper.createAnswerPreview(answer)
            };
          });
          this.filteredStarredMessages = [...this.starredMessages];
        } else {
          this.starredMessages = [];
          this.filteredStarredMessages = [];
        }
        this.isLoadingStarredMessages = false;
      },
      error: (err) => {
        this.starredMessages = [];
        this.filteredStarredMessages = [];
        this.isLoadingStarredMessages = false;
      }
    });
  }

  onStarredSearch(): void {
    const searchText = this.starredSearchText.toLowerCase().trim();
    if (!searchText) {
      this.filteredStarredMessages = [...this.starredMessages];
      return;
    }

    const searchTokens = this.tokenizeSearchText(searchText.toLowerCase());
    this.filteredStarredMessages = this.starredMessages.filter(msg =>
      this.matchesAllTokens(msg.Question || '', searchTokens)
    );
  }

  unstarFromSaved(message: any, event: Event): void {
    event.stopPropagation();
    const messageId = message.MessageId || message.messageId || message.id;
    if (!messageId) {
      console.warn('[unstarFromSaved] ❌ No message ID found in:', message);
      return;
    }

    this.apiService.updateChatStarred(messageId, false).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          // Update local starredMessages list
          const beforeCount = this.starredMessages.length;
          this.starredMessages = this.starredMessages.filter(m => {
            const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
            const targetId = (messageId || '').toString().toLowerCase();
            return mId !== targetId;
          });
          this.onStarredSearch(); // Refresh filtered list

          // Also update allChatList if it contains this message
          this.allChatList.forEach(chat => {
            const msg = chat.ChatHistory?.find((h: any) => {
              const hId = (h.MessageId || h.messageId || '').toString().toLowerCase();
              const targetId = (messageId || '').toString().toLowerCase();
              return hId === targetId;
            });
            if (msg) {
              msg.IsStarred = false;
              (msg as any).isStarred = false;
            }
          });

          // Update chatPreviewBlocks if current
          const currentMsg = this.chatPreviewBlocks.find(b => {
            const bId = (b.messageId || '').toString().toLowerCase();
            const targetId = (messageId || '').toString().toLowerCase();
            return bId === targetId;
          });
          if (currentMsg) {
            currentMsg.isStarred = false;
          }

          this.showToast('Removed from saved questions', 'success');
        }
      }
    });
  }

  deleteFromSaved(message: any, event: Event): void {
    event.stopPropagation();
    const messageId = message.MessageId || message.messageId || message.id;
    if (!messageId) return;

    if (!confirm('Are you sure you want to delete this question?')) return;

    this.apiService.updateChatStarred(messageId, false).subscribe({
      next: () => {
        this.apiService.deleteChatMessage(messageId).subscribe({
          next: (res: string) => {
            const apiResponse = JSON.parse(res);
            if (apiResponse.HasValidData) {
              // Remove from local lists
              const beforeCount = this.starredMessages.length;
              this.starredMessages = this.starredMessages.filter(m => {
                const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
                const targetId = (messageId || '').toString().toLowerCase();
                return mId !== targetId;
              });
              this.onStarredSearch();

              // Update allChatList
              this.allChatList.forEach(chat => {
                if (chat.ChatHistory) {
                  const idx = chat.ChatHistory.findIndex((h: any) => {
                    const hId = (h.MessageId || h.messageId || '').toString().toLowerCase();
                    const targetId = (messageId || '').toString().toLowerCase();
                    return hId === targetId;
                  });
                  if (idx > -1) {
                    chat.ChatHistory.splice(idx, 1);
                  }
                }
              });

              // Remove from chatPreviewBlocks if it exists
              const chatObj = this.chatPreviewBlocks.find(b => {
                const bId = (b.messageId || '').toString().toLowerCase();
                const targetId = (messageId || '').toString().toLowerCase();
                return bId === targetId;
              });
              
              if (chatObj) {
                const pIndex = this.chatPreviewBlocks.indexOf(chatObj);
                if (pIndex > -1) this.chatPreviewBlocks.splice(pIndex, 1);
              }

              // Handle current view if deleting the active message or if list is empty
              if (messageId === this.selectedMessageId || this.chatPreviewBlocks.length === 0) {
                this.selectedMessageId = null;
                this.displayTable = false;
                this.showSnapshot = false;
                this.clearOutputDataObject();
                this.isInsightspopupOpen = false;

                if (this.chatPreviewBlocks.length === 0) {
                  this.navigateToLanding();
                }
              }

              this.showToast('Question deleted successfully', 'success');
            }
          }
        });
      },
      error: () => {
        console.warn('[deleteFromSaved] ⚠️ Pre-emptive unstar failed, proceeding with delete anyway');
        // Fallback to just delete if unstar fails
        this.apiService.deleteChatMessage(messageId).subscribe();
      }
    });
  }

  onStarredQuestionClick(message: { MessageId: string; Question: string; ChatId: string }): void {
    this.isSavedQuestionsOpen = false;
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === message.MessageId));

    if (chat) {
      const specificMsg = chat.ChatHistory?.find(h => h.MessageId === message.MessageId);

      if (specificMsg) {
        this.chatPreviewBlocks = [
          ChatHistoryHelper.createChatPreviewBlock(specificMsg, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
        ];

        this.newChatId = chat.ChatId || null;
        this.guidChatId = chat.ChatId || '';
        this.selectedChatId = chat.ChatId || null;
        this.currentView = 'chat';
      }
    } else {
      // Fallback if chat is not in current list
      this.chatPreviewBlocks = [
        ChatHistoryHelper.createChatPreviewBlock({
          Question: message.Question || '',
          MessageId: message.MessageId,
          IsStarred: true
        }, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
      ];
      this.guidChatId = message.ChatId || message.MessageId;
      this.selectedChatId = message.ChatId || message.MessageId;
      this.currentView = 'chat';
    }

    this.selectedMessageId = message.MessageId;
    this.getChatResponse(message.MessageId, true);
  }


  closeChatHistory(): void {
    this.isChatHistoryOpen = false;
  }

  closeSavedQuestions(): void {
    this.isSavedQuestionsOpen = false;
  }

  toggleChatArea(): void {
    this.isChatAreaVisible = !this.isChatAreaVisible;
  }

  onSendMessage(): void {
    if (this.arktabaccess) {
      console.warn('[SEND GUARD] Cannot send new message - previous question still processing');
      return;
    }

    if (this.searchText && this.searchText.trim()) {
      this.inputValue = this.searchText.trim();
      this.isNewChatSession = false;
      this.selectedMessageId = null;
      this.sendInputMessage();
      this.searchText = '';
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      if (this.chatHistoryScroll && this.chatHistoryScroll.nativeElement) {
        const element = this.chatHistoryScroll.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 100);
  }

  scrollToMessage(messageId: string | undefined, align: 'start' | 'end' = 'end'): void {
    if (!messageId) {
      this.scrollToBottom();
      return;
    }

    // Explicitly show/keep the loader spinning during background rendering and scroll wait, EXCEPT for new questions
    const targetBlock = this.chatPreviewBlocks.find(b => b.messageId === messageId);
    const isTempQuery = targetBlock?.isTemp || false;
    if (!isTempQuery) {
      // this._loaderService.showLoader();
    }

    let attempts = 0;
    const maxAttempts = 25; // Wait/poll for up to 2.5 seconds (handles complex API response rendering)
    let lastHeight = 0;
    let heightStableCount = 0;

    const tryScroll = () => {
      const element = document.getElementById('message-' + messageId);
      const container = this.chatHistoryScroll?.nativeElement;

      if (element && container) {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const currentHeight = elementRect.height;


        // Track height stability (ensure it is actually rendered with a positive height)
        const isStable = currentHeight > 10 && Math.abs(currentHeight - lastHeight) < 5;

        // Enforce a minimum loader spin duration of 6 attempts (600ms) for historical scroll targets
        if (isStable && (isTempQuery || attempts >= 6)) {
          heightStableCount++;
        } else if (!isStable) {
          heightStableCount = 0; // Still rendering, expanding, or waiting for highcharts
        }

        lastHeight = currentHeight;

        // When height has stabilized, trigger the single smooth scroll
        if (heightStableCount === 3) {
          let targetScrollTop = 0;
          if (align === 'start') {
            // Align the top of the new question header with the top of the container
            targetScrollTop = container.scrollTop + elementRect.top - containerRect.top;
          } else {
            // Align the bottom of the element with the bottom of the container
            const relativeElementBottom = elementRect.bottom - containerRect.top;
            targetScrollTop = container.scrollTop + relativeElementBottom - containerRect.height + 24;
          }

          container.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth'
          });

          setTimeout(() => {
            this.isScrollingToTarget = false;
          }, 1000);

          // Defensively ensure loader is closed, EXCEPT for new questions (which are still streaming answers)
          if (!isTempQuery) {
            this.scrollSpacerHeight = 0; // Collapses the spacer only when real content has finished rendering and is scrolled!
            this._loaderService.hideLoader();
            this.stopAiLoader();
            this.arktabaccess = false;
          }
          return;
        }
      }

      if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryScroll, 100);
      } else {
        console.warn('[SCROLL-DEBUG] Timed out waiting for render stabilization. Force scrolling smoothly...');
        this.isScrollingToTarget = false;
        if (!isTempQuery) {
          this.scrollSpacerHeight = 0;
          this._loaderService.hideLoader();
          this.stopAiLoader();
          this.arktabaccess = false;
        }
        if (element && container) {
          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          let targetScrollTop = 0;
          if (align === 'start') {
            targetScrollTop = container.scrollTop + elementRect.top - containerRect.top;
          } else {
            const relativeElementBottom = elementRect.bottom - containerRect.top;
            targetScrollTop = container.scrollTop + relativeElementBottom - containerRect.height + 24;
          }
          container.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
        } else {
          this.scrollToBottom();
        }
      }
    };

    // Start tracking immediately
    setTimeout(tryScroll, 50);
  }

  toggleView(): void {
    this.isListView = !this.isListView;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getGridImage(index: number): string {
    const imageNumber = (index % 6) + 1;
    return `url('/assets/ImagesAskme/Grid_${String(imageNumber).padStart(2, '0')}.jpg')`;
  }

  truncateText(text: string, maxLength: number = 150): string {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + '...';
  }

  navigateToChat(): void {
    this.currentView = 'chat';
    this.isNewChatSession = false;
    this.isMultiQuestionMode = false;
  }

  navigateToLanding(): void {
    if (this.guidChatId) {
      this.abandoningSessionId = this.guidChatId;
      this.isNewChatStarted = true;
    }
    this.currentView = 'landing';
    this.isMultiQuestionMode = false;
    this.chatPreviewBlocks = [];
    this.guidChatId = '';
    this.validatedSessionId = '';
    this.newChatId = null;
    this.selectedChatId = null;
    this.selectedMessageId = null;
    this.inputValue = '';
    this.searchText = '';
    this.isNewChatSession = true;
  }

  onCloseChatHistory(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.closeChatHistory();
      this.isClosing = false;
    }, 300);
  }

  onBackClickChatHistory(): void {
    this.onCloseChatHistory();
  }

  toggleAccordion(item: any): void {
    if (item.isExpanded) {
      item.isExpanded = false;
      item.isCollapsing = true;
      clearTimeout(item.collapseTimer);
      item.collapseTimer = setTimeout(() => {
        item.isCollapsing = false;
      }, 550);
      return;
    }

    clearTimeout(item.collapseTimer);
    item.isCollapsing = false;
    item.isExpanded = true;
  }

  toggleMonthGroup(group: any): void {
    group.isExpanded = !group.isExpanded;
    if (!group.isExpanded && group.chats) {
      group.chats.forEach((chat: any) => {
        chat.isExpanded = false;
        chat.isCollapsing = false;
        clearTimeout(chat.collapseTimer);
      });
    }
  }

  onChatHeaderQuestionClick(item: any): void {
    this.isChatHistoryOpen = false;
    if (item.mainQuestionMessageId) {
      this.getChatResponse(item.mainQuestionMessageId);
    }
  }

  onCloseSavedQuestions(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.closeSavedQuestions();
      this.isClosing = false;
    }, 300);
  }

  onBackClickSavedQuestions(): void {
    this.onCloseSavedQuestions();
  }

  // --- Multi-Question Logic ---
  showTemplatePrompt: boolean = false;
  pendingFileInput: HTMLInputElement | null = null;

  toggleMultiQuestionMode(): void {
    this.isMultiQuestionMode = !this.isMultiQuestionMode;
    if (!this.isMultiQuestionMode) {
      this.showTemplatePrompt = false;
      this.pendingFileInput = null;
    }
    if (this.isMultiQuestionMode && this.multiQuestionList.length === 0) {
      this.multiQuestionList = [''];
    }
  }

  addMultiQuestion(): void {
    if (this.multiQuestionList.length >= 10) {
      this.showToast('You can only add up to 10 questions at a time.', 'info');
      return;
    }
    this.multiQuestionList.push('');
    setTimeout(() => {
      const mqList = document.querySelector('.mq-list');
      if (mqList) {
        mqList.scrollTop = mqList.scrollHeight;
        const inputs = mqList.querySelectorAll('.mq-input');
        if (inputs.length > 0) {
          (inputs[inputs.length - 1] as HTMLElement).focus();
        }
      }
    }, 0);
  }

  promptForTemplate(fileInput: HTMLInputElement): void {
    this.pendingFileInput = fileInput;
    this.showTemplatePrompt = true;
  }

  handleTemplateSelection(download: boolean): void {
    this.showTemplatePrompt = false;
    if (download) {
      this.downloadBatchTemplate();
    } else if (this.pendingFileInput) {
      this.pendingFileInput.click();
    }
    this.pendingFileInput = null;
  }

  downloadBatchTemplate(): void {
    const templateData = [
      ['Question'],
      ['What are the top 5 brands by sales?'],
      ['Show me the monthly revenue trend.']
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(templateData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
    XLSX.writeFile(workbook, 'Batch_Questions_Template.xlsx');
  }

  onBatchExcelUpload(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        const jsonData = XLSX.utils.sheet_to_json<any[]>(worksheet, { header: 1 });
        const extractedQuestions: string[] = [];
        
        for (let i = 0; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row && row.length > 0 && row[0]) {
            const question = String(row[0]).trim();
            // Skip the header row if it exists
            if (question && question.toLowerCase() !== 'question') {
              extractedQuestions.push(question);
            }
          }
        }
        
        if (extractedQuestions.length > 0) {
          if (this.multiQuestionList.length === 1 && !this.multiQuestionList[0].trim()) {
            this.multiQuestionList = extractedQuestions;
          } else {
            this.multiQuestionList = [...this.multiQuestionList, ...extractedQuestions];
          }
          
          if (this.multiQuestionList.length > 10) {
            this.multiQuestionList = this.multiQuestionList.slice(0, 10);
            this.showToast('You can only upload up to 10 questions at a time. Extra questions were removed.', 'info');
          } else {
             this.showToast('Questions loaded from Excel successfully.', 'success');
          }
        } else {
          this.showToast('No valid questions found in the Excel file.', 'info');
        }
      } catch (err) {
        console.error('Error parsing Excel file:', err);
        this.showToast('Failed to parse the Excel file.', 'error');
      }
      target.value = '';
    };
    reader.readAsArrayBuffer(file);
  }

  removeMultiQuestion(index: number): void {
    this.multiQuestionList.splice(index, 1);
    if (this.multiQuestionList.length === 0) {
      this.multiQuestionList = [''];
    }
  }

  get hasValidMultiQuestions(): boolean {
    return this.multiQuestionList.some(q => q && q.trim().length > 0);
  }

  sendMultiQuestions(): void {
    const validQuestions = this.multiQuestionList.map(q => q.trim()).filter(q => q.length > 0);
    
    if (validQuestions.length === 0) {
      this.isMultiQuestionMode = false;
      return;
    }

    this.queuedQuestions = validQuestions;
    this.isProcessingQueue = true;
    this.isMultiQuestionMode = false;
    this.multiQuestionList = [''];

    this.processNextQueuedQuestion();
  }

  processNextQueuedQuestion(): void {
    if (this.queuedQuestions.length > 0) {
      const nextQ = this.queuedQuestions.shift();
      if (nextQ) {
        this.searchForm.patchValue({ query: nextQ });
        this.onSearchSubmit();
      }
    } else {
      this.isProcessingQueue = false;
    }
  }

  onSearchSubmit(): void {
    if (this.isDictating) {
      this.stopDictation();
    }

    const searchQuery = this.searchForm.get('query')?.value;
    if (searchQuery && searchQuery.trim()) {
      // Guard: Prevent sending new message while previous question is still processing
      if (this.arktabaccess) {
        console.warn('[SEND GUARD] Cannot send search query - previous question still processing');
        return;
      }

      this.isMultiQuestionMode = false;
      this.inputValue = searchQuery.trim();
      this.currentView = 'chat';
      this.selectedMessageId = null;
      this.isHistorySaving = true;
      this.sendInputMessage();
      this.searchForm.patchValue({ query: '' });
    }
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    let dataFormat;
    data = data.filter((a: any) => a.study === study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None'
        );
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value
        );
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected);
      }

      if (data[0].dataformat.length > 0) {
        dataFormat = data[0].dataformat.filter((a: any) => a.value);
      }
      this.aggregatedVariables = data[0].aggregatedvariables;
    }
  }

  Summary() {
    const content =
      this.inforRibbon != undefined
        ? this.inforRibbon.nativeElement.textContent
        : '';
    return content;
  }

  private getOrchestrationRequest(): Observable<any> {
    return from(this.getBearerToken()).pipe(
      tap(token => this.currentOrchToken = token),
      switchMap(token => {
        const modules = this.modulesAccess || {};

        const findModuleAccess = (searchKey: string) => {
          const actualKey = Object.keys(modules).find(k => k.toLowerCase() === searchKey.toLowerCase());
          return actualKey ? modules[actualKey]?.has_access : false;
        };

        const hasSnapshot = findModuleAccess('snapshot');
        const hasCrosstab = findModuleAccess('crosstab');
        const hasBrandAnalysis = findModuleAccess('brand_analysis') || findModuleAccess('brandanalysis');

        const activeCount = [hasSnapshot, hasCrosstab, hasBrandAnalysis].filter(v => v).length;
        this.hasSnapshotActive = hasSnapshot;
        this.hasCrosstabActive = hasCrosstab;
        this.hasBrandAnalysisActive = hasBrandAnalysis;


        const currentWidgetDetails = {
          widget_name: this.widget_Name || '',
          widget_id: this.widget_Id || ''
        };

        // CASE 1: Single Module Access (Direct Specialized Call)
        if (activeCount === 1) {
          if (hasSnapshot) {
            return this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.currentQueryForStream, true, false, true, 0, currentWidgetDetails);
          } else if (hasCrosstab) {
            return this.apiService.crosstabAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.currentQueryForStream, true, false, true, 0, currentWidgetDetails);
          } else if (hasBrandAnalysis) {
            return this.apiService.brandAnalysisAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.currentQueryForStream, true, false, true, 0, currentWidgetDetails);
          }
        }

        // CASE 2: Multi-Module Access (Mcode Decider Strategy)
        if (activeCount > 1) {

          return new Observable(observer => {
            const decider$ = this.apiService.mcodeChatAgentStream(
              this.selected_client, this.selected_study, this.guidChatId, token, this.currentQueryForStream,
              true, false, hasSnapshot, hasCrosstab, hasBrandAnalysis, true, 0
            ).pipe(shareReplay(1));


            // Helper to execute FULL lifecycle (Stream + Payload) for a module
            const executeTask = (mcode: number, query: string, primaryMcode: number): Observable<any> => {
              const msgId: string = this.selectedMessageId || (this.chatPreviewBlocks.length > 0 ? (this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].messageId || 'current') : 'current');
              if (!this.inFlightPreFetches[msgId]) this.inFlightPreFetches[msgId] = new Set();
              this.inFlightPreFetches[msgId].add(mcode);

              const currentWidgetDetails = {
                widget_name: this.widget_Name || '',
                widget_id: this.widget_Id || ''
              };

              const stream$ = mcode === 1 ? this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0, currentWidgetDetails) :
                (mcode === 2 ? this.apiService.brandAnalysisAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0, currentWidgetDetails) :
                  this.apiService.crosstabAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0, currentWidgetDetails));

              return new Observable(obs => {
                let streamMetadata: any = null;
                const sSub = stream$.subscribe({
                  next: (event) => {
                    if (event && event.event === 'final_result') {
                      streamMetadata = event;
                    } else if (event && event.event === 'status') {
                      obs.next(event);
                    } else if (event && event.event !== 'done' && event.event !== 'meta') {
                      obs.next(event);
                    }
                  },
                  error: (err) => {
                    this.inFlightPreFetches[msgId].delete(mcode);
                    obs.error(err);
                  },
                  complete: () => {
                    if (!streamMetadata) {
                      this.inFlightPreFetches[msgId].delete(mcode);
                      obs.error(`Stream ${mcode} result missing`);
                      return;
                    }

                    const rawData = streamMetadata.data;
                    const resData = rawData.result || rawData.final_output || rawData;
                    const payloadParams = {
                      session_id: this.validatedSessionId || msgId,
                      study: this.selected_study,
                      client_name: this.selected_client,
                      bearer_token: token, mcode: mcode, significance: "None", confidence_level: "None",
                      base: "ANSWER", weight: resData.weight || resData.Weight || this.selectedWeight || "Unweighted"
                    };

                    let specialized: any = null;
                    if (mcode === 1) {
                      this.widget_Id = resData.Widget_ID || resData.widget_id || this.widget_Id;
                      this.widget_Name = resData.Widget_Name || resData.widget_name || this.widget_Name;
                      specialized = { ...payloadParams, snapshot_type: resData.snapshot_type || resData.Snapshot_Type, primary_brands: resData.Primary_Brands || resData.primary_brands, primary_metrics: resData.Primary_Metrics || resData.primary_metrics || resData.primary_metircs, market: resData.Markets || resData.market, timeperiod: resData.Time_Period || resData.timeperiod, Filter_Audience: resData.Filter_Audience || resData.filter_audience, Metric_Filters: resData.Metric_Filters || resData.metric_filters, Snapshot_Name: resData.Snapshot_Name || resData.snapshot_name, Section: resData.Section || resData.section, Widget_ID: this.widget_Id, Widget_Name: this.widget_Name, selected_doc_id: resData.selected_doc_id, snapshot_index: rawData.snapshot_index, widget_snapshot_index: rawData.widget_snapshot_index };
                    } else {
                      specialized = { ...payloadParams, row: resData.Row, column: resData.Column, row_nesting: resData.Row_Nesting, column_nesting: resData.Column_Nesting, filters: resData.Filters, brand_analysis_index: rawData.brand_analysis_index, crosstab_index: rawData.crosstab_index };
                    }

                    const payload$ = mcode === 1 ? this.apiService.snapshotPayloadAPI(specialized) :
                      (mcode === 2 ? this.apiService.brandAnalysisPayloadAPI(specialized) :
                        this.apiService.crosstabPayloadAPI(specialized));

                    payload$.subscribe({
                      next: (payloadRes: any) => {
                        const dataStr = payloadRes?.response?.Data || payloadRes?.Data;
                        const isEmpty = dataStr === '[]' || dataStr === '"{}"' || dataStr === '{}' || (Array.isArray(dataStr) && dataStr.length === 0);
                        
                        if (isEmpty || !dataStr) {
                           console.warn(`[ORCHESTRATION] Payload returned empty Data for mcode: ${mcode}. Disqualifying module.`);
                           this.inFlightPreFetches[msgId].delete(mcode);
                           obs.error(`Empty data for mcode ${mcode}`);
                           return;
                        }

                        // Populate cache immediately so main flow can use it
                        if (!this.multiViewDataCache[msgId]) this.multiViewDataCache[msgId] = {};
                        this.multiViewDataCache[msgId][mcode] = payloadRes;

                        // Emit immediately to unblock UI render!
                        obs.next({
                          event: 'final_result',
                          mcode: mcode,
                          isPreFetched: true,
                          data: rawData,
                          payloadParams: specialized,
                          payload: payloadRes,
                          insights: null // Insights will stream later in the UI
                        });
                        obs.complete();

                        // Fire and forget insights fetch for background caching (ONLY for secondary modules)
                        if (mcode !== primaryMcode) {
                          this.fetchInsightsAsObservable(mcode, payloadRes, msgId, specialized).subscribe({
                            next: (insightsResult) => {
                              this.inFlightPreFetches[msgId].delete(mcode);
                            },
                            error: (err) => {
                              console.warn(`[ORCHESTRATION] Insights pre-fetch failed for mcode: ${mcode} in background.`, err);
                              this.inFlightPreFetches[msgId].delete(mcode);
                            }
                          });
                        } else {
                          // For primary module, we skip background fetch so callInsightsAPI can stream it to the UI!
                          this.inFlightPreFetches[msgId].delete(mcode);
                        }
                      },
                      error: (err) => {
                        this.inFlightPreFetches[msgId].delete(mcode);
                        obs.error(err);
                      }
                    });
                  }
                });
                return () => sSub.unsubscribe();
              });
            };

            const deciderSub = decider$.subscribe({
              next: (event: any) => {
                if (event && event.event === 'status') {
                  observer.next(event);
                  return;
                }
                if (event && event.event !== 'final_result' && event.event !== 'done' && event.event !== 'meta') {
                  observer.next(event);
                  return;
                }

                if (event && event.event === 'final_result' && event.data) {
                  const rawData = event.data;
                  const resData = rawData.result || rawData;
                  const rankingStr = resData.priority_order || resData.mcode_ranking || '';
                  let priorityMcode = resData.priority_mcode;
                  const optimizedQuery = resData.resolved_question || resData.question || this.inputValue;

                  deciderSub.unsubscribe();


                  let mcodeRanking: number[] = [];
                  if (rankingStr && typeof rankingStr === 'string' && rankingStr.trim() !== '') {
                    const digits = rankingStr.match(/\d+/g)?.map(d => parseInt(d)) || [];
                    mcodeRanking = rankingStr.includes('=') && !rankingStr.includes('>') ? [...digits].reverse() : [...digits];
                  } else if (priorityMcode) {
                    const p = parseInt(priorityMcode.toString());
                    if (p === 1) mcodeRanking = [1, 2, 3];
                    else if (p === 2) mcodeRanking = [2, 1, 3];
                    else if (p === 3) mcodeRanking = [3, 2, 1];
                    else mcodeRanking = [p];
                  }

                  // Access Filtering + Completeness
                  mcodeRanking = mcodeRanking.filter(m => (m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab));
                  [1, 2, 3].forEach(m => {
                    if (((m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab)) && !mcodeRanking.includes(m)) {
                      mcodeRanking.push(m);
                    }
                  });
                  mcodeRanking = Array.from(new Set(mcodeRanking));

                  if (mcodeRanking.length === 0) { observer.error('No valid mcodes'); return; }
                  console.log('[ORCHESTRATION] Final Sequence:', mcodeRanking);

                  // Parallel Pre-fetch all Tasks
                  const taskMap: { [key: number]: Observable<any> } = {};
                  if (hasSnapshot) taskMap[1] = executeTask(1, optimizedQuery, priorityMcode).pipe(shareReplay(1));
                  if (hasBrandAnalysis) taskMap[2] = executeTask(2, optimizedQuery, priorityMcode).pipe(shareReplay(1));
                  if (hasCrosstab) taskMap[3] = executeTask(3, optimizedQuery, priorityMcode).pipe(shareReplay(1));

                  // Start all tasks: forward status ONLY for priority module, others run silently in background
                  Object.entries(taskMap).forEach(([key, t$]) => {
                    const mcodeNum = parseInt(key);
                    t$.subscribe({
                      next: (event) => {
                        if (event && event.event === 'status' && mcodeNum === priorityMcode) {
                          observer.next(event);
                        }
                      },
                      error: (err) => console.warn(`[ORCHESTRATION] Task stream error for mcode ${key}:`, err)
                    });
                  });

                  // Parallel execution of all tasks, collecting all successes for multi-view
                  const allTasks$ = forkJoin(
                    Object.keys(taskMap).reduce((acc: any, key) => {
                      const m = parseInt(key);
                      acc[key] = taskMap[m].pipe(
                        catchError((err) => {
                          console.warn(`[ORCHESTRATION] Task ${m} failed:`, err);
                          if (m === priorityMcode) {
                            const idx = mcodeRanking.indexOf(m);
                            const nextMcode = mcodeRanking[idx + 1];
                            if (nextMcode) {
                              const moduleName = nextMcode === 1 ? 'Snapshot' : (nextMcode === 2 ? 'Brand Analysis' : 'Crosstab');
                              observer.next({ event: 'status', message: `Primary module failed. Switching to ${moduleName}...` });
                              priorityMcode = nextMcode; // Forward status events from the new fallback module!
                            }
                          }
                          return of(null);
                        })
                      );
                      return acc;
                    }, {})
                  );

                  allTasks$.subscribe({
                    next: (results: any) => {
                      // Find the primary result based on ranking order. This inherently allows fallback if the priority module completely failed (returned null)
                      const primaryMcode = mcodeRanking.find(m => results[m] && results[m].event === 'final_result');

                      if (!primaryMcode) {
                        observer.error('All analytical agents failed to return a result.');
                        return;
                      }

                      const primaryResult = results[primaryMcode];

                      // Gather all successful payloads into member_responses for multi-view switcher
                      const member_responses: any = {};
                      Object.keys(results).forEach(key => {
                        const res = results[key];
                        if (res && res.event === 'final_result') {
                          const m = parseInt(key);
                          const moduleKey = m === 1 ? 'snapshot' : (m === 2 ? 'brand_analysis' : 'crosstab');
                          member_responses[moduleKey] = res.data?.result || res.data?.final_output || res.data || {};
                        }
                      });

                      // Attach member_responses to the primary result's data object
                      if (primaryResult.data) {
                        primaryResult.data.member_responses = {
                          ...(primaryResult.data.member_responses || {}),
                          ...member_responses
                        };
                      }

                      observer.next(primaryResult);
                      observer.complete();
                    },
                    error: (err) => observer.error(err)
                  });
                }
              },
              error: (err: any) => {
                console.error('[ORCHESTRATION] Decider failed. Absolute fallback.');
                const fallbackRanking = [1, 2, 3].filter(m => (m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab));
                if (fallbackRanking.length === 0) { observer.error('No access'); return; }

                const firstFallbackName = fallbackRanking[0] === 1 ? 'Snapshot' : (fallbackRanking[0] === 2 ? 'Brand Analysis' : 'Crosstab');
                observer.next({ event: 'status', message: `Routing failed. Falling back to ${firstFallbackName}...` });

                const fbMap: { [key: number]: Observable<any> } = {};
                fallbackRanking.forEach(m => fbMap[m] = executeTask(m, this.inputValue, fallbackRanking[0]).pipe(shareReplay(1)));
                Object.values(fbMap).forEach(t$ => t$.subscribe({ error: () => { } }));

                const allFallbackTasks$ = forkJoin(
                  Object.keys(fbMap).reduce((acc: any, key) => {
                    const m = parseInt(key);
                    acc[key] = fbMap[m].pipe(catchError(() => of(null)));
                    return acc;
                  }, {})
                );

                allFallbackTasks$.subscribe({
                  next: (results: any) => {
                    const primaryMcode = fallbackRanking.find(m => results[m]);
                    if (!primaryMcode) { observer.error('Absolute fallback failed'); return; }

                    const primaryResult = results[primaryMcode];
                    const member_responses: any = {};
                    Object.keys(results).forEach(key => {
                      const res = results[key];
                      if (res && res.event === 'final_result') {
                        const m = parseInt(key);
                        const moduleKey = m === 1 ? 'snapshot' : (m === 2 ? 'brand_analysis' : 'crosstab');
                        member_responses[moduleKey] = res.data?.result || res.data?.final_output || res.data || {};
                      }
                    });

                    if (primaryResult.data) {
                      primaryResult.data.member_responses = member_responses;
                    }

                    observer.next(primaryResult);
                    observer.complete();
                  },
                  error: (e) => observer.error(e)
                });
              }
            });
            return () => deciderSub.unsubscribe();
          });
        }

        // FALLBACK: If count is 0 or other logic fails
        return this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue, true, false, true, 0);
      })
    );
  }

  private queueStatusMessage(msg: string) {
    if (msg) {
      this.statusQueue.push(msg);
      if (!this.isProcessingStatusQueue) {
        this.processNextStatus();
      }
    }
  }

  private processNextStatus() {
    if (this.statusQueue.length === 0) {
      this.isProcessingStatusQueue = false;
      return;
    }

    this.isProcessingStatusQueue = true;
    const nextMsg = this.statusQueue.shift();
    if (nextMsg) {
      this.streamStatusText = nextMsg;
    }

    setTimeout(() => {
      this.processNextStatus();
    }, 800); // Display each technical step for at least 800ms
  }

  populateWeightDropdown(): void {
    if (!this.variableTabData || (Array.isArray(this.variableTabData) && this.variableTabData.length === 0)) {
      this.variableTabData = this.crossTabService.getVarTabData || [];
    }

    this.WeightDropDownList = [];
    this.weightFilter = {};

    this.configWeights?.filter((x: any) => x.is_selected).forEach((x: any) => { // only selected weights
      let WeightedData = this.variableTabData.filter(
        (a: any) => a.data_variable_code === x.variable_code
      );

      if (x.variable_label === 'Unweighted') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_label,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_label;

      } else if (x.variable_label.trim() === 'Boost Factor') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_code,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_code;

      } else {
        if (WeightedData.length > 0) {
          this.WeightDropDownList.push({
            Label: WeightedData[0].Level1,
            responseCode: WeightedData[0].data_variable_code,
            tooltip: WeightedData[0].tooltip,
          });
          this.weightFilter[WeightedData[0].Level1] = WeightedData[0].data_variable_code;
        } else {
          // Fallback when variableTabData has no match: map to Primary/Secondary Weight labels
          const nonSpecialCount = this.WeightDropDownList.filter(
            (w: any) => w.Label !== 'Unweighted' && w.Label !== 'Boost Factor'
          ).length;
          const weightLabel = nonSpecialCount === 0 ? 'Primary Weight'
            : nonSpecialCount === 1 ? 'Secondary Weight'
              : `Weight ${nonSpecialCount + 1}`;
          this.WeightDropDownList.push({
            Label: weightLabel,
            responseCode: x.variable_code,
            tooltip: x.variable_label,
          });
          this.weightFilter[weightLabel] = x.variable_code;
        }
      }
    });

    if (this.WeightDropDownList.length > 0 && this.DefaultWeight == '') {
      const defaultWeightObj = this.configWeights?.find((x: any) => 
        x.is_default === true || 
        x.is_active === true || 
        x.is_default_weight === true || 
        x.default === true
      );

      let matchedDropdown;
      if (defaultWeightObj) {
        matchedDropdown = this.WeightDropDownList.find(w => w.responseCode === defaultWeightObj.variable_code || (defaultWeightObj.variable_label === 'Unweighted' && w.Label === 'Unweighted'));
      }

      if (matchedDropdown) {
        this.DefaultWeight = matchedDropdown.Label;
        this.selectedWeight = matchedDropdown.responseCode;
      } else {
        const primaryWeight = this.WeightDropDownList.find(w => w.Label === 'Primary Weight');
        if (primaryWeight) {
          this.DefaultWeight = primaryWeight.Label;
          this.selectedWeight = primaryWeight.responseCode;
        } else {
          const unweighted = this.WeightDropDownList.find(w => w.Label === 'Unweighted' || w.responseCode === 'Unweighted');
          if (unweighted) {
            this.DefaultWeight = unweighted.Label;
            this.selectedWeight = unweighted.responseCode;
          } else {
            this.DefaultWeight = this.WeightDropDownList[0].Label;
            this.selectedWeight = this.WeightDropDownList[0].responseCode;
          }
        }
      }
      this._configService.weightLabel = this.DefaultWeight;
    }
  }

  isSelected(SelectedValue: string, block?: any): boolean {
    const target = block || this;
    return target.selectedIndex === SelectedValue;
  }

  isSelectedSignificance(SelectedValue: string, block?: any): boolean {
    const target = block || this;
    return target.SignificanceVsReference === SelectedValue;
  }

  // Strip parent prefix from nested child values (e.g., "Audience|Gender|Male" -> "Gender|Male")
  private normalizeNestedChildFields(data: any[]): void {
    if (!data?.length) return;
    const normalize = (val: string) => {
      if (!val) return val;
      const p = val.split('|');
      return p.length >= 3 ? p.slice(1).join('|') : val;
    };
    data.forEach(item => {
      if (item.Level1RowChild) item.Level1RowChild = normalize(item.Level1RowChild);
      if (item.Level2RowChild) item.Level2RowChild = normalize(item.Level2RowChild);
      if (item.Level1ColChild) item.Level1ColChild = normalize(item.Level1ColChild);
      if (item.Level2ColChild) item.Level2ColChild = normalize(item.Level2ColChild);
      if (item.rowChild) item.rowChild = normalize(item.rowChild);
      if (item.colChild) item.colChild = normalize(item.colChild);
    });
  }

  // Strip |Yes or |No from Child fields in Brand Analysis payload
  private cleanBrandAnalysisChild(obj: any): void {
    if (!obj || typeof obj !== 'object') return;

    if (Array.isArray(obj)) {
      for (const item of obj) {
        this.cleanBrandAnalysisChild(item);
      }
    } else {
      const childKeys = ['Child', 'rowChild', 'colChild', 'Level1RowChild', 'Level2RowChild', 'Level1ColChild', 'Level2ColChild', 'Parent'];
      for (const key of childKeys) {
        if (typeof obj[key] === 'string') {
          if (obj[key].endsWith('|Yes')) {
            obj[key] = obj[key].substring(0, obj[key].length - 4);
          } else if (obj[key].endsWith('|No')) {
            obj[key] = obj[key].substring(0, obj[key].length - 3);
          }
        }
      }
      for (const key of Object.keys(obj)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.cleanBrandAnalysisChild(obj[key]);
        }
      }
    }
  }


  BindTableOutput(CrossTabOuputData: any, block: any = null) {
    const target = block || this;

    // Always replace the reference to trigger Angular Change Detection (OnPush), while preserving other props
    target.OutputdataObject = { ...(target.OutputdataObject || {}), Row: [], Column: [] } as any;

    target.CrossTabOutPutData = (target.CrossTabOutPutData || []).filter(
      (a: CrossTabOutputItem) => a.colChild !== null
    );

    target.CrossTabOutPutData.forEach((item: CrossTabOutputItem, index: number) => {
      const selections = TableOutputProcessorHelper.createSelections(item);
      const parents = TableOutputProcessorHelper.createParentObjects(item, selections);

      TableOutputProcessorHelper.processParent(parents.row, target.OutputdataObject.Row, selections.nested.row);
      TableOutputProcessorHelper.processParent(parents.col, target.OutputdataObject.Column, selections.nested.col);
    });

    // CRITICAL: Attach flatData to the OutputdataObject for lookup in TableOutputComponent
    target.OutputdataObject.flatData = CrossTabOuputData;


    // If updating a historical block, also update builtTableData to ensure getOutputData() returns the fresh state
    if (block) {
      block.builtTableData = block.OutputdataObject;
    }
  }

  replacePipe(input: string): string {
    let cleaned = input;
    if ((this.mcode == 2 || this.mcode == 3) && typeof cleaned === 'string') {
      if (cleaned.endsWith('|Yes')) cleaned = cleaned.substring(0, cleaned.length - 4);
      else if (cleaned.endsWith('|No')) cleaned = cleaned.substring(0, cleaned.length - 3);
    }
    return SelectionSummaryHelper.replacePipe(cleaned);
  }

  onTableIconClick(block: any = null) {
    const target = block || this;
    target.isTableClick = true;
    this.updateChartDisablingFlags(block);
    this.resetChartStates('table', block);
  }

  sortOutputData(block: any = null) {
    const target = block || this;
    if (!target.OutputdataObject) return;

    const targetDataObject = target.dataObject && target.dataObject.Row && target.dataObject.Row.length > 0 ? target.dataObject : this.dataObject;

    target.OutputdataObject.Row.sort((a: any, b: any) => {
      const indexA = targetDataObject.Row.findIndex(
        (item: any) => item.Parent === a.Parent
      );
      const indexB = targetDataObject.Row.findIndex(
        (item: any) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    target.OutputdataObject.Column.sort((a: any, b: any) => {
      const indexA = targetDataObject.Column.findIndex(
        (item: any) => item.Parent === a.Parent
      );
      const indexB = targetDataObject.Column.findIndex(
        (item: any) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    target.OutputdataObject.Row.forEach((row: any) => {
      const parentData = targetDataObject.Row.find(
        (item: any) => item.Parent === row.Parent
      );
      if (parentData) {
        row.Data.sort((a: any, b: any) => {
          const indexA = parentData.Data.findIndex(
            (data: any) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data: any) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    target.OutputdataObject.Row.forEach((row: any) => {
      row.Data.forEach((outputSelection: any) => {
        targetDataObject.RowNesting.forEach((rowNest: any) => {
          this.sortByChildIndex(outputSelection.NestedArray, rowNest.Data);
        });
      });
    });

    target.OutputdataObject.Row.forEach((row: any) => {
      row.Data.forEach((outputSelection: any) => {
        outputSelection.NestedArray.forEach((nestedItem: any) => {
          targetDataObject.RowNesting.forEach((rowNest: any) => {
            this.sortByChildIndex(nestedItem.NestedArray, rowNest.Data);
          });
        });
      });
    });

    target.OutputdataObject.Column.forEach((col: any) => {
      const parentData = targetDataObject.Column.find(
        (item: any) => item.Parent === col.Parent
      );
      if (parentData) {
        col.Data.sort((a: any, b: any) => {
          const indexA = parentData.Data.findIndex(
            (data: any) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data: any) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    target.OutputdataObject.Column.forEach((col: any) => {
      col.Data.forEach((outputSelection: any) => {
        targetDataObject.ColNesting.forEach((colNest: any) => {
          this.sortByChildIndex(outputSelection.NestedArray, colNest.Data);
        });
      });
    });

    target.OutputdataObject.Column.forEach((col: any) => {
      col.Data.forEach((outputSelection: any) => {
        outputSelection.NestedArray.forEach((nestedItem: any) => {
          targetDataObject.ColNesting.forEach((colNest: any) => {
            this.sortByChildIndex(nestedItem.NestedArray, colNest.Data);
          });
        });
      });
    });
    target.OutputdataObject = JSON.parse(JSON.stringify(target.OutputdataObject));
  }

  toggleDataBlock(block: string, chatBlock?: any): void {
    const target = chatBlock || this;
    this.resetChartStates('table', chatBlock);
    target.isLineChartClick = false;
    target.displayTable = true;
    const rowdata = this.dataObject['Row'];
    const columndata = this.dataObject['Column'];
    const rowDataLength: number = rowdata.length > 0 ? rowdata[0].Data.length : 0;
    target.DefaultDataDropDown = block;
    this.updateChartDisablingFlags(chatBlock);
    target.dataDropDown = false;
    if (block === 'Data') {
      target.isData = true;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Sample Size') {
      target.isData = false;
      target.isSampleSize = true;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Sample') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = true;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Numerator') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = true;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Unweighted Numerator') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = true;
    }

    if (target.isIndex) {
      target.isChartView = false;
    }
  }

  toggleSigBlock(blockName: string, chatBlock?: any): void {
    const target = chatBlock || this;
    if (blockName === 'Sig') {
      target.isSig = true;
      target.isIndex = false;
      this.updateChartDisablingFlags(chatBlock);
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
      this.resetChartStates('table', chatBlock);
      this.is_Time_Period_Present = true;

      // When switching back to Significance from Index, ensure baseline "None" significance is processed
      if (this.mcode == 3 && this.lastCrosstabPayload) {
        this.callSignificancePayloadService("None", this.lastCrosstabPayload, target);
      } else if (this.mcode == 2 && this.lastBrandAnalysisPayload) {
        this.callBrandAnalysisPayloadService("None", this.lastBrandAnalysisPayload, target);
      } else {
        this.createTable(false, Feature.CrosstabOutput, false, chatBlock);
      }
    } else if (blockName === 'Index') {
      this.displayTable = true;
      this.isData = true;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
      this.DefaultDataDropDown = 'Data';
      this.resetChartStates('table', chatBlock);
      target.isSig = false;
      target.isIndex = true;
      target.isChartView = false;
      target.disableStackChart = true;
      target.disableLineChart = true;
      target.DefaultReferenceLevel = 'None';
      target.DefaultSampleSize = 'None';
      target.DefaultConfidenceLevel = 'None';
      target.SignificanceVsReference = '';
      target.isReference = false;
      target.selectedIndex = '';
      target.isPairWise = false;
      if (target.isTranspose) {
        target.isTranspose = false;
        this.reverseTranspose();
      }
      target.IndexData = this.getLastLevelColumnNestingValues(target);
    }
    target.sampleSizeDropdown = false;
  }
  createTable(
    isSampleSize: boolean,
    feature: string = Feature.CrosstabOutput,
    isIndexing: boolean,
    block: any = null
  ) {
    const target = block || this;
    this.variableTabData = this.crossTabService.getVarTabData || [];
    if (!this.variableTabData || this.variableTabData.length === 0) {
      console.warn('[METADATA-WARNING] variableTabData is missing in createTable. Attempting to recover...');
    }
    this.displayTable = true;
    this.isDemoStudy = false;
    this.isSig = isIndexing ? false : true;
    this.isIndex = isIndexing ? true : false;
    this.referenceLevelDropDown = false;
    this.DefaultReferenceLevel = isIndexing
      ? this.DefaultReferenceLevel
      : 'None';
    this.selectedIndex = isIndexing ? this.selectedIndex : '';
    const targetDataObject = target.dataObject && target.dataObject.Row && target.dataObject.Row.length > 0 ? target.dataObject : this.dataObject;
    const targetOutputDataObject = target.OutputdataObject;

    const rowdata = targetOutputDataObject && targetOutputDataObject.Row?.length > 0 ? targetOutputDataObject.Row : targetDataObject['Row'];
    const RowNesting = targetDataObject['RowNesting'];
    const columndata = targetOutputDataObject && targetOutputDataObject.Column?.length > 0 ? targetOutputDataObject.Column : targetDataObject['Column'];
    const ColNesting = targetDataObject['ColNesting'];
    const Filter = targetDataObject['Filter'];
    let isTimePeriodPresent = (this.variableTabData || []).filter(
      (a: any) => a.is_time_Period_Present === true
    );
    const columnDataLength: number =
      columndata.length > 0 ? columndata.length : 0;
    let isDimensionPresent = (this.variableTabData || []).filter(
      (a: any) => a.is_dimension_Present === true
    );

    this.is_Time_Period_Present = (this.variableTabData && this.variableTabData.length > 0)
      ? (isTimePeriodPresent.length > 0)
      : (target && target.is_Time_Period_Present !== undefined ? target.is_Time_Period_Present : true);

    this.is_dimension_Present = isDimensionPresent.length == 0 ? false : true;
    this.is_indexingShow =
      this.selectedDataFormat == 'Respondent Level' && this.is_indexing
        ? columnDataLength > 1
          ? false
          : true
        : false;
    target.isDisableReference = (target.IndexData && target.IndexData.length <= 1) ? true : (columnDataLength > 1 ? true : false);
    const TimePeriodinColumn = ((columndata as any[]) || []).filter((parent: any) => {
      return (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true');
    });

    const isDefaultRespGrp = this.filterDataByCalculationType(rowdata as any, 'respgrp');
    const isMeanMetric = this.filterDataByCalculationType(rowdata as any, 'mean');
    const isMultiPunchRow = this.filterDataByCalculationType(rowdata as any, 'multipunch');
    const isMultiPunchColumn = this.filterDataByCalculationType(columndata as any, 'multipunch');
    this.updateChartDisablingFlags(block);
    if (isSampleSize) {
      this.isLineChartClick = this.isLineChartClick || this.isTableClick;
      this.isVerticalGroupBarChartClick =
        this.isVerticalGroupBarChartClick || this.isTableClick;
      this.isVerticalBarChartClick =
        this.isVerticalBarChartClick || this.isTableClick;
      this.isVerticalStackChartClick =
        this.isVerticalStackChartClick || this.isTableClick;
      this.isTableClick = false;
      this.displayTable = !(
        this.isLineChartClick ||
        this.isVerticalGroupBarChartClick ||
        this.isVerticalStackChartClick
      );
      this.isData = !(
        this.isLineChartClick ||
        this.isVerticalGroupBarChartClick ||
        this.isVerticalStackChartClick
      );
    } else {
      this.isTableClick = false;
      this.isLineChartClick = false;
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isData = true;
      this.DefaultDataDropDown = DEFAULT_VALUES.DATA;
      this.isTranspose = false;
      this.displayTable = true;
      this.isTotal = this.isIndex ? this.isTotal : false;
      target.isDisablePairWise = true;
      if (
        this.dataObject.ColNesting.length === 0 &&
        this.dataObject.Column.length === 1 &&
        this.dataObject.Column[0].Data.length <= 10
      )
        target.isDisablePairWise = false;
    }
    this.isSampleSize = false;
    this.isWeightedLabel = false;
    this.sampleSizeDropdown = false;
    this.confidenceLevelDropDown = false;

    const matchColumnFound = this.isLevel1TimePeriodPresent(
      this.listCItemsList
    );
    const matchColumnNestFound = this.isLevel1TimePeriodPresent(
      this.listDItemsList
    );
    const matchFilterNestFound = this.isLevel1TimePeriodPresent(
      this.listEItemsList
    );

    const matchColumnDimension = this.isDimensionPresent(this.listCItemsList);

    const matchColumnNestDimension = this.isDimensionPresent(
      this.listDItemsList
    );

    const matchFilterDimension = this.isDimensionPresent(this.listEItemsList);

    const distinctValuesForListA = this.getDistinctLevel0Values(
      this.listAItemsList
    );

    const distinctValuesForListC = this.getDistinctLevel0Values(
      this.listCItemsList
    );
    const distinctValuesForListD = this.getDistinctLevel0Values(
      this.listDItemsList
    );
    const distinctValuesForListE = this.getDistinctLevel0Values(
      this.listEItemsList
    );

    const allDistinctValues = [
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const allDistinctValueAggregated = [
      ...distinctValuesForListA,
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const distinctEntryList = this.getDistinctENtryList(this.entryList);

    const distinctAggregatedMetric = this.getDistinctAggregaredMetrics(
      this.variableTabData
    );

    const allEntryListPresent = distinctEntryList.every((entry) =>
      allDistinctValues.includes(entry)
    );

    const allEntryListPresentAggregated = distinctAggregatedMetric.every(
      (entry) => allDistinctValueAggregated.includes(entry)
    );

    const matchingCount = distinctEntryList.filter((entry) =>
      allDistinctValues.includes(entry)
    ).length;

    let Isshowpopup = false;

    if (Isshowpopup == false) {

      this.SelectionSummary();
      this.isCreateBtnClick = true;
      this.clearOutputDataObject();
      this._loaderService.showLoader();
      var weightColumnName: string = '';
      var isBoostFactor: boolean = false;

      if (target.DefaultWeight.trim() == 'Boost Factor') {
        weightColumnName = this.WeightDropDownList[0].responseCode;
        isBoostFactor = true;
      }

      var istimePeriodWave = this.isWaveTimePeriod();
      this.AssignDataToPreviousDataObject(this.dataObject);

      this.$unSubscribeSubmitData4 = this.crossTabService
        .getOutPutData(
          this.previewDataObject,
          this.selected_client,
          this.selected_study,
          target.DefaultSampleSize,
          this.isFilteringActive,
          target.DefaultConfidenceLevel,
          target.isTotalBase,
          target.selectedWeight,
          weightColumnName,
          isBoostFactor,
          target.SignificanceVsReference,
          this.columnLength,
          this.dataArray,
          this.isBrandAnalysis,
          this.isAggregatedData,
          this.isSemiAggregatedData,
          this.isRespondentLevel,
          this.aggregatedVariables,
          istimePeriodWave,
          target.isTotal
        )
        .subscribe((result: results) => {
          if (result.HasValidData) {
            let JsonData = JSON.parse(result.Data);
            target.isReference = false;
            target.CrossTabOutPutEntireData = JsonData;
            this.normalizeNestedChildFields(target.CrossTabOutPutEntireData);
            let chartType = target.isTranspose ? 'column' : 'bar';

            if (target.CrossTabOutPutEntireData.length > 0) {
              target.CrossTabOutPutData = target.CrossTabOutPutEntireData;
              if (!target.isTotal) {
                target.CrossTabOutPutData = target.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);
              }

              if (target.isIndex && target.selectedIndex != '') {
                // manipulateIndexData needs target support too if we want to support it for blocks
                this.manipulateIndexData();
              }

              this.BindTableOutput(target.CrossTabOutPutData, block);
              this.sortOutputData(block);

              if (target.isTranspose) {
                this.handleOutputdataObjectOnTransposeSelect(block);
              }

              this.crossTabService.setCrossTabOuputData(target.CrossTabOutPutData);

              if (target.isLineChartClick) {
                this.onTrendChartIconClick(block);
              } else if (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) {
                this.VerticalChartClick(chartType, block);
              } else if (target.isVerticalStackChartClick) {
                this.onVerticalStackBarChartIconClick(chartType, block);
              }
            }
          }
          this.usageDataLog(feature);
          this._loaderService.hideLoader();
        });
    }

    if (target.IndexData && target.IndexData.length <= 1) {
      this.isDisableReference = true;
    } else {
      this.isDisableReference = columnDataLength > 1;
    }
  }

  usageDataLog(feature: string) {
    let summarytext = '';
    if (this.summaryText != undefined && this.summaryText != null)
      summarytext = this.summaryText?.nativeElement.innerText;
    else summarytext = this.selectionSummary.replace(/<[^>]*>/g, '');
    this._usermanagementService.UsageData(
      COMMON_CONSTANTS.DataExplorerModuleId.toString(),
      this.selected_client,
      this.selected_study,
      feature,
      summarytext,
      ''
    );
  }

  AssignDataToPreviousDataObject(dataObject: DataObject) {
    this.previewDataObject.Row = dataObject.Row;
    this.previewDataObject.Column = dataObject.Column;
    this.previewDataObject.ColNesting = dataObject.ColNesting;
    this.previewDataObject.RowNesting = dataObject.RowNesting;
    this.previewDataObject.Filter = dataObject.Filter;
  }

  private isWaveTimePeriod() {
    if (
      this.mandatoryVariableMapping == undefined ||
      this.mandatoryVariableMapping == null
    )
      return false;
    else {
      let timePeriodEntries: any = this.mandatoryVariableMapping.filter(
        (entry: any) =>
          entry.variable_label === 'Time Period' &&
          entry.variable_code &&
          entry.variable_code.trim() !== ''
      );

      let isWaveTimePeriod =
        timePeriodEntries.length === 0 ||
        timePeriodEntries.every(
          (entry: any) =>
            entry.variable_code === timePeriodEntries[0].variable_code
        );

      return isWaveTimePeriod;
    }
  }

  clearOutputDataObject(block: any = null) {
    const target = block || this;
    target.OutputdataObject = {
      Column: [],
      Row: [],
    };
    target.FinalOutputdataObject = {
      Row: [],
      Column: [],
    };
  }

  getDistinctAggregaredMetrics(list: any[]) {
    return DataTransformersHelper.getDistinctAggregaredMetrics(list);
  }

  getDistinctENtryList(list: any[]) {
    return DataTransformersHelper.getDistinctENtryList(list);
  }
  // Utility Methods
  private tokenizeSearchText(searchText: string): string[] {
    return DataTransformersHelper.tokenizeSearchText(searchText);
  }

  private matchesAllTokens(text: string, tokens: string[]): boolean {
    return DataTransformersHelper.matchesAllTokens(text, tokens);
  }

  private filterByVariableCode(dataArray: any[], variableCode: string, responseCode?: string): any[] {
    return DataTransformersHelper.filterByVariableCode(this.variableTabData, variableCode, responseCode);
  }

  private getDistinctValues<T, K extends keyof T>(list: T[], key: K): T[K][] {
    return DataTransformersHelper.getDistinctValues(list, key);
  }

  getDistinctLevel0Values(list: any[]) {
    return DataTransformersHelper.getDistinctLevel0Values(list);
  }

  getDistinctLevel1Values(list: any[]) {
    return DataTransformersHelper.getDistinctLevel1Values(list);
  }

  private sortByChildIndex(items: any[], referenceData: any[]): void {
    DataTransformersHelper.sortByChildIndex(items, referenceData);
  }

  private filterByPipeLevels(child: string): any[] {
    if (!this.variableTabData || this.variableTabData.length === 0) {
      this.variableTabData = this.crossTabService.getVarTabData || [];
    }
    return ChartUtilitiesHelper.filterByPipeLevels(child, this.variableTabData || []);
  }

  isChartClosing: boolean = false;
  isTableClosing: boolean = false;

  private resetChartStates(activeChart?: 'table' | 'line' | 'bar' | 'stack' | 'groupBar', block: any = null): void {
    const target = block || this;
    const isSwitchingFromTable = target.displayTable && activeChart !== 'table' && activeChart !== undefined;
    const isSwitchingToTable = activeChart === 'table' && !target.displayTable;

    if (isSwitchingFromTable) {
      // Add a slight delay for a "softer" transition from table to chart
      target.isTableClosing = true;
      this.applyChartStates(activeChart, block); // Set flags instantly for button feedback
      setTimeout(() => {
        target.displayTable = false;
        target.isTableClosing = false;
      }, 500); // Wait for table to shrink
    } else if (isSwitchingToTable) {
      // Soft transition back to table - Immediate overlap for smooth slide-up
      target.isTableClick = true; // Immediate icon feedback
      target.isChartClosing = true;
      target.displayTable = true; // Show table immediately so it "takes" its space
      this.applyChartStates(activeChart, block);


      // Finish closing charts after they've shrunk
      // This causes the insights to slide up from ChartHeight to TableHeight
      setTimeout(() => {
        target.isChartClosing = false;
      }, 800);
    } else {
      this.applyChartStates(activeChart, block);
    }
  }

  private applyChartStates(activeChart?: string, block: any = null): void {
    const target = block || this;
    target.isTableClick = activeChart === 'table';
    target.isLineChartClick = activeChart === 'line';
    target.isVerticalBarChartClick = activeChart === 'bar';
    target.isVerticalStackChartClick = activeChart === 'stack';
    target.isVerticalGroupBarChartClick = activeChart === 'groupBar';
    target.isChartView = !!activeChart;

    if (block) {
      if (!block.LineChart) block.LineChart = JSON.parse(JSON.stringify(this.LineChart));
      if (!block.StackChart) block.StackChart = JSON.parse(JSON.stringify(this.StackChart));
      if (!block.BarChart) block.BarChart = JSON.parse(JSON.stringify(this.BarChart));
    }
  }

  private getShareNumber(item: CrossTabOutputItem): number | null {
    // Hardcoded to Answer base and 'Weight' as per user request
    return ChartUtilitiesHelper.getShareNumber(item, false, 'Weight');
  }

  private neutralizeChartIds(block: any = null): void {
    const ids = [
      'line-chartContainer',
      'stack-chart-container',
      'chart-container',
      'vertical-chart-container',
      'stack-chart-container2' // Just in case
    ];
    const target = block || this;
    const currentBlockEl = target.messageId ? document.querySelector(`[data-message-id="${target.messageId}"]`) : null;

    if (currentBlockEl) {
      ids.forEach(id => {
        const elements = currentBlockEl.querySelectorAll(`[id^="${id}_rendered_"], #${id}`);
        elements.forEach(el => {
          el.id = id;
        });
      });
    }

    ids.forEach(id => {
      document.querySelectorAll(`#${id}`).forEach(el => {
        if (currentBlockEl && currentBlockEl.contains(el)) {
          return;
        }
        el.id = id + '_rendered_' + Math.random().toString(36).substr(2, 9);
      });
    });
  }

  private calculatePercentageValue(shareNumber: number | null, item: CrossTabOutputItem): number | string {
    return ChartUtilitiesHelper.calculatePercentageValue(shareNumber, item);
  }

  private getChangeVsPY(item: CrossTabOutputItem): number | string {
    // Hardcoded to Answer base as per user request
    return ChartUtilitiesHelper.getChangeVsPY(item, false);
  }

  private getSignificanceString(item: CrossTabOutputItem): string {
    // Hardcoded to Answer base as per user request
    return ChartUtilitiesHelper.getSignificanceString(item, false);
  }

  private getSampleSizeString(item: CrossTabOutputItem): string {
    // Hardcoded to Answer base as per user request, with fallback for nulls to avoid 'I/S'
    const s = ChartUtilitiesHelper.getSampleSizeString(item, false);
    return s === '0' ? (item.totalUnweightedBase?.toString() || '999') : s;
  }

  private getDistinctChildValuesFormatted(dataObject: checkboxSelectionWithParent[]): string[] {
    return ChartUtilitiesHelper.getDistinctChildValuesFormatted(dataObject);
  }

  private filterDataByCalculationType(data: checkboxSelectionWithParent[], type: 'multipunch' | 'respgrp' | 'mean'): checkboxSelectionWithParent[] {
    return ChartUtilitiesHelper.filterDataByCalculationType(data || [], type);
  }

  private initializeChartData(chart: LineChart | StackChart | GroupBarChart): void {
    ChartUtilitiesHelper.initializeChartData(chart);
  }

  private sortChartDataBySeriesName(chartData: any[], distinctRowChildValues: string[]): void {
    ChartUtilitiesHelper.sortChartDataBySeriesName(chartData, distinctRowChildValues);
  }

  private getDistinctPipeParts(rowValues: string[]): { first: string[], second: string[], third: string[], fourth: string[], fifth: string[] } {
    return ChartUtilitiesHelper.getDistinctPipeParts(rowValues);
  }

  private calculateStackFlag(parts: { first: string[], second: string[], third: string[], fourth: string[], fifth: string[] }): boolean {
    return ChartUtilitiesHelper.calculateStackFlag(parts);
  }

  private getDistinctColumnChildValues(outputData: any = null): string[] {
    return ChartUtilitiesHelper.getDistinctColumnChildValues((outputData || this.OutputdataObject) as any);
  }

  isDimensionPresent(list: any[]): boolean {
    return DataTransformersHelper.isDimensionPresent(list);
  }

  isLevel1TimePeriodPresent(list: any[]): boolean {
    return DataTransformersHelper.isLevel1TimePeriodPresent(list);
  }

  getLastLevelColumnNestingValues(block?: any) {
    var indexData;
    const outputDataObj = block ? this.getOutputData(block) : this.OutputdataObject;
    if (outputDataObj && outputDataObj.Column && outputDataObj.Column.length > 0) {
      if (outputDataObj['Column'][0]['Data'].length > 0) {
        let firstLevelLength =
          outputDataObj['Column'][0]['Data'].length;

        if (firstLevelLength > 0) {
          let level0 =
            outputDataObj['Column'][0]['Data'][firstLevelLength - 1];
          if (level0.NestedArray.length > 0) {
            let secondLevelLength = level0.NestedArray.length;
            if (secondLevelLength > 0) {
              let level1 = level0.NestedArray[secondLevelLength - 1];

              if (level1.NestedArray.length > 0) {
                let finalData =
                  outputDataObj['Column'][0]['Data'][
                    firstLevelLength - 1
                  ].NestedArray[secondLevelLength - 1].NestedArray;
                indexData = finalData;
                if (!block) this.columnLength = 2;
              } else {
                indexData = level0.NestedArray;
                if (!block) this.columnLength = 1;
              }
            }
          } else {
            indexData = outputDataObj['Column'][0]['Data'];
            if (!block) this.columnLength = 0;
          }
        }
      }
    }

    return indexData;
  }

  SelectionSummary() {
    const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
    const disctinctRowNestingValues = this.getDistinctChildValues(
      this.dataObject.RowNesting
    );
    const disctinctColumnValues = this.getDistinctChildValues(
      this.dataObject.Column
    );
    const disctinctColumnNestingValues = this.getDistinctChildValues(
      this.dataObject.ColNesting
    );
    const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);

    const RowValues = this.transformData(disctinctRowValues);
    const RowNestingValues = this.transformData(disctinctRowNestingValues);
    const ColumnValues = this.transformData(disctinctColumnValues);
    const ColumnNestingValues = this.transformData(
      disctinctColumnNestingValues
    );
    const FilterData = this.transformData(FilterValues);
    this.BindSelectionSummary(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      false
    );
  }

  BindSelectionSummary(
    RowValues: string[],
    RowNestingValues: string[],
    ColumnValues: string[],
    ColumnNestingValues: string[],
    FilterData: string[],
    isSavedSelection: boolean
  ) {
    this.selectionSummary = SelectionSummaryHelper.buildSelectionSummaryText(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      isSavedSelection,
      {
        selectedDataFormat: this.selectedDataFormat,
        DefaultSampleSize: this.DefaultSampleSize,
        SignificanceVsReference: this.SignificanceVsReference,
        DefaultConfidenceLevel: this.DefaultConfidenceLevel,
        selectedIndex: this.selectedIndex,
        isIndex: this.isIndex,
        DefaultWeight: this.DefaultWeight,
        isTotalBase: this.isTotalBase,
        selected_study: this.selected_study,
        isFilteringActive: this.isFilteringActive,
        BASE_TYPES: BASE_TYPES
      }
    );
  }

  transformData(dataList: string[]): string[] {
    return SelectionSummaryHelper.transformData(dataList);
  }

  reverseTranspose() {
    if (
      this.OutputdataObject != null &&
      (this.OutputdataObject['Row'].length > 0 ||
        this.OutputdataObject['Column'].length > 0)
    ) {
      let tempRow = [...this.OutputdataObject.Column];
      let tempColumn = [...this.OutputdataObject.Row];
      this.OutputdataObject.Row = [...tempRow];
      this.OutputdataObject.Column = [...tempColumn];
    }
  }

  async SampleSizeDropDownClick(SelectedValue: string, block: any = null) {
    const target = block || this;
    target.isPairWise = false;
    target.isReference = false;

    // Set default confidence level if it was 'None' and we are selecting a significance type
    if (SelectedValue !== 'None' && target.DefaultConfidenceLevel === 'None') {
      target.DefaultConfidenceLevel = this.is_confidenceLevel.length > 0 ? this.is_confidenceLevel[0]['key'] : '95%';
    }

    if (SelectedValue == 'Reference') {
      target.isReference = true;

      target.IndexData = this.getLastLevelColumnNestingValues(target);
    } else {
      target.SignificanceVsReference = '';
      target.isReference = false;
      target.DefaultDataDropDown = 'Data';
      target.DefaultSampleSize = SelectedValue;
      const isPreviousYear = SelectedValue === 'Previous Year' || (SelectedValue && SelectedValue.includes('Previous Year'));
      const isPreviousPeriod = SelectedValue === 'Previous Period' || (SelectedValue && SelectedValue.includes('Previous Period'));
      const isNone = SelectedValue === 'None';

      if (isNone) {
        target.DefaultConfidenceLevel = 'None';
      }

      // Resolve correct payload based on target context (Current session vs Historical Block)
      const analytical = target.analyticalData || target.parsedData;
      const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
      const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;

      const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
      const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

      // Specialized Payload Service Call for "Previous Year", "Previous Period" or "None" (Crosstab)
      if ((isPreviousYear || isPreviousPeriod || isNone) && this.getMcode(target) == 3 && effectiveCrosstabPayload) {
        target.sampleSizeDropdown = false;
        const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
        this.callSignificancePayloadService(significanceType, effectiveCrosstabPayload, target);
        return;
      }

      // Specialized Payload Service Call for "Previous Year", "Previous Period" or "None" (Brand Analysis)
      if ((isPreviousYear || isPreviousPeriod || isNone) && this.getMcode(target) == 2 && effectiveBrandPayload) {
        target.sampleSizeDropdown = false;
        const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
        this.callBrandAnalysisPayloadService(significanceType, effectiveBrandPayload, target);
        return;
      }

      if (SelectedValue == 'None') {
        target.DefaultConfidenceLevel = 'None';
      } else if (SelectedValue == 'Pairwise') {
        target.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
        target.isPairWise = true;
      } else {
        target.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
      }
      target.sampleSizeDropdown = false;
      this.createTable(true, Feature.Significance, false, target);
    }
  }

  processPayloadServiceResponse(res: any, block: any = null) {
    const target = block || this;

    if (res && res.response) {
      let resultData = res.response;

      // The backend might return a result object that has a 'Data' string or direct object
      let parsedData: any[] = [];
      try {
        if (resultData.Data) {
          parsedData = typeof resultData.Data === 'string' ? JSON.parse(resultData.Data) : resultData.Data;
        } else {
          parsedData = typeof resultData === 'string' ? JSON.parse(resultData) : resultData;
        }
      } catch (e) {
        console.error('[SIGNIFICANCE-ERROR] Error parsing response data:', e);
        return;
      }

      if (!Array.isArray(parsedData)) {
        console.error('[SIGNIFICANCE-ERROR] Response data is not an array:', parsedData);
        return;
      }


      target.CrossTabOutPutEntireData = parsedData;
      this.normalizeNestedChildFields(target.CrossTabOutPutEntireData);
      target.CrossTabOutPutData = (target.isTotal ?? this.isTotal)
        ? target.CrossTabOutPutEntireData
        : target.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);

      this.BindTableOutput(target.CrossTabOutPutData, block);

      // Sort the target's data object
      if (target.OutputdataObject && target.OutputdataObject.Row) {
        this.sortOutputData(block);
      }

      if (target.isTranspose) {
        this.handleOutputdataObjectOnTransposeSelect(block);
      }

      // Sync to shared service for components still using it (like SidePanel)
      this.crossTabService.setCrossTabOuputData(target.CrossTabOutPutData);

      // Trigger chart updates for the active view
      const chartType = target.isTranspose ? 'column' : 'bar';
      if (target.isLineChartClick) {
        this.onTrendChartIconClick(block);
      } else if (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) {
        this.VerticalChartClick(chartType, block);
      } else if (target.isVerticalStackChartClick) {
        this.onVerticalStackBarChartIconClick(chartType, block);
      }
    }
  }

  async confidenceDropDownClick(SelectedValue: string, block: any = null) {
    const target = block || this;
    target.DefaultConfidenceLevel = SelectedValue;
    target.confidenceLevelDropDown = false;
    target.DefaultDataDropDown = 'Data';

    const isPreviousYear = target.DefaultSampleSize === 'Previous Year' || (target.DefaultSampleSize && target.DefaultSampleSize.includes('Previous Year'));
    const isPreviousPeriod = target.DefaultSampleSize === 'Previous Period' || (target.DefaultSampleSize && target.DefaultSampleSize.includes('Previous Period'));
    const isNone = target.DefaultSampleSize === 'None';

    // Resolve correct payload based on target context (Current session vs Historical Block)
    const analytical = target.analyticalData || target.parsedData;
    const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
    const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;
    const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
    const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

    if ((isPreviousYear || isPreviousPeriod || isNone) && this.getMcode(target) == 3 && effectiveCrosstabPayload) {
      const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
      this.callSignificancePayloadService(significanceType, effectiveCrosstabPayload, target);
      return;
    }

    if ((isPreviousYear || isPreviousPeriod || isNone) && this.getMcode(target) == 2 && effectiveBrandPayload) {
      const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
      this.callBrandAnalysisPayloadService(significanceType, effectiveBrandPayload, target);
      return;
    }

    this.createTable(true, Feature.ConfidenceLevel, false);
  }

  async callSignificancePayloadService(significanceType: string, payload: any = this.lastCrosstabPayload, block: any = null) {
    this._loaderService.showLoader();
    try {
      const token = await this.getBearerToken();
      const target = block || this;
      const requestPayload = {
        bearer_token: token,
        session_id: this.guidChatId,
        client_name: this.selected_client,
        study: this.selected_study,
        payload: payload,
        Significance: significanceType,
        SignificanceVsReference: target.SignificanceVsReference || "",
        "Confidence Level": target.DefaultConfidenceLevel,
        Base: target.DefaultBase,
        Weight: target.selectedWeight
      };


      this.apiService.crosstabPayloadService(requestPayload).subscribe({
        next: (res: any) => {
          this.processPayloadServiceResponse(res, block);
          this._loaderService.hideLoader();
        },
        error: (err: any) => {
          console.error('[SIGNIFICANCE-ERROR] crosstab-payload-service failed:', err);
          this._loaderService.hideLoader();
        }
      });
    } catch (e) {
      console.error('Exception in Significance specialized call:', e);
      this._loaderService.hideLoader();
    }
  }

  async callBrandAnalysisPayloadService(significanceType: string, payload: any = this.lastBrandAnalysisPayload, block: any = null) {
    this._loaderService.showLoader();
    try {
      const token = await this.getBearerToken();
      const target = block || this;
      const requestPayload = {
        bearer_token: token,
        session_id: this.guidChatId,
        client_name: this.selected_client,
        study: this.selected_study,
        payload: payload,
        Significance: significanceType,
        SignificanceVsReference: target.SignificanceVsReference || "",
        "Confidence Level": target.DefaultConfidenceLevel,
        Base: target.DefaultBase,
        Weight: target.selectedWeight
      };

      this.apiService.brandAnalysisPayloadService(requestPayload).subscribe({
        next: (res: any) => {
          this.processPayloadServiceResponse(res, block);
          this._loaderService.hideLoader();
        },
        error: (err: any) => {
          console.error('Error calling brand-analysis-payload-service:', err);
          this._loaderService.hideLoader();
        }
      });
    } catch (e) {
      console.error('Exception in Brand Analysis Significance specialized call:', e);
      this._loaderService.hideLoader();
    }
  }

  referenceDropDownClickIndexSignificance(SelectedValue: string, block?: any) {
    const target = block || this;
    target.SignificanceVsReference = SelectedValue;
    target.DefaultConfidenceLevel =
      this.is_confidenceLevel.length > 0
        ? this.is_confidenceLevel[0]['key']
        : '95%';
    target.DefaultSampleSize = 'Reference';
    target.DefaultDataDropDown = 'Data';
    target.isReference = false;

    const analytical = target.analyticalData || target.parsedData;
    const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
    const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;
    const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
    const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

    if (this.getMcode(target) === 3 && effectiveCrosstabPayload) {
      this.callSignificancePayloadService(target.DefaultSampleSize || 'None', effectiveCrosstabPayload, target);
    } else if (this.getMcode(target) === 2 && effectiveBrandPayload) {
      this.callBrandAnalysisPayloadService(target.DefaultSampleSize || 'None', effectiveBrandPayload, target);
    } else {
      this.createTable(true, Feature.Significance, false, target);
    }
  }

  referenceDropDownClick(SelectedValue: string, block?: any) {
    const target = block || this;
    target.DefaultReferenceLevel = this.replacePipe(SelectedValue);
    target.selectedIndex = SelectedValue;
    this.createTable(false, Feature.Index, true, target);
  }

  togglePanel(SelectedDropDown: string, block?: any) {
    const target = block || this;
    if (SelectedDropDown == 'significance') {
      target.sampleSizeDropdown = !target.sampleSizeDropdown;
      target.isReference = false;
    } else if (SelectedDropDown == 'confidence') {
      target.confidenceLevelDropDown = !target.confidenceLevelDropDown;
    } else if (SelectedDropDown == 'reference') {
      target.referenceLevelDropDown = !target.referenceLevelDropDown;
    } else if (SelectedDropDown == 'weight') {
      target.weightDropDown = !target.weightDropDown;
    } else if (SelectedDropDown == 'Base') {
      target.baseDropDown = !target.baseDropDown;
    } else if (SelectedDropDown == 'datadropdown') {
      target.dataDropDown = !target.dataDropDown;
    }
  }

  toggleActiveBlock(block: string, chatBlock?: any): void {
    const target = chatBlock || this;
    if (block === 'filtering') {
      target.isFilteringActive = true;
      target.isProfilingActive = false;
    } else if (block === 'profiling') {
      target.isFilteringActive = false;
      target.isProfilingActive = true;
    } else if (block === 'total_base') {
      target.isTotalBase = true;
      target.isAnswerBase = false;
      target.baseDropDown = false;
      target.DefaultBase = 'Total Base';

      if (target.selectionSummary) {
        target.selectionSummary = target.selectionSummary.replace(/\|\|\s*Base:\s*[^|]+/, `|| Base: ${BASE_TYPES.TOTAL}`);
      }

      const analytical = target.analyticalData || target.parsedData;
      const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
      const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;
      const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
      const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

      if (this.getMcode(target) === 3 && effectiveCrosstabPayload) {
        this.callSignificancePayloadService(target.DefaultSampleSize || 'None', effectiveCrosstabPayload, target);
      } else if (this.getMcode(target) === 2 && effectiveBrandPayload) {
        this.callBrandAnalysisPayloadService(target.DefaultSampleSize || 'None', effectiveBrandPayload, target);
      } else {
        this.createTable(false, Feature.CrosstabOutput, false, chatBlock);
      }
    } else if (block === 'answer_base') {
      if (!this.enableAnswerBase) {
        return;
      }
      target.isTotalBase = false;
      target.isAnswerBase = true;
      target.baseDropDown = false;
      target.DefaultBase = 'Answer Base';

      if (target.selectionSummary) {
        target.selectionSummary = target.selectionSummary.replace(/\|\|\s*Base:\s*[^|]+/, `|| Base: ${BASE_TYPES.ANSWER}`);
      }

      const analytical = target.analyticalData || target.parsedData;
      const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
      const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;
      const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
      const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

      if (this.getMcode(target) === 3 && effectiveCrosstabPayload) {
        this.callSignificancePayloadService(target.DefaultSampleSize || 'None', effectiveCrosstabPayload, target);
      } else if (this.getMcode(target) === 2 && effectiveBrandPayload) {
        this.callBrandAnalysisPayloadService(target.DefaultSampleSize || 'None', effectiveBrandPayload, target);
      } else {
        this.createTable(false, Feature.CrosstabOutput, false, chatBlock);
      }
    }
  }

  weightDropDownClick(SelectedValue: string, selectedWeight: string, chatBlock?: any) {
    const target = chatBlock || this;
    target.DefaultWeight = SelectedValue;
    target.weightDropDown = !target.weightDropDown;
    target.selectedWeight = selectedWeight;

    if (target.selectionSummary) {
      target.selectionSummary = target.selectionSummary.replace(/\|\|\s*Weight:\s*[^|]+/, `|| Weight: ${SelectedValue}`);
    }

    const analytical = target.analyticalData || target.parsedData;
    const blockPayloadCrosstab = analytical?.getConfiguration?.crosstab_payload || analytical?.AgentPayload?.getConfiguration?.crosstab_payload;
    const blockPayloadBrand = analytical?.brand_analysis_payload || analytical?.brand_anlysis_payload || analytical?.brand_analysis_payload;
    const effectiveCrosstabPayload = blockPayloadCrosstab || this.lastCrosstabPayload;
    const effectiveBrandPayload = blockPayloadBrand || this.lastBrandAnalysisPayload;

    if (this.getMcode(target) === 3 && effectiveCrosstabPayload) {
      this.callSignificancePayloadService(target.DefaultSampleSize || 'None', effectiveCrosstabPayload, target);
    } else if (this.getMcode(target) === 2 && effectiveBrandPayload) {
      this.callBrandAnalysisPayloadService(target.DefaultSampleSize || 'None', effectiveBrandPayload, target);
    } else {
      this.createTable(false, Feature.CrosstabOutput, false, chatBlock);
    }
  }

  handleExportClick(event?: Event, block: any = null) {
    if (event) event.stopPropagation();
    this.isExportspopup = false;
    ExportHandlerHelper.handleExportClick(this, block);
  }

  OnTransposeClick(block: any = null) {
    const target = block || this;

    // If Hide NA is active, we should re-filter based on the new transpose state!
    if (target.isHideNA) {
      let filteredData = [...(target.CrossTabOutPutEntireData || [])];
      if (!target.isTotal) {
        filteredData = filteredData.filter((x: any) => !x.isTotal);
      }
      if (target.isIndex && target.selectedIndex !== '') {
        target.CrossTabOutPutData = filteredData;
        this.manipulateIndexData(block);
        filteredData = [...(target.CrossTabOutPutData || [])];
      }
      // Toggle transpose
      target.isTranspose = !target.isTranspose;
      filteredData = this.getHideNAFilteredData(filteredData, !!target.isTranspose, block);
      target.CrossTabOutPutData = filteredData;
      target.OutputdataObject = { ...(target.OutputdataObject || {}), Row: [], Column: [] } as any;
      this.BindTableOutput(target.CrossTabOutPutData, block);
      if (target.isTranspose) {
        this.handleOutputdataObjectOnTransposeSelect(block);
      }
    } else {
      this.handleOutputdataObjectOnTransposeSelect(block);
      target.isTranspose = !target.isTranspose;
    }

    this.updateChartDisablingFlags(block);

    // Fallback if chart view is disabled or all charts are disabled
    if (!target.isChartView) {
      target.isTableView = true;
      target.isVerticalBarChartClick = false;
      target.isVerticalGroupBarChartClick = false;
      target.isVerticalStackChartClick = false;
      target.isLineChartClick = false;
    } else {
      // Fallback if the currently selected chart becomes disabled
      if (target.isVerticalStackChartClick && target.disableStackChart) {
        target.isVerticalStackChartClick = false;
        target.isVerticalBarChartClick = true;
      }
      if (target.isLineChartClick && target.disableLineChart) {
        target.isLineChartClick = false;
        target.isVerticalBarChartClick = true;
      }

      if (
        (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) &&
        target.isTranspose
      ) {
        this.VerticalChartClick(CHART_TYPES.BAR, block);
      } else if (
        (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) &&
        !target.isTranspose
      ) {
        this.VerticalChartClick(CHART_TYPES.COLUMN, block);
      } else if (target.isVerticalStackChartClick && target.isTranspose) {
        this.onVerticalStackBarChartIconClick(CHART_TYPES.BAR, block);
      } else if (target.isVerticalStackChartClick && !target.isTranspose) {
        this.onVerticalStackBarChartIconClick(CHART_TYPES.COLUMN, block);
      }
    }

    target.isSignificanceContainerDisabled =
      !target.isSignificanceContainerDisabled;
  }

  OnHideNAClick(block: any = null) {
    const target = block || this;
    target.isHideNA = !target.isHideNA;

    if (!target.CrossTabOutPutEntireData || target.CrossTabOutPutEntireData.length === 0) {
      if (target.CrossTabOutPutData && target.CrossTabOutPutData.length > 0) {
        target.CrossTabOutPutEntireData = [...target.CrossTabOutPutData];
      }
    }

    let filteredData = [...(target.CrossTabOutPutEntireData || [])];

    if (!target.isTotal) {
      filteredData = filteredData.filter((x: any) => !x.isTotal);
    }

    if (target.isIndex && target.selectedIndex !== '') {
      target.CrossTabOutPutData = filteredData;
      this.manipulateIndexData(block);
      filteredData = [...(target.CrossTabOutPutData || [])];
    }

    if (target.isHideNA) {
      filteredData = this.getHideNAFilteredData(filteredData, !!target.isTranspose, block);
    }

    target.CrossTabOutPutData = filteredData;
    target.OutputdataObject = { ...(target.OutputdataObject || {}), Row: [], Column: [] } as any;
    this.BindTableOutput(target.CrossTabOutPutData, block);

    if (target.isTranspose) {
      this.handleOutputdataObjectOnTransposeSelect(block);
    }

    this.updateChartDisablingFlags(block);

    // Fallback if chart view is disabled or all charts are disabled
    if (!target.isChartView) {
      target.isTableView = true;
      target.isVerticalBarChartClick = false;
      target.isVerticalGroupBarChartClick = false;
      target.isVerticalStackChartClick = false;
      target.isLineChartClick = false;
    } else {
      // Fallback if the currently selected chart becomes disabled
      if (target.isVerticalStackChartClick && target.disableStackChart) {
        target.isVerticalStackChartClick = false;
        target.isVerticalBarChartClick = true;
      }
      if (target.isLineChartClick && target.disableLineChart) {
        target.isLineChartClick = false;
        target.isVerticalBarChartClick = true;
      }

      // Rerender the active chart if in chart view
      if (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) {
        this.VerticalChartClick(target.isTranspose ? CHART_TYPES.BAR : CHART_TYPES.COLUMN, block);
      } else if (target.isVerticalStackChartClick) {
        this.onVerticalStackBarChartIconClick(target.isTranspose ? CHART_TYPES.BAR : CHART_TYPES.COLUMN, block);
      } else if (target.isLineChartClick) {
        this.onTrendChartIconClick(block);
      }
    }

    if (!block) {
      this.crossTabService.setCrossTabOuputData(target.CrossTabOutPutData);
    }
  }

  getCellValue(cell: any, block: any = null) {
    const target = block || this;
    if (target.isSampleSize) {
      return cell.answerUnweightedBase;
    }

    if (target.isWeightedLabel) {
      return cell.answerWeightedBase;
    }

    if (target.isWeightedNumerator) {
      return cell.answerWeightedNumerator;
    }

    if (target.isUnWeightedNumerator) {
      return cell.answerUnweightedBase;
    }

    return cell.answerWeightedShare
      ?? cell.answerUnweightedShare
      ?? cell.value
      ?? cell.weightedBase
      ?? cell.totalWeightedShare;
  }

  getHideNAFilteredData(data: any[], isTransposed: boolean = false, block: any = null): any[] {
    if (isTransposed) {
      return this.getHideNAFilteredByRow(data, block);
    }
    return this.getHideNAFilteredByColumn(data, block);
  }

  getHideNAFilteredByColumn(data: any[], block: any = null): any[] {
    const columnMap = new Map<string, any[]>();

    data.forEach(item => {
      const colKey = item.colVariableCode + "_" + item.colResponseCode;
      if (!columnMap.has(colKey)) {
        columnMap.set(colKey, []);
      }
      columnMap.get(colKey)!.push(item);
    });

    const validColumns = new Set<string>();

    columnMap.forEach((items, key) => {
      const hasValid = items.some(cell => {
        const val = this.getCellValue(cell, block);
        return val !== null && val !== 'NA';
      });
      if (hasValid) {
        validColumns.add(key);
      }
    });

    const result = data.filter(item => {
      const colKey = item.colVariableCode + "_" + item.colResponseCode;
      return validColumns.has(colKey);
    });
    return result;
  }

  getHideNAFilteredByRow(data: any[], block: any = null): any[] {
    const rowMap = new Map<string, any[]>();

    data.forEach(item => {
      const rowKey = item.colVariableCode + "_" + item.colResponseCode;
      if (!rowMap.has(rowKey)) {
        rowMap.set(rowKey, []);
      }
      rowMap.get(rowKey)!.push(item);
    });

    const validRows = new Set<string>();

    rowMap.forEach((items, key) => {
      const hasValid = items.some(cell => {
        const val = this.getCellValue(cell, block);
        return val !== null && val !== 'NA';
      });
      if (hasValid) {
        validRows.add(key);
      }
    });

    const result = data.filter(item => {
      const rowKey = item.colVariableCode + "_" + item.colResponseCode;
      return validRows.has(rowKey);
    });
    return result;
  }

  handlePPTExportClick(event?: Event, block: any = null) {
    if (event) event.stopPropagation();
    this.isExportspopup = false;
    ExportHandlerHelper.handlePPTExportClick(this, block);
  }

  fetchDiagnostic() {
    this.inputValue = '';
    this.apiService.getDiagonistics().subscribe((dt) => {
      try {
        const result = typeof dt === 'string' ? JSON.parse(dt) : dt;
        const data: Array<DiagnosticData> = JSON.parse(result.Data);
        this.displayDiagnosticData(data);
      } catch (err) {
        console.error('Failed to load diagnostics data.', err, dt);
        alert('Failed to load diagnostics data.');
      }
    });
  }

  displayDiagnosticData(data: DiagnosticData[]) {
    DiagnosticViewerHelper.displayDiagnosticData(data);
  }

  afterSubmit() {
    this.outputData = this._configService.standardSnapOutputData;

    if (
      this._configService.selectedcompareacrossOption == 'Multiple Brands' ||
      this._configService.selectedcompareacrossOption == 'Multiple Markets'
    ) {
      this._configService.standardSnapOutputData.sort((a: any, b: any) => {
        const sortIdA =
          this._configService.brandSortId.find(
            (item: any) => item.name === a.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        const sortIdB =
          this._configService.brandSortId.find(
            (item: any) => item.name === b.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        return sortIdA - sortIdB;
      });
    }

    this.outputData = Array.from(
      new Set(
        this.outputData
          .map((item: any) => {
            try {
              return JSON.stringify(item);
            } catch (err) {
              return null;
            }
          })
          .filter((item: any) => item !== null)
      )
    )
      .map((item: any) => {
        try {
          return JSON.parse(item);
        } catch (err) {
          return null;
        }
      })
      .filter((item) => item !== null);
    let arr: any[] = [];
    let arrWithoutTrend: any[] = [];

    if (!this.widgetData || this.widgetData.length === 0) {
      return;
    }

    this.items = _.cloneDeep(this.widgetData);
    if (this._configService.selectedcompareacrossOption.includes('Multiple')) {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);

      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      let brands: string[] = _.uniq(
        this.outputData.map((metric: any) => metric.colChild)
      );
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);
              let resultBrands = DataTransformersHelper.checkBrands(brands);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    outputRow.push(row);
                  }
                }

                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: DataTransformersHelper.handleBrandName(row.colChild, resultBrands),
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (result.slice(0, 6).length > 0) {
                result.slice(0, 6).forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    } else {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);

      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );
              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    outputRow.push(row);
                  }
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                  });
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));
              //;
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    }
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this.output_details = {
      pageData: this.pageData,
      widgetData: this.itemWithoutTrendItems,
    };

    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this._configService.itemWithTrendData = arr;
    this.selectedWidgetName = 'Awareness';
    this.selectedWidgetID = this.promptData.Widget_ID;


    this.filteredWidgetData = this.output_details.widgetData.filter(
      (widget: any) => widget.previewChartPostion == this.selectedWidgetID
    )[0];
    this.filteredWidgetID = this.filteredWidgetData.previewChartPostion;



    const widgetName = this.filteredWidgetData?.widget_name || 'Widget';
    const compareAcross = this.promptData?.Snapshot_Type || SNAPSHOT_TYPES.SINGLE_BRAND;
    const metrics = this.filteredWidgetData?.metric?.[0]?.metric_value || [];
    const pData = this.promptData || {};
    const marketsData = pData.Markets || pData.markets || pData.Market || pData.market || [];
    const timesData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];
    const filtersData = pData.Filter_Audience || pData.filter_audience || pData.Filter || pData.filter || [];

    const extractNameValue = (item: any) => {
      if (typeof item === 'string') {
        const parts = item.split('|');
        if (parts.length >= 2) {
          return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
        }
        return parts.pop();
      }
      if (item && item.name) return item.name;
      if (item && item.Child) return item.Child;
      if (item && item.option) return item.option;
      return String(item);
    };

    const metricNames = metrics.map((m: any) => m.option || m.metric_option || '').filter((name: string) => name).join(', ');
    const baseType = this.promptData?.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER;

    const extractLastPart = (item: any) => {
      if (typeof item === 'string') return item.split('|').pop();
      if (item && item.name) return item.name;
      if (item && item.Child) return item.Child;
      if (item && item.option) return item.option;
      return String(item);
    };

    const marketNames = marketsData.length > 0 ? marketsData.map((m: any) => extractLastPart(m)).join(', ') : 'All Markets';
    const timePeriodNames = timesData.length > 0 ? timesData.map((t: any) => extractNameValue(t)).join(', ') : 'All Time Periods';
    const filterNames = filtersData.length > 0 ? filtersData.map((f: any) => extractNameValue(f)).join(', ') : 'All Respondents';
    const brandsData = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
    const brandsNames = brandsData.length > 0 ? brandsData.map((b: any) => extractNameValue(b)).join(', ') : 'All Brands';

    let selections = 'Time Period: ' + timePeriodNames + '; Brands: ' + brandsNames;
    if (filtersData.length > 0) {
      selections += '; Filters: ' + filterNames;
    }

    this._configService.selectionSummaryTextTitle =
      'Compare Across: ' + compareAcross + ': ' + widgetName +
      ' || Entry Point: Markets: ' + marketNames +
      ' || Selections: ' + selections +
      ' || Significance: None' +
      ' || Base: ' + baseType +
      ' || Weight: Primary Weight';


    if (!this.Snapshotdataforexport) {
      this.Snapshotdataforexport = this._configService.getDropdownValues();
    }

    this.Snapshotdataforexport.compareAcross = compareAcross;
    this.Snapshotdataforexport.snapshotName = this.promptData?.Snapshot_Name || 'Snapshot';
    this.Snapshotdataforexport.clientName = this.selected_client;
    this.Snapshotdataforexport.studyName = this.selected_study;
    this.Snapshotdataforexport.selectionSummary = this._configService.selectionSummaryTextTitle;
    this.Snapshotdataforexport.baseType = baseType;

    setTimeout(() => this.showSnapshot = true, 5);
    setTimeout(() => MarkdownPayloadHelper.buildSnapshotMarkdown(this), 500);
  }


  sortTrendTimeporiodData(metricData: any[]): any[] {
    let filteredLeftPanelData = this._configService.leftPanelData?.filter(
      (item: any) =>
        item.Level0 === 'Time Period' || item.Level1 === 'Time Period'
    );
    filteredLeftPanelData?.sort((a: any, b: any) => {
      return a.level1_sort_id - b.level1_sort_id;
    });

    metricData?.sort((a: any, b: any) => {
      const indexA = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === a.lvl1Child.split('|')[1]
      );
      const indexB = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === b.lvl1Child.split('|')[1]
      );
      return indexA - indexB;
    });
    metricData?.sort((a: any, b: any) => {
      const [monthA, yearA] = a.lvl1Child?.split('|')[1].split('_');
      const [monthB, yearB] = b.lvl1Child?.split('|')[1].split('_');
      const dateA: any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB: any = new Date(yearB, this.getMonthNumber(monthB) - 1);
      return dateA - dateB;
    });

    return metricData;
  }

  getMonthNumber(monthAbbr: any) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return months.indexOf(monthAbbr) + 1;
  }

  OnInsigthsbuttonClick(isChatResponse = false, getSnapshotInsights?: any, getSnapshotInsightsTrend?: any, targetBlock?: any) {
    let WidgetId = this.Widget_Id;
    this.arktabaccess = false;
    let data = [];
    this.InsightsResponse = [];
    let ShareColumn = (this.selectedDataFormat != 'Respondent Level' ? 'value' : (this.isTotalBase
      ? (this.selectedWeight == "Unweighted" ? 'totalUnweightedShare' : 'totalWeightedShare')
      : (this.selectedWeight == "Unweighted" ? 'answerUnweightedShare' : 'answerWeightedShare')));
    let BaseColumn = !this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    if (!this.Snapshotdataforexport) {
      this.Snapshotdataforexport = this._configService.getDropdownValues();
    }

    this.Snapshotdataforexport.selectionSummary = this.selectionSummary;
    this.isInsightspopupOpen = true;
    if (getSnapshotInsights && isChatResponse) {
      // Re-normalize everything into component properties for view consistency:
      let rawText = '';
      if (typeof getSnapshotInsights === 'string') rawText = getSnapshotInsights;
      else if (getSnapshotInsights?.insights?.Value) rawText = getSnapshotInsights.insights.Value;
      else if (getSnapshotInsights?.Value) rawText = getSnapshotInsights.Value;

      if (rawText.includes('[[[SPLIT]]]')) {
        const parts = rawText.split('[[[SPLIT]]]');
        this.snapshotinsights_standard_text = parts[0];
        this.snapshotinsights_trendline_text = parts[1];
      } else {
        this.snapshotinsights_standard_text = rawText;
        // Check if there was separate trend insights (previous migration format)
        if (getSnapshotInsightsTrend) {
          if (typeof getSnapshotInsightsTrend === 'string') this.snapshotinsights_trendline_text = getSnapshotInsightsTrend;
          else if (getSnapshotInsightsTrend?.insights?.Value) this.snapshotinsights_trendline_text = getSnapshotInsightsTrend.insights.Value;
          else if (getSnapshotInsightsTrend?.Value) this.snapshotinsights_trendline_text = getSnapshotInsightsTrend.Value;
        }
      }

      const targetText = this.isTrendActive ? (this.snapshotinsights_trendline_text || this.snapshotinsights_standard_text) : this.snapshotinsights_standard_text;
      this.insightsVal = this.formatInsightsIntoPoints(targetText);

      // Populate multiViewInsightsCache immediately for history consistency
      const msgId = targetBlock?.messageId || this.selectedMessageId || 'current';
      
      if (!this.multiViewInsightsCache[msgId]) this.multiViewInsightsCache[msgId] = {};
      const combinedRaw = (this.snapshotinsights_standard_text || '').trim() + "[[[SPLIT]]]" + (this.snapshotinsights_trendline_text || '').trim();

      this.multiViewInsightsCache[msgId][this.mcode] = {
        insightsVal: this.insightsVal,
        qnaText: this.chatPreviewBlocks.find(b => b.messageId === msgId)?.QuestionAnswer || '',
        standard_insights: this.snapshotinsights_standard_text,
        trend_insights: this.snapshotinsights_trendline_text,
        rawInsights: combinedRaw
      };
    } else {
      this.insightsVal = (getSnapshotInsights && !isChatResponse) ? this.formatInsightsIntoPoints(getSnapshotInsights) : '';
    }

    (getSnapshotInsights && isChatResponse ? of(getSnapshotInsights) :
      this.apiService.getInsightsData(
        this.isIndexSelected,
        this.MainResult,
        this.selected_study,
        this.selected_client,
        this.selectionSummary,
        this.confidenceLevel,
        ShareColumn,
        BaseColumn,
        this._configService.getDropdownValues().compareAcross,
        "",
        "",
        WidgetId,
        localStorage.getItem('useremail') ?? '',
        '',
        'ARK'
      ))
      .subscribe({
        next: (result: string) => {
          // Requirement: Save insights data to Elasticsearch chat history for mcode==1 (snapshot module)
          if (!isChatResponse) {
            let snapshotInsightsText = 'No data Available';
            try {
              if (result && typeof result === 'string') {
                let insightsValue = result;
                try {
                  const parsed = JSON.parse(result);
                  const firstKey = Object.keys(parsed)[0];
                  if (firstKey && parsed[firstKey] && parsed[firstKey].Value) {
                    insightsValue = parsed[firstKey].Value;
                  }
                } catch (parseError) {
                }
                const insights = insightsValue.split('- ').map(item => item.trim()).filter(item => item.length > 0);
                if (insights.length > 0) {
                  snapshotInsightsText = insights.slice(0, 2).map(insight => {
                    let cleaned = insight.replace(/\*\*/g, ''); // Remove bold asterisks
                    cleaned = cleaned.replace(/^[^:]+:\s*/, ''); // Remove header before colon
                    cleaned = cleaned.replace(/\\n/g, ' '); // Remove escaped newlines
                    cleaned = cleaned.replace(/\n/g, ' '); // Remove actual newlines
                    return cleaned.trim();
                  }).join(' ');
                }
              }
            } catch (e) {
              console.log('Error extracting snapshot insights:', e);
            }
            this.updateQuestionAnswerForSelectedMessage(snapshotInsightsText);
            this.pushChatResponseEntry('getSnapshotInsights', result);
            this.saveChatList(
              targetBlock ? targetBlock.question : (this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue),
              this.chatResponse,
              snapshotInsightsText,
              targetBlock?.messageId
            );
            this.chatResponse = [];
          }
          this.showSnapshot = true;

          if (!isChatResponse) {
            let parsedResult: any;

            try {
              parsedResult = JSON.parse(result);
            } catch {
              parsedResult = null;
            }

            if (parsedResult && !parsedResult.success) {
              this.insightsVal = this.formatInsightsIntoPoints(parsedResult.message || "No Data Available");
            }
            else if (result && result.trim() !== "") {
              let parsedInsightsObj = JSON.parse(result);
              let combinedInsightsText = '';
              for (const section in parsedInsightsObj) {
                if (parsedInsightsObj[section] && parsedInsightsObj[section].Value) {
                  combinedInsightsText += parsedInsightsObj[section].Value + '\n';
                }
              }
              this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);
            } else {
              this.insightsVal = ["No Data Available"];
            }
            this.InsightsResponse = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: this.insightsVal.join('\n'),
              show: true
            };
            this.stopAiLoader();
            this.arktabaccess = false; // Stop loader
          }
          if (isChatResponse) {
            let parsedResult: any;
            let combinedInsightsText = '';
            let insightsFound = false;

            if (typeof result === "string") {
              try {
                parsedResult = JSON.parse(result);
              } catch (e) {
                // If it's a plain string (possibly with [[[SPLIT]]]), use it directly
                combinedInsightsText = result;
                insightsFound = true;
                parsedResult = null;
              }
            } else if (typeof result === "object") {
              parsedResult = result;
            }

            if (parsedResult && typeof parsedResult === 'object') {
              for (const section in parsedResult) {
                if (parsedResult[section] && parsedResult[section].Value) {
                  combinedInsightsText += (combinedInsightsText ? '\n' : '') + parsedResult[section].Value;
                  insightsFound = true;
                }
              }
            }

            if (insightsFound && combinedInsightsText) {
              // Ensure snapshot dual-text properties are updated if the result contained the split marker
              if (combinedInsightsText.includes('[[[SPLIT]]]')) {
                const parts = combinedInsightsText.split('[[[SPLIT]]]');
                this.snapshotinsights_standard_text = parts[0];
                this.snapshotinsights_trendline_text = parts[1];
              }

              this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);

              // Update cache with the resolved points
              const msgId = targetBlock?.messageId || this.selectedMessageId || 'current';
              if (this.multiViewInsightsCache[msgId]?.[this.mcode]) {
                this.multiViewInsightsCache[msgId][this.mcode].insightsVal = this.insightsVal;
                if (combinedInsightsText.includes('[[[SPLIT]]]')) {
                  this.multiViewInsightsCache[msgId][this.mcode].standard_insights = this.snapshotinsights_standard_text;
                  this.multiViewInsightsCache[msgId][this.mcode].trend_insights = this.snapshotinsights_trendline_text;
                  this.multiViewInsightsCache[msgId][this.mcode].rawInsights = combinedInsightsText;
                }
              }
            } else {
              this.insightsVal = ["No Data Available"];
            }

            this.InsightsResponse = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: Array.isArray(this.insightsVal) ? this.insightsVal.join('\n') : String(this.insightsVal),
              show: true
            };
          }
          this._insightsSerive.showInisghts(this.InsightsResponse);
          this.stopAiLoader();
          this.arktabaccess = false;
        },
        error: (error) => {
          console.error('Error fetching insights for snapshot:', error);
          this.insightsVal = ['Failed to generate insights. Please try again.'];
          this.setFailedCaseState(true, targetBlock);
          this.stopAiLoader();
          this.arktabaccess = false;
        }
      });
  }

  async callInsightsAPI(
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any,
    targetBlock?: any
  ): Promise<void> {
    if (this.failedCase) {
      console.warn('[ORCHESTRATION] callInsightsAPI skipped: failedCase is true (preceding error detected)');
      return;
    }

    // [UNBLOCK UI] Hide the AI loader so the UI can immediately plot the data while insights stream!
    this.stopAiLoader();
    this.arktabaccess = false;

    this.insightsStreamingText = '';
    this.insightsStreamingPoints = [];
    this.isInsightspopupOpen = true;
    this.insightsVal = '';
    this.setFailedCaseState(false, targetBlock);
    
    const innerMsgId = targetBlock?.messageId || this.selectedMessageId || 'current';
    if (!this.inFlightInsights[innerMsgId]) {
      this.inFlightInsights[innerMsgId] = new Set();
    }
    this.inFlightInsights[innerMsgId].add(mcode);

    try {
      // Determine default active view for snapshots:
      // (1 brand AND 1 market) -> Trend View is best for temporal analysis
      // (Multi-brand OR Multi-market) -> Normal View is best for cross-comparison
      const bArray = this.promptData?.Primary_Brands || this.promptData?.primary_brands || this.promptData?.Brands || this.promptData?.brands || [];
      const mArray = this.promptData?.Markets || this.promptData?.markets || [];
      const isSingleFocus = (bArray.length === 1 && (mArray.length <= 1));

      if (mcode === 1 && this.filteredWidgetData?.trendline_response && isSingleFocus) {
        this.isTrendActive = true;
      } else {
        this.isTrendActive = false;
      }

      let basePayload = await MarkdownPayloadHelper.buildMarkdownPayload(this);
      if (!basePayload) {
        throw new Error('Payload construction failed');
      }

      // Merge specialized payload (Row, Column, etc.) for non-primary modules so the API has the required data structures
      if (this.chatPayload && mcode > 1) {
        basePayload = { ...this.chatPayload, ...basePayload };
      }

      if (!markdown || !InsightsGeneratorHelper.hasValidDataInMarkdown(markdown)) {
        this.setFailedCaseState(true, targetBlock);
        this.errorHeader = 'Analysis Status:';
        this.insightsVal = ['Metric values are zero or null for the selected criteria.'];
        this.InsightsResponse = {
          header: this.errorHeader,
          message: this.insightsVal[0],
          show: true,
        };
        this._insightsSerive.showInisghts(this.InsightsResponse);
        this.updateMarkdownTextRealTime(this.insightsVal[0]);
        this.stopAiLoader();
        this.isInsightspopupOpen = true;
        this.arktabaccess = false;
        
        if (this.inFlightInsights[innerMsgId]) {
          this.inFlightInsights[innerMsgId].delete(mcode);
        }
        return;
      }


      this.insightsVal = [];
      this.insightsStreamingText = '';
      this.insightsStreamingPoints = [];
      this.isInsightspopupOpen = true;
      this.stopInsightsAutoScroll();

      this.InsightsResponse = {
        header: 'Insights (Connecting...)',
        message: 'Connecting to specialized intelligence stream...',
        show: true,
      };
      this._insightsSerive.showInisghts(this.InsightsResponse);

      let insightsResponse = '';
      let qnaResponse = '';
      let insightsCompleted = false;
      let qnaCompleted = false;
      let firstChunkReceived = false;

      // Reset specific snapshot text storage
      this.snapshotinsights_standard_text = '';
      this.snapshotinsights_trendline_text = '';

      // Check if we need dual calls for snapshot trend context
      const isSnapshotTrend = (mcode === 1 && !!this.filteredWidgetData?.trendline_response);
      let standardDone = false;
      let trendDone = !isSnapshotTrend;

      const finalizeDualInsights = () => {
        if (standardDone && trendDone) {
          const combinedRaw = (this.snapshotinsights_standard_text || "No Data Available").trim() +
            "[[[SPLIT]]]" +
            (this.snapshotinsights_trendline_text || "No Data Available").trim();
          const jsonFormatted = JSON.stringify({ "insights": { "Value": combinedRaw } });

          this.pushChatResponseEntry('getSnapshotInsights', jsonFormatted);

          this.isInsightsStreaming = false;
          setTimeout(() => {
            this.scrollInsightsToTopSmooth();
          }, 1000);

          insightsCompleted = true;
          this.checkStreamCompletion(insightsCompleted, qnaCompleted, jsonFormatted, qnaResponse, mcode, targetBlock);
        }
      };

      if (isSnapshotTrend) {
        // --- CALL 1: Standard Summary ---
        this.apiService.snapshotSummaryAgentStream({ ...basePayload, stream: true }).subscribe({
          next: (event) => {
            const text = this.extractTextFromStreamEvent(event);
            if (text && text !== 'done') {
              this.snapshotinsights_standard_text += text;
              if (!this.isTrendActive) {
                if (!firstChunkReceived) {
                  firstChunkReceived = true;
                  this.InsightsResponse = { header: 'Insights (Streaming...)', message: 'Generating standard insights...', show: true };
                  this._insightsSerive.showInisghts(this.InsightsResponse);
                }
                insightsResponse = this.snapshotinsights_standard_text;
                this.processInsightsChunkRealTime(text, insightsResponse);
              }
            }
          },
          error: (err) => {
            console.error('[Standard Insights Error]:', err);
            this.snapshotinsights_standard_text += '\n[Standard Insights Error]\n';
            if (!this.isTrendActive) {
              insightsCompleted = true;
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, this.snapshotinsights_standard_text, qnaResponse, mcode, targetBlock);
            }
          },
          complete: () => {
            standardDone = true;

            if (!this.isTrendActive) {
              const finalStandard = this.snapshotinsights_standard_text;
              insightsResponse = finalStandard;
              this.isInsightsStreaming = false; // Reset streaming flag
              this.processInsightsChunkFinal(finalStandard);
              // Show UI as done, but let finalizeDualInsights handle history/completion if needed
            }
            finalizeDualInsights();
          }
        });

        // --- CALL 2: Trend Summary ---
        (async () => {
          const trendBasePayload = await MarkdownPayloadHelper.buildMarkdownPayload(this, true); // Get trend markdown
          this.apiService.snapshotSummaryAgentStream({ ...trendBasePayload, stream: true }).subscribe({
            next: (event) => {
              const text = this.extractTextFromStreamEvent(event);
              if (text && text !== 'done') {
                this.snapshotinsights_trendline_text += text;
                if (this.isTrendActive) {
                  if (!firstChunkReceived) {
                    firstChunkReceived = true;
                    this.InsightsResponse = { header: 'Trend Insights (Streaming...)', message: 'Generating trend analysis...', show: true };
                    this._insightsSerive.showInisghts(this.InsightsResponse);
                  }
                  insightsResponse = this.snapshotinsights_trendline_text;
                  this.processInsightsChunkRealTime(text, insightsResponse);
                }
              }
            },
            error: (err) => {
              console.error('[Trend Insights Error]:', err);
              this.snapshotinsights_trendline_text += '\n[Trend Insights Error]\n';
              if (this.isTrendActive) {
                insightsCompleted = true;
                this.checkStreamCompletion(insightsCompleted, qnaCompleted, this.snapshotinsights_trendline_text, qnaResponse, mcode, targetBlock);
              }
            },
            complete: () => {
              trendDone = true;

              if (this.isTrendActive) {
                const finalTrend = this.snapshotinsights_trendline_text;
                insightsResponse = finalTrend;
                this.processInsightsChunkFinal(finalTrend);
              }
              finalizeDualInsights();
            }
          });
        })();

      } else {
        // 1. Single Summary Agent logic
        let summaryObs$: Observable<any> | null = null;
        const summaryPayload = { ...basePayload, stream: true };

        if (mcode === 1) summaryObs$ = this.apiService.snapshotSummaryAgentStream(summaryPayload);
        else if (mcode === 2) summaryObs$ = this.apiService.brandAnalysisSummaryAgentStream(summaryPayload);
        else if (mcode === 3) summaryObs$ = this.apiService.crosstabSummaryAgentStream(summaryPayload);

        if (summaryObs$) {
          summaryObs$.subscribe({
            next: (event) => {
              if (!firstChunkReceived) {
                firstChunkReceived = true;
                this.InsightsResponse = {
                  header: 'Insights (Streaming...)',
                  message: 'AI is generating insights in real-time...',
                  show: true,
                };
                this._insightsSerive.showInisghts(this.InsightsResponse);
              }

              const text = this.extractTextFromStreamEvent(event);

              if (text && text !== 'done') {
                insightsResponse += text;
                this.processInsightsChunkRealTime(text, insightsResponse);
              }
            },
            error: (err) => {
              console.error('[Insights Stream Error]:', err);
              insightsResponse += '\n[Insights Error]\n';
              insightsCompleted = true;
              this.insightsVal = ['Insights Generation failed.'];
              this.updateInsightsPopupFinal();
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode, targetBlock);
            },
            complete: () => {
              insightsCompleted = true;
              if (insightsResponse && !this.insightsStreamingText) this.insightsStreamingText = insightsResponse;
              this.processInsightsChunkFinal(this.insightsStreamingText || insightsResponse);

              let formattedInsights = this.insightsStreamingText || insightsResponse;
              if (mcode === 1) {
                formattedInsights = JSON.stringify({ "insights": { "Value": (formattedInsights || "No Data Available").trim() } });
              }
              this.pushChatResponseEntry((mcode === 1 ? 'getSnapshotInsights' : 'getInsights'), formattedInsights);
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, formattedInsights, qnaResponse, mcode, targetBlock);
            }
          });
        }
      }

      // 2. Q&A Agent - Always streaming for real-time interaction
      let qnaObs$: Observable<any> | null = null;
      const qnaPayload = { ...basePayload, stream: true };

      if (mcode === 1) qnaObs$ = this.apiService.snapshotQaAgentStream(qnaPayload);
      else if (mcode === 2) qnaObs$ = this.apiService.brandAnalysisQaAgentStream(qnaPayload);
      else if (mcode === 3) qnaObs$ = this.apiService.crosstabQaAgentStream(qnaPayload);

      if (qnaObs$) {
        qnaObs$.subscribe({
          next: (event) => {
            // if (this.arktabaccess) {
            //   this.stopAiLoader();
            //   this.arktabaccess = false;
            // }

            let text = '';
            if (event.event === 'text_delta') {
              text = event.data?.delta || '';
            } else if (typeof event.data === 'string') {
              text = event.data;
            } else if (event.data) {
              text = event.data.delta || event.data.chunk || event.data.Value || '';
            }

            if (text && text !== 'done') {
              qnaResponse += text;
              this.updateMarkdownTextRealTime(qnaResponse);
            }
          },
          error: (err) => {
            console.error('[QnA Stream Error]:', err);
            qnaResponse += '\n[QnA Stream Error]\n';
            qnaCompleted = true;
            this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode, targetBlock);
          },
          complete: () => {
            qnaCompleted = true;
            this.pushChatResponseEntry('getQnA', qnaResponse);
            this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode, targetBlock);
          }
        });
      }
    } catch (error) {
      console.error('[Insights Error]:', error);
      this.insightsVal = ['Failed to authenticate or build payload.'];
      this.stopAiLoader();
      this.arktabaccess = false;
      const innerMsgId = targetBlock?.messageId || this.selectedMessageId || 'current';
      if (this.inFlightInsights[innerMsgId]) {
        this.inFlightInsights[innerMsgId].delete(mcode);
      }
    }
  }

  private processInsightsChunkRealTime(newChunk: string, fullResponse: string): void {
    try {
      this.insightsStreamingText += newChunk;
      this.insightsStreamingPoints = this.formatInsightsIntoPoints(this.insightsStreamingText);
      this.updateInsightsPopupRealTime();
    } catch (error) {
    }
  }

  private processInsightsChunkFinal(fullInsightsResponse: string): void {
    this.isInsightsStreaming = false; // Streaming complete
    try {
      const rawInsightsForSaving = fullInsightsResponse;
      let parsedInsights: any;
      try {
        parsedInsights = JSON.parse(fullInsightsResponse);
      } catch (e) {
        parsedInsights = null;
      }

      if (parsedInsights && typeof parsedInsights === 'object') {
        let combinedInsightsText = '';
        let insightsFound = false;

        for (const section in parsedInsights) {
          if (parsedInsights[section] && parsedInsights[section].Value) {
            combinedInsightsText += parsedInsights[section].Value + '\n';
            insightsFound = true;
          }
        }

        if (insightsFound) {
          this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);
        } else {
          this.insightsVal = ["No Data Available"];
        }
      } else if (fullInsightsResponse && fullInsightsResponse.trim() !== "") {
        this.insightsVal = this.formatInsightsIntoPoints(fullInsightsResponse);
      } else {
        this.insightsVal = ["No Data Available"];
      }
      this.updateInsightsPopupFinal();

      setTimeout(() => {
        this.scrollInsightsToTopSmooth();
      }, 500);

    } catch (error) {
      this.insightsVal = ['Failed to process insights.'];
      this.updateInsightsPopupFinal();

      setTimeout(() => {
        this.scrollInsightsToTopSmooth();
      }, 300);
    }
  }

  private formatInsightsIntoPoints(text: any): string[] {
    if (!text) {
      return [];
    }

    let rawText = '';

    // Determine the raw source text based on data type
    if (typeof text === 'string') {
      rawText = text;
    } else if (typeof text === 'object') {
      // Handle the case where we've received or parsed an object structure
      // Case 1: Direct Value property (e.g. { Value: "..." })
      if (text.Value && typeof text.Value === 'string') {
        rawText = text.Value;
      }
      // Case 2: Nested insights (e.g. { insights: { Value: "..." } })
      else if (text.insights && text.insights.Value && typeof text.insights.Value === 'string') {
        rawText = text.insights.Value;
      }
      // Case 3: Keyed sections (common in original insights Response e.g. { "Section 1": { Value: "..." } })
      else {
        let combinedVal = '';
        let foundValue = false;

        for (const key in text) {
          if (text[key] && text[key].Value && typeof text[key].Value === 'string') {
            combinedVal += text[key].Value + '\n';
            foundValue = true;
          }
        }

        if (foundValue) {
          rawText = combinedVal;
        } else {
          // If no recognized structure, fallback to string representation
          try {
            rawText = JSON.stringify(text);
          } catch (e) {
            rawText = String(text);
          }
        }
      }
    } else {
      rawText = String(text);
    }

    // Handle dual-view snapshot insights (Standard vs Trend)
    if (rawText.includes('[[[SPLIT]]]')) {
      const parts = rawText.split('[[[SPLIT]]]');
      rawText = this.isTrendActive ? (parts[1] || parts[0]) : parts[0];
    }

    // Safety check that rawText is now a string and has a trim method
    if (!rawText || typeof rawText.trim !== 'function' || rawText.trim() === '') {
      return [];
    }

    let cleanedText = this.cleanStreamingArtifacts(rawText);

    cleanedText = cleanedText
      .replace(/##+\s*/g, '')   // Remove all markdown headers (# ## ### etc.)
      .replace(/^---+\s*$/gm, '') // Remove horizontal rules without breaking table separators
      .replace(/\n\n+/g, '\n')  // Collapse multiple newlines
      .trim();

    // SPLIT LOGIC: Use a stateful parser to identify points while keeping tables whole
    const lines = cleanedText.split(/\n/);
    let points: string[] = [];
    let currentPoint = '';
    let inTable = false;

    lines.forEach(line => {
      const trimmedLine = line.trim();
      const isTableLine = trimmedLine.startsWith('|');

      if (isTableLine) {
        // If we were building a non-table point, save it and start the table
        if (!inTable && currentPoint.trim() !== '') {
          points.push(currentPoint.trim());
          currentPoint = '';
        }
        inTable = true;
        currentPoint += (currentPoint ? '\n' : '') + line;
      } else {
        // If we're coming out of a table, save the table block first
        if (inTable) {
          points.push(currentPoint.trim());
          currentPoint = '';
          inTable = false;
        }

        // Handle normal point splitting: Start a new point for every non-empty line
        if (trimmedLine !== '') {
          if (currentPoint.trim() !== '') {
            points.push(currentPoint.trim());
          }
          currentPoint = line;
        }
      }
    });

    // Push the final remaining point
    if (currentPoint.trim() !== '') {
      points.push(currentPoint.trim());
    }

    let finalPoints = points
      .map((pointText: string) => {
        // Only clean non-table lines deeply
        if (pointText.includes('|')) {
          return pointText;
        }

        let cleaned = pointText
          .replace(/^[-•*]\s*/, '')  // Remove bullet markers at start of the point
          .replace(/^\s*-\s*/, '')   // Remove hyphens
          .replace(/\s+/g, ' ')       // Collapse multiple internal spaces
          .trim();

        // Ensure each distinct point (if sentence-like) has a period if not ending in punctuation
        if (cleaned && !cleaned.match(/[.!?]$/) && cleaned.length > 20) {
          cleaned += '.';
        }

        return cleaned;
      })
      .filter((p: string) => p.length > 2); // Keep all valid points

    return finalPoints.length > 0 ? finalPoints : ["No Data Available"];
  }

  private extractTextFromStreamEvent(event: any): string {
    if (!event) return '';
    if (event.event === 'text_delta') {
      return event.data?.delta || '';
    } else if (typeof event.data === 'string') {
      return event.data;
    } else if (event.data) {
      let text = event.data.delta || event.data.chunk || event.data.Value || (typeof event.data === 'string' ? event.data : '');
      if (!text && event.data.insights && event.data.insights.Value) {
        text = event.data.insights.Value;
      }
      return text;
    }
    return '';
  }

  private cleanStreamingArtifacts(text: string): string {
    let cleaned = text;

    cleaned = cleaned.replace(/data:\s*/gi, '');
    cleaned = cleaned.replace(/event:\s*\w+/gi, '');

    // Fix Unicode character encoding issues common in streaming
    cleaned = cleaned.replace(/â€œ/g, '"');  // Opening quote
    cleaned = cleaned.replace(/â€/g, '"');   // Closing quote  
    cleaned = cleaned.replace(/â€'/g, '—');  // Em dash
    cleaned = cleaned.replace(/â€'/g, '-');  // En dash

    // Fix Unicode character encoding issues common in streaming

    // Fix spacing between numbers and words (e.g., "past12months" → "past 12 months")
    cleaned = cleaned.replace(/([a-z])(\d+)/gi, '$1 $2');
    cleaned = cleaned.replace(/(\d+)([a-z])/gi, '$1 $2');

    // Fix hyphenated or dashed words that got spaces (e.g., "12 -month" → "12-month")
    cleaned = cleaned.replace(/(\d+)\s*-\s*([a-z]+)/gi, '$1-$2');

    // Fix both literal string "\n" and encoded "\\n" artifacts
    cleaned = cleaned.replace(/\\n/g, '\n');

    // Collapse multiple horizontal spaces only (preserve newlines for list splitting)
    cleaned = cleaned.replace(/[ \t]+/g, ' ');

    return cleaned;
  }

  private updateInsightsPopupRealTime(): void {
    try {
      if (!this.isInsightspopupOpen) {
        this.isInsightspopupOpen = true;
      }

      const currentText = Array.isArray(this.insightsVal) && this.insightsVal.length > 0
        ? this.insightsVal[0]
        : '';

      this.InsightsResponse = {
        header: 'Insights (Streaming...)',
        message: currentText,
        show: true,
      };
      this._insightsSerive.showInisghts(this.InsightsResponse);

    } catch (error) {
    }
  }

  private updateInsightsPopupFinal(): void {
    try {
      this.InsightsResponse = {
        header: 'Insights',
        message: Array.isArray(this.insightsVal) ? this.insightsVal.join('\n') : String(this.insightsVal),
        show: true,
      };

      this._insightsSerive.showInisghts(this.InsightsResponse);

    } catch (error) {
    }
  }


  private scrollInsightsDownSmooth(): void {
    try {
      this.stopInsightsAutoScroll();

      const activeIndex = this.chatPreviewBlocks.findIndex(b => b.messageId === this.selectedMessageId);
      const activeContainer = this.insightsContainers?.toArray()[activeIndex];

      if (activeContainer && activeContainer.nativeElement) {
        const scrollableContainer = activeContainer.nativeElement.closest('.output-insights');

        if (scrollableContainer) {
          const currentScrollTop = scrollableContainer.scrollTop;
          const maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;

          if (maxScrollTop > 0 && currentScrollTop < maxScrollTop) {
            this.isInsightsScrolling = true;
            const scrollStep = Math.max(2, Math.ceil((maxScrollTop - currentScrollTop) / 20));

            this.insightsScrollInterval = setInterval(() => {
              const newScrollTop = scrollableContainer.scrollTop + scrollStep;

              if (newScrollTop >= maxScrollTop) {
                scrollableContainer.scrollTop = maxScrollTop;
                this.stopInsightsAutoScroll();
              } else {
                scrollableContainer.scrollTop = newScrollTop;
              }
            }, 50);
          }
        }
      }
    } catch (error) {
      console.warn('Error during insights auto-scroll:', error);
      this.stopInsightsAutoScroll();
    }
  }

  private scrollInsightsToTopSmooth(): void {
    try {
      this.stopInsightsAutoScroll();

      const activeIndex = this.chatPreviewBlocks.findIndex(b => b.messageId === this.selectedMessageId);
      const activeContainer = this.insightsContainers?.toArray()[activeIndex];

      if (activeContainer && activeContainer.nativeElement) {
        const el = activeContainer.nativeElement;
        el.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } catch (error) {
      console.warn('Error during insights scroll to top:', error);
    }
  }


  private stopInsightsAutoScroll(): void {
    if (this.insightsScrollInterval) {
      clearInterval(this.insightsScrollInterval);
      this.insightsScrollInterval = null;
    }
    this.isInsightsScrolling = false;
  }

  private updateMarkdownTextRealTime(qnaResponse: string): void {
    try {
      if (qnaResponse && qnaResponse.trim() !== "") {
        let cleanedQnaText = this.cleanQnaTextForParaOnly(qnaResponse);

        cleanedQnaText = cleanedQnaText
          .replace(/\s+/g, ' ')  // Collapse multiple spaces
          .replace(/^\s+|\s+$/g, '')  // Trim
          .trim();

        this.updateQuestionAnswerForSelectedMessage(cleanedQnaText);
      }
    } catch (error) {
      console.warn('Error updating markdown text in real-time:', error);
    }
  }

  /**
   * Helper to strip markdown tables from QnA text, leaving only paragraphs.
   */
  private cleanQnaTextForParaOnly(text: string): string {
    if (!text) return "";

    // Split by actual newlines or literal \n strings common in streams
    const lines = text.split(/\n|\\n/);

    return lines
      .filter(line => {
        const trimmed = line.trim();
        // Ignore lines that look like markdown table rows or separators
        if (trimmed.startsWith('|') || (trimmed.startsWith('+-') && trimmed.endsWith('-+')) || (trimmed.startsWith('|-') && trimmed.endsWith('-|'))) {
          return false;
        }
        return true;
      })
      .join('\n')
      .trim();
  }

  private checkStreamCompletion(
    insightsCompleted: boolean,
    qnaCompleted: boolean,
    insightsResponse: string,
    qnaResponse: string,
    mcode: number,
    targetBlock?: any
  ): void {
    if (insightsCompleted && qnaCompleted) {
      let finalQnaText = 'No data Available';
      if (mcode === 1) {
        let snapshotQnaText = 'No data Available';
        try {
          if (qnaResponse && qnaResponse.trim() !== "") {
            snapshotQnaText = this.cleanQnaTextForParaOnly(qnaResponse)
              .replace(/^[^:]+:\s*/, '')  // Remove prefixes like "Answer:"
              .replace(/\\n/g, ' ')  // Replace escaped newlines
              .replace(/\n/g, ' ')  // Replace actual newlines
              .trim();
          }
        } catch (e) {
          console.warn('Error processing snapshot QnA text:', e);
        }
        finalQnaText = snapshotQnaText;
        this.updateQuestionAnswerForSelectedMessage(snapshotQnaText);
      } else {
        let processedQnaText = 'No data Available';
        try {
          if (qnaResponse && qnaResponse.trim() !== "") {
            processedQnaText = this.cleanQnaTextForParaOnly(qnaResponse)
              .replace(/^[^:]+:\s*/, '')  // Remove prefixes like "Answer:"
              .replace(/\\n/g, ' ')  // Replace escaped newlines
              .replace(/\n/g, ' ')  // Replace actual newlines
              .trim();
          }
        } catch (e) {
          console.warn('Error processing crosstab/brand analysis QnA text:', e);
        }
        finalQnaText = processedQnaText;
        this.updateQuestionAnswerForSelectedMessage(processedQnaText);
      }

      this.isStreamFinished = true; // Mark insights stream as successfully finished!
      this.statusQueue = []; // Clear queue to instantly show post-stream message
      this._insightsSerive.showInisghts(this.InsightsResponse);
      setTimeout(() => {
        this.stopAiLoader();
        this.arktabaccess = false;
      }, 1500);

      // Update the session cache for multi-view persistence BEFORE saving history
      const msgId = targetBlock?.messageId || this.selectedMessageId || 'current';
      if (!this.multiViewInsightsCache[msgId]) {
        this.multiViewInsightsCache[msgId] = {};
      }
      if (!this.multiViewInsightsCache[msgId][mcode]) {
        this.multiViewInsightsCache[msgId][mcode] = {} as any;
      }
      this.multiViewInsightsCache[msgId][mcode].insightsVal = this.insightsVal;
      this.multiViewInsightsCache[msgId][mcode].qnaText = finalQnaText;
      if (mcode !== 1) {
        this.multiViewInsightsCache[msgId][mcode].rawInsights = insightsResponse;
      } else {
        this.multiViewInsightsCache[msgId][mcode].standard_insights = this.snapshotinsights_standard_text;
        this.multiViewInsightsCache[msgId][mcode].trend_insights = this.snapshotinsights_trendline_text;
        const combinedRaw = (this.snapshotinsights_standard_text || '').trim() + "[[[SPLIT]]]" + (this.snapshotinsights_trendline_text || '').trim();
        this.multiViewInsightsCache[msgId][mcode].rawInsights = combinedRaw;
      }

      // Save history AFTER cache is populated so that getInsights is bundled into ES!
      const doSave = () => {
        this.saveChatList(
          targetBlock ? targetBlock.question : (this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue),
          this.chatResponse,
          finalQnaText,
          targetBlock?.messageId
        );
        this.chatResponse = [];
        const innerMsgId = targetBlock?.messageId || this.selectedMessageId || 'current';
        if (this.inFlightInsights[innerMsgId]) {
          this.inFlightInsights[innerMsgId].delete(mcode);
        }
      };

      if ((this as any).pendingBackgroundFetches) {
        (this as any).pendingBackgroundFetches.then(doSave).catch((err: any) => {
           console.error('[ORCHESTRATION] Error waiting for background fetches before save:', err);
           doSave();
        });
      } else {
        doSave();
      }
    }
  }

  buildSnapshotMarkdownForAPI(): string {
    return InsightsGeneratorHelper.buildSnapshotMarkdownForAPI(
      this.OutputData,
      this.isTotalBase,
      this.selectedWeight,
      Number(this.insufficientBase || 0)
    );
  }

  buildCrosstabMarkdownForAPI(): string {
    return InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(
      this.CrossTabOutPutData,
      this.isTotalBase,
      this.selectedWeight,
      Number(this.insufficientBase || 0)
    );
  }

  private resetSessionState(): void {
    // 1. Reset Toggle States
    this.isTranspose = false;
    this.isHideNA = false;
    this.isTotal = false;
    this.chartType = CHART_TYPES.COLUMN;
    this.is_TransposeBtn = false;
    this.is_chart_visualization = false;
    this.isVerticalBarChartClick = false;
    this.isLineChartClick = false;
    this.isVerticalStackChartClick = false;
    this.isVerticalGroupBarChartClick = false;
    this.disableStackChart = false;
    this.disableLineChart = false;
    this.StackFlag = false;
    this.isData = true;
    this.isWeightedLabel = false;
    this.isSampleSizeBlock = false;
    this.isWeightedSampleBlock = false;
    this.isWeightedNumerator = false;
    this.isUnWeightedNumerator = false;
    this.isTotalBase = true;
    this.isAnswerBase = false;
    this.isReference = false;
    this.isSig = true;
    this.isIndex = false;
    this.isTrendActive = false;
    this.isTrendAvailable = false;
    this.displayTable = false;
    this.isTableView = false;
    this.isChartView = true;
    this.isListView = true;
    this.isTableClick = false;

    // 2. Reset Selected Data Formats
    this.selectedDataFormat = '';
    
    // Reset Error States
    this.failedCase = false;
    this.noContentFlag = false;
    this.isInsightspopupOpen = false;
    this.errorHeader = '';
    
    // Reset weights to configuration defaults instead of empty string
    const defaultWeightObj = this.configWeights?.find((x: any) => 
      x.is_default === true || 
      x.is_active === true || 
      x.is_default_weight === true || 
      x.default === true
    );
    let matchedDropdown;
    if (defaultWeightObj) {
      matchedDropdown = this.WeightDropDownList?.find(w => w.responseCode === defaultWeightObj.variable_code || (defaultWeightObj.variable_label === 'Unweighted' && w.Label === 'Unweighted'));
    }
    if (matchedDropdown) {
      this.selectedWeight = matchedDropdown.responseCode;
      this.DefaultWeight = matchedDropdown.Label;
    } else {
      const primaryWeight = this.WeightDropDownList?.find(w => w.Label === 'Primary Weight');
      if (primaryWeight) {
        this.selectedWeight = primaryWeight.responseCode;
        this.DefaultWeight = primaryWeight.Label;
      } else {
        const unweighted = this.WeightDropDownList?.find(w => w.Label === 'Unweighted' || w.responseCode === 'Unweighted');
        if (unweighted) {
          this.selectedWeight = unweighted.responseCode;
          this.DefaultWeight = unweighted.Label;
        } else if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
          this.selectedWeight = this.WeightDropDownList[0].responseCode;
          this.DefaultWeight = this.WeightDropDownList[0].Label;
        } else {
          this.selectedWeight = '';
          this.DefaultWeight = '';
        }
      }
    }
    
    this.selectedIndex = '';
    this.threshold = '';
    this.SignificanceVsReference = '';

    // 3. Reset Data Caches / Global Objects
    this.CrossTabOutPutEntireData = [];
    this.CrossTabOutPutData = [];
    this.insightsVal = [];
    this.selectionSummary = '';
    this.defaultQuestionAnswer = 'Answering question...';

    this.LineChart = { title: '', Data: [], Properties: [] };
    this.StackChart = { title: '', Data: [], Properties: [] };
    this.BarChart = { title: '', Data: [], Properties: [] };

    this.dataObject = { Row: [], Column: [], RowNesting: [], ColNesting: [], Filter: [], CustomGroup: [], CustomCalculation: [] };
    this.OutputdataObject = { Row: [], Column: [], RowNesting: [], ColNesting: [], Filter: [], CustomGroup: [], CustomCalculation: [] } as any;

    // 4. Reset Multi-View States
    this.availableViews = [];
    this.activeView = null;
    this.allMemberResponses = null;
    this.orchestrationRawData = null;

    // 5. Reset Dropdowns/Panels
    this.sampleSizeDropdown = false;
    this.confidenceLevelDropDown = false;
    this.referenceLevelDropDown = false;
    this.BaseDropDownToggle = false;
    this.weightDropDown = false;
    this.dataDropDown = false;
  }

  sendInputMessage(ChatResponse?: any, isChatResponse: boolean = false, targetBlock: any = null) {
    this.streamStatusText = '';
    this.currentView = 'chat';
    if (this.isNewChatStarted && !isChatResponse && this.abandoningSessionId) {
      this.isNewChatStarted = false;
      const sessionToDelete = this.abandoningSessionId;
      from(this.getBearerToken()).pipe(
        switchMap(token => forkJoin([
          this.apiService.deleteRestrictedCache(token, sessionToDelete, true),
          this.apiService.deleteClientStudyContext(token, sessionToDelete)
        ]))
      ).subscribe({
        next: () => {
          this.abandoningSessionId = '';
        },
        error: (err) => console.error('[ChatbotService] Error deleting abandoned session cache/context:', err)
      });
    }

    if (!isChatResponse)
      this.selectedChatId = null;
    this.moduleSelectionToggle = false;
    this.showModuleDropdown = false;
    this.askMeLanding = false;

    if (!isChatResponse && this.isInsightsStreaming) {
      console.warn('[SEND GUARD] Cannot send input - stream is active');
      return;
    }

    // 1. PUSH QUESTION IMMEDIATELY FOR INSTANT UI FEEDBACK
    if (!isChatResponse && this.inputValue && this.inputValue.trim()) {
      this.isHistorySaving = true;
      this.isWaitingForFinalSave = true;
      // Remove any trailing failed question from the UI before pushing the new one
      if (this.chatPreviewBlocks.length > 0) {
        const lastBlock = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
        if (lastBlock.failedCase) {
          this.chatPreviewBlocks.pop();
          this.chatResponse = []; // Clear pending payload so it isn't saved to history
        }
      }

      this.resetSessionState(); // Reset global component state for fresh question
      const tempId = ChatHistoryHelper.generateGuid();
      this.chatPreviewBlocks.push({
        question: this.inputValue,
        messageId: tempId,
        isTemp: true,
        response: '',
        isLiked: null,
        isStarred: false,
        feedbackSaved: false,
        showLikeInput: false,
        likeReason: '',
        showDislikeInput: false,
        dislikeReason: '',
        QuestionAnswer: this.defaultQuestionAnswer,
        isTrendActive: this.isTrendActive,
        isExportspopup: false,
        sampleSizeDropdown: false,
        confidenceLevelDropDown: false,
        referenceLevelDropDown: false,
        baseDropDown: false,
        weightDropDown: false,
        isReference: false,
        isSig: true,
        isIndex: false,
        DefaultSampleSize: 'None',
        SignificanceVsReference: '',
        DefaultConfidenceLevel: '95%',
        DefaultReferenceLevel: 'None',
        selectedWeight: this.selectedWeight || 'Weight',
        DefaultWeight: this.DefaultWeight || 'Total Population',
        DefaultBase: this.DefaultBase || 'Total Base',
        isTotalBase: true,
        isAnswerBase: true,
        is_sigtesting: true,
        is_Time_Period_Present: true,
        isTranspose: false,
        dataDropDown: false,
        DefaultDataDropDown: 'Data',
        isTableClick: true,
        isVerticalStackChartClick: false,
        isVerticalBarChartClick: false,
        isVerticalGroupBarChartClick: false,
        isLineChartClick: false,
        isChartView: true,
        disableStackChart: false,
        disableLineChart: false,
        showStackTooltip: false,
        showLineTooltip: false,
        showBarTooltip: false,
        showMainTooltip: false,
        StackFlag: false,
        displayTable: true,
        isTableClosing: false,
        isChartClosing: false,
        // Isolated Chart Objects
        StackChart: { title: '', Data: [], Properties: [] },
        LineChart: { title: '', Data: [], Properties: [] },
        BarChart: { title: '', Data: [], Properties: [] },
        // Isolated Data Storage
        OutputdataObject: { Row: [], Column: [], RowNesting: [], ColNesting: [], Filter: [], CustomGroup: [], CustomCalculation: [] },
        CrossTabOutPutData: []
      });
      // Capture input for orchestration and clear immediately for UX
      const submittedQuery = this.inputValue;
      this.currentQueryForStream = submittedQuery;
      this.hasPendingQuery = true; // Flag to ensure the flow continues
      this.selectedMessageId = null; // Clear selected message so empty UI isn't shown
      this.inputValue = '';
      const containerHeight = this.chatHistoryScroll?.nativeElement?.clientHeight || 600;
      this.scrollSpacerHeight = containerHeight;
      this.cdr.detectChanges();

      // Instantly trigger scroll to align the new question at the top of the container!
      this.scrollToMessage(tempId, 'start');
    }

    if (isChatResponse) {
      this.isInsightsStreaming = false; // Not streaming when loading history
    } else {
      this.isInsightsStreaming = true;
      this.availableViews = [];
      this.activeView = null;
      this.orchestrationRawData = null;
      this.allMemberResponses = null;
      this.setFailedCaseState(false, targetBlock);
      this.noContentFlag = false;
    }

    if (this.hasPendingQuery || isChatResponse) {
      this.hasPendingQuery = false;
      this.displayTable = false;
      this.showSnapshot = false;
      this.isCreateBtnClick = false;
      this.is_indexing = false;
      this.is_sigtesting = false;
      this.insightsVal = '';
      this.insightsStreamingText = '';
      this.insightsStreamingPoints = [];
      this.isselectionsummarycollapse = false;
      this.isselectionsummarycollapse2 = false;
      this.OutputdataObject.Row = [];
      this.OutputdataObject.Column = [];

      // DEFER THE HEAVY LOADING AND ORCHESTRATION TO ALLOW BROWSER PAINT
      const delay = (!isChatResponse && this.chatPreviewBlocks.filter(b => b.question).length > 1) ? 500 : 0;
      setTimeout(() => {
        this.displayTable = false;
        this.showSnapshot = false;
        this.isCreateBtnClick = false;
        this.is_indexing = false;
        this.is_sigtesting = false;
        this.insightsVal = '';
        this.insightsStreamingText = '';
        this.insightsStreamingPoints = [];
        this.MainResult = undefined;
        this.OutputData = [];
        this.CrossTabOutPutData = [];
        this._configService.updateSignificanceValue('None');
        this._configService.updateConfedenceValue('None');
        this._configService.IndexSelected = false;
        this._configService.baseSelected = 'Total Base';
        this._configService.isTotalBase = true;
        this.arktabaccess = true;
        this.isStreamFinished = false;
        this.startAiLoader();

        this.isVerticalGroupBarChartClick = false;
        this.isVerticalBarChartClick = false;
        this.isVerticalStackChartClick = false;
        this.isLineChartClick = false;
        this.isInsightspopupOpen = false;

        this.continueProcessingMessage(ChatResponse, isChatResponse, targetBlock);
      }, delay);
    }
  }

  /**
   * Separated logic for the heavy orchestration and API calls
   */
  private continueProcessingMessage(ChatResponse: any, isChatResponse: boolean, targetBlock: any = null) {
    if (!targetBlock && !isChatResponse && this.chatPreviewBlocks.length > 0) {
      targetBlock = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
    }

    if (this.inputValue !== '' || isChatResponse || true) { // Always true if called here
      // History saving logic for previous block if needed
      if (this.chatResponse && this.chatResponse.length > 0 && this.chatPreviewBlocks.length > 1) {
        const lastQuestion = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 2];
        const questionAnswer = lastQuestion.QuestionAnswer || this.defaultQuestionAnswer;

        this.saveChatList(
          lastQuestion.question,
          this.chatResponse,
          questionAnswer,
          lastQuestion.messageId
        );
      }
      this.setFailedCaseState(false, targetBlock);
      this.chatResponse = [];
      let AgentPayload: any = null;
      let getSnapshotConfiguration: any = null;
      let GetCustomSnapshotWidget: any = null;
      let GetQuery: any = null;
      let getSnapshotOutput: any = null;
      let getSnapshotLoadData: any = null;
      let getConfiguration: any = null;
      let getSnapshotInsights: any = null;
      let getSnapshotInsightsTrend: any = null;
      let getInsights: any = null;
      let getQnA: any = null;
      let parsedHistory: any = null;

      if (isChatResponse) {
        const parsed = this.parseChatResponse(ChatResponse);
        parsedHistory = parsed;

        AgentPayload = parsed['AgentPayload'] || parsed['GetMcode'];
        if (typeof AgentPayload === 'number' || !AgentPayload) {
          AgentPayload = { event: 'final_result', data: ChatResponse, isChatResponse: true, messageId: this.selectedMessageId, member_responses: parsed['member_responses'] };
        } else if (!AgentPayload.event) {
          AgentPayload = { event: 'final_result', data: ChatResponse, isChatResponse: true, messageId: this.selectedMessageId, member_responses: parsed['member_responses'] };
        }
        getSnapshotConfiguration = parsed['getSnapshotConfiguration'];
        GetCustomSnapshotWidget = parsed['GetCustomSnapshotWidget'];
        GetQuery = parsed['GetQuery'];
        getSnapshotOutput = parsed['getSnapshotOutput'];
        getSnapshotLoadData = parsed['getSnapshotLoadData'];
        getConfiguration = parsed['getConfiguration'];
        getSnapshotInsights = parsed['getSnapshotInsights'];
        getSnapshotInsightsTrend = parsed.getSnapshotInsightsTrend;
        getInsights = parsed['getInsights'];
        getQnA = parsed['getQnA'];

        // Determine default view for historical snapshot: 1 brand -> Trend, Multi -> Normal
        if (AgentPayload && AgentPayload.promptData) {
          const pData = AgentPayload.promptData;
          const brands = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
          const combinedInsights = getSnapshotInsights || '';
          const hasTrendInsights = !!getSnapshotInsightsTrend || (typeof combinedInsights === 'string' && combinedInsights.includes('[[[SPLIT]]]'));

          if (hasTrendInsights && brands.length === 1) {
            this.isTrendActive = true;
          } else {
            this.isTrendActive = false;
          }
        }
        // Assign restored configuration to service for analytical controls
        if (getSnapshotConfiguration) {
          this._configService.outputSnapshotData = getSnapshotConfiguration;
          this.snapshotConfiguration = getSnapshotConfiguration; // Pass directly to popup
          if (getSnapshotConfiguration.brandMetadata) {
            this._configService.brandData = getSnapshotConfiguration.brandMetadata;
          }
          if (getSnapshotConfiguration.weights) {
            this._configService.weights = getSnapshotConfiguration.weights;
          }
        } else {
          console.warn('[CHATBOT] No getSnapshotConfiguration found in parsed response.');
        }
        this.snapshotinsights_standard_text = getSnapshotInsights || '';
        this.snapshotinsights_trendline_text = getSnapshotInsightsTrend || '';
      }

      const needAccessCheck = !isChatResponse && (!this.validatedSessionId || this.validatedSessionId !== this.guidChatId);

      // Helper to identify available analytical views from orchestration response
      const identifyAvailableViews = (rawData: any, parsedResponses?: any) => this.identifyAvailableViews(rawData, parsedResponses);


      const accessCheckRequest$ = needAccessCheck ? from(this.getBearerToken()).pipe(
        switchMap(token => {
          return this.apiService.accessCheck(
            this.selected_client,
            this.selected_study,
            token,
            this.guidChatId || ''
          );
        }),
        tap((res: any) => {
          if (res && res.session_id) {
            this.guidChatId = res.session_id;
            this.modulesAccess = res.modules_access;
            this.isCacheGenerated = false;
          }
          this.validatedSessionId = this.guidChatId;
        }),
        catchError((error) => {
          console.error('[ACCESS-CHECK ERROR] Access check failed:', error);
          return throwError(() => error);
        })
      ) : of(null);

      const generateCacheRequest$ = accessCheckRequest$.pipe(
        switchMap(() => {
          if (!this.isCacheGenerated && this.modulesAccess) {
            const activeModules: any = {};
            for (const [key, value] of Object.entries(this.modulesAccess)) {
              if ((value as any).has_access) {
                activeModules[key] = value;
              }
            }

            return from(this.getBearerToken()).pipe(
              switchMap(token => forkJoin([
                this.apiService.generateRestrictedCache(
                  this.selected_client,
                  this.selected_study,
                  token,
                  this.guidChatId,
                  activeModules
                ),
                this.apiService.generateClientStudyContext(
                  this.selected_client,
                  this.selected_study,
                  token,
                  this.guidChatId,
                  activeModules
                )
              ])),
              tap(() => {
                this.isCacheGenerated = true;
              }),
              catchError(err => {
                console.error('[CACHE ERROR] Cache/Context generation failed:', err);
                return of(null);
              })
            );
          }
          return of(null);
        })
      );

      const orchestrationRequest$ = AgentPayload && isChatResponse
        ? of(AgentPayload)
        : generateCacheRequest$.pipe(
          switchMap(() => {
            return this.getOrchestrationRequest();
          }),
          catchError((error) => {
            console.error('[ORCHESTRATION PIPE ERROR] Error in orchestration pipeline:', error);
            return throwError(() => error);
          })
        );

      if (AgentPayload && isChatResponse) {
      } else {
      }

      orchestrationRequest$.pipe(
        finalize(() => {
          this.scrollSpacerHeight = 0; // Absolute guarantee to clean up spacer on stream termination/error!
          if (isChatResponse) {
            this._loaderService.hideLoader();
          }
        })
      ).subscribe({
        next: async (response) => {
          let data = response;

          // Handle Snapshot Agent streaming events
          if (data && data.event) {
            if (data.event === 'final_result') {
              const rawData = data.data;
              let extractedMcode = rawData?.priority_mcode;
              if (extractedMcode === undefined || extractedMcode === null) {
                extractedMcode = data.mcode;
              }
              if (extractedMcode === undefined || extractedMcode === null) {
                extractedMcode = rawData.mcode || rawData.final_output?.mcode
                  || (rawData.member_responses ? (Object.values(rawData.member_responses)[0] as any)?.mcode : undefined);
              }
              if (extractedMcode === undefined || extractedMcode === null) {
                const firstChild = Object.values(rawData)[0] as any;
                extractedMcode = firstChild?.mcode || firstChild?.Mcode || 0;
              }
              let mcode = extractedMcode;
              this.mcode = mcode;
              this.isBrandAnalysis = (mcode === 2);

              // Store orchestration data for multi-view support
              this.orchestrationRawData = rawData;
              const isDirectMemberResponses = !!(rawData.snapshot || rawData.brand_analysis || rawData.brandanalysis || rawData.crosstab);
              this.allMemberResponses = rawData.member_responses || data.member_responses || (isDirectMemberResponses ? rawData : null);
              this.availableViews = identifyAvailableViews(rawData, this.allMemberResponses);

              // FAILSAFE: If identifyAvailableViews returned empty but we have allMemberResponses, build views directly
              if (this.availableViews.length === 0 && this.allMemberResponses) {
                console.warn('[MULTI-VIEW] identifyAvailableViews returned empty — building views directly from allMemberResponses keys:', Object.keys(this.allMemberResponses));
                const mr = this.allMemberResponses;
                const hasMrSnap = !!mr.snapshot;
                const hasMrBA = !!(mr.brand_analysis || mr.brandanalysis);
                const hasMrCT = !!mr.crosstab;
                if (hasMrSnap) this.availableViews.push({ name: 'Snapshot', mcode: 1, key: 'snapshot' });
                if (hasMrBA) this.availableViews.push({ name: 'Brand Analysis', mcode: 2, key: mr.brand_analysis ? 'brand_analysis' : 'brandanalysis' });
                if (hasMrCT) this.availableViews.push({ name: 'Crosstab', mcode: 3, key: 'crosstab' });
              }

              // ULTIMATE FAILSAFE: If still no views (single-module path, no member_responses), create one view based on mcode
              if (this.availableViews.length === 0) {
                const viewName = mcode === 1 ? 'Snapshot' : (mcode === 2 ? 'Brand Analysis' : 'Crosstab');
                const viewKey = mcode === 1 ? 'snapshot' : (mcode === 2 ? 'brand_analysis' : 'crosstab');
                this.availableViews = [{ name: viewName, mcode: mcode, key: viewKey }];
                console.warn('[MULTI-VIEW] Ultimate fallback — created single view for mcode:', mcode);
              }

              // Fallback logic: If Team API returned mcode 99 (error) but we have multi-module access,
              // check if any specialized agent has a valid result in member_responses to use as fallback.
              const activeCount = (this.hasSnapshotActive ? 1 : 0) + (this.hasBrandAnalysisActive ? 1 : 0) + (this.hasCrosstabActive ? 1 : 0);
              if (mcode === 99 && activeCount > 1 && this.allMemberResponses) {
                if (this.hasCrosstabActive && this.allMemberResponses.crosstab) {
                  console.warn('[ORCHESTRATION] Team API returned 99. Falling back to Crosstab results.');
                  mcode = 3;
                  this.mcode = 3;
                  this.isBrandAnalysis = false;
                  this.streamStatusText = 'Routing to Crosstab Analysis...';
                } else if (this.hasBrandAnalysisActive && (this.allMemberResponses.brand_analysis || this.allMemberResponses.brandanalysis)) {
                  console.warn('[ORCHESTRATION] Team API returned 99. Falling back to Brand Analysis results.');
                  mcode = 2;
                  this.mcode = 2;
                  this.isBrandAnalysis = true;
                  this.streamStatusText = 'Routing to Brand Analysis...';
                }
              }

              // [FIX] Always strictly sync activeView to match the final mcode.
              // availableViews.find(v => v.mcode === mcode) is authoritative.
              // If not found (module not in available views), fall back to first available and sync mcode.
              const newActiveView = this.availableViews.find(v => v.mcode === mcode) || this.availableViews[0];
              if (newActiveView && newActiveView.mcode !== mcode) {
                console.warn(`[MULTI-VIEW] mcode ${mcode} not found in available views. Syncing mcode to: ${newActiveView.mcode}`);
                mcode = newActiveView.mcode;
                this.mcode = mcode;
                this.isBrandAnalysis = (mcode === 2);
              }

              // Always update activeView to match final mcode — don't skip based on previous state
              this.activeView = newActiveView;
              if (targetBlock) {
                targetBlock.availableViews = [...this.availableViews];
                targetBlock.activeView = this.activeView;
                targetBlock.isBrandAnalysis = this.isBrandAnalysis;
              }

              // Priority extraction for Step 2 Payload: final_output -> member_responses -> result
              let result = rawData.final_output;
              if (!result || Object.keys(result).length === 0 || mcode !== rawData.final_output?.mcode) {
                if (this.allMemberResponses) {
                  // Select member response based on current (possibly fallback) mcode
                  if (mcode === 1) result = this.allMemberResponses.snapshot;
                  else if (mcode === 2) result = this.allMemberResponses.brand_analysis || this.allMemberResponses.brandanalysis;
                  else if (mcode === 3) result = this.allMemberResponses.crosstab;

                  // Absolute fallback to first available agent response if still empty
                  if (!result) result = Object.values(this.allMemberResponses)[0];
                }
              }

              if (!result || Object.keys(result).length === 0) {
                result = rawData.result || {};
              }
              this.chatPayload = this.constructSpecialized(mcode, result, rawData);

              // Construct Parallel Payload for Background Step 2 (if multi-module)
              this.parallelChatPayload = null;
              if (activeCount > 1 && rawData.member_responses) {
                // Secondary fallback: Crosstab > Brand Analysis
                if (this.hasCrosstabActive && mcode !== 3 && rawData.member_responses.crosstab) {
                  this.parallelChatPayload = this.constructSpecialized(3, rawData.member_responses.crosstab, rawData);
                }
              }

              // Update UI state with the result data
              this.promptData = result;
              this.isTotalBase = result.isTotalBase ?? false;
              this.selectedWeight = result.weight || result.Weight || this.selectedWeight;
              
              if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
                const matchedWeight = this.WeightDropDownList.find(w => w.responseCode === this.selectedWeight);
                this.DefaultWeight = matchedWeight ? matchedWeight.Label : (this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight);
              } else {
                this.DefaultWeight = this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight;
              }
              if (targetBlock) {
                targetBlock.selectedWeight = this.selectedWeight;
                targetBlock.DefaultWeight = this.DefaultWeight;
              }

              if (mcode === 1) {
                this.widget_Id = result.Widget_ID || result.widget_id || this.widget_Id;
                this.widget_Name = result.Widget_Name || result.widget_name || this.widget_Name;
              }

              // Normalize data structure for downstream dependencies
              const { timeline, total_elapsed_seconds, ...rest } = rawData;
              data = {
                ...rest,
                ...result,
                response: result || {}
              };
            } else if (['done', 'meta'].includes(data.event)) {
              return; // Skip system events
            } else {
              // Intermediate stream events

              // Only display 'status' event messages in the UI loader
              if (data.event === 'status') {
                // Support both structured {message: '...'} and plain string messages
                const statusMsg = data.message || data.data?.message || (typeof data.data === 'string' ? data.data : '');
                if (statusMsg && statusMsg.trim() !== '') {
                  const displayText = statusMsg.trim();
                  this.queueStatusMessage(displayText);
                }
              }

              return; // Wait for final_result before processing core UI logic
            }
          }

          // Mark stream as finished but let the queue drain naturally to show sub-agent steps
          this.isStreamFinished = true;


          const effectivePayload = isChatResponse ? data : this.chatPayload;
          // CRITICAL: For fresh queries, this.mcode is already authoritatively set in the final_result block above.
          // Only restore mcode from effectivePayload when replaying history (isChatResponse=true).
          // Overwriting this.mcode from chatPayload.mcode here would undo the fallback-correct mcode.
          if (isChatResponse) {
            let restoredMcode = parsedHistory?.member_responses?.final_mcode || effectivePayload?.mcode || this.mcode;
            
            // Smart fallback if mcode couldn't be determined from standard paths (especially single-module Snapshot)
            if (!restoredMcode || restoredMcode === 0) {
              if (parsedHistory?.getSnapshotInsights || parsedHistory?.getSnapshotOutput || parsedHistory?.getSnapshotConfiguration) {
                restoredMcode = 1;
              } else if (parsedHistory?.getConfiguration) {
                restoredMcode = parsedHistory?.GetMcode || 3;
              }
            }

            this.mcode = restoredMcode;
            if (targetBlock) {
              targetBlock.mcode = this.mcode;
              targetBlock.isBrandAnalysis = (this.mcode === 2);
            }
          } else if (effectivePayload) {
            effectivePayload.mcode = this.mcode;
          }
          // Also keep isBrandAnalysis in sync after potential mcode restore from history
          this.isBrandAnalysis = (this.mcode === 2);

          if (isChatResponse) {

            // Restore Step 2 data from history
            const restoredResponse = (this.mcode === 1) ? getSnapshotOutput : getConfiguration;
            if (restoredResponse) {
              // Flatten the saved data to match fresh query structure
              data.response = restoredResponse.response ? restoredResponse.response : restoredResponse;
              if (restoredResponse.customization_Properties) {
                data.customization_Properties = restoredResponse.customization_Properties;
              }
              if (restoredResponse.quadrantText) {
                data.quadrantText = restoredResponse.quadrantText;
              }

              if (this.mcode == 3 && restoredResponse.crosstab_payload) {
                this.lastCrosstabPayload = restoredResponse.crosstab_payload;
              } else if (this.mcode == 1 && restoredResponse.snapshot_payload) {
                this.lastSnapshotPayload = restoredResponse.snapshot_payload;
              } else if (this.mcode == 2) {
                // Backend returns 'brand_anlysis_payload' (typo) — handle both spellings + effectivePayload fallback
                this.lastBrandAnalysisPayload = restoredResponse.brand_analysis_payload || restoredResponse.brand_anlysis_payload || effectivePayload;
              }
            }

            // Restore UI context from history (Significance, Weight etc, and Error flags)
            if (parsedHistory) {
              if (parsedHistory['SignificanceVsReference']) this.SignificanceVsReference = parsedHistory['SignificanceVsReference'];
              if (parsedHistory['DefaultConfidenceLevel']) this.DefaultConfidenceLevel = parsedHistory['DefaultConfidenceLevel'];
              if (parsedHistory['selectedWeight']) this.selectedWeight = parsedHistory['selectedWeight'];
              if (parsedHistory['failedCase'] !== undefined) {
                 this.failedCase = parsedHistory['failedCase'];
                 if (targetBlock) targetBlock.failedCase = parsedHistory['failedCase'];
              }
              if (parsedHistory['noContentFlag'] !== undefined) this.noContentFlag = parsedHistory['noContentFlag'];
              if (parsedHistory['errorHeader'] !== undefined) this.errorHeader = parsedHistory['errorHeader'];
              if (parsedHistory['is_indexing'] !== undefined) this.is_indexing = parsedHistory['is_indexing'];
              if (parsedHistory['is_sigtesting'] !== undefined) this.is_sigtesting = parsedHistory['is_sigtesting'];
              if (parsedHistory['member_responses']) {
                this.allMemberResponses = parsedHistory['member_responses'];
                this.availableViews = this.identifyAvailableViews(effectivePayload, this.allMemberResponses);
                this.activeView = this.availableViews.find(v => v.mcode === this.mcode) || this.availableViews[0];
                if (targetBlock) {
                  targetBlock.availableViews = [...this.availableViews];
                  targetBlock.activeView = this.activeView;
                }

                if (this.mcode === 1) {
                  this.showSnapshot = true;
                  this.isBrandAnalysis = false;
                } else if (this.mcode === 2) {
                  this.showSnapshot = false;
                  this.isBrandAnalysis = true;
                } else {
                  this.showSnapshot = false;
                  this.isBrandAnalysis = false;
                }
              }
            }

            // Ensure promptData is available for downstream dataObject reconstruction
            if (data === effectivePayload) {
               data.promptData = { ...effectivePayload };
               delete data.promptData.promptData;
            } else {
               data.promptData = effectivePayload;
            }
          }

          let safePayload = effectivePayload || {};
          if (data === safePayload) {
             safePayload = { ...safePayload };
             delete safePayload.promptData;
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('AgentPayload', safePayload);
            this.pushChatResponseEntry('SignificanceVsReference', this.SignificanceVsReference);
            this.pushChatResponseEntry('DefaultConfidenceLevel', this.DefaultConfidenceLevel);
            this.pushChatResponseEntry('selectedWeight', this.selectedWeight);
            this.pushChatResponseEntry('failedCase', this.failedCase);
            this.pushChatResponseEntry('noContentFlag', this.noContentFlag);
            this.pushChatResponseEntry('errorHeader', this.errorHeader);
            this.pushChatResponseEntry('is_indexing', this.is_indexing);
            this.pushChatResponseEntry('is_sigtesting', this.is_sigtesting);
          }

          this.promptData = safePayload;
          if (safePayload && !safePayload.mcode) {
             safePayload.mcode = this.mcode;
          }
          if (this.mcode === 1) {
            this.snapshotConfiguration = this.promptData;
          }


          // Requirement: Step 2 - Call unified endpoint with chatPayload to get finalized output data (Analytical Task)
          if (!isChatResponse && this.chatPayload) {
            let opData: any;
            const activeCount = (this.hasSnapshotActive ? 1 : 0) + (this.hasBrandAnalysisActive ? 1 : 0) + (this.hasCrosstabActive ? 1 : 0);

            try {
              // Step 2 logic for primary view
              const msgId: string = this.selectedMessageId || (this.chatPreviewBlocks.length > 0 ? (this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].messageId || 'current') : 'current');
              if (!this.multiViewDataCache[msgId]) this.multiViewDataCache[msgId] = {};

              // RACE CONDITION FIX: Wait for in-flight priority data if orchestration already started it
              if (!this.multiViewDataCache[msgId][this.mcode]) {
                let attempts = 0;
                while (attempts < 100 && !this.multiViewDataCache[msgId][this.mcode] && (this.inFlightPreFetches[msgId]?.has(this.mcode))) {
                  await new Promise(r => setTimeout(r, 100)); // Wait 100ms
                  attempts++;
                }
              }

              if (this.multiViewDataCache[msgId]?.[this.mcode]) {
                opData = this.multiViewDataCache[msgId][this.mcode];
              } else {
                // Only request if truly missing and not in-flight
                if (this.mcode === 1) opData = await this.apiService.snapshotPayloadAPI(this.chatPayload).toPromise();
                else if (this.mcode === 2) opData = await this.apiService.brandAnalysisPayloadAPI(this.chatPayload).toPromise();
                else if (this.mcode === 3) opData = await this.apiService.crosstabPayloadAPI(this.chatPayload).toPromise();

                if (opData) this.multiViewDataCache[msgId][this.mcode] = opData;
              }

              // [DATA ISOLATION] Ensure ALL available views from orchestration have their Step 2 data fetched before saving history
              if (this.availableViews && this.availableViews.length > 1) {
                const fetchPromises = this.availableViews.map(async (v: any) => {
                  if (v.mcode !== this.mcode && !this.multiViewDataCache[msgId]?.[v.mcode]) {
                    console.log(`[ORCHESTRATION] Pre-fetching missing data for view ${v.name} (mcode ${v.mcode}) before history save`);
                    try {
                      const resData = this.allMemberResponses?.[v.key] || this.allMemberResponses?.[v.key?.replace('_', '')] || {};
                      const specialized = this.constructSpecialized(v.mcode, resData);

                      const freshToken = await this.getBearerToken();
                      if (freshToken) specialized.bearer_token = freshToken;

                      let vOpData = null;
                      if (v.mcode === 1) vOpData = await this.apiService.snapshotPayloadAPI(specialized).toPromise();
                      else if (v.mcode === 2) vOpData = await this.apiService.brandAnalysisPayloadAPI(specialized).toPromise();
                      else if (v.mcode === 3) vOpData = await this.apiService.crosstabPayloadAPI(specialized).toPromise();

                      if (vOpData) {
                        const dataStr = vOpData?.response?.Data || vOpData?.Data;
                        const isEmpty = dataStr === '[]' || dataStr === '"{}"' || dataStr === '{}' || (Array.isArray(dataStr) && dataStr.length === 0);

                        if (isEmpty || !dataStr) {
                           console.warn(`[ORCHESTRATION] Missing data for pre-fetched view ${v.name}. Skipping insights.`);
                           return;
                        }

                        this.multiViewDataCache[msgId][v.mcode] = vOpData;
                        await this.fetchInsightsAsObservable(v.mcode, vOpData, msgId, specialized).toPromise();
                        console.log(`[ORCHESTRATION] Pre-fetched insights for ${v.name}`);
                      }
                    } catch (err) {
                      console.warn(`[ORCHESTRATION] Failed to pre-fetch view ${v.name}`, err);
                    }
                  }
                });
                (this as any).pendingBackgroundFetches = Promise.all(fetchPromises).then(() => {
                  // [DATA ISOLATION] Pre-package allMemberResponses synchronously before pushing it to chatResponse array
                  if (this.allMemberResponses && this.availableViews && this.availableViews.length > 1) {
                    const safeStringify = (obj: any) => {
                      const cache = new WeakSet();
                      const ignoredKeys = ['Errors', 'Snapshot_Reason', 'BrandAnalysis_Reason', 'Crosstab_Reason'];
                      return JSON.stringify(obj, (key, value) => {
                        if (ignoredKeys.includes(key)) return undefined;
                        if (typeof value === 'object' && value !== null) {
                          if (cache.has(value)) return;
                          cache.add(value);
                        }
                        return value;
                      });
                    };

                    if (this.allMemberResponses.brandanalysis && !this.allMemberResponses.brand_analysis) {
                      this.allMemberResponses.brand_analysis = this.allMemberResponses.brandanalysis;
                      delete this.allMemberResponses.brandanalysis;
                    }

                    const mods = [
                      { code: 1, key: 'snapshot', esKey: 'getSnapshotOutput' },
                      { code: 2, key: 'brand_analysis', esKey: 'getConfiguration' },
                      { code: 3, key: 'crosstab', esKey: 'getConfiguration' }
                    ];

                    mods.forEach(mod => {
                      if (this.allMemberResponses && this.allMemberResponses[mod.key]) {
                        const cachedOpData = this.multiViewDataCache[msgId]?.[mod.code] || this.multiViewDataCache['current']?.[mod.code];
                        if (cachedOpData) {
                          this.allMemberResponses[mod.key][mod.esKey] = safeStringify(cachedOpData);
                        }
                        if (mod.code === 1 && this.promptData) {
                          this.allMemberResponses[mod.key]['getSnapshotConfiguration'] = typeof this.promptData === 'string' ? this.promptData : JSON.stringify(this.promptData);
                        }
                        const insightsCache = this.multiViewInsightsCache[msgId] || this.multiViewInsightsCache['current'];
                        if (insightsCache && insightsCache[mod.code]) {
                          const cachedData = insightsCache[mod.code];
                          if (mod.code === 1) {
                            this.allMemberResponses[mod.key]['getSnapshotInsights'] = cachedData.standard_insights || '';
                            this.allMemberResponses[mod.key]['getSnapshotInsights_Trend'] = cachedData.trend_insights || '';
                          } else {
                            this.allMemberResponses[mod.key]['getInsights'] = cachedData.rawInsights || '';
                          }
                          this.allMemberResponses[mod.key]['getQnA'] = cachedData.qnaText || '';
                        }
                      }
                    });
                  }
                  
                  if (this.allMemberResponses && !isChatResponse) {
                    this.pushChatResponseEntry('member_responses', this.allMemberResponses);
                  }
                });
              } else {
                (this as any).pendingBackgroundFetches = Promise.resolve();
              }

              if (opData) {
                data.response = opData.response || opData;
                data.payload = opData;

                if (this.mcode == 3 && opData.crosstab_payload) {
                  this.cleanBrandAnalysisChild(opData.crosstab_payload);
                  this.lastCrosstabPayload = opData.crosstab_payload;
                } else if (this.mcode == 1 && opData.snapshot_payload) {
                  this.lastSnapshotPayload = opData.snapshot_payload;
                } else if (this.mcode == 2) {
                  // Backend returns 'brand_anlysis_payload' (typo) — handle both spellings + chatPayload fallback
                  const bPayload = opData.brand_analysis_payload || opData.brand_anlysis_payload || this.chatPayload;
                  this.cleanBrandAnalysisChild(bPayload);
                  this.lastBrandAnalysisPayload = bPayload;
                }

                // History Bundling & Metadata persistence
                if (opData.response_payload_trendline) {
                  this.currentRowPayloadTrendline = opData.response_payload_trendline;
                  data.response.response_payload_trendline = opData.response_payload_trendline;
                }
                if (opData.trendline_response) {
                  this.currentTrendlineResponse = opData.trendline_response;
                  data.response.trendline_response = opData.trendline_response;
                }
                if (opData.customization_Properties_trendline) {
                  this.currentCustomizationTrendline = opData.customization_Properties_trendline;
                  data.response.customization_Properties_trendline = opData.customization_Properties_trendline;
                }
                // Store response_payload for significance re-render support
                if (opData.response_payload) {
                  data.response.response_payload = opData.response_payload;
                }
                if (opData.customization_Properties) data.customization_Properties = opData.customization_Properties;
                if (opData.quadrantText) data.quadrantText = opData.quadrantText;
                data.promptData = this.promptData;

                if (!isChatResponse) {
                  const key = (this.mcode === 1) ? 'getSnapshotOutput' : 'getConfiguration';
                  this.pushChatResponseEntry(key, opData);
                  this.pushChatResponseEntry('getConfiguration', opData);
                  this.pushChatResponseEntry('getSnapshotConfiguration', this.promptData);

                  // [PRIORITY-INSIGHT-PERSISTENCE] If insights were pre-fetched, bundle them NOW for history
                  const cachedIns = (this.multiViewInsightsCache[msgId] || {})[this.mcode];
                  if (cachedIns) {
                    console.log(`[SAVE-HISTORY] Bundling pre-fetched insights for priority mcode ${this.mcode}`);
                    if (this.mcode === 1) {
                      this.pushChatResponseEntry('getSnapshotInsights', cachedIns.standard_insights);
                      this.pushChatResponseEntry('getSnapshotInsights_Trend', cachedIns.trend_insights);
                    } else {
                      this.pushChatResponseEntry('getInsights', cachedIns.rawInsights);
                    }
                    if (cachedIns.qnaText) this.pushChatResponseEntry('getQnA', cachedIns.qnaText);
                  }

                  if ((this.mcode === 1 || this.mcode === 2 || this.mcode === 3) && !isChatResponse) {
                    console.log(`[SAVE-HISTORY] Ensuring history persistence for analytical mcode ${this.mcode}`);
                    // Note: Actual save happens after insights reveal (cached or fresh)
                  } else if (!isChatResponse && activeCount <= 1) {
                    console.log(`[SAVE-HISTORY] Saving immediate response for fallback mcode ${this.mcode}`);
                    this.saveChatList(targetBlock ? targetBlock.question : (this.inputValue || this.promptData?.user_input || 'Analytics Question'), this.chatResponse, this.defaultQuestionAnswer, targetBlock?.messageId);
                  }
                }
              }
            } catch (err: any) {
              console.error(`[API-ERROR] Failed to finalize analysis for mcode ${this.mcode}:`, err);
              this.isStreamFinished = false;
              this.isInsightsStreaming = false;
              this.stopAiLoader();
              this.setFailedCaseState(true);

              let errorMsg = 'We encountered an unexpected error while finalizing your analysis. Please try again later.';
              this.errorHeader = 'Analysis Error:';

              if (err.status === 400) {
                errorMsg = 'There was an issue with the request parameters. Please try refining your query.';
                this.errorHeader = 'Invalid Request:';
              } else if (err.status === 500) {
                errorMsg = 'We\'re currently experiencing an internal server error while finalizing the analysis. Please try again later.';
                this.errorHeader = 'Server Error:';
              }

              if (!isChatResponse) {
                this.pushChatResponseEntry('failedCase', true);
                this.pushChatResponseEntry('errorHeader', this.errorHeader);
                if (this.chatPreviewBlocks.length > 0) {
                  this.updateQuestionAnswerForSelectedMessage('An error occurred during final processing.');
                }
                // Save failed state to history so it doesn't hang on reload
                this.saveChatList(targetBlock ? targetBlock.question : (this.inputValue || this.currentQuestion || 'Analytics Question'), this.chatResponse, errorMsg, targetBlock?.messageId);
              }

              this.insightsVal = errorMsg;
              this._insightsSerive.showInisghts({
                header: this.errorHeader || 'Analysis Error',
                message: errorMsg,
                show: true,
              });
              this.isInsightspopupOpen = true;
              return;
            }
          }



          if (!isChatResponse && (!data?.response || Object.keys(data.response).length === 0)) {
            const noContentMsg = 'I apologize, but I couldn\'t find any relevant data for your question. This might be because:<br><br>• The requested data is not available in the current study<br>• Your query might need to be more specific<br>• There may be data access restrictions<br><br>Please try rephrasing your question or contact your administrator for assistance.';
            const shortNoContentMsg = 'No relevant data found for the current study. Please rephrase your question.';

            this.setFailedCaseState(true);
            this.noContentFlag = true;
            this.errorHeader = 'Data Status:';
            this.isStreamFinished = false;
            this.isInsightsStreaming = false;
            this.arktabaccess = false;
            this.isInsightspopupOpen = true;
            this.insightsVal = noContentMsg;

            if (!isChatResponse) {
              this.pushChatResponseEntry('failedCase', true);
              this.pushChatResponseEntry('noContentFlag', true);
              this.pushChatResponseEntry('errorHeader', this.errorHeader);
            }

            if (targetBlock) {
              this.selectedMessageId = targetBlock.messageId || null;
            } else if (this.chatPreviewBlocks.length > 0) {
              this.selectedMessageId = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].messageId || null;
            }

            if (this.chatPreviewBlocks.length > 0) {
              const lastIdx = this.chatPreviewBlocks.length - 1;
              this.updateQuestionAnswerForSelectedMessage(shortNoContentMsg);
              // Removed saveChatList to prevent recording 'no data' questions in history
              this.isHistorySaving = false;
            } else if (this.inputValue) {
              const tempMsgId = 'temp-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
              this.selectedMessageId = tempMsgId;
              this.chatPreviewBlocks.push({
                messageId: tempMsgId,
                question: this.inputValue,
                response: '',
                QuestionAnswer: shortNoContentMsg,
                isTrendActive: this.isTrendActive,
                isExportspopup: false,
                sampleSizeDropdown: false,
                confidenceLevelDropDown: false,
                referenceLevelDropDown: false,
                baseDropDown: false,
                weightDropDown: false,
                isReference: false,
                isSig: true,
                isIndex: false,
                DefaultSampleSize: 'None',
                SignificanceVsReference: '',
                DefaultConfidenceLevel: '95%',
                DefaultReferenceLevel: 'None',
                selectedWeight: this.selectedWeight || 'Weight',
                DefaultWeight: this.DefaultWeight || 'Total Population',
                DefaultBase: this.DefaultBase || 'Total Base',
                isTotalBase: true,
                isAnswerBase: true,
                is_sigtesting: true,
                is_Time_Period_Present: true,
                isTranspose: false,
                dataDropDown: false,
                DefaultDataDropDown: 'Data',
                isTableClick: true,
                isVerticalStackChartClick: false,
                isVerticalBarChartClick: false,
                isVerticalGroupBarChartClick: false,
                isLineChartClick: false,
                isChartView: true,
                disableStackChart: false,
                disableLineChart: false,
                showStackTooltip: false,
                showLineTooltip: false,
                showBarTooltip: false,
                showMainTooltip: false,
                StackFlag: false,
                displayTable: true,
                isTableClosing: false,
                isChartClosing: false
              });
              // Removed saveChatList to prevent recording 'no data' questions in history
              this.isHistorySaving = false;
            }

            setTimeout(() => {
              const chatScroll = document.querySelector('.chat-history-scroll');
              if (chatScroll) {
                chatScroll.scrollTop = chatScroll.scrollHeight;
              }
            }, 100);

            const noContentObj: InsightsModel = {
              header: this.errorHeader,
              message: noContentMsg,
              show: true,
            };
            this._insightsSerive.showInisghts(noContentObj);
            this.isInsightspopupOpen = true;
            return;
          }
          const rowData = data.payload?.Row || data.promptData?.row || data.promptData?.Row;
          const colData = data.payload?.Column || data.promptData?.column || data.promptData?.Column;
          const colNestData = data.payload?.ColNesting || data.promptData?.col_nesting || data.promptData?.column_nesting || [];
          const rowNestData = data.payload?.RowNesting || data.promptData?.row_nesting || [];
          const filters = data.payload?.Filter || data.promptData?.filters || {};

          if (rowData && Array.isArray(rowData) && rowData.length > 0) {

            if (typeof rowData[0] === 'object' && rowData[0].Parent) {
              this.AssignDataToDataObject(data.payload || data.promptData);
            } else {

              this.syncDataObjectFromPrompt(data.payload || data.promptData);
            }
          }


          if (this.promptData && typeof this.promptData === 'object') {
            this.promptData.entryPointData = this.dataArray;
            this.isTotalBase = this.promptData.isTotalBase !== undefined ? this.promptData.isTotalBase : false;
            this.selectedWeight = this.promptData.weight || this.promptData.Weight || this.selectedWeight;
            this.isAnswerBase = !this.isTotalBase;
            this.DefaultBase = this.isTotalBase ? 'Total Base' : 'Answer Base';
            
            if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
              const matchedWeight = this.WeightDropDownList.find(w => w.responseCode === this.selectedWeight);
              this.DefaultWeight = matchedWeight ? matchedWeight.Label : (this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight);
            } else {
              this.DefaultWeight = this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight;
            }

            if (!isChatResponse && this.chatPreviewBlocks.length === 0 && this.promptData?.user_input) {
              this.chatPreviewBlocks.push({
                question: this.promptData.user_input,
                response: '',
                QuestionAnswer: this.defaultQuestionAnswer,
                isTrendActive: this.isTrendActive,
                isExportspopup: false,
                sampleSizeDropdown: false,
                confidenceLevelDropDown: false,
                referenceLevelDropDown: false,
                baseDropDown: false,
                weightDropDown: false,
                isReference: false,
                isSig: true,
                isIndex: false,
                DefaultSampleSize: 'None',
                SignificanceVsReference: '',
                DefaultConfidenceLevel: '95%',
                DefaultReferenceLevel: 'None',
                selectedWeight: this.selectedWeight || 'Weight',
                DefaultWeight: this.DefaultWeight || 'Total Population',
                DefaultBase: this.DefaultBase || 'Total Base',
                isTotalBase: this.isTotalBase,
                isAnswerBase: this.isAnswerBase,
                is_sigtesting: true,
                is_Time_Period_Present: true,
                isTranspose: false,
                dataDropDown: false,
                DefaultDataDropDown: 'Data',
                isTableClick: true,
                isVerticalStackChartClick: false,
                isVerticalBarChartClick: false,
                isVerticalGroupBarChartClick: false,
                isLineChartClick: false,
                isChartView: true,
                disableStackChart: false,
                disableLineChart: false,
                showStackTooltip: false,
                showLineTooltip: false,
                showBarTooltip: false,
                showMainTooltip: false,
                StackFlag: false,
                displayTable: true,
                isTableClosing: false,
                isChartClosing: false
              });
            }
          } else {
            this.isTotalBase = false;
            const primaryWeight = this.WeightDropDownList?.find(w => w.Label === 'Primary Weight');
            if (primaryWeight) {
              this.selectedWeight = primaryWeight.responseCode;
              this.DefaultWeight = primaryWeight.Label;
            } else {
              this.selectedWeight = 'Unweighted';
              if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
                const matchedWeight = this.WeightDropDownList.find(w => w.responseCode === this.selectedWeight);
                this.DefaultWeight = matchedWeight ? matchedWeight.Label : 'Total Population';
              } else {
                this.DefaultWeight = 'Total Population';
              }
            }
          }

          const msgId = this.selectedMessageId || 'current';

          // 1. GLOBAL INSIGHT SYNCHRONIZATION:
          // [REMOVED] The primary module no longer waits for background insights. 
          // It will immediately plot the UI and let callInsightsAPI stream the insights.

          // Requirement: Snapshot module (mcode==1) with Elasticsearch chat history support
          // Support both fresh API responses and saved chat data from Elasticsearch
          if (this.mcode == 1) {
            this._configService.snapshotProductType = 'custom';
            this._configService.selectedSnapshotType = data.promptData?.Snapshot_Type || data.promptData?.snapshot_type;
            this.selectedSection = data.promptData?.Section || data.promptData?.section;
            this.widget_Id = data.promptData?.Widget_ID || data.promptData?.widget_id;
            this.widget_Name = data.promptData?.Widget_Name || data.promptData?.widget_name;

            this.widegtconfigdetails.section = this.promptData?.Section || this.promptData?.section || '';

            // UNCONDITIONALLY build the Selection Summary for Snapshot
            const buildSelectionSummary = () => {
              const pData = data.promptData || this.promptData || {};
              
              const extractVal = (item: any) => {
                if (typeof item === 'string') {
                  const parts = item.split('|');
                  if (parts.length >= 2) return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
                  return parts.pop();
                }
                if (item && item.name) return item.name;
                if (item && item.Child) return item.Child;
                return String(item);
              };
              
              const extractLastPart = (item: any) => {
                if (typeof item === 'string') return item.split('|').pop();
                if (item && item.name) return item.name;
                if (item && item.Child) return item.Child;
                return String(item);
              };

              const compareAcross = pData.Snapshot_Type || pData.snapshot_type || 'Single Brand';
              const section = pData.Section || pData.section || 'Analysis';
              
              const mktData = pData.Markets || pData.markets || pData.Market || pData.market || [];
              const tpData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];
              const brandsData = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
              const filtersData = pData.Filter_Audience || pData.filter_audience || pData.Filters || pData.filters || [];

              const markets = mktData.length > 0 ? mktData.map(extractLastPart).join(', ') : 'All Markets';
              const timeperiod = tpData.length > 0 ? tpData.map(extractVal).join(', ') : 'All Time Periods';
              const brands = brandsData.length > 0 ? brandsData.map(extractVal).join(', ') : 'All Brands';
              const filters = filtersData.length > 0 ? filtersData.map(extractVal).join(', ') : 'All Respondents';
              const studyInfo = this.selected_study || '';
              
              const baseType = pData.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER;

              let selections = 'Time Period: ' + timeperiod + '; Brands: ' + brands + '; Study: ' + studyInfo;
              if (filtersData.length > 0) {
                selections += '; Filters: ' + filters;
              }

              return 'Compare Across: ' + compareAcross + ': ' + section +
                ' || Entry Point: Markets: ' + markets +
                ' || Selections: ' + selections +
                ' || Significance: None' +
                ' || Base: ' + baseType +
                ' || Weight: Primary Weight';
            };

            this._configService.selectionSummaryTextTitle = buildSelectionSummary();
            this.selectionSummary = this._configService.selectionSummaryTextTitle;
            
            if (targetBlock) {
              targetBlock.selectionSummary = this.selectionSummary;
              console.log('[SelectionSummary] Guaranteed assignment at start of Snapshot processing:', this.selectionSummary);
            }

            // Select data source: getSnapshotOutput for saved chats, data.response for fresh queries
            let snapshotDataSource = null;
            if (isChatResponse && getSnapshotOutput) {
              snapshotDataSource = getSnapshotOutput;
              // Ensure trendline data is available for historical chats
              if (snapshotDataSource.response_payload_trendline) {
                this.currentRowPayloadTrendline = snapshotDataSource.response_payload_trendline;
              }
              if (snapshotDataSource.trendline_response) {
                this.currentTrendlineResponse = snapshotDataSource.trendline_response;
              }
              if (snapshotDataSource.customization_Properties_trendline) {
                this.currentCustomizationTrendline = snapshotDataSource.customization_Properties_trendline;
              }
            } else if (data != null && data != undefined && data != '' && data.response != null && data.response.Data != null) {
              snapshotDataSource = data.response;
            } else {
            }

            if (snapshotDataSource != null && snapshotDataSource.Data != null) {
              try {
                let opData = JSON.parse(snapshotDataSource.Data);
                this.MainResult = opData;


                // Requirement: Save snapshot output to Elasticsearch for chat history persistence
                if (!isChatResponse) {
                  this.pushChatResponseEntry('getSnapshotOutput', snapshotDataSource);
                }

                const sortedOPdata = opData.sort(
                  (a: any, b: any) => a.widgetNumber - b.widgetNumber
                );

                const snapTypeVal = this.promptData.Snapshot_Type || this.promptData.snapshot_type;
                if (snapTypeVal) {
                  this._configService.selectedcompareacrossOption = snapTypeVal;
                }

                // (Removed legacy try/catch SelectionSummary block that was meant for crosstabs)
                
                this._configService.standardSnapOutputData = sortedOPdata;
                this.OutputData = sortedOPdata;

                if (sortedOPdata && sortedOPdata.length > 0) {

                  // Requirement: Prepare filteredWidgetData structure for output-popup component
                  if (this.widgetData && this.widgetData.length > 0) {
                    const matchedWidget = this.widgetData.find(
                      (widget: any) => widget.previewChartPostion == this.promptData.Widget_ID
                    );

                    if (matchedWidget) {
                      matchedWidget.customizationProperties = this.getFormattedCustomProperties(matchedWidget.customizationProperties, matchedWidget.widgetchart_name);

                      // Re-apply colChild formatting for multi-market in pre-structured widgetData
                      if (matchedWidget.metric?.[0]?.metric_value) {
                        matchedWidget.metric[0].metric_value.forEach((metricRow: any) => {
                          if (metricRow.data && Array.isArray(metricRow.data)) {
                            metricRow.data.forEach((dataArrEntry: any) => {
                              const colParts = (dataArrEntry.colChild || '').split('|');
                              const specificCol = colParts.pop() || dataArrEntry.colChild;
                              const parentLabel = colParts.pop() || 'Market';

                              // Use only market name as specific part (Table1 uses split('|')[1])
                              dataArrEntry.colChild = `${parentLabel}|${specificCol}`;
                            });
                          }
                        });
                      }

                      this.filteredWidgetData = matchedWidget;
                      this.filteredWidgetID = matchedWidget.previewChartPostion;
                    } else {

                      // SMART WIDGET SELECTION: Match question natively first, then query Widget_ID, then default
                      let selectedWidget: any = null;
                      const currentQuestion = (this.currentQuestion || '').toLowerCase();
                      const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');

                      if (currentQuestion) {
                        const matchedWidget: any = uniqueWidgets.find((widget: any) =>
                          currentQuestion.includes(widget.widgetName.toLowerCase())
                        );
                        if (matchedWidget) {
                          selectedWidget = matchedWidget;
                        }
                      }

                      if (!selectedWidget) {
                        const targetWidgetID = this.promptData?.Widget_ID || this.promptData?.widget_id;
                        if (targetWidgetID) {
                          const idMatchedWidget: any = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
                          if (idMatchedWidget) {
                            selectedWidget = idMatchedWidget;
                          }
                        }
                      }

                      if (!selectedWidget) {
                        selectedWidget = sortedOPdata[0];
                      }

                      // Filter sortedOPdata to only include rows from the selected widget
                      const widgetFilteredData = sortedOPdata.filter((item: any) =>
                        item.widgetNumber === selectedWidget.widgetNumber
                      );


                      // Fallback base for rows with null base (like 'Overall Consideration')
                      const fallbackBase = widgetFilteredData.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

                      // DEBUG: log raw colChild/Level1ColChild from backend (Path 1)
                      if (widgetFilteredData.length > 0) {
                        console.log('[MULTI-MARKET DEBUG Path1] First row raw data:', {
                          colChild: widgetFilteredData[0].colChild,
                          Level1ColChild: widgetFilteredData[0].Level1ColChild,
                          rowChild: widgetFilteredData[0].rowChild
                        });
                      }

                      const uniqueMetrics = _.uniqBy(widgetFilteredData, 'rowChild').map((item: any) => ({
                        option: item.rowChild,
                        selectOrder: 0,
                        typeofmetric: 'METRIC',
                        metric_group: '',
                        data: widgetFilteredData
                          .filter((row: any) => row.rowChild === item.rowChild)
                          .map((row: any) => {
                            const dataValue = row.answerWeightedShare;
                            const data2Value = row.answerWeightedShareIndex;

                            // Specific Market extraction for Table1Component compatibility:
                            const colParts = (row.colChild || '').split('|');
                            const specificCol = colParts.pop() || row.colChild;
                            const parentLabel = colParts.pop() || 'Market';

                            // Format: "Parent|Market" (Table1 uses split('|')[1])
                            const resolvedColChild = `${parentLabel}|${specificCol}`;

                            return {
                              data: dataValue,
                              data2: data2Value,
                              lvl1Child: row.Level1ColChild,
                              colChild: resolvedColChild,
                              rowChild: row.rowChild,
                              totalUnweightedBase: row.totalUnweightedBase,
                              totalUnweightedShare: row.totalUnweightedShare,
                              totalWeightedBase: row.totalWeightedBase,
                              totalWeightedShare: row.totalWeightedShare,
                              totalWeightedShareIndex: row.totalWeightedShareIndex,
                              answerUnweightedBase: row.answerUnweightedBase,
                              answerUnweightedShare: row.answerUnweightedShare,
                              answerWeightedBase: row.answerWeightedBase,
                              answerWeightedShare: row.answerWeightedShare,
                              answerWeightedShareIndex: row.answerWeightedShareIndex,
                              changeVsPY_Answer: row.changeVsPY_Answer,
                              changeVsPY_Total: row.changeVsPY_Total,
                              Level1ColResponseCode: row.Level1ColResponseCode,
                              Level1NestColVariableCode: row.Level1NestColVariableCode,
                              CalculationType: row.CalculationType || 'share',
                              CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                              baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                              changeVsPY: row.changeVsPY_Answer,
                              Significance_Value: row.Significance_Answer
                            };
                          })
                      }));

                      // Sort uniqueMetrics in descending order of values
                      uniqueMetrics.sort((a: any, b: any) => {
                        const valA = a.data?.[0]?.data ?? 0;
                        const valB = b.data?.[0]?.data ?? 0;
                        return valB - valA; // Descending
                      });

                      const isBubbleChart = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

                      this.filteredWidgetData = {
                        widgetchart_name: selectedWidget.widgetChartType,
                        widget_name: selectedWidget.widgetName,
                        previewChartPostion: selectedWidget.widgetNumber,
                        customizationProperties: this.getFormattedCustomProperties(selectedWidget.customization_Properties || data.customization_Properties, selectedWidget.widgetChartType),
                        quadrantText: data.quadrantText ? JSON.stringify(data.quadrantText) : null,
                        metric: isBubbleChart ? [
                          { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
                          { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
                          { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
                        ] : [{
                          metric_option: 'Data',
                          metric_group: '',
                          metric_value: uniqueMetrics
                        }],
                        response_payload_trendline: data.response_payload_trendline,
                        trendline_response: data.trendline_response
                      };
                      this.filteredWidgetID = selectedWidget.widgetNumber;

                    }
                  } else {

                    // SMART WIDGET SELECTION: Match question to widget name first, fallback to payload Widget_ID, then default to first
                    let selectedWidget: any = null;
                    const currentQuestion = (this.currentQuestion || '').toLowerCase();
                    const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');


                    // 1. Try to find widget whose name matches the user's question
                    if (currentQuestion) {
                      const matchedWidget: any = uniqueWidgets.find((widget: any) =>
                        currentQuestion.includes(widget.widgetName.toLowerCase())
                      );

                      if (matchedWidget) {
                        selectedWidget = matchedWidget;
                      }
                    }

                    // 2. If no text match, fallback to what the Python orchestrator provided
                    if (!selectedWidget) {
                      const targetWidgetID = this.promptData?.Widget_ID || this.promptData?.widget_id;
                      if (targetWidgetID) {
                        const idMatchedWidget: any = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
                        if (idMatchedWidget) {
                          selectedWidget = idMatchedWidget;
                        }
                      }
                    }

                    // 3. Absolute fallback to first index
                    if (!selectedWidget) {
                      selectedWidget = sortedOPdata[0];
                    }

                    // Filter sortedOPdata to only items from the selected widget
                    const widgetFilteredData = sortedOPdata.filter((item: any) =>
                      item.widgetNumber === selectedWidget.widgetNumber
                    );


                    // Fallback base for rows with null base (like 'Overall Consideration')
                    const fallbackBase = widgetFilteredData.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

                    // DEBUG: log raw colChild/Level1ColChild from backend (Path 2)
                    if (widgetFilteredData.length > 0) {
                      console.log('[MULTI-MARKET DEBUG Path2] First row raw data:', {
                        colChild: widgetFilteredData[0].colChild,
                        Level1ColChild: widgetFilteredData[0].Level1ColChild,
                        rowChild: widgetFilteredData[0].rowChild
                      });
                    }

                    const uniqueMetrics = _.uniqBy(widgetFilteredData, 'rowChild').map((item: any) => ({
                      option: item.rowChild,
                      selectOrder: 0,
                      typeofmetric: 'METRIC',
                      metric_group: '',
                      data: widgetFilteredData
                        .filter((row: any) => row.rowChild === item.rowChild)
                        .map((row: any) => {
                          const dataValue = row.answerWeightedShare;
                          const data2Value = row.answerWeightedShareIndex;

                          // Specific Market extraction for Table1Component compatibility:
                          const colParts = (row.colChild || '').split('|');
                          const specificCol = colParts.pop() || row.colChild;
                          const parentLabel = colParts.pop() || 'Market';

                          // Format: "Parent|Market" (Table1 uses split('|')[1])
                          const resolvedColChild = `${parentLabel}|${specificCol}`;

                          return {
                            data: dataValue,
                            data2: data2Value,
                            lvl1Child: row.Level1ColChild,
                            colChild: resolvedColChild,
                            rowChild: row.rowChild,
                            totalUnweightedBase: row.totalUnweightedBase,
                            totalUnweightedShare: row.totalUnweightedShare,
                            totalWeightedBase: row.totalWeightedBase,
                            totalWeightedShare: row.totalWeightedShare,
                            totalWeightedShareIndex: row.totalWeightedShareIndex,
                            answerUnweightedBase: row.answerUnweightedBase,
                            answerUnweightedShare: row.answerUnweightedShare,
                            answerWeightedBase: row.answerWeightedBase,
                            answerWeightedShare: row.answerWeightedShare,
                            answerWeightedShareIndex: row.answerWeightedShareIndex,
                            changeVsPY_Answer: row.changeVsPY_Answer,
                            changeVsPY_Total: row.changeVsPY_Total,
                            Level1ColResponseCode: row.Level1ColResponseCode,
                            Level1NestColVariableCode: row.Level1NestColVariableCode,
                            CalculationType: row.CalculationType || 'share',
                            CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                            baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                            changeVsPY: row.changeVsPY_Answer,
                            Significance_Value: row.Significance_Answer
                          };
                        })
                    }));

                    // Sort uniqueMetrics in descending order of values as per user request
                    uniqueMetrics.sort((a: any, b: any) => {
                      const valA = a.data?.[0]?.data ?? 0;
                      const valB = b.data?.[0]?.data ?? 0;
                      return valB - valA; // Descending
                    });

                    const isBubbleChart = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

                    this.filteredWidgetData = {
                      widgetchart_name: selectedWidget.widgetChartType,
                      widget_name: selectedWidget.widgetName,
                      previewChartPostion: selectedWidget.widgetNumber,
                      customizationProperties: this.getFormattedCustomProperties(data.customization_Properties || selectedWidget.customization_Properties, selectedWidget.widgetChartType),
                      quadrantText: data.quadrantText ? JSON.stringify(data.quadrantText) : null,
                      metric: isBubbleChart ? [
                        { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
                        { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
                        { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
                      ] : [{
                        metric_option: 'Data',
                        metric_group: '',
                        metric_value: uniqueMetrics  // Array of objects, not JSON string
                      }],
                      response_payload_trendline: data.response_payload_trendline,
                      trendline_response: data.trendline_response
                    };
                    this.filteredWidgetID = selectedWidget.widgetNumber;


                    const compareAcross = data.promptData?.Snapshot_Type || data.promptData?.snapshot_type;
                    const section = data.promptData?.Section || data.promptData?.section;

                    const pData = data.promptData || {};
                    const marketsArray = pData.Markets || pData.markets || pData.Market || pData.market || [];
                    const brandsArray = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
                    const timeperiodArray = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];
                    const metricsArray = pData.Primary_Metrics || pData.primary_metrics || pData.Metrics || pData.metrics || pData.Selected_Metrics || [];
                    const filtersArray = pData.Filter_Audience || pData.filter_audience || pData.Filters || pData.filters || [];


                    const extractValue = (item: any) => {
                      if (typeof item === 'string') {
                        const parts = item.split('|');
                        if (parts.length >= 2) {
                          return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
                        }
                        return parts.pop();
                      }
                      if (item && item.name) return item.name;
                      if (item && item.Child) return item.Child;
                      return String(item);
                    };

                    const extractLastPartOnly = (item: any) => {
                      if (typeof item === 'string') return item.split('|').pop();
                      if (item && item.name) return item.name;
                      if (item && item.Child) return item.Child;
                      return String(item);
                    };

                    const markets = marketsArray.length > 0 ? marketsArray.map((f: any) => extractLastPartOnly(f)).join(', ') : '';
                    const entryPoint = 'Markets: ' + markets;

                    const brands = brandsArray.length > 0 ? brandsArray.map((c: any) => extractValue(c)).join(', ') : '';
                    const timeperiod = timeperiodArray.length > 0 ? timeperiodArray.map((f: any) => extractValue(f)).join(', ') : '';
                    const filters = filtersArray.length > 0 ? filtersArray.map((f: any) => extractValue(f)).join(', ') : 'All Respondents';

                    const primaryMetric = metricsArray.map((r: any) => extractValue(r)).join(', ');
                    const metricNames = primaryMetric || uniqueMetrics.map((m: any) => m.option).join(', ');

                    const baseType = data.promptData?.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER;


                    let selections = 'Time Period: ' + timeperiod + '; Brands: ' + brands;
                    if (filtersArray.length > 0) {
                      selections += '; Filters: ' + filters;
                    }

                    this._configService.selectionSummaryTextTitle =
                      'Compare Across: ' + compareAcross + ': ' + section +
                      ' || Entry Point: Markets: ' + markets +
                      ' || Selections: ' + selections +
                      ' || Significance: None' +
                      ' || Base: ' + baseType +
                      ' || Weight: Primary Weight';

                    if (targetBlock) {
                      targetBlock.selectionSummary = this._configService.selectionSummaryTextTitle;
                    }
                    
                    console.log('[SelectionSummary] Generated inside getChatResponse:', {
                      hasTargetBlock: !!targetBlock,
                      targetBlockId: targetBlock?.messageId,
                      summaryText: this._configService.selectionSummaryTextTitle
                    });

                    this.GenerateSelectionSummary();

                    if (!this.Snapshotdataforexport) {
                      this.Snapshotdataforexport = this._configService.getDropdownValues();
                    }

                    this.Snapshotdataforexport.compareAcross = compareAcross;
                    if (marketsArray.length > 1) {
                      this._configService.selectedSnapshotType = 'Multiple Markets';
                    } else {
                      this._configService.selectedSnapshotType = compareAcross || 'Standard Chart';
                    }
                    this.Snapshotdataforexport.snapshotName = data.promptData?.Snapshot_Name || 'Snapshot';
                    this.Snapshotdataforexport.clientName = this.selected_client;
                    this.Snapshotdataforexport.studyName = this.selected_study;
                    this.Snapshotdataforexport.selectionSummary = this._configService.selectionSummaryTextTitle;
                    this.Snapshotdataforexport.baseType = baseType;
                  }
                } else {
                }


                if (this.widgetData && this.widgetData.length > 0) {
                  this.afterSubmit();
                } else {
                  this.outputData = sortedOPdata;

                  // Populate allPageOutputData / allPageOutputDataWithoutTrend so
                  // editablePPTClicked() and excelexportClicked() can find the data
                  // even when afterSubmit() was not called.
                  if (this.filteredWidgetData) {
                    const widgetItems = [this.filteredWidgetData];
                    this._configService.allPageOutputData = [widgetItems];
                    this._configService.allPageOutputDataWithoutTrend = [widgetItems];
                  }
                }

                const outputViewDiv = document.querySelector('.output-view');
                if (outputViewDiv) {
                  outputViewDiv?.classList.remove('DN');
                }


                // [UNIVERSAL TREND INJECTION] 
                // Hard-inject stored trend components into filteredWidgetData just before exposing to UI
                if (this.filteredWidgetData) {
                  if (this.currentRowPayloadTrendline) this.filteredWidgetData.response_payload_trendline = this.currentRowPayloadTrendline;
                  if (this.currentTrendlineResponse) this.filteredWidgetData.trendline_response = this.currentTrendlineResponse;
                  if (this.currentCustomizationTrendline) this.filteredWidgetData.customization_Properties_trendline = this.currentCustomizationTrendline;
                  // Inject response_payload so the popup can call snapshotPayloadService on significance change
                  const storedResponsePayload = data?.response?.response_payload;
                  if (storedResponsePayload && !this.filteredWidgetData.response_payload) {
                    this.filteredWidgetData.response_payload = storedResponsePayload;
                  }

                  // [METADATA INJECTION] Ensure the popup has context for multi-brand/multi-market logic
                  const resolvedCompareAcross = data.promptData?.Snapshot_Type || data.promptData?.snapshot_type;
                  this.filteredWidgetData.snapshot_type = resolvedCompareAcross || this._configService.selectedSnapshotType || 'Single Brand';
                  this.filteredWidgetData.selectedcompareacrossOption = resolvedCompareAcross || this._configService.selectedcompareacrossOption;
                }

                this.showSnapshot = true;

                setTimeout(() => MarkdownPayloadHelper.buildSnapshotMarkdown(this), 500);
              } catch (error) {
              }
            } else {
            }

            this.Snapshotdataforexport = this._configService.getDropdownValues();

            if (!this.selectionSummary || this.selectionSummary === '') {
              this.selectionSummary = 'Snapshot Analysis';
            }
            
            if (targetBlock) {
              targetBlock.selectionSummary = this.selectionSummary;
              console.log('[SelectionSummary] Assigned fallback/constructed summary to targetBlock:', this.selectionSummary);
            }
            if (!this.confidenceLevel || this.confidenceLevel === '') {
              this.confidenceLevel = '90%';
            }
            if (!this.selected_study) {
              this.selected_study = this.landingdata?.study || '';
            }
            if (!this.selected_client) {
              this.selected_client = this.landingdata?.client_code || this.promptData?.Client_Code;
            }

            const insightsStartTime = performance.now();

            // Call insights API for snapshot (mcode == 1)
            const markdownData = this.buildSnapshotMarkdownForAPI();
            const widget_details = {
              snapshot_type: this.promptData?.Snapshot_Type || this.promptData?.snapshot_type || '',
              snapshot_name: this.promptData?.Snapshot_Name || this.promptData?.snapshot_name || '',
              section: this.promptData?.Section || this.promptData?.section || '',
              widget_id: this.promptData?.Widget_ID || this.promptData?.widget_id || '',
              widget_name: this.promptData?.Widget_Name || this.promptData?.widget_name || ''
            };

            if (isChatResponse) {
              if (getSnapshotInsights) {
                this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights, getSnapshotInsightsTrend, targetBlock);
              } 
              if (getSnapshotLoadData) {
                this.stopAiLoader();
                this.arktabaccess = false;
              } else {
                if (!this.insightsVal || this.insightsVal.length === 0) {
                  this.insightsVal = ['Insights not available for this historical chat.'];
                }
                this.stopAiLoader();
                this.arktabaccess = false;
              }
            } else {
              // Use cached insights if available (from pre-fetch)
              const cached = (this.multiViewInsightsCache[msgId] || {})[this.mcode];
              if (cached) {
                console.log(`[ORCHESTRATION] Applying cached insights for Snapshot (mcode: ${this.mcode})`);
                this.insightsVal = cached.insightsVal;
                this.updateMarkdownTextRealTime(cached.qnaText);
                this.isInsightspopupOpen = true;
                this.isInsightsStreaming = false;
                this.isStreamFinished = true;
                this.statusQueue = []; // Clear queue to instantly show post-stream message
                setTimeout(() => {
                  this.stopAiLoader();
                  this.arktabaccess = false;
                }, 1500);

                if (!isChatResponse) {
                  // Insights already pushed in Step 2 bundling above if cached
                  this.saveChatList(
                    targetBlock ? targetBlock.question : (this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue),
                    this.chatResponse,
                    cached.qnaText || this.getFirstTwoInsightsAsPlainText() || 'Insights ready.',
                    targetBlock?.messageId
                  );
                }
              } else if (!this.failedCase) {
                console.warn(`[ORCHESTRATION] No cached insights for mcode: ${this.mcode}. Triggering fallback.`);
                
                // Unblock the main UI wrapper immediately by setting the selected message ID to the active block
                if (targetBlock && targetBlock.messageId) {
                  this.selectedMessageId = targetBlock.messageId;
                }

                setTimeout(() => {
                  this.callInsightsAPI(this.mcode, markdownData, this.currentQuestion, widget_details, targetBlock);
                }, 100);
              }
            }
          }

          if (this.mcode != 1) {
            this.LoadRibbonData(this.filteredlist);

            // Force crosstab view for mcode 2 and 3
            this.showSnapshot = false;
            this.arktabaccess = false;
            this.isDiagnostic = true;
            this.existingquery = this.inputValue;
            this.OutputdataObject.Row = [];
            this.OutputdataObject.Column = [];
            this.CrossTabOutPutData = [];



            if (data.response != null && data.response.HasValidData !== false) {
              let outputstring = data.response;
              this.displayTable = true;
              this.resetChartStates('table');

              try {
                if (typeof outputstring.Data === 'string') {
                  this.CrossTabOutPutData = JSON.parse(outputstring.Data);
                } else if (Array.isArray(outputstring.Data)) {
                  this.CrossTabOutPutData = outputstring.Data;
                } else {
                  console.error('Unexpected outputstring.Data format:', typeof outputstring.Data);
                  this.CrossTabOutPutData = [];
                }
              } catch (parseError) {
                console.error('Error parsing outputstring.Data:', parseError);
                console.error('Raw outputstring.Data:', outputstring.Data);
                this.CrossTabOutPutData = [];
              }
              this.SelectionSummary();

              this.variableTabData = this.receivedData;
              if (typeof outputstring.Data === 'string') {
                this.CrossTabOutPutEntireData = JSON.parse(outputstring.Data);
              } else if (Array.isArray(outputstring.Data)) {
                this.CrossTabOutPutEntireData = outputstring.Data;
              } else {
                console.error('Unexpected outputstring.Data format for EntireData:', typeof outputstring.Data);
                this.CrossTabOutPutEntireData = [];
              }
              this.normalizeNestedChildFields(this.CrossTabOutPutEntireData);
              if (this.mcode == 2 || this.mcode == 3) {
                this.cleanBrandAnalysisChild(this.CrossTabOutPutEntireData);
                this.cleanBrandAnalysisChild(this.CrossTabOutPutData);
              }
              let chartType = 'column';
              chartType = this.isTranspose ? 'column' : 'bar';
              if (this.CrossTabOutPutEntireData.length > 0) {
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
              }
              this.isTranspose = false;
              this.insufficientBase = this.insufficentBase || '';
              this.DefaultConfidenceLevel = 'None';
              this.isAnswerBase = false;
              this.isSampleSize = false;
              this.isWeightedLabel = false;
              this.LowBase = this.lowBase || '';
              this.isPairWise = false;
              this.DefaultSampleSize = 'None';
              this.threshold = '';
              this.selectedIndex = '';
              this.isIndex = false;
              this.selectedWeight = this.promptData.weight || this.promptData.Weight || this.selectedWeight;
              if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
                const matchedWeight = this.WeightDropDownList.find(w => w.responseCode === this.selectedWeight);
                this.DefaultWeight = matchedWeight ? matchedWeight.Label : (this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight);
              } else {
                this.DefaultWeight = this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight;
              }
              this.isBrandAnalysis = this.promptData.mcode == 2 ? true : false;


              if (!this.isTotal) {
                const preFilterCount = this.CrossTabOutPutEntireData.length;
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
                  (x: any) => {
                    return !x.isTotal;
                  }
                );
              } else {
              }

              if (this.isIndex && this.selectedIndex != '') {
                this.manipulateIndexData();
              }

              this.BindTableOutput(this.CrossTabOutPutData);
              this.sortOutputData();


              this.isCreateBtnClick = true;
              if (this.isTranspose) {
                this.handleOutputdataObjectOnTransposeSelect();
              }
              if (
                this.OutputdataObject.Row.length != 0 &&
                this.OutputdataObject.Column.length != 0
              ) {
                this.displayTable = true;
                setTimeout(() => MarkdownPayloadHelper.storeTableAsMarkdown(this), 300);
              }
              this.updateChartDisablingFlags();


              this.crossTabService.setCrossTabOuputData(
                this.CrossTabOutPutData
              );
              if (this.isLineChartClick) {
                this.onTrendChartIconClick();
              } else if (
                this.isVerticalGroupBarChartClick ||
                this.isVerticalBarChartClick
              ) {
                this.VerticalChartClick(this.chartType);
              } else if (this.isVerticalStackChartClick) {
                this.onVerticalStackBarChartIconClick(this.chartType);
              }
              this.is_Time_Period_Present = true;

            } else {
              console.error('==== NO VALID RESPONSE DATA ====');
              console.error('data.response is null or HasValidData is false');
              console.error('Cannot populate CrossTabOutPutData');
              this.CrossTabOutPutData = [];
            }

            this.isInsightspopupOpen = false;
            this.arktabaccess = true;
            this.isInsightsBtnEnabled = true;


            if (this.CrossTabOutPutData && this.CrossTabOutPutData.length > 0) {
              const hasNonZeroData = this.CrossTabOutPutData.some((item: any) => {
                const hasValue = (item.totalWeightedShare > 0 ||
                  item.totalUnweightedShare > 0 ||
                  item.answerWeightedShare > 0 ||
                  item.answerUnweightedShare > 0 ||
                  item.value > 0);
                return hasValue;
              });


              if (!hasNonZeroData) {
                this.insightsVal = isChatResponse ? (getInsights || ['No insights available for this selection.']) : ['Metric values are zero or null for the selected criteria.'];
              }

              const markdownData = this.buildCrosstabMarkdownForAPI();

              if (isChatResponse) {
                if (getInsights) {
                  this.openInsights(isChatResponse, getInsights);
                } else {
                  this.insightsVal = ['Insights not available for this historical chat.'];
                  this.isInsightspopupOpen = true;
                  this.arktabaccess = false;
                }
              } else {
                // Use cached insights if available (from pre-fetch)
                const cached = (this.multiViewInsightsCache[msgId] || {})[this.mcode];
                if (cached) {
                  console.log(`[ORCHESTRATION] Applying cached insights for mcode: ${this.mcode}`);
                  this.insightsVal = cached.insightsVal;
                  this.updateMarkdownTextRealTime(cached.qnaText);
                  this.isInsightspopupOpen = true;
                  this.isInsightsStreaming = false;
                  this.isStreamFinished = true;
                  this.statusQueue = []; // Clear queue to instantly show post-stream message
                  setTimeout(() => {
                    this.stopAiLoader();
                    this.arktabaccess = false;
                  }, 1500);

                  if (!isChatResponse) {
                    // Insights already pushed in Step 2 bundling if cached
                    this.saveChatList(
                      targetBlock ? targetBlock.question : (this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue),
                      this.chatResponse,
                      cached.qnaText || this.getFirstTwoInsightsAsPlainText() || 'Insights ready.',
                      targetBlock?.messageId
                    );
                  }
                } else if (!this.failedCase) {
                  console.warn(`[ORCHESTRATION] No cached insights for mcode: ${this.mcode}. Triggering fallback.`);
                  
                  // Unblock the main UI wrapper immediately by setting the selected message ID to the active block
                  if (targetBlock && targetBlock.messageId) {
                    this.selectedMessageId = targetBlock.messageId;
                  }

                  setTimeout(() => {
                    this.callInsightsAPI(this.mcode, markdownData, this.currentQuestion, {}, targetBlock);
                  }, 100);
                }
              }
            } else {
              console.error('[Insights Check] CrossTabOutPutData is empty, cannot generate insights');
              this.insightsVal = ['No output data available for this question.'];
              this.setFailedCaseState(true);
              this.isInsightspopupOpen = true;
              this.isStreamFinished = false;
              this.isInsightsStreaming = false;
              this.arktabaccess = false;
              if (!isChatResponse) {
                this.saveChatList(targetBlock ? targetBlock.question : (this.currentQuestion || 'Analytics Question'), this.chatResponse, 'No output data available for this question.', targetBlock?.messageId);
              }
            }
            if (isChatResponse || !this.CrossTabOutPutData || this.CrossTabOutPutData.length === 0) {
              this.arktabaccess = false;
            }
            this.LoadRibbonData(this.filteredlist);
            // OLD code - 08/12/2025
          }

          if (this.mcode == 99) {
            this.insightsVal = this.fallbackMessage();
            this.setFailedCaseState(true);
            this.errorHeader = 'Analysis Status:';
            this.isStreamFinished = false;
            this.isInsightsStreaming = false;
            this.arktabaccess = false;
            this.isInsightspopupOpen = true;
            this.currentView = 'chat';

            if (!isChatResponse) {
              this.pushChatResponseEntry('failedCase', true);
              this.pushChatResponseEntry('errorHeader', this.errorHeader);
            }

            const errorMessage = this.fallbackMessage();
            const shortErrorMessage = 'I encountered an issue processing your query. Please try again.';
            if (this.chatPreviewBlocks.length > 0) {
              this.updateQuestionAnswerForSelectedMessage(shortErrorMessage);
            }

            // Removed saveChatList to prevent recording mcode 99 errors in history
            this.isHistorySaving = false;
            this.isDiagnostic = true;

            if (this.promptData && typeof this.promptData === 'object' && Object.keys(this.promptData).length > 0) {
              this.apiService.getOutputData(
                this.inputValue,
                this.landingdata.client_code,
                this.landingdata.study,
                [],
                this.promptData,
                this.weightFilter
              ).subscribe(
                (outputResponse) => {
                  this.promptData = outputResponse;
                  this.insightsVal = outputResponse.p_user_response || this.fallbackMessage();
                  this.Widget_Id = outputResponse.Widget_ID;
                  this.isTotalBase = outputResponse.isTotalBase;
                  this.setFailedCaseState(true);
                  this.errorHeader = 'Analysis Status:';
                  this.isInsightspopupOpen = true;
                  this.arktabaccess = false;
                  this.isDiagnostic = true;

                  if (!isChatResponse) {
                    this.pushChatResponseEntry('failedCase', true);
                    this.pushChatResponseEntry('errorHeader', this.errorHeader);
                  }
                },
                (error) => {
                  console.error('getOutputData error:', error);
                  this.arktabaccess = false;
                  this.inputValue = '';
                }
              );
            } else {
              this.arktabaccess = false;
              this.inputValue = '';
            }
          }

          if (targetBlock) {
            targetBlock.CrossTabOutPutData = [...(this.CrossTabOutPutData || [])];
            targetBlock.OutputdataObject = this.OutputdataObject ? JSON.parse(JSON.stringify(this.OutputdataObject)) : null;
            targetBlock.CrossTabOutPutEntireData = [...(this.CrossTabOutPutEntireData || [])];
            targetBlock.dataObject = this.dataObject ? JSON.parse(JSON.stringify(this.dataObject)) : null;
            targetBlock.IndexData = this.getLastLevelColumnNestingValues(targetBlock) || [];
            targetBlock.variableTabData = [...(this.variableTabData || [])];
            targetBlock.WeightDropDownList = [...(this.WeightDropDownList || [])];
            targetBlock.SampleSizeList = [...(this.SampleSizeList || [])];

            // [DATA ISOLATION] Sync all UI and analytical settings to keep the control bar in sync
            targetBlock.mcode = this.mcode;
            targetBlock.is_sigtesting = this.is_sigtesting;
            targetBlock.is_Time_Period_Present = this.is_Time_Period_Present;
            targetBlock.isIndex = this.isIndex;
            targetBlock.isSig = this.isSig;
            targetBlock.isTranspose = this.isTranspose;
            targetBlock.is_TransposeBtn = this.is_TransposeBtn;
            targetBlock.is_confidenceLevel = [...(this.is_confidenceLevel || [])];
            targetBlock.SignificanceVsReference = this.SignificanceVsReference;
            targetBlock.DefaultConfidenceLevel = this.DefaultConfidenceLevel;
            targetBlock.DefaultSampleSize = this.DefaultSampleSize;
            targetBlock.DefaultReferenceLevel = this.DefaultReferenceLevel;
            targetBlock.selectedWeight = this.selectedWeight;
            targetBlock.DefaultWeight = this.DefaultWeight;
            targetBlock.DefaultBase = this.DefaultBase;
            targetBlock.isTotalBase = this.isTotalBase;
            targetBlock.isAnswerBase = this.isAnswerBase;
            targetBlock.isSampleSize = this.isSampleSize;
            
            targetBlock.IndexData = this.getLastLevelColumnNestingValues(targetBlock) || [];
            
            // If IndexData has options, enable reference. Otherwise disable it.
            targetBlock.isDisableReference = targetBlock.IndexData?.length <= 1;
            targetBlock.isWeightedLabel = this.isWeightedLabel;
            targetBlock.isTableClick = this.isTableClick;
            targetBlock.isChartView = this.isChartView;
            targetBlock.isVerticalGroupBarChartClick = this.isVerticalGroupBarChartClick;
            targetBlock.isVerticalBarChartClick = this.isVerticalBarChartClick;
            targetBlock.isVerticalStackChartClick = this.isVerticalStackChartClick;
            targetBlock.isLineChartClick = this.isLineChartClick;
            targetBlock.DefaultDataDropDown = this.DefaultDataDropDown || 'Data';
            targetBlock.disableStackChart = this.disableStackChart;
            targetBlock.disableLineChart = this.disableLineChart;
            targetBlock.showStackTooltip = this.showStackTooltip;
            targetBlock.showLineTooltip = this.showLineTooltip;
            targetBlock.showBarTooltip = this.showBarTooltip;
            targetBlock.showMainTooltip = this.showMainTooltip;
          }
        },
        error: (error: any) => {
          console.error('[ORCHESTRATION ERROR] Orchestration API failed:', error);
          this.stopAiLoader();
          this.arktabaccess = false;
          this.isInsightsStreaming = false;

          let errorMessage = 'We encountered an issue while processing your request. Please try again later or contact support if the issue persists.';
          let shortErrorMessage = 'Unable to process request. Please try again.';
          this.errorHeader = 'Analysis Error:';
          
          if (typeof error === 'string' && error.includes('All analytical agents failed')) {
            errorMessage = 'We couldn\'t generate a complete analysis for this request. Please try refining your question or selecting different parameters.';
            shortErrorMessage = 'Analysis could not be completed. Please refine your question.';
            this.errorHeader = 'Analysis Unavailable:';
          } else if (error.status === 401) {
            errorMessage = 'Session expired. Please refresh the page to continue asking questions in this chat.';
            shortErrorMessage = 'Session expired. Please refresh page.';
            this.errorHeader = 'Authentication Error:';
            console.error('[ORCHESTRATION ERROR] 401 - Authentication failed, likely expired session for old chat');
          } else if (error.status === 403) {
            errorMessage = 'Access denied. You do not have permission to perform this action.';
            shortErrorMessage = 'Access denied. Permission required.';
            this.errorHeader = 'Access Denied:';
          } else if (error.status === 404) {
            errorMessage = 'The requested service could not be found. Please contact your administrator if this issue persists.';
            shortErrorMessage = 'Service connection failed.';
            this.errorHeader = 'Invalid Request:';
          } else if (error.status === 500) {
            errorMessage = 'We\'re currently experiencing an internal server error. Please contact your administrator for assistance.';
            shortErrorMessage = 'Internal server error.';
            this.errorHeader = 'Server Error:';
          } else if (error.status === 0) {
            errorMessage = 'It looks like you\'re offline or experiencing a network issue. Please check your internet connection and try again.';
            shortErrorMessage = 'Network connection interrupted.';
            this.errorHeader = 'Network Error:';
          }

          if (targetBlock) {
            this.selectedMessageId = targetBlock.messageId || null;
          } else if (this.chatPreviewBlocks.length > 0) {
            this.selectedMessageId = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].messageId || null;
          }

          if (this.chatPreviewBlocks.length > 0) {
            this.updateQuestionAnswerForSelectedMessage(shortErrorMessage);
          } else if (!isChatResponse) {
            const tempMsgId = 'temp-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            this.selectedMessageId = tempMsgId;
            this.chatPreviewBlocks.push({
              messageId: tempMsgId,
              question: this.inputValue || 'Question',
              response: '',
              isLiked: null,
              isStarred: false,
              feedbackSaved: false,
              showLikeInput: false,
              likeReason: '',
              showDislikeInput: false,
              dislikeReason: '',
              QuestionAnswer: shortErrorMessage,
              isTrendActive: this.isTrendActive,
              isExportspopup: false,
              sampleSizeDropdown: false,
              confidenceLevelDropDown: false,
              referenceLevelDropDown: false,
              baseDropDown: false,
              weightDropDown: false,
              isReference: false,
              isSig: true,
              isIndex: false,
              DefaultSampleSize: 'None',
              SignificanceVsReference: '',
              DefaultConfidenceLevel: '95%',
              DefaultReferenceLevel: 'None',
              selectedWeight: this.selectedWeight || 'Weight',
              DefaultWeight: this.DefaultWeight || 'Total Population',
              DefaultBase: this.DefaultBase || 'Total Base',
              isTotalBase: true,
              isAnswerBase: true,
              is_sigtesting: true,
              is_Time_Period_Present: true,
              isTranspose: false,
              dataDropDown: false,
              DefaultDataDropDown: 'Data',
              isTableClick: true,
              isVerticalStackChartClick: false,
              isVerticalBarChartClick: false,
              isVerticalGroupBarChartClick: false,
              isLineChartClick: false,
              isChartView: true,
              disableStackChart: false,
              disableLineChart: false,
              showStackTooltip: false,
              showLineTooltip: false,
              showBarTooltip: false,
              showMainTooltip: false,
              StackFlag: false,
              displayTable: true,
              isTableClosing: false,
              isChartClosing: false
            });
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('failedCase', true);
            this.pushChatResponseEntry('noContentFlag', true);
            this.pushChatResponseEntry('errorHeader', this.errorHeader);
          }

          this.insightsVal = errorMessage;
          this.setFailedCaseState(true, targetBlock);
          this.noContentFlag = true;
          this.isInsightspopupOpen = true;
          const errorObj: InsightsModel = {
            header: this.errorHeader || 'Error',
            message: errorMessage,
            show: true,
          };
          this._insightsSerive.showInisghts(errorObj);

          // Removed saveChatList to prevent recording orchestration error questions in history
          this.isHistorySaving = false;
          this.currentView = 'chat';
        }
      });
    }
  }

  AssignDataToDataObject(datamodel: any) {
            this.isTotalBaseFromPrompt = datamodel.isTotalBase;
  }

  LoadRibbonData(receivedData: any) {
    let ribbonSource = receivedData;
    // When loading from history, receivedData is the full analyticalData object. 
    // The ribbon configuration data is nested inside getConfiguration.
    if (receivedData && !receivedData.comparison_point && receivedData.getConfiguration) {
        ribbonSource = Array.isArray(receivedData.getConfiguration) ? receivedData.getConfiguration[0] : receivedData.getConfiguration;
    }

    const activeDataFormat = ribbonSource.dataformat?.find((df: any) => df.value === true);
    const dataFormatKey = activeDataFormat ? activeDataFormat.key : (ribbonSource.dataformat ? ribbonSource.dataformat[0]?.key : 'Missing');
    this.selectedDataFormat = dataFormatKey;
    this._configService.isRespondentLevel = dataFormatKey === 'Respondent Level';
    this._configService.isAggregatedData = dataFormatKey === 'Aggregated';
    this._configService.isSemiAggregatedData = dataFormatKey === 'Semi-Aggregated';

    if (this.SampleSizeList.length == 0 && ribbonSource && ribbonSource.comparison_point) {
      for (const item of ribbonSource.comparison_point) {
        if (item.value) {
          this.SampleSizeList.push(item);
        }
      }
    } else if (this.SampleSizeList.length == 0) {
      console.warn(`[RIBBON-DEBUG] Cannot populate SampleSizeList. comparison_point is missing!`);
    }
    const outputPage = ribbonSource.output_page || [];
    this.is_indexing = (this.mcode === 2 || this.mcode === 3) ? true : (outputPage[1]?.value || false);
    this.isRowNesting =
      dataFormatKey === 'Respondent Level'
        ? ribbonSource.nesting[0]?.is_selected
        : false;
    this.isColumnNesting = ribbonSource.nesting ? ribbonSource.nesting[1]?.is_selected : false;
    this.is_TransposeBtn =
      dataFormatKey === 'Respondent Level'
        ? ribbonSource.output_page[0]?.value
        : false;
    this.filteringAnsBlock =
      dataFormatKey === 'Respondent Level'
        ? ribbonSource.filter_function[0]?.value
        : false;
    this.AnsBaseBlock =
      dataFormatKey === 'Respondent Level'
        ? ribbonSource.filter_function[1]?.value
        : false;
    this.is_sigtesting =
      dataFormatKey === 'Respondent Level'
        ? ribbonSource.output_page[2]?.value
        : false;
    (this.is_brand_analysis = ribbonSource.is_brand_analysis),
      (this.is_chart_visualization = ribbonSource.is_chart_visualization),
      (this.is_sticky_selection = ribbonSource.is_sticky_selection),
      (this.is_reset_selection = ribbonSource.is_reset_selection),
      (this.is_Transpose = ribbonSource.output_page ? ribbonSource.output_page[0]?.value : false),
      (this.is_sigtesting = (this.mcode === 2 || this.mcode === 3) ? true : (outputPage[2]?.value || false)),
      (this.is_ranking = ribbonSource.output_page ? ribbonSource.output_page[3]?.value : false),
      (this.is_confidenceLevel = ribbonSource.confidence_level);
    (this.isFilterToggle = ribbonSource.filter_function ? ribbonSource.filter_function[0]?.value : false),
      (this.isAnswerToggle = ribbonSource.filter_function ? ribbonSource.filter_function[1]?.value : false),
      (this.excelExport = ribbonSource.export_download ? ribbonSource.export_download[0]?.value : false),
      (this.repository = ribbonSource.export_download ? ribbonSource.export_download[2]?.value : false),
      (this.lowBaseIdentifier = ribbonSource.export_download ? ribbonSource.export_download[3]?.value : false),
      (this.is_AI_Integration = ribbonSource.is_AI_Integration),
      (this.is_StoryBoard = ribbonSource.is_StoryBoard),
      (this.is_Column_Row_Percentage = ribbonSource.is_Column_Row_Percentage),
      (this.insufficentBase = ribbonSource.low_base_identifier ? ribbonSource.low_base_identifier[0]?.data_value : 0),
      (this.insufficientBase = ribbonSource.low_base_identifier ? ribbonSource.low_base_identifier[0]?.data_value : 0),
      (this.lowBase = ribbonSource.low_base_identifier ? ribbonSource.low_base_identifier[1]?.data_value : 0),
      (this.LowBase = ribbonSource.low_base_identifier ? ribbonSource.low_base_identifier[1]?.data_value : 0),
      (this.threshold = ribbonSource.threshold_identifier ? ribbonSource.threshold_identifier[0]?.data_value : 0),
      (this.iscustomgrp = ribbonSource.custom_content ? ribbonSource.custom_content[0]?.value : false),
      (this.iscustomCalc = ribbonSource.custom_content ? ribbonSource.custom_content[1]?.value : false),
      (this.iscustomreport = ribbonSource.custom_content ? ribbonSource.custom_content[2]?.value : false),
      (this.changeEntryPoint = ribbonSource.save_selection ? ribbonSource.save_selection[1]?.value : false),
      (this.aggregatedVariables = ribbonSource.aggregatedvariables),
      (this.isWeightedBase =
        ribbonSource.aggregatedvariables && ribbonSource.aggregatedvariables[1]?.data_value == '' ? false : true),
      (this.isSampleSize =
        ribbonSource.aggregatedvariables && ribbonSource.aggregatedvariables[2]?.data_value == '' ? false : true),
      (this.mandatoryVariableMapping = ribbonSource.mandatory_variable_mapping),
      (this.isSelectAllMetrics = ribbonSource.is_SelectAll_Metrics);
    this.isSelectAllMetricsLevel = ribbonSource.isSelectAllMetrics;
    this.SampleSizeContainer =
      dataFormatKey === 'Respondent Level'
        ? true
        : ribbonSource.isWeightedBase || ribbonSource.isSampleSize
          ? true
          : false;
    this.isSampleSizeBlock =
      dataFormatKey === 'Respondent Level'
        ? true
        : ribbonSource.isSampleSize;
    this.isWeightedSampleBlock =
      dataFormatKey === 'Respondent Level'
        ? true
        : ribbonSource.isWeightedBase;
    const noneexists = this.SampleSizeList.some(
      (item: { key: string }) => item.key === 'None'
    );
    if (!noneexists) {
      let newPair = { key: 'None', value: true };
      this.SampleSizeList.unshift(newPair);
    }
  }

  manipulateIndexData(block: any = null) {
    const target = block || this;
    let level = 0;
    if (this.dataObject.ColNesting.length > 0) {
      level = this.dataObject.ColNesting.length;
    }
    const dataToUse = target.CrossTabOutPutData || [];
    const selectedIndex = target.selectedIndex || '';
    const selectedWeight = target.selectedWeight || '';

    let selectedIndexData = dataToUse.filter((x: any) => {
      if (level == 1) return x.Level1ColChild == selectedIndex;
      else if (level == 2) return x.Level2ColChild == selectedIndex;
      else return x.colChild == selectedIndex;
    });
    if (selectedIndexData.length > 0) {
      selectedIndexData = JSON.parse(JSON.stringify(selectedIndexData));
      selectedIndexData.forEach((item: any) => {
        let indexData = dataToUse.filter((x: any) => {
          if (level == 1) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild
            );
          } else if (level == 2) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild &&
              x.Level1ColChild == item.Level1ColChild
            );
          } else
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild
            );
        });
        if (indexData.length > 0) {
          indexData.forEach((indexItem: any) => {
            if (selectedWeight == 'Unweighted') {
              indexItem.totalUnweightedShare = isNaN(
                indexItem.totalUnweightedShare / item.totalUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalUnweightedShare / item.totalUnweightedShare
                )
                  ? indexItem.totalUnweightedShare / item.totalUnweightedShare
                  : null;
              indexItem.answerUnweightedShare = isNaN(
                indexItem.answerUnweightedShare / item.answerUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerUnweightedShare / item.answerUnweightedShare
                )
                  ? indexItem.answerUnweightedShare / item.answerUnweightedShare
                  : null;
              indexItem.totalUnweightedShare_Index =
                indexItem.totalUnweightedShare;
              indexItem.answerUnweightedShare_Index =
                indexItem.answerUnweightedShare;
            } else {
              indexItem.totalWeightedShare = isNaN(
                indexItem.totalWeightedShare / item.totalWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalWeightedShare / item.totalWeightedShare
                )
                  ? indexItem.totalWeightedShare / item.totalWeightedShare
                  : null;
              indexItem.answerWeightedShare = isNaN(
                indexItem.answerWeightedShare / item.answerWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerWeightedShare / item.answerWeightedShare
                )
                  ? indexItem.answerWeightedShare / item.answerWeightedShare
                  : null;
              indexItem.totalWeightedShare_Index = indexItem.totalWeightedShare;
              indexItem.answerWeightedShare_Index =
                indexItem.answerWeightedShare;
            }
          });
        }
      });
    }
  }

  onVerticalStackBarChartIconClick(chartType: string, block: any = null, distinctColChildValues?: string[]) {
    this.neutralizeChartIds(block);
    const target = block || this;
    if (target.disableStackChart) return;
    const currentOutputData = (target.OutputdataObject && target.OutputdataObject.Row?.length > 0) ? target.OutputdataObject : this.OutputdataObject;
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues(currentOutputData);
    }
    this.initializeChartData(target.StackChart);
    // Reset global color dictionary to force chart to generate new colors for isolated block
    this.crossTabService.setColorDictionary([]);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.StackChartData(target.StackChart, [], 'None', target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('stack', block);
    target.isChartView = true;
    let index = 1;

    const dataToUse = (target.CrossTabOutPutData && target.CrossTabOutPutData.length > 0) ? target.CrossTabOutPutData : this.CrossTabOutPutData;
    dataToUse.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      target.StackChart.Data.push({
        'Series Name': target.isTranspose ? item.colChild.replaceAll('|', ' : ') : item.rowChild.replaceAll('|', ' : '),
        'Category Name': target.isTranspose ? item.rowChild.replaceAll('|', ' : ') : item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance1: this.getSignificanceString(item), // Required by StackBarProperties
        'Sample size': this.getSampleSizeString(item)
      });
      index++;
    });

    if (dataToUse.length > 0) {
      target.StackChart.title = dataToUse[0].colChild;
    }

    const numberType = dataToUse?.[0]?.CalculationType || 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(currentOutputData.Row as any);

    this.StackChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 100, // For stacked bar chart
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: (target.DefaultSampleSize || this.DefaultSampleSize) == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || dataToUse?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = target.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(target.StackChart.Data, distinctRowChildValues);
    const selectedSignifcance = (target.DefaultSampleSize || this.DefaultSampleSize) === 'Pairwise' ? 'None' : (target.DefaultSampleSize || this.DefaultSampleSize);
    setTimeout(() => {
      this.crossTabService.StackChartData(target.StackChart, distinctColChildValues, selectedSignifcance, target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  onTrendChartIconClick(block: any = null) {
    this.neutralizeChartIds(block);
    const target = block || this;
    if (target.disableLineChart) return;
    target.disableLineChart = false;
    this.initializeChartData(target.LineChart);
    // Reset global color dictionary to force chart to generate new colors for isolated block
    this.crossTabService.setColorDictionary([]);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.LineChartData(target.LineChart, [], 'None', this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('line', block);
    target.isChartView = true;
    const currentOutputData = (target.OutputdataObject && target.OutputdataObject.Row?.length > 0) ? target.OutputdataObject : this.OutputdataObject;
    const rowdata = currentOutputData['Row'];
    this.updateChartDisablingFlags(block);

    let numberType: string = 'percentage';
    const distinctColChildValues = this.getDistinctColumnChildValues(currentOutputData);
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(currentOutputData.Row as any);

    const dataToUse = (target.CrossTabOutPutData && target.CrossTabOutPutData.length > 0) ? target.CrossTabOutPutData : this.CrossTabOutPutData;
    dataToUse.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      let calculatedPercentage: number | string =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      let changePy: number | string =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      target.LineChart.Data.push({
        'Series Name': target.isTranspose ? item.colChild.replaceAll('|', ' : ') : item.rowChild.replaceAll('|', ' : '),
        'Category Name': target.isTranspose ? item.rowChild.replaceAll('|', ' : ') : item.colChild.replaceAll('|', ' : '),
        'Rounded Value': ShareNumber == null ? 'NA' : calculatedPercentage,
        XValue: '0',
        Value: calculatedPercentage,
        Label: calculatedPercentage.toString(),
        'Change value vs PY': changePy,
        Significance: this.isTotalBase
          ? (item.Significance_Total == null ? 0 : item.Significance_Total)
          : (item.Significance_Answer == null ? 0 : item.Significance_Answer),
        'Sample Size': this.isTotalBase
          ? (item.totalUnweightedBase == null ? 0 : item.totalUnweightedBase)
          : (item.answerUnweightedBase == null ? 0 : item.answerUnweightedBase),
      });
    });

    if (this.CrossTabOutPutData.length > 0) {
      target.LineChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }

    target.LineChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: false,
      chartStyle: 'area',
      showLegend: true,
      gridlines: false,
      legendPosition: 'bottom',
      stacking: 0,
      darkTheme: false,
      axisLabelOrientation: 'center',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelFormat: (numberType == 'mean' || this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'center',
      datalabelStyle: this.DefaultSampleSize == 'None' ? '' : 'sigchan',
      datalabelOrientation: 0,
      axisImage: false,
      lineWidth: 2,
      gridLineDashStyle: 'Solid',
      markerLineWidth: 1,
      markerStyle: 'circle',
      title: 'LineChart',
      shadow: false,
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    this.sortChartDataBySeriesName(target.LineChart.Data, distinctRowChildValues);
    let selectedSignifcance = this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    setTimeout(() => {
      this.crossTabService.LineChartData(target.LineChart, distinctColChildValues, selectedSignifcance, this.DefaultConfidenceLevel, numberType, '');
    }, 100);
  }

  getDistinctChildValues(data: checkboxSelectionWithParent[]): string[] {
    return ChartUtilitiesHelper.getDistinctChildValues(data || []);
  }

  onVerticalBarChartIconClick(chartType: string, block: any = null, distinctColChildValues?: string[]) {
    this.neutralizeChartIds(block);
    const target = block || this;
    const currentOutputData = (target.OutputdataObject && target.OutputdataObject.Row?.length > 0) ? target.OutputdataObject : this.OutputdataObject;
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues(currentOutputData);
    }
    this.initializeChartData(target.BarChart);
    // Reset global color dictionary to force chart to generate new colors for isolated block
    this.crossTabService.setColorDictionary([]);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.ChartData(target.BarChart, [], 'None', target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('bar', block);
    let index = 1;

    const dataToUse = (target.CrossTabOutPutData && target.CrossTabOutPutData.length > 0) ? target.CrossTabOutPutData : this.CrossTabOutPutData;
    dataToUse.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      target.isVerticalBarChartClick = true;
      target.isVerticalStackChartClick = false;
      target.isVerticalGroupBarChartClick = false;
      target.isTableClick = false;
      target.isLineChartClick = false;
      target.isChartView = true;

      target.BarChart.Data.push({
        'Series Name': target.isTranspose ? item.colChild.replaceAll('|', ' : ') : item.rowChild.replaceAll('|', ' : '),
        'Category Name': target.isTranspose ? item.rowChild.replaceAll('|', ' : ') : item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        XValue: index.toString(),
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance2: this.getSignificanceString(item),
        'Sample size': this.getSampleSizeString(item)
      });
      index++;
    });

    if (dataToUse.length > 0) {
      target.BarChart.title = dataToUse[0].colChild;
    }

    const numberType = (dataToUse.length > 0) ? (dataToUse[0].CalculationType || 'percentage') : 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(currentOutputData.Row as any);

    target.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: (target.DefaultSampleSize || this.DefaultSampleSize) == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || dataToUse?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = target.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(target.BarChart.Data, distinctRowChildValues);
    const selectedSignifcance = (target.DefaultSampleSize || this.DefaultSampleSize) === 'Pairwise' ? 'None' : (target.DefaultSampleSize || this.DefaultSampleSize);
    setTimeout(() => {
      this.crossTabService.ChartData(target.BarChart, distinctColChildValues, selectedSignifcance, target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  onGroupVerticalChartClick(chartType: string, block: any = null, distinctColChildValues?: string[]) {
    this.neutralizeChartIds(block);
    const target = block || this;
    const currentOutputData = (target.OutputdataObject && target.OutputdataObject.Row?.length > 0) ? target.OutputdataObject : this.OutputdataObject;
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues(currentOutputData);
    }
    this.initializeChartData(target.BarChart);
    // Reset global color dictionary to force chart to generate new colors for isolated block
    this.crossTabService.setColorDictionary([]);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.GrpChartData(target.BarChart, [], 'None', target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('groupBar', block);
    target.isVerticalGroupBarChartClick = true;
    target.isVerticalBarChartClick = false;
    target.isVerticalStackChartClick = false;
    target.isTableClick = false;
    target.isLineChartClick = false;
    target.isChartView = true;

    const dataToUse = (target.CrossTabOutPutData && target.CrossTabOutPutData.length > 0) ? target.CrossTabOutPutData : this.CrossTabOutPutData;
    dataToUse.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      target.BarChart.Data.push({
        'Series Name': target.isTranspose ? item.colChild.replaceAll('|', ' : ') : item.rowChild.replaceAll('|', ' : '),
        'Category Name': target.isTranspose ? item.rowChild.replaceAll('|', ' : ') : item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        XValue: '1',
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance2: this.getSignificanceString(item),
        'Sample size': this.getSampleSizeString(item)
      });
    });

    if (dataToUse.length > 0) {
      target.BarChart.title = dataToUse[0].colChild;
    }

    const numberType = (dataToUse.length > 0) ? (dataToUse[0].CalculationType || 'percentage') : 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(currentOutputData.Row as any);

    target.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: (target.DefaultSampleSize || this.DefaultSampleSize) == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || dataToUse?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = target.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(target.BarChart.Data, distinctRowChildValues);
    const selectedSignifcance = (target.DefaultSampleSize || this.DefaultSampleSize) === 'Pairwise' ? 'None' : (target.DefaultSampleSize || this.DefaultSampleSize);
    setTimeout(() => {
      this.crossTabService.GrpChartData(target.BarChart, distinctColChildValues, selectedSignifcance, target.DefaultConfidenceLevel || this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  VerticalChartClick(chartType: string, block: any = null) {
    const target = block || this;
    this.variableTabData = this.crossTabService.getVarTabData || [];
    const currentOutputData = (target.OutputdataObject && target.OutputdataObject.Row?.length > 0) ? target.OutputdataObject : this.OutputdataObject;
    const rowdata = currentOutputData['Row'];
    const rowDataLengthValue: number = rowdata.length > 1 ? rowdata.length : rowdata[0]?.Data?.length || 0;


    this.updateChartDisablingFlags(block);
    if (!target.isChartView) return;
    const distinctColChildValues = this.getDistinctColumnChildValues(currentOutputData);

    this.resetChartStates(undefined, block);
    target.isChartView = true;
    target.isLineChartClick = false;
    target.isVerticalStackChartClick = false;
    target.isVerticalBarChartClick = true;

    if (rowDataLengthValue == 1) {
      this.onVerticalBarChartIconClick(chartType, block, distinctColChildValues);
    } else {
      this.onGroupVerticalChartClick(chartType, block, distinctColChildValues);
    }
  }

  getDistinctValuesByPipeCount(data: string[], pipeCount: number): string[] {
    return ChartUtilitiesHelper.getDistinctValuesByPipeCount(data, pipeCount);
  }

  handleOutputdataObjectOnTransposeSelect(block: any = null) {
    const target = block || this;
    if (
      target.OutputdataObject != null &&
      (target.OutputdataObject['Row'].length > 0 ||
        target.OutputdataObject['Column'].length > 0)
    ) {
      let tempRow = [...target.OutputdataObject.Row];
      let tempColumn = [...target.OutputdataObject.Column];
      target.OutputdataObject.Row = [...tempColumn];
      target.OutputdataObject.Column = [...tempRow];
    }
    if (
      target.builtTableData != null &&
      target.builtTableData !== target.OutputdataObject &&
      (target.builtTableData['Row'].length > 0 ||
        target.builtTableData['Column'].length > 0)
    ) {
      let tempRow = [...target.builtTableData.Row];
      let tempColumn = [...target.builtTableData.Column];
      target.builtTableData.Row = [...tempColumn];
      target.builtTableData.Column = [...tempRow];
    }
  }


  calcThershold(type: string): string {
    if (this.threshold === null || this.threshold === undefined || this.threshold === '') {
      return '';
    }
    const thresholdValue = Number(this.threshold) || 0;
    if (type === 'Add') {
      return (100 + thresholdValue).toString();
    } else {
      return (100 - thresholdValue).toString();
    }
  }

  openInsights(isChatResponse = false, getInsights?: any) {
    this.isExportspopup = false;

    if (getInsights && isChatResponse) {
      this.insightsVal = this.formatInsightsIntoPoints(getInsights);
    }

    if (this.noContentFlag) {
      this.isInsightspopupOpen = true;
      const noContentObj: InsightsModel = {
        header: this.errorHeader || 'Analysis Status:',
        message: this.insightsVal || 'No content, we will fix as soon as possible',
        show: true,
      };
      this._insightsSerive.showInisghts(noContentObj);
      return;
    }

    if (this.isInsightspopupOpen) {
      this.isInsightspopupOpen = false;
      return;
    }

    const insightsObj: InsightsModel = {
      header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
      message: '',
      show: false,
    };
    this._insightsSerive.showInisghts(insightsObj);

    const ShareColumn = (this.selectedDataFormat !== 'Respondent Level')
      ? 'value'
      : (this.isTotalBase
        ? (this.selectedWeight === 'Unweighted' ? 'totalUnweightedShare' : 'totalWeightedShare')
        : (this.selectedWeight === 'Unweighted' ? 'answerUnweightedShare' : 'answerWeightedShare'));

    const BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    this.isInsightspopupOpen = true;
    if (!isChatResponse) {
      this.insightsVal = [];
      this.setFailedCaseState(false);
    }

    const initialObj: InsightsModel = {
      header: 'Insights (Processing...)',
      message: 'Analyzing data and preparing AI context...',
      show: true,
    };

    this._insightsSerive.showInisghts(initialObj);
    let currentStreamingText = '';
    let isFirstChunk = true;

    const processingTimeout = setTimeout(() => {
      if (isFirstChunk) {
        const stillProcessingObj: InsightsModel = {
          header: 'Insights (Still Processing...)',
          message: 'Complex analysis in progress, please wait...',
          show: true,
        };
        this._insightsSerive.showInisghts(stillProcessingObj);
      }
    }, 3000);

    const updateStreamingUI = () => {
      if (currentStreamingText.trim().length === 0) {
        return;
      }

      const streamingObj: InsightsModel = {
        header: 'Insights (Streaming...)',
        message: currentStreamingText,
        show: true,
      };
      this._insightsSerive.showInisghts(streamingObj);
      this.insightsVal = [currentStreamingText];
    };

    setTimeout(() => {
      if (!this.selectionSummary || this.selectionSummary.trim() === '') {
        const rowData = this.dataObject?.Row?.[0]?.Data?.map((d: any) => d.Child).join(', ') || 'N/A';
        const colData = this.dataObject?.Column?.[0]?.Data?.map((d: any) => d.Child).join(', ') || 'N/A';
        const pData = this.promptData || {};
        const mktData = pData.Markets || pData.markets || pData.Market || pData.market || [];
        const tpData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];

        const extractLabels = (item: any) => {
          if (typeof item === 'string') {
            const parts = item.split('|');
            if (parts.length >= 2) {
              return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
            }
            return parts.pop();
          }
          if (item && item.name) return item.name;
          if (item && item.Child) return item.Child;
          return String(item);
        };

        const marketNames = mktData.length > 0 ? mktData.map((m: any) => extractLabels(m)).join(', ') : 'All Markets';
        const timePeriodNames = tpData.length > 0 ? tpData.map((t: any) => extractLabels(t)).join(', ') : 'All Time Periods';

        this.selectionSummary = `Study: ${this.selected_study || 'Unknown'} || Market: ${marketNames} || Time Period: ${timePeriodNames} || Row: ${rowData} || Column: ${colData}`;
      }

      let insightsDataToSend = this.CrossTabOutPutData;
      if (this.mcode === 2) {
        insightsDataToSend = this.CrossTabOutPutData.map((item: any) => {
          if (item.colChild === null || item.colChild === undefined || !item.colVariableCode) {
            const columnData = this.dataObject?.Column?.[0]?.Data?.[0];
            const columnLabel = columnData?.Child || 'Total';
            const columnVarCode = columnData?.variablecode || item.rowVariableCode || 'Total_Variable';
            return {
              ...item,
              colChild: item.colChild || columnLabel,
              colVariableCode: item.colVariableCode || columnVarCode
            };
          }
          return item;
        });
      }

      const insightsObservable = getInsights && isChatResponse
        ? of(getInsights)
        : this.crossTabService.getInsightsData(
          insightsDataToSend,
          this.selected_study,
          this.selected_client,
          this.selectionSummary,
          this.DefaultConfidenceLevel,
          ShareColumn,
          BaseColumn
        );

      insightsObservable.subscribe({
        next: (chunk: string) => {
          if (isFirstChunk) {
            clearTimeout(processingTimeout);
            isFirstChunk = false;
          }

          const chunkStr = typeof chunk === 'string' ? chunk : String(chunk);
          const isErrorMessage = /\b(error occurred|failed|exception|invalid)\b/i.test(chunkStr);

          if (isErrorMessage) {
            throw new Error(chunkStr);
          }

          if (isChatResponse && getInsights) {
            if (typeof chunk === 'string') {
              currentStreamingText = chunk;
            } else if (typeof chunk === 'object') {
              currentStreamingText = JSON.stringify(chunk);
            } else {
              currentStreamingText = String(chunk);
            }
          } else {
            currentStreamingText += chunk;
          }
          updateStreamingUI();
        },

        complete: () => {
          clearTimeout(processingTimeout);

          if (!currentStreamingText || currentStreamingText.trim().length === 0) {
            this.insightsVal = this.fallbackMessage();
            this.setFailedCaseState(true);

            if (this.chatPreviewBlocks.length > 0) {
              this.updateQuestionAnswerForSelectedMessage('No data Available');
            }

            if (!isChatResponse) {
              this.pushChatResponseEntry('getInsights', 'No data Available');
              // Removed saveChatList to prevent recording empty insights in history
              this.isHistorySaving = false;
              this.chatResponse = [];
            }
            const emptyObj: InsightsModel = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: 'No data Available',
              show: true,
            };
            this._insightsSerive.showInisghts(emptyObj);
            this.arktabaccess = false;
            return;
          }

          let processedResult = currentStreamingText;
          try {
            const parsed = JSON.parse(currentStreamingText);

            if (Array.isArray(parsed)) {
              this.insightsVal = parsed;

              const insightsPlainText = this.getFirstTwoInsightsAsPlainText();
              const hasQnAResponse = this.chatResponse.some(entry => entry.hasOwnProperty('getQnA'));
              if (!hasQnAResponse && !isChatResponse) {
                this.updateQuestionAnswerForSelectedMessage(insightsPlainText || 'No data Available');
              }

              if (!isChatResponse) {
                this.pushChatResponseEntry('getInsights', currentStreamingText);
                const qnaEntry = this.chatResponse.find(entry => entry.hasOwnProperty('getQnA'));
                const qnaText = qnaEntry ? qnaEntry['getQnA'] : '';
                this.saveChatList(
                  this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
                  this.chatResponse,
                  qnaText || insightsPlainText || 'No data Available'
                );
                this.chatResponse = [];
              }

              this.arktabaccess = false;
              return;
            } else if (typeof parsed === 'object') {
              let combinedText = '';
              for (const key in parsed) {
                if (parsed[key] && typeof parsed[key] === 'object' && parsed[key].Value) {
                  combinedText += parsed[key].Value + '\n';
                } else if (typeof parsed[key] === 'string') {
                  combinedText += parsed[key] + '\n';
                }
              }
              processedResult = combinedText;
            } else {
              processedResult = String(parsed);
            }
          } catch (e) {
          }

          const finalInsights = processedResult
            .split('- ')
            .map(item => item.trim())
            .filter(item => item.length > 0 && !item.startsWith('```'))
            .map(item => item.replace(/```$/, '').trim());

          if (finalInsights.length === 0 && processedResult.trim().length > 0) {
            const altInsights = processedResult
              .split('\n')
              .map(item => item.trim())
              .filter(item => item.length > 0);

            if (altInsights.length > 0) {
              this.insightsVal = altInsights;
            } else {
              this.insightsVal = [processedResult.trim()];
            }
          } else {
            this.insightsVal = finalInsights;
          }
          const insightsPlainText = this.getFirstTwoInsightsAsPlainText();
          const hasQnAResponse = this.chatResponse.some(entry => entry.hasOwnProperty('getQnA'));
          if (!hasQnAResponse && !isChatResponse) {
            this.updateQuestionAnswerForSelectedMessage(insightsPlainText || 'No data Available');
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('getInsights', currentStreamingText);
            const qnaEntry = this.chatResponse.find(entry => entry.hasOwnProperty('getQnA'));
            const qnaText = qnaEntry ? qnaEntry['getQnA'] : '';
            this.saveChatList(
              this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
              this.chatResponse,
              qnaText || insightsPlainText || 'No data Available'
            );
            this.chatResponse = [];
          }

          const finalInsightsObj: InsightsModel = {
            header: 'Insights',
            message: currentStreamingText,
            show: true,
          };
          this._insightsSerive.showInisghts(finalInsightsObj);
          this.arktabaccess = false;
        },

        error: (err) => {
          clearTimeout(processingTimeout);
          console.error('An error occurred while processing insights:', err);
          console.error('Error details:', {
            message: err.message,
            stack: err.stack,
            CrossTabOutPutData: this.CrossTabOutPutData?.length,
            selectionSummary: this.selectionSummary,
            selected_study: this.selected_study,
            selected_client: this.selected_client
          });

          const errorMessage = err.message || 'Unable to generate insights. Please check your data selection.';
          this.insightsVal = [errorMessage];
          this.setFailedCaseState(true);
          this.isInsightspopupOpen = true;

          const errorObj: InsightsModel = {
            header: 'Insights (Error)',
            message: errorMessage,
            show: true,
          };
          this._insightsSerive.showInisghts(errorObj);
          this.arktabaccess = false;
        },
      });
    }, 500);
  }

  SelectionsummaryCollapseExpand(text: any, block: any = null) {
    const target = block || this;
    this.isselectionsummarycollapse = true;
    setTimeout(() => {
      this.isselectionsummarycollapse2 = true;
    }, 300);
    if (text == 'SelectionSummary') {
      this.isselectionHeader = "Selection Summary";
      this.issavedselectionblock = false;
    }
    else {
      this.isselectionHeader = "Save Selections";
      this.issavedselectionblock = true;
      this.SaveSelectiontext = '';
    }

    // Determine which data object to use for summary
    const sourceDataObject = block ? this.getOutputData(block) : this.dataObject;
    this.isSummaryForSnapshot = this.showSnapshot || this.isSnapshotVisible(target);

    if (this.isSummaryForSnapshot) {
      this.GenerateSelectionSummary(target.selectionSummary)
    }
    else {
      const disctinctRowValues = this.getDistinctChildValues(sourceDataObject.Row);
      const disctinctRowNestingValues = this.getDistinctChildValues(sourceDataObject.RowNesting || []);
      const disctinctColumnValues = this.getDistinctChildValues(sourceDataObject.Column);
      const disctinctColumnNestingValues = this.getDistinctChildValues(sourceDataObject.ColNesting || []);
      let FilterValues: string[] = [];
      const rawFilters = (block && block.result && block.result.Filters) || sourceDataObject.Filters;
      if (rawFilters && typeof rawFilters === 'object') {
        const flattenedFilters: string[] = [];
        Object.values(rawFilters).forEach((val: any) => {
          if (Array.isArray(val)) {
            flattenedFilters.push(...val);
          } else if (typeof val === 'string') {
            flattenedFilters.push(val);
          }
        });
        FilterValues = flattenedFilters;
      } else {
        FilterValues = this.getDistinctChildValues(sourceDataObject.Filter || []);
      }

      const RowValues = this.transformData(disctinctRowValues);
      const RowNestingValues = this.transformData(disctinctRowNestingValues);
      const ColumnValues = this.transformData(disctinctColumnValues);
      const ColumnNestingValues = this.transformData(disctinctColumnNestingValues);
      const FilterData = this.transformData(FilterValues);

      let isSavedSelection = false
      this.Columnselections = [];
      this.Rowselections = [];
      this.AllSelections = [];

      this.Columnselections = ColumnValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim()
        };
      });

      this.Rowselections = RowValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim()
        };
      });

      if (FilterData.length > 0) {
        this.AllSelections = FilterData.map(item => {
          const [key, ...valueParts] = item.split(':');
          return {
            key: key.trim(),
            value: valueParts.join(':').trim()
          };
        });
      }

      if (RowNestingValues.length > 0) {
        let rowNestingSection = RowNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Row Nesting',
          value: rowNestingSection
        });
      }
      if (ColumnNestingValues.length > 0) {
        let colNestSection = ColumnNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Column Nesting',
          value: colNestSection
        });
      }

      if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
        let significanceSection;
        if (this.SignificanceVsReference != '') {
          significanceSection = `${this.DefaultSampleSize
            } : ${this.replacePipe(
              this.SignificanceVsReference
            )}`;
        } else {
          significanceSection = this.DefaultSampleSize;
        }
        this.AllSelections.push({
          key: 'Significance',
          value: significanceSection
        });

        this.AllSelections.push({
          key: 'Confidence Level',
          value: this.DefaultConfidenceLevel
        });
      }

      if (
        this.selectedIndex != '' &&
        this.isIndex &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        let Reference = `${this.replacePipe(
          this.selectedIndex
        )}`;

        this.AllSelections.push({
          key: 'Reference',
          value: Reference
        });
      }
      if (
        target.DefaultWeight != '' &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        this.AllSelections.push({
          key: 'Calculation Weight',
          value: target.DefaultWeight
        });
      }
      if (this.selectedDataFormat == 'Respondent Level') {
        let Base = `${target.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER}`;
        this.AllSelections.push({
          key: 'Calculation Base',
          value: Base
        });
      }
    }

  }

  OnCloseClick() {
    setTimeout(() => {
      this.isselectionsummarycollapse = false;
    }, 500);
    this.isselectionsummarycollapse2 = false;
    this.issavedselectionblock = false;
  }

  Exportspopup(event?: Event, block?: any) {
    if (event) event.stopPropagation();
    if (block) {
      block.isExportspopup = !block.isExportspopup;
    } else {
      this.isExportspopup = !this.isExportspopup;
    }
  }

  GenerateSelectionSummary(customSummary?: string) {
    const summaryToUse = customSummary || this._configService.selectionSummaryTextTitle;
    const result = SelectionSummaryHelper.parseSelectionSummary(
      summaryToUse
    );
    this.titleSection = result.titleSection;
    this.entryPoints = result.entryPoints;
    this.selections = result.selections;
    this.selectionSummary = summaryToUse;
  }

  getChatListData() {
    this.apiService.getChatList(this.selected_client, this.selected_study).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const allChats = JSON.parse(apiResponse.Data) as ChatListDocument[];
          this.allChatList = allChats;
          this.onChatSearch();

        } else {
          this.recentChats = [];
          this.olderChats = [];
          this.allChatList = [];
          this.chatAccordions = [];
        }
      },
      error: () => {
        this.recentChats = [];
        this.olderChats = [];
      }
    });
  }

  loadLatestChatIfExists() {
    if (this.isNewChatSession) {
      this.isNewChatSession = false;
      this.currentView = 'landing';
      this.arktabaccess = false;
      return;
    }

    setTimeout(() => {
      if (this.allChatList && this.allChatList.length > 0) {
        const sortedChats = ChatHistoryHelper.sortChatsByDate(this.allChatList);
        const latestChat = sortedChats[0];

        if (latestChat && latestChat.ChatId) {
          this.newChatId = latestChat.ChatId;
          this.guidChatId = latestChat.ChatId;
          this.selectedChatId = latestChat.ChatId;

          if (latestChat.ChatHistory && latestChat.ChatHistory.length > 0) {
            this.currentView = 'chat';
            const sortedHistory = ChatHistoryHelper.sortChatHistoryByIndex(latestChat.ChatHistory);
            this.chatPreviewBlocks = sortedHistory.map(msg =>
              ChatHistoryHelper.createChatPreviewBlock(msg, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
            );
            this.scrollToBottom();
            const lastMessage = sortedHistory[sortedHistory.length - 1];
            if (lastMessage && lastMessage.MessageId) {
              this.getChatResponse(lastMessage.MessageId, true);
            }
            this.arktabaccess = false;
          } else {
            this.currentView = 'landing';
            this.arktabaccess = false;
          }
        } else {
          this.currentView = 'landing';
          this.arktabaccess = false;
        }
      } else {
        this.currentView = 'landing';
        this.arktabaccess = false;
      }
    }, 1000);
  }

  onChatSearch(): void {
    const searchText = this.chatSearchText.toLowerCase().trim();
    const nestedSearchText = this.isNestedSearchVisible ? this.chatNestedSearchText.toLowerCase().trim() : '';

    if (this.allChatList.length === 0 && (this.recentChats.length > 0 || this.olderChats.length > 0)) {
      this.allChatList = [...this.recentChats, ...this.olderChats];
    }

    // Always calculate primary count for conditional toggle visibility
    const primaryOnly = ChatHistoryHelper.filterChatsBySearch(this.allChatList, searchText, '');
    this.primaryFilteredCount = primaryOnly.length;

    const filteredChats = ChatHistoryHelper.filterChatsBySearch(this.allChatList, searchText, nestedSearchText);
    this.chatAccordions = ChatHistoryHelper.mapChatsToAccordions(filteredChats);
  }

  toggleNestedSearch(): void {
    this.isNestedSearchVisible = !this.isNestedSearchVisible;
    if (!this.isNestedSearchVisible) {
      this.chatNestedSearchText = '';
    }
    this.onChatSearch();
  }


  saveChatList(title: string, chatResponse?: { [key: string]: string }[], questionAnswerMarkdown?: string, messageId?: string) {
    this.isHistorySaving = true;
    this.newChatId = null;
    const chatExists = this.allChatList.some(chat => chat.ChatId === this.guidChatId);

    if (chatExists) {
      this.newChatId = this.guidChatId;
      this.selectedChatId = this.newChatId;
      this.saveChatHistory(this.newChatId, chatResponse, title, undefined, questionAnswerMarkdown, undefined, undefined, undefined, messageId);
      return;
    }

    this.apiService.saveChatList(title, this.guidChatId, this.selected_client, this.selected_study).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          this.newChatId = apiResponse.Data;
          this.selectedChatId = this.newChatId;
          this.getChatListData();
          this.saveChatHistory(this.newChatId, chatResponse, title, undefined, questionAnswerMarkdown, undefined, undefined, undefined, messageId);
        } else {
          this.isHistorySaving = false;
        }
      },
      error: () => {
        this.isHistorySaving = false;
      }
    });
  }

  saveChatHistory(
    chatId: string,
    questionAnswer?: { [key: string]: string }[],
    question?: string,
    messageIndex?: number,
    questionAnswerMarkdown?: string,
    isLiked?: boolean | null,
    likeReason?: string,
    dislikeReason?: string,
    messageId?: string
  ) {
    this.isHistorySaving = true;

    const questionText = question || '';
    const questionAnswerText = questionAnswerMarkdown || this.defaultQuestionAnswer;

    let answerString: string;
    if (this.allMemberResponses && Object.keys(this.allMemberResponses).length > 0) {
      // Inject the finalized orchestration mcode to ensure history parsers don't default to the wrong module
      this.allMemberResponses.final_mcode = this.mcode;

      const safeStringify = (obj: any) => {
        const cache = new WeakSet();
        const ignoredKeys = ['Errors', 'Snapshot_Reason', 'BrandAnalysis_Reason', 'Crosstab_Reason'];
        return JSON.stringify(obj, (key, value) => {
          if (ignoredKeys.includes(key)) return undefined;
          if (typeof value === 'object' && value !== null) {
            if (cache.has(value)) return;
            cache.add(value);
          }
          return value;
        });
      };

      if (this.allMemberResponses.brandanalysis && !this.allMemberResponses.brand_analysis) {
        this.allMemberResponses.brand_analysis = this.allMemberResponses.brandanalysis;
        delete this.allMemberResponses.brandanalysis;
      }

      const modules = [
        { code: 1, key: 'snapshot', esKey: 'getSnapshotOutput' },
        { code: 2, key: 'brand_analysis', esKey: 'getConfiguration' },
        { code: 3, key: 'crosstab', esKey: 'getConfiguration' }
      ];

      const innerMsgId = messageId || this.selectedMessageId || 'current';

      modules.forEach(mod => {
        if (this.allMemberResponses[mod.key]) {
          // Use the raw analytical data from cache
          const cachedOpData = this.multiViewDataCache[innerMsgId]?.[mod.code] || this.multiViewDataCache['current']?.[mod.code];
          if (cachedOpData) {
            this.allMemberResponses[mod.key][mod.esKey] = safeStringify(cachedOpData);
          }

          if (mod.code === 1 && this.promptData) {
            this.allMemberResponses[mod.key]['getSnapshotConfiguration'] = typeof this.promptData === 'string' ? this.promptData : JSON.stringify(this.promptData);
          }

          const insightsCache = this.multiViewInsightsCache[innerMsgId] || this.multiViewInsightsCache['current'];
          if (insightsCache && insightsCache[mod.code]) {
            const cachedData = insightsCache[mod.code];
            if (mod.code === 1) {
              this.allMemberResponses[mod.key]['getSnapshotInsights'] = cachedData.standard_insights || '';
              this.allMemberResponses[mod.key]['getSnapshotInsights_Trend'] = cachedData.trend_insights || '';
            } else {
              this.allMemberResponses[mod.key]['getInsights'] = cachedData.rawInsights || '';
            }
            this.allMemberResponses[mod.key]['getQnA'] = cachedData.qnaText || '';
          }
        }
      });

      answerString = safeStringify(this.allMemberResponses);
    } else {
      answerString = questionAnswer && questionAnswer.length > 0
        ? JSON.stringify(questionAnswer)
        : JSON.stringify([]);
    }

    const innerMsgIdGlobal = messageId || this.selectedMessageId || 'current';
    let aggregatedInsights: string[] = [];
    const insightsCacheGlobal = this.multiViewInsightsCache[innerMsgIdGlobal] || this.multiViewInsightsCache['current'];
    if (insightsCacheGlobal) {
      Object.values(insightsCacheGlobal).forEach((cachedData: any) => {
        if (cachedData.rawInsights) aggregatedInsights.push(cachedData.rawInsights);
        if (cachedData.standard_insights) aggregatedInsights.push(cachedData.standard_insights);
        if (cachedData.trend_insights) aggregatedInsights.push(cachedData.trend_insights);
      });
    }

    let finalMessageIndex = messageIndex;
    if (finalMessageIndex === undefined || finalMessageIndex === null) {
      const idx = messageId ? this.chatPreviewBlocks.findIndex(b => b.messageId === messageId) : -1;
      finalMessageIndex = idx > -1 ? idx : (this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks.length - 1 : 0);
    }

    const chatHistory: ChatHistoryDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      MessageId: messageId,
      Question: questionText,
      MessageIndex: finalMessageIndex,
      QuestionAnswer: questionAnswerText,
      IsActive: true,
      IsStarred: false,
      Insights: aggregatedInsights.length > 0 ? aggregatedInsights.join('\n\n') : undefined,
      IsLiked: isLiked ?? null,
      LikeReason: likeReason || '',
      DislikeReason: dislikeReason || ''
    };

    const chatAnswer: ChatAnswerDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      Answer: answerString
    };

    const diagnosticPayload = this.prepareDiagnosticPayload();

    const request: SaveChatResponseRequest = {
      ChatHistory: chatHistory,
      ChatAnswer: chatAnswer,
      PythonPrompt: diagnosticPayload ? JSON.stringify(diagnosticPayload) : undefined,
      SelectedClient: this.selected_client || this.landingdata?.client_code || undefined,
      SelectedStudy: this.selected_study || this.landingdata?.study || undefined,
      InputQuery: questionText || undefined
    };
    this.apiService.saveChatHistory(request).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const returnedMessageId = apiResponse.Data;
          if (this.chatPreviewBlocks.length > 0) {
            let targetChat = null;
            if (messageId) {
              targetChat = this.chatPreviewBlocks.find(b => b.messageId === messageId);
            }
            if (!targetChat) {
              targetChat = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
            }

            if (targetChat && (!targetChat.messageId || targetChat.isTemp)) {
              targetChat.messageId = returnedMessageId;
              targetChat.isTemp = false; // Mark as no longer temporary
              this.selectedMessageId = returnedMessageId;

              // Force dynamic flag calculation once data is finalized
              this.updateChartDisablingFlags(targetChat);

              // Force CD and scroll beautifully to the question header
              this.cdr.detectChanges();
              this.scrollToMessage(returnedMessageId, 'start');
            }

            if (this.isWaitingForFinalSave) {
              if (document.hidden) {
                this.unreadNotificationCount++;
                this.playNotificationSound();
                
                const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
                if (link) {
                  // Only store the original if we haven't already
                  if (!this.baseFaviconHref) {
                    this.baseFaviconHref = link.href;
                  }
                  
                  const canvas = document.createElement('canvas');
                  canvas.width = 32;
                  canvas.height = 32;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.onload = () => {
                      ctx.drawImage(img, 0, 0, 32, 32);
                      
                      // Draw red notification badge
                      ctx.beginPath();
                      ctx.arc(23, 23, 9, 0, 2 * Math.PI); // Bottom right
                      ctx.fillStyle = '#ff3b30'; // iOS style red
                      ctx.fill();
                      
                      // Add number inside badge
                      const displayCount = this.unreadNotificationCount > 9 ? '9+' : this.unreadNotificationCount.toString();
                      ctx.fillStyle = '#ffffff';
                      ctx.font = 'bold 12px Arial';
                      if (displayCount === '9+') ctx.font = 'bold 10px Arial';
                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'middle';
                      ctx.fillText(displayCount, 23, 24); // Center text
                      
                      link.href = canvas.toDataURL('image/png');
                    };
                    img.src = this.baseFaviconHref;
                  }
                }

                const onVisibilityChange = () => {
                  if (!document.hidden) {
                    if (this.unreadNotificationCount > 0) {
                      const msg = this.unreadNotificationCount > 1 ? `${this.unreadNotificationCount} answers generated and saved.` : "Answer generated and saved.";
                      this.showToast(msg, 'success');
                      this.unreadNotificationCount = 0;
                      if (link && this.baseFaviconHref) {
                        link.href = this.baseFaviconHref;
                        this.baseFaviconHref = ''; // Reset
                      }
                    }
                    document.removeEventListener('visibilitychange', onVisibilityChange);
                  }
                };
                document.addEventListener('visibilitychange', onVisibilityChange);
              } else {
                this.showToast("Answer generated and saved.", 'success');
              }

              this.isWaitingForFinalSave = false;

              if (this.isProcessingQueue) {
                setTimeout(() => {
                  this.processNextQueuedQuestion();
                }, 1000);
              }
            }
          }
          this.getChatListData();
        }
        this.isHistorySaving = false;
      },
      error: (err) => {
        this.isHistorySaving = false;
      }
    });
  }

  prepareDiagnosticPayload(): any {
    try {
      if (this.availableViews && this.availableViews.length > 1 && this.allMemberResponses) {
        const payloads: any[] = [];
        for (const view of this.availableViews) {
           const viewData = this.allMemberResponses[view.key] || {};
           const payload: any = {
             mcode: view.mcode,
             user_input: viewData.user_input || this.promptData?.user_input,
             isTotalBase: viewData.isTotalBase ?? this.isTotalBase,
             isBrandAnalysis: view.mcode === 2,
             entryPointData: this.dataArray || [],
             Row: viewData.Row || viewData.row || (view.mcode === this.mcode ? this.dataObject?.Row : []) || [],
             Column: viewData.Column || viewData.column || (view.mcode === this.mcode ? this.dataObject?.Column : []) || [],
             Filter: viewData.Filter || viewData.filters || viewData.filter || (view.mcode === this.mcode ? this.dataObject?.Filter : []) || [],
             RowNesting: viewData.RowNesting || viewData.row_nesting || (view.mcode === this.mcode ? this.dataObject?.RowNesting : []) || [],
             ColNesting: viewData.ColNesting || viewData.column_nesting || (view.mcode === this.mcode ? this.dataObject?.ColNesting : []) || [],
             clientCode: this.landingdata?.client_code || this.selected_client,
             studyname: this.landingdata?.study || this.selected_study,
             significance: this.DefaultConfidenceLevel || 'None',
             confidenceLevel: this.DefaultConfidenceLevel || 'None',
             SelectedWeight: this.selectedWeight || 'weight',
             Section: viewData.data?.snapshot_result?.snapshot?.widget_output?.section || this.selectedSection || '',
             Snapshot_Name: viewData.data?.snapshot_result?.snapshot?.widget_output?.snapshot_name || this.Snapshotdataforexport?.snapshotName || '',
             Snapshot_Type: viewData.data?.snapshot_result?.snapshot?.widget_output?.snapshot_type || this._configService.selectedSnapshotType || '',
             Widget_Id: view.mcode === 1 ? (viewData.Widget_ID || viewData.widget_id || this.widget_Id || '') : '',
             Widget_Name: view.mcode === 1 ? (viewData.Widget_Name || viewData.widget_name || this.widget_Name || '') : '',
             ...(viewData || {})
           };
           payloads.push(payload);
        }
        return payloads;
      }

      const payload: any = {
        mcode: this.mcode,
        user_input: this.promptData?.user_input,
        isTotalBase: this.isTotalBase,
        isBrandAnalysis: this.isBrandAnalysis,
        entryPointData: this.dataArray || [],

        // Selection data
        Row: this.dataObject?.Row || [],
        Column: this.dataObject?.Column || [],
        Filter: this.dataObject?.Filter || [],
        RowNesting: this.dataObject?.RowNesting || [],
        ColNesting: this.dataObject?.ColNesting || [],

        // Configuration
        clientCode: this.landingdata?.client_code || this.selected_client,
        studyname: this.landingdata?.study || this.selected_study,
        significance: this.DefaultConfidenceLevel || 'None',
        confidenceLevel: this.DefaultConfidenceLevel || 'None',
        SelectedWeight: this.selectedWeight || 'weight',

        // Snapshot related
        Section: this.selectedSection || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.section || '',
        Snapshot_Name: this.Snapshotdataforexport?.snapshotName || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.snapshot_name || '',
        Snapshot_Type: this._configService.selectedSnapshotType || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.snapshot_type || '',
        Widget_Id: this.widget_Id || '',
        Widget_Name: this.widget_Name || '',
        ...(this.promptData || {})
      };
      return payload;
    } catch (error) {
      console.error('Error preparing diagnostic payload:', error);
      return this.promptData || {};
    }
  }

  async getChatResponse(messageId: string | undefined, showSingleMessageOnly: boolean = false, autoScroll: boolean = true) {
    if (!messageId) return;
    this.isChatHistoryOpen = false;
    this.isSavedQuestionsOpen = false;
    this.isScrollingToTarget = true;
    this.scrollSpacerHeight = 0; // Clear any active new-question spacer
    this.currentView = 'chat';

    // Ensure metadata is ready before processing the response (prevents empty dropdowns)
    await this.preFetchMetadata();

    this.isNewChatStarted = false;
    this.abandoningSessionId = '';
    this.OutputData = [];
    this.CrossTabOutPutData = [];
    this.showSnapshot = false;
    this.displayTable = false;
    this.setFailedCaseState(false);
    this.isCreateBtnClick = false;
    this.insightsVal = '';
    this.insightsStreamingText = '';
    this.insightsStreamingPoints = [];
    this.isselectionsummarycollapse = false;
    this.isselectionsummarycollapse2 = false;
    this._configService.standardSnapOutputData = [];
    this.MainResult = undefined;
    this.filteredWidgetData = undefined;
    this._configService.updateSignificanceValue('None');
    this._configService.updateConfedenceValue('None');
    this._configService.IndexSelected = false;
    this._configService.baseSelected = 'Total Base';
    this._configService.isTotalBase = true;
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === messageId));

    if (chat) {

      const targetMessage = chat.ChatHistory?.find((h: any) => h.MessageId === messageId);
      if (targetMessage) {
      }
    }

    if (chat) {
      this.selectedChatId = chat.ChatId || null;
      this.selectedMessageId = messageId;
      this.guidChatId = chat.ChatId || '';
      this.newChatId = chat.ChatId || null;

      if (!showSingleMessageOnly) {
        this.chatPreviewBlocks = (chat.ChatHistory || []).map(h =>
          ChatHistoryHelper.createChatPreviewBlock(h, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
        );
      }
    } else {
      this.selectedChatId = messageId;
      this.guidChatId = messageId;
    }

    // SESSION VALIDATION FOR OLD HISTORY
    if (this.guidChatId && this.validatedSessionId !== this.guidChatId) {
      this.isCacheGenerated = false; // Reset flag for the new (old) session
      this.getBearerToken().then(token => {
        this.apiService.accessCheck(
          this.selected_client || '',
          this.selected_study || '',
          token,
          this.guidChatId || ''
        ).subscribe({
          next: (res: any) => {
            if (res && res.modules_access) {
              this.modulesAccess = res.modules_access;
              this.validatedSessionId = this.guidChatId;

              const activeModules: any = {};
              for (const [key, value] of Object.entries(this.modulesAccess)) {
                if ((value as any).has_access) {
                  activeModules[key] = value;
                }
              }

              this.apiService.generateRestrictedCache(
                this.selected_client || '',
                this.selected_study || '',
                token,
                this.guidChatId,
                activeModules
              ).subscribe({
                next: () => {
                  this.isCacheGenerated = true;
                },
                error: (err) => {
                  console.error('[getChatResponse] ❌ Cache failed:', err);
                }
              });
            }
          },
          error: (err) => {
            console.error('[getChatResponse] ❌ Access check failed:', err);
          }
        });
      });
    }

    this.isChatHistoryOpen = false;
    this.isSavedQuestionsOpen = false;
    this.inputValue = '';

    if (chat && !showSingleMessageOnly && this.selectedChatId) {
      console.log('[getChatResponse] ⏳ Loading answers incrementally for:', messageId);
      this.pendingMessageId = messageId;
      this.isPreFetchingAnswers = false; // Reset to allow fetching
      this.loadAnswersIncrementally(chat, messageId);
      return;
    }

    const cachedBlock = this.chatPreviewBlocks.find(b => b.messageId?.toLowerCase() === messageId?.toLowerCase());
    if (cachedBlock && cachedBlock.fullAnswer) {
      this.sendInputMessage(cachedBlock.fullAnswer, true, cachedBlock);
      if (autoScroll) {
        this.scrollToMessage(messageId, 'start');
      }
      return;
    }

    if (this.isPreFetchingAnswers) {
      this.pendingMessageId = messageId;
      // Loader stays on. loadAllAnswersForChat will resolve this.
      return;
    }

    console.warn('[getChatResponse] ⚠️ Analytical answer not found in session cache for:', messageId);

    this.apiService.getChatResponse(messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);

        if (apiResponse.HasValidData && apiResponse.Data) {
          let historyItem: any;
          const parsedData = JSON.parse(apiResponse.Data);

          if (Array.isArray(parsedData)) {
            historyItem = parsedData[0];
          } else {
            historyItem = parsedData;
          }

          let answerData = historyItem?.Answer;
          if (typeof answerData === 'string') {
            try {
              answerData = JSON.parse(answerData);
            } catch (e) {
              console.error('[getChatResponse API] Failed to parse answer data:', e);
            }
          }

          // Cache it for this session
          if (cachedBlock) {
            cachedBlock.fullAnswer = answerData;
            const parsed = this.parseChatResponse(answerData);
            cachedBlock.parsedData = parsed;
            cachedBlock.mcode = parsed.member_responses?.final_mcode || parsed.AgentPayload?.mcode || parsed.GetMcode?.mcode || 0;
            cachedBlock.isBrandAnalysis = (cachedBlock.mcode === 2);
            cachedBlock.analyticalData = parsed;
            this.populateBlockInsights(cachedBlock, parsed);
          }

          this.sendInputMessage(answerData, true, cachedBlock);
          if (autoScroll) {
            this.scrollToMessage(messageId, 'start');
          }
        } else {
          console.warn('[getChatResponse API] No valid data returned for messageId:', messageId);
          this.isScrollingToTarget = false;
          this._loaderService.hideLoader();
        }
      },
      error: (err) => {
        this.chatHistory = [];
        this.isScrollingToTarget = false;
        this._loaderService.hideLoader();
      }
    });
  }

  loadAnswersIncrementally(chat: any, messageId: string): void {
    if (this.isPreFetchingAnswers) return;
    this.isPreFetchingAnswers = true;

    // 1. Map chatHistory to chatPreviewBlocks if not already done
    this.chatPreviewBlocks = (chat.ChatHistory || []).map((h: any) =>
      ChatHistoryHelper.createChatPreviewBlock(h, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
    );

    // Find the index of the selected messageId
    const targetIdx = this.chatPreviewBlocks.findIndex(b => b.messageId?.toLowerCase() === messageId.toLowerCase());
    if (targetIdx === -1) {
      console.warn(`[INCREMENTAL-LOAD] Target messageId ${messageId} not found in history!`);
      this.isPreFetchingAnswers = false;
      this._loaderService.hideLoader();
      return;
    }

    // Collect IDs of target, one above (targetIdx - 1), and one below (targetIdx + 1)
    const indicesToLoad = [targetIdx, targetIdx - 1, targetIdx + 1].filter(idx => idx >= 0 && idx < this.chatPreviewBlocks.length);

    const blocksToLoad = indicesToLoad.map(idx => this.chatPreviewBlocks[idx]).filter(b => b && b.messageId && !b.fullAnswer);

    if (blocksToLoad.length === 0) {
      this.isPreFetchingAnswers = false;
      this.resolvePendingMessage(messageId);
      return;
    }

    // Call apiService.getChatResponse for each in parallel
    const obsList = blocksToLoad.map(block => {
      return this.apiService.getChatResponse(block.messageId!).pipe(
        catchError(err => {
          console.error('[INCREMENTAL-LOAD] Error fetching block:', block.messageId, err);
          return of(null);
        })
      );
    });

    forkJoin(obsList).subscribe({
      next: (results: any[]) => {
        results.forEach((res, index) => {
          if (!res) return;
          const block = blocksToLoad[index];
          try {
            const apiResponse = JSON.parse(res);
            if (apiResponse.HasValidData && apiResponse.Data) {
              const parsedData = JSON.parse(apiResponse.Data);
              const historyItem = Array.isArray(parsedData) ? parsedData[0] : parsedData;
              let answerData = historyItem?.Answer;
              if (typeof answerData === 'string') {
                try {
                  answerData = JSON.parse(answerData);
                } catch (e) {
                  console.error('[INCREMENTAL-LOAD] Failed to parse answer string:', e);
                }
              }
              block.fullAnswer = answerData;
              const parsed = this.parseChatResponse(answerData);
              block.parsedData = parsed;
              const parsedMcode = parsed.member_responses?.final_mcode || parsed.AgentPayload?.mcode || parsed.GetMcode?.mcode || 0;
              if (!block.userSelectedMcode) {
                block.mcode = parsedMcode;
              }
              block.isBrandAnalysis = (block.mcode === 2);
              block.is_sigtesting = (block.mcode === 2 || block.mcode === 3);
              block.analyticalData = parsed;

              const rawData = parsed.AgentPayload || parsed.GetMcode;
              if (rawData) {
                block.availableViews = this.identifyAvailableViews(rawData, parsed.member_responses);
                if (!block.userSelectedMcode) {
                  block.activeView = block.availableViews.find((v: any) => v.mcode === block.mcode) || block.availableViews[0];
                } else {
                  block.activeView = block.availableViews.find((v: any) => v.mcode === block.mcode) || block.activeView;
                }

                // Set default response payload for the UI to render immediately
                if (block.activeView && parsed.member_responses) {
                  const result = parsed.member_responses[block.activeView.key] || parsed.member_responses[block.activeView.key.replace('_', '')];
                  if (result) {
                    (parsed as any).response = result.response || result;
                  }
                }
              }

              this.populateBlockInsights(block, parsed);
            }
          } catch (e) {
            console.error('[INCREMENTAL-LOAD] Parse error for block:', block.messageId, e);
          }
        });

        // Force array reference update
        this.chatPreviewBlocks = [...this.chatPreviewBlocks];

        // Resolve the pending/selected message
        this.resolvePendingMessage(messageId);
        this.isPreFetchingAnswers = false;
      },
      error: (err) => {
        console.error('[INCREMENTAL-LOAD] Parallel load failed:', err);
        this.isPreFetchingAnswers = false;
        this.isScrollingToTarget = false;
        this._loaderService.hideLoader();
      }
    });
  }

  lazyFetchBlockAnswer(block: any): void {
    if (!block || !block.messageId || block.fullAnswer || this.inFlightLazyFetches.has(block.messageId)) {
      return;
    }

    this.inFlightLazyFetches.add(block.messageId);

    this.apiService.getChatResponse(block.messageId).subscribe({
      next: (res: string) => {
        try {
          const apiResponse = JSON.parse(res);
          if (apiResponse.HasValidData && apiResponse.Data) {
            const parsedData = JSON.parse(apiResponse.Data);
            const historyItem = Array.isArray(parsedData) ? parsedData[0] : parsedData;
            let answerData = historyItem?.Answer;
            if (typeof answerData === 'string') {
              try {
                answerData = JSON.parse(answerData);
              } catch (e) {
                console.error('[LAZY-FETCH] Failed to parse:', e);
              }
            }
            block.fullAnswer = answerData;
            const parsed = this.parseChatResponse(answerData);
            block.parsedData = parsed;
            const parsedMcodeLazy = parsed.member_responses?.final_mcode || parsed.AgentPayload?.mcode || parsed.GetMcode?.mcode || 0;
            if (!block.userSelectedMcode) {
              block.mcode = parsedMcodeLazy;
            }
            block.isBrandAnalysis = (block.mcode === 2);
            block.is_sigtesting = (block.mcode === 2 || block.mcode === 3);
            block.analyticalData = parsed;

            const rawData = parsed.AgentPayload || parsed.GetMcode;
            if (rawData) {
              block.availableViews = this.identifyAvailableViews(rawData, parsed.member_responses);
              if (!block.userSelectedMcode) {
                block.activeView = block.availableViews.find((v: any) => v.mcode === block.mcode) || block.availableViews[0];
              } else {
                block.activeView = block.availableViews.find((v: any) => v.mcode === block.mcode) || block.activeView;
              }

              // Set default response payload for the UI to render immediately
              if (block.activeView && parsed.member_responses) {
                const result = parsed.member_responses[block.activeView.key] || parsed.member_responses[block.activeView.key.replace('_', '')];
                if (result) {
                  (parsed as any).response = result.response || result;
                }
              }
            }

            this.populateBlockInsights(block, parsed);
          }
        } catch (e) {
          console.error('[LAZY-FETCH] Parse error:', e);
        }
        this.inFlightLazyFetches.delete(block.messageId!);
      },
      error: (err) => {
        console.error(`[LAZY-FETCH] ❌ Failed to lazy load message: ${block.messageId}`, err);
        this.inFlightLazyFetches.delete(block.messageId!);
      }
    });
  }

  private populateBlockInsights(block: any, parsed: any): void {
    const pAny = parsed as any;

    // 1. Normal Insights Extraction
    if (pAny.Insights && Array.isArray(pAny.Insights)) {
      block.insights = pAny.Insights;
    } else if (pAny.getSnapshotInsights) {
      const gsi = pAny.getSnapshotInsights;
      if (gsi.Insights && Array.isArray(gsi.Insights)) {
        block.insights = gsi.Insights;
      } else if (typeof gsi === 'string') {
        block.insights = this.formatInsightsIntoPoints(gsi);
      } else if (gsi.Value) {
        block.insights = this.formatInsightsIntoPoints(gsi.Value);
      } else if (gsi.insights?.Value) {
        block.insights = this.formatInsightsIntoPoints(gsi.insights.Value);
      }
    } else if (pAny.getInsights) {
      if (Array.isArray(pAny.getInsights)) {
        block.insights = pAny.getInsights;
      } else if (typeof pAny.getInsights === 'string') {
        block.insights = this.formatInsightsIntoPoints(pAny.getInsights);
      } else if (pAny.getInsights.Insights) {
        block.insights = pAny.getInsights.Insights;
      }
    } else if (pAny.getSnapshotOutput?.Insights) {
      block.insights = pAny.getSnapshotOutput.Insights;
    }

    // 2. Trend Insights Extraction
    if (pAny.getSnapshotInsightsTrend) {
      const gsit = pAny.getSnapshotInsightsTrend;
      if (gsit.Insights && Array.isArray(gsit.Insights)) {
        block.insightsTrend = gsit.Insights;
      } else if (typeof gsit === 'string') {
        block.insightsTrend = this.formatInsightsIntoPoints(gsit);
      } else if (gsit.Value) {
        block.insightsTrend = this.formatInsightsIntoPoints(gsit.Value);
      } else if (gsit.insights?.Value) {
        block.insightsTrend = this.formatInsightsIntoPoints(gsit.insights.Value);
      }
    }

    // 3. Seed multiViewInsightsCache for all modules from history
    if (block.messageId && parsed.member_responses) {
      if (!this.multiViewInsightsCache[block.messageId]) {
        this.multiViewInsightsCache[block.messageId] = {};
      }

      const res = parsed.member_responses;
      const tryParse = (val: any) => {
        if (typeof val === 'string') {
          try {
            const trimmed = val.trim();
            if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
              return JSON.parse(trimmed);
            }
          } catch (e) { }
        }
        return val;
      };

      const mapModuleInsights = (modData: any, code: number) => {
        if (!modData) return;
        const qnaText = tryParse(modData.getQnA) || '';
        
        const existingCache = this.multiViewInsightsCache[block.messageId]?.[code];
        const hasExistingData = existingCache && ((existingCache.insightsVal && existingCache.insightsVal.length > 0) || (existingCache.qnaText && existingCache.qnaText.trim() !== ''));
        
        if (!hasExistingData) {
          if (code === 1) {
            const std = tryParse(modData.getSnapshotInsights) || '';
            const trd = tryParse(modData.getSnapshotInsights_Trend) || '';
            const combined = `${std}[[[SPLIT]]]${trd}`;
            this.multiViewInsightsCache[block.messageId][code] = {
              insightsVal: this.formatInsightsIntoPoints(combined),
              qnaText: qnaText,
              standard_insights: std,
              trend_insights: trd,
              rawInsights: combined
            };
          } else {
            const raw = tryParse(modData.getInsights) || '';
            this.multiViewInsightsCache[block.messageId][code] = {
              insightsVal: this.formatInsightsIntoPoints(raw),
              qnaText: qnaText,
              rawInsights: raw
            };
          }
        }
      };

      mapModuleInsights(res.snapshot, 1);
      mapModuleInsights(res.brand_analysis || res.brandanalysis, 2);
      mapModuleInsights(res.crosstab, 3);
    }
  }

  private resolvePendingMessage(messageId: string): void {
    if (this.pendingMessageId) {
      const matchedBlock = this.chatPreviewBlocks.find(b => b.messageId?.toLowerCase() === this.pendingMessageId?.toLowerCase());
      if (matchedBlock && matchedBlock.fullAnswer) {
        this.sendInputMessage(matchedBlock.fullAnswer, true, matchedBlock);
        this.scrollToMessage(this.pendingMessageId, 'start');
        this._loaderService.hideLoader();
        this.pendingMessageId = null;
      } else {
        this._loaderService.hideLoader();
        this.pendingMessageId = null;
      }
    }
  }

  onChatScroll(event: Event): void {
    if (this.isScrollingToTarget) {
      return;
    }

    const container = event.target as HTMLElement;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const thresholdBuffer = 400; // Load blocks that are within 400px of the viewport

    this.chatPreviewBlocks.forEach((block, index) => {
      if (!block.messageId || block.isTemp || block.fullAnswer || this.inFlightLazyFetches.has(block.messageId)) {
        return;
      }

      const element = document.getElementById('message-' + block.messageId);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        // Check if the element is near the visible region of the container
        const isNearVisible = (
          elementRect.bottom >= containerRect.top - thresholdBuffer &&
          elementRect.top <= containerRect.bottom + thresholdBuffer
        );

        if (isNearVisible) {
          this.lazyFetchBlockAnswer(block);
        }
      }
    });
  }

  // Helper getters to resolve data per block in the template
  getOutputData(block: any): any {
    const blockId = block.messageId || 'live-message';
    const blockMcode = block.mcode || this.getMcode(block) || 0;

    // Priority 1: Reconstructed historical data (with full filters/nesting)
    if (block.builtTableData && block.builtTableData.Filter) {
      return block.builtTableData;
    }

    // Priority 2: Isolated data from recent interactions (Significance/Transposing etc)
    if (block.OutputdataObject && (block.OutputdataObject.Row?.length > 0 || block.OutputdataObject.Column?.length > 0)) {
      if (!(block.OutputdataObject as any).flatData && block.CrossTabOutPutData) {
        (block.OutputdataObject as any).flatData = block.CrossTabOutPutData;
      }
      return block.OutputdataObject;
    }

    // Priority 3: Global data if this is the active live message (not a saved historical block)
    if (!block.messageId && block === this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1] && this.OutputdataObject?.Row?.length > 0) {
      return this.OutputdataObject;
    }

    const analytical = block.analyticalData || block.fullAnswer || {};

    // Try to find the configuration or use raw analytical data
    let data = analytical.getConfiguration ||
      analytical.getSnapshotOutput ||
      analytical.AgentPayload?.getConfiguration ||
      analytical.AgentPayload ||
      analytical.DataObject ||
      (analytical.Data ? analytical : null) ||
      (analytical.Row ? analytical : null);

    if (!data) {
      return null;
    }

    // If it's a raw payload containing a Data string (possibly inside a response object)
    // Historical Crosstabs often nest it inside getConfiguration.response.Data
    const dataString = (data?.response?.Data && typeof data.response.Data === 'string') ? data.response.Data :
      ((data?.Data && typeof data.Data === 'string') ? data.Data :
        ((data?.response && typeof data.response === 'string') ? data.response : null));

    // Check if we should use the cached version
    const filterExistsInSource = !!(analytical.Filter || data.Filter || analytical.filters || data.filters || analytical.AgentPayload?.filters);
    if (block.builtTableData && (block.builtTableData.Filter || !filterExistsInSource)) {
      // Ensure CrossTabOutPutData is synced to the block for exports even when cached
      if (!block.CrossTabOutPutData && block.builtTableData.flatData) {
        block.CrossTabOutPutData = block.builtTableData.flatData;
      }
      return block.builtTableData;
    }


    if (dataString && !data?.Row) {
      // Pass the object that contains the Data string to buildHistoricalTableData
      const dataWrapper = data?.response?.Data ? data.response : data;

      // [DATA ISOLATION] Capture flat data for charts
      const rawData = dataWrapper.Data;
      block.CrossTabOutPutData = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

      block.builtTableData = this.buildHistoricalTableData(dataWrapper);

      // [DATA ISOLATION] Reconstruct Filter and Nesting metadata from strings
      // Extract from various possible names: Filter, filters, RowNesting, Row, etc.
      let combinedFilters: string[] = [];
      const filtersObj = analytical.Filters ||
        data.Filters ||
        data.response?.Filters ||
        analytical.filters ||
        data.filters ||
        data.response?.filters ||
        analytical.AgentPayload?.Filters ||
        analytical.AgentPayload?.filters ||
        analytical.AgentPayload?.getConfiguration?.Filter ||
        analytical.AgentPayload?.getConfiguration?.filters;

      if (filtersObj && typeof filtersObj === 'object') {
        Object.values(filtersObj).forEach(val => {
          if (Array.isArray(val)) {
            combinedFilters.push(...val);
          } else if (typeof val === 'string' && val.trim() !== '') {
            combinedFilters.push(val);
          }
        });
      }

      const filterSource = analytical.Filter ||
        data.Filter ||
        data.response?.Filter ||
        (combinedFilters.length > 0 ? combinedFilters : null) ||
        analytical.Filters ||
        data.Filters ||
        analytical.filters ||
        data.filters;

      const rowNestingSource = analytical.RowNesting || data.RowNesting || data.response?.RowNesting ||
        analytical.row_nesting || data.row_nesting || data.Row_Nesting ||
        analytical.AgentPayload?.row_nesting || analytical.AgentPayload?.RowNesting || analytical.Row_Nesting;

      const colNestingSource = analytical.ColNesting || data.ColNesting || data.response?.ColNesting ||
        analytical.column_nesting || data.column_nesting || data.Column_Nesting ||
        analytical.AgentPayload?.column_nesting || analytical.AgentPayload?.ColNesting || analytical.Column_Nesting;

      const rowSource = analytical.Row || data.Row || analytical.row || data.row ||
        analytical.AgentPayload?.row || analytical.AgentPayload?.Row;

      const colSource = analytical.Column || data.Column || analytical.column || data.column ||
        analytical.AgentPayload?.column || analytical.AgentPayload?.Column;

      if (filterSource) {
        block.builtTableData.Filter = this.transformToDataObject(filterSource, 'Filter');
      }
      if (rowNestingSource) {
        block.builtTableData.RowNesting = this.transformToDataObject(rowNestingSource, 'Row Nesting');
      }
      if (colNestingSource) {
        block.builtTableData.ColNesting = this.transformToDataObject(colNestingSource, 'Column Nesting');
      }

      // If we reconstructed from scratch but didn't find rows/cols in buildHistoricalTableData (e.g. opData empty)
      // try to populate them from the configuration arrays if available
      if (block.builtTableData.Row?.length === 0 && rowSource) {
        block.builtTableData.Row = this.transformToDataObject(rowSource, 'Row');
      }
      if (block.builtTableData.Column?.length === 0 && colSource) {
        block.builtTableData.Column = this.transformToDataObject(colSource, 'Column');
      }

      return block.builtTableData;
    }

    const finalData = {
      ...data,
      Row: data?.Row || data?.row || [],
      Column: data?.Column || data?.column || [],
      RowNesting: data?.RowNesting || data?.row_nesting || data?.Row_Nesting || [],
      ColNesting: data?.ColNesting || data?.column_nesting || data?.Column_Nesting || []
    };

    // [DATA ISOLATION] Ensure CrossTabOutPutData is populated even if Row data already exists
    if (!block.CrossTabOutPutData || block.CrossTabOutPutData.length === 0) {
      const rawData = data?.Data || data?.response?.Data;
      if (rawData) {
        block.CrossTabOutPutData = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
      }
    }

    if (finalData.Row.length === 0) {
      console.warn(`[getOutputData] ⚠️ Final table data has 0 rows for block: ${block.messageId}`);
    }

    // [DATA ISOLATION] Persist the resolved data object back to the block for consistent lookup
    if (!block.OutputdataObject || block.OutputdataObject.Row?.length === 0) {
      block.OutputdataObject = finalData;
    }

    if (!(block.OutputdataObject as any).flatData && block.CrossTabOutPutData) {
      (block.OutputdataObject as any).flatData = block.CrossTabOutPutData;
    }
    if (!(finalData as any).flatData && block.CrossTabOutPutData) {
      (finalData as any).flatData = block.CrossTabOutPutData;
    }

    return finalData;
  }

  getMcode(block: any): number {
    if (block.messageId === this.selectedMessageId) {
      return this.mcode;
    }
    return block.mcode || 0;
  }

  isSnapshotVisible(block: any): boolean {
    const mcode = this.getMcode(block);

    // For active message, respect the global showSnapshot flag but only if it's actually mcode 1
    if (block.messageId === this.selectedMessageId && this.selectedMessageId !== null) {
      return this.showSnapshot && mcode === 1;
    }

    // For historical messages, mcode is the definitive indicator
    if (mcode === 1) return true;
    if (mcode === 2 || mcode === 3) return false;

    // Fallback if mcode is missing: check for definitive snapshot markers
    const analytical = block.analyticalData || block.parsedData;
    return !!(
      block.fullAnswer?.getSnapshotConfiguration ||
      block.fullAnswer?.GetCustomSnapshotWidget ||
      analytical?.getSnapshotConfiguration ||
      analytical?.GetCustomSnapshotWidget
    );
  }

  /**
   * Determines if action buttons (Download, Selection Summary) should be visible for a block.
   */
  isActionsVisible(block: any): boolean {
    if (block.messageId === this.selectedMessageId) {
      return (this.isCreateBtnClick || this.showSnapshot) && !this.failedCase;
    }
    // Historical: Show if we have any analytical/full data and it's not a failed state
    return !!(block.analyticalData || block.fullAnswer) && !block.failedCase;
  }

  isInsightVisible(block: any): boolean {
    const hasData = !!(block.insights && block.insights.length > 0) ||
      !!(block.insightsTrend && block.insightsTrend.length > 0) ||
      !!(block.analyticalData?.Insights && Array.isArray(block.analyticalData.Insights) && block.analyticalData.Insights.length > 0);

    const isVisible = (block.messageId === this.selectedMessageId && this.selectedMessageId !== null)
      ? (this.isInsightspopupOpen || hasData)
      : hasData;

    if (this.failedCase && block.messageId === this.selectedMessageId) {
      // console.log('[DEBUG UI] isInsightVisible for failed block:', { ... });
    }

    return isVisible;
  }

  getInsightsForBlock(block: any): string[] {
    if (block.messageId === this.selectedMessageId && this.selectedMessageId !== null) {
      const insights = Array.isArray(this.insightsVal) ? this.insightsVal : (this.insightsVal ? [this.insightsVal] : []);
      if (this.failedCase) {
        // console.log('[DEBUG UI] getInsightsForBlock for failed active block:', insights);
      }
      return insights;
    }

    if (block.messageId && block.mcode) {
      const cached = this.multiViewInsightsCache[block.messageId]?.[block.mcode] || this.multiViewInsightsCache['current']?.[block.mcode];
      const isTrend = !!block.isTrendActive;
      
      if (cached) {
         if (isTrend && cached.trend_insights) return this.formatInsightsIntoPoints(cached.trend_insights);
         if (!isTrend && cached.insightsVal && Array.isArray(cached.insightsVal) && cached.insightsVal.length > 0) return cached.insightsVal;
         if (!isTrend && cached.standard_insights) return this.formatInsightsIntoPoints(cached.standard_insights);
         if (!isTrend && cached.rawInsights) return this.formatInsightsIntoPoints(cached.rawInsights);
         return []; // Module was explicitly toggled, do not fall back to default module insights
      } 
    }

    const isTrend = !!block.isTrendActive;
    return isTrend ? (block.insightsTrend || []) : (block.insights || []);
  }

  copyResponseToClipboard(block: any) {
    if (this.copiedResponseId === block.messageId) return; // Prevent double-clicking

    const responseText = this.getCurrentQnAResponse(block);
    if (!responseText || responseText === 'Answering question...') return;
    
    const temp = document.createElement('div');
    temp.innerHTML = responseText;
    const textToCopy = temp.textContent || temp.innerText || '';

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.copiedResponseId = block.messageId;
      setTimeout(() => {
        if (this.copiedResponseId === block.messageId) {
          this.copiedResponseId = null;
        }
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy response: ', err);
    });
  }

  async copyFullResponse(block: any) {
    if (this.copiedResponseId === block.messageId) return;

    try {
      let markdown = '';
      
      // Extract exact table from the UI block
      const blockId = 'message-' + block.messageId;
      const blockEl = document.getElementById(blockId);
      if (blockEl) {
        const tableDiv = blockEl.querySelector('.table-preview');
        if (tableDiv) {
          const colHeadersElements = tableDiv.querySelectorAll('.preview-columns-header .row-header-title, .preview-columns-header .col-nest-header-txt');
          const headers: string[] = ['Metric'];
          colHeadersElements.forEach((el: any) => {
            const text = el.textContent?.trim();
            if (text) headers.push(text);
          });
          
          if (headers.length > 1) {
            markdown += `| ${headers.join(' | ')} |\n`;
            markdown += `| ${headers.map(() => '---').join(' | ')} |\n`;

            const rowHeadersElements = tableDiv.querySelectorAll('.table-rows-header-block .row-col-header-title, .table-rows-header-block .row-nest-header-txt');
            const dataContainers = tableDiv.querySelectorAll('.preview-table-body .row-data-container');

            for (let i = 0; i < dataContainers.length; i++) {
              const rowHead = rowHeadersElements[i]?.textContent?.trim() || `Row ${i + 1}`;
              const cells = dataContainers[i].querySelectorAll('.cell-data');
              let rowArray = [rowHead];
              cells.forEach((cell: any) => {
                rowArray.push(cell.textContent?.trim() || '');
              });
              markdown += `| ${rowArray.join(' | ')} |\n`;
            }
          }
        }
      }

      // If no table is visible in DOM, fallback to programmatic data
      if (!markdown) {
        const mcode = block.mcode || this.mcode;
        
        if (mcode === 1) {
           const snapData = block.snapshotData || (block.messageId === this.selectedMessageId ? this.filteredWidgetData : null);
           if (snapData) {
              markdown = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(snapData);
           } else if (block.messageId === this.selectedMessageId && this.OutputData && this.OutputData.length > 0) {
              markdown = InsightsGeneratorHelper.buildSnapshotMarkdownForAPI(this.OutputData, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
           }
        }
        
        if (!markdown) {
          let opData = null;
          if (block.analyticalData?.member_responses) {
            const viewKey = block.activeView?.key || (mcode === 1 ? 'snapshot' : mcode === 2 ? 'brandanalysis' : 'crosstab');
            opData = block.analyticalData.member_responses[viewKey] || block.analyticalData.member_responses[viewKey.replace('_', '')];
          }
          if (!opData) opData = block.analyticalData || block.parsedData;
          
          // Fallback for current active block if data not found in block object
          if (!opData && block.messageId === this.selectedMessageId) {
             if (mcode === 3) markdown = InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(this.CrossTabOutPutData, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
          }
          
          if (opData && !markdown) {
            const outputResponse = opData.response || opData;
            let dataArr: any[] | null = null;
            const targetData = outputResponse.Data || outputResponse.result?.Data || outputResponse;
            
            if (targetData) {
              if (typeof targetData === 'string') {
                try { dataArr = JSON.parse(targetData); } catch {}
              } else if (Array.isArray(targetData)) {
                dataArr = targetData;
              }
            }
            
            if (mcode === 1) {
              if (Array.isArray(dataArr)) {
                markdown = InsightsGeneratorHelper.buildSnapshotMarkdownForAPI(dataArr, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
              } else if (opData.metric || (opData.response && opData.response.metric)) {
                markdown = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(opData.response || opData);
              }
            } else {
              const crossTabData = dataArr || (opData.response || opData);
              if (Array.isArray(crossTabData)) {
                markdown = InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(crossTabData, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
              }
            }
          }
        }
      }

      const notes = [
        "\\* - Indicates Low Base (" + (this.LowBase || 55) + ")",
        "I/S - Indicates Insufficient Sample (" + (this.insufficientBase || 25) + ")",
        "NA - Indicates Base = 0"
      ].join('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

      let insightsText = '';
      const insightsArray = this.getInsightsForBlock(block);
      if (insightsArray && insightsArray.length > 0) {
        insightsText = "### Insights:\n" + insightsArray.map((i, index) => {
          const trimmed = i.trim();
          return trimmed.startsWith('|') ? (index > 0 ? "\n" + trimmed : trimmed) : "- " + trimmed;
        }).join('\n');
      }

      let qnaText = '';
      const rawQna = this.getCurrentQnAResponse(block);
      if (rawQna && rawQna !== 'Answering question...') {
        // rawQna is already markdown, avoid HTML conversion
        qnaText = "### Summary:\n" + rawQna.trim();
      }

      const fullText = [
        "### Question: " + (block.question || this.currentQuestion || ''),
        markdown ? "### Data Table:\n" + markdown : "",
        markdown ? notes : "",
        insightsText,
        qnaText
      ].filter(part => part.trim() !== "").join('\n\n').trim();

      await navigator.clipboard.writeText(fullText);
      
      this.copiedResponseId = block.messageId;
      setTimeout(() => {
        if (this.copiedResponseId === block.messageId) {
          this.copiedResponseId = null;
        }
      }, 2000);
      
    } catch (err) {
      console.error('Failed to copy full response: ', err);
    }
  }

  async handleCopyChartClick(event: Event, block: any, popupCdr?: ChangeDetectorRef) {
    event.stopPropagation();
    if (this.copiedChartId === block.messageId || this.isCopyingId === block.messageId) return;

    this.isCopyingId = block.messageId;

    block.isExportspopup = false; // Hide popup so it's not in the screenshot

    // Force a small delay to allow Angular to render the loading state
    setTimeout(async () => {
      try {
        const blockId = 'message-' + block.messageId;
        const blockEl = document.getElementById(blockId);
        if (blockEl) {
          // Capture the chart or table container
          const targetEl = blockEl.querySelector('.table-output-wrapper') || 
                           blockEl.querySelector('.table-output-wrapper-snapshot');
          
          if (targetEl) {
             const hcContainer = targetEl.querySelector('.highcharts-container') as HTMLElement;
             if (hcContainer) {
                 let svgString = '';
                 
                 // Check if Highcharts object is globally available and has getSVG
                 const Highcharts = (window as any).Highcharts;
                 const chartIndexAttr = hcContainer.getAttribute('data-highcharts-chart');
                 if (Highcharts && Highcharts.charts && chartIndexAttr !== null) {
                     const chart = Highcharts.charts[parseInt(chartIndexAttr, 10)];
                     if (chart && typeof chart.getSVG === 'function') {
                         svgString = chart.getSVG({
                             sourceWidth: chart.chartWidth,
                             sourceHeight: chart.chartHeight,
                             scale: 3, // Highcharts native SVG export scaling
                             chart: { backgroundColor: '#ffffff' }
                         });
                     }
                 }
                 
                 // If getSVG() isn't available, manually extract and serialize the SVG node
                 if (!svgString) {
                     const svgEl = hcContainer.querySelector('svg.highcharts-root');
                     if (svgEl) {
                         const svgClone = svgEl.cloneNode(true) as SVGElement;
                         if (!svgClone.getAttribute('xmlns')) {
                             svgClone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                         }
                         
                         // Scale the SVG natively for extreme clarity
                         const rect = hcContainer.getBoundingClientRect();
                         const scale = 3;
                         svgClone.setAttribute('width', (rect.width * scale) + 'px');
                         svgClone.setAttribute('height', (rect.height * scale) + 'px');
                         if (!svgClone.getAttribute('viewBox')) {
                             svgClone.setAttribute('viewBox', `0 0 ${rect.width} ${rect.height}`);
                         }

                         const serializer = new XMLSerializer();
                         svgString = serializer.serializeToString(svgClone);
                     }
                 }

                     if (svgString) {
                         const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
                         const url = URL.createObjectURL(svgBlob);
                         const img = new Image();
                         
                         img.onload = async () => {
                             const canvas = document.createElement('canvas');
                             const scale = 3; // High resolution / zoom-in
                             canvas.width = hcContainer.offsetWidth * scale;
                             canvas.height = hcContainer.offsetHeight * scale;
                             const ctx = canvas.getContext('2d');
                             if (ctx) {
                                 ctx.fillStyle = '#ffffff';
                                 ctx.fillRect(0, 0, canvas.width, canvas.height);
                                 // Draw crisp SVG background
                                 ctx.drawImage(img, 0, 0);
                                 
                                 // Only overlay html2canvas for snapshot charts to preserve performance
                                 const isSnapshot = targetEl.classList.contains('table-output-wrapper-snapshot');
                                 const svgNode = hcContainer.querySelector('svg.highcharts-root') as HTMLElement;
                                 const originalVisibility = svgNode ? svgNode.style.visibility : '';
                                 
                                 if (isSnapshot) {
                                     // Hide SVG temporarily to capture only the HTML overlays (like useHTML data labels)
                                     if (svgNode) svgNode.style.visibility = 'hidden';
                                     
                                     try {
                                         const htmlCanvas = await html2canvas(hcContainer, {
                                             useCORS: true,
                                             scale: 3,
                                             backgroundColor: null,
                                             logging: false
                                         });
                                         // Overlay the HTML labels
                                         ctx.drawImage(htmlCanvas, 0, 0);
                                     } catch (e) {
                                         console.error('Failed to overlay HTML labels', e);
                                     }
                                     
                                     // Restore SVG visibility
                                     if (svgNode) svgNode.style.visibility = originalVisibility;
                                 }
                                 
                                 canvas.toBlob(async (blob) => {
                                     if (blob) {
                                         try {
                                             const item = new ClipboardItem({ "image/png": blob });
                                             await navigator.clipboard.write([item]);
                                             this.copiedChartId = block.messageId;
                                             setTimeout(() => { 
                                               if (this.copiedChartId === block.messageId) {
                                                 this.copiedChartId = null; 
                                                 this.cdr.detectChanges();
                                                 if (popupCdr) popupCdr.detectChanges();
                                               }
                                             }, 2000);
                                         } catch (err) {
                                             console.error('Clipboard write failed. Document might not be focused.', err);
                                         } finally {
                                             this.isCopyingId = null;
                                             this.cdr.detectChanges();
                                             if (popupCdr) popupCdr.detectChanges();
                                         }
                                     } else {
                                         this.isCopyingId = null;
                                         this.cdr.detectChanges();
                                         if (popupCdr) popupCdr.detectChanges();
                                     }
                                     URL.revokeObjectURL(url);
                                 }, 'image/png');
                             }
                         };
                         img.onerror = (err) => {
                             console.error('SVG Image load error', err);
                             this.isCopyingId = null;
                             this.cdr.detectChanges();
                             if (popupCdr) popupCdr.detectChanges();

                             URL.revokeObjectURL(url);
                         };
                         img.src = url;
                         return; // Successfully handled natively
                     }
             }

             // 2. Fallback to html2canvas for tables (no SVGs to wash out)
             const canvas = await html2canvas(targetEl as HTMLElement, {
                useCORS: true,
                scale: 3, // Zoom-in for crisp text
                backgroundColor: '#ffffff'
             });
             
             canvas.toBlob(async (blob) => {
               if (blob) {
                 const item = new ClipboardItem({ "image/png": blob });
                 await navigator.clipboard.write([item]);
                 
                 this.isCopyingId = null;
                 this.copiedChartId = block.messageId;
                 this.cdr.detectChanges(); // Force UI update
                 if (popupCdr) popupCdr.detectChanges();
                 setTimeout(() => {
                   if (this.copiedChartId === block.messageId) {
                     this.copiedChartId = null;
                     this.cdr.detectChanges();
                     if (popupCdr) popupCdr.detectChanges();
                   }
                 }, 2000);
               }
             }, 'image/png');
          }
        }
      } catch (err) {
        this.isCopyingId = null;
        this.cdr.detectChanges();
        if (popupCdr) popupCdr.detectChanges();
        console.error('Failed to copy chart image: ', err);
      }
    }, 150);
  }

  copyInsightsToClipboard(block: any) {
    if (this.copiedInsightsId === block.messageId) return; // Prevent double-clicking

    const insights = this.getInsightsForBlock(block);
    if (!insights || insights.length === 0) return;
    
    // Strip HTML tags from insights using a simple regex since they might be passed through formatMarkdown
    const textToCopy = insights.map(insight => {
      // Remove any HTML tags that might be in the insight
      const temp = document.createElement('div');
      temp.innerHTML = insight;
      return temp.textContent || temp.innerText || '';
    }).join('\n\n');

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.copiedInsightsId = block.messageId;
      setTimeout(() => {
        if (this.copiedInsightsId === block.messageId) {
          this.copiedInsightsId = null;
        }
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy insights: ', err);
    });
  }

  getCustomData(block: any): any {
    const config = this.getSnapshotConfig(block);
    const resolvedCompareAcross = config?.Snapshot_Type || config?.snapshot_type || config?.snapshotType;

    if (block.messageId === this.selectedMessageId && this.selectedMessageId !== null) {
      if (this.filteredWidgetData && Object.keys(this.filteredWidgetData).length > 0) {
        if (resolvedCompareAcross) {
          this.filteredWidgetData.snapshot_type = resolvedCompareAcross;
          this.filteredWidgetData.selectedcompareacrossOption = resolvedCompareAcross;
        }
        return this.filteredWidgetData;
      }
      // If filteredWidgetData is empty but it's the active message, fall through to historical logic.
    }

    if (block.builtCustomData) {
      if (resolvedCompareAcross) {
        block.builtCustomData.snapshot_type = resolvedCompareAcross;
        block.builtCustomData.selectedcompareacrossOption = resolvedCompareAcross;
      }
      if (block.messageId === this.selectedMessageId && !this.filteredWidgetData) {
        this.filteredWidgetData = block.builtCustomData;
        this._configService.allPageOutputData = [[block.builtCustomData]];
        this._configService.allPageOutputDataWithoutTrend = [[block.builtCustomData]];
      }
      return block.builtCustomData;
    }

    // Historical block handling: Extract structured widget data from cached analytical data
    const analytical = block.analyticalData;

    if (!analytical) return block.fullAnswer?.GetCustomSnapshotWidget || {};

    let data = analytical.GetCustomSnapshotWidget;

    // Check if we need to transform GetCustomSnapshotWidget
    if (data && data.Data && typeof data.Data === 'string' && !data.widgetchart_name) {
      block.builtCustomData = this.buildHistoricalWidgetData(data, analytical);
      if (resolvedCompareAcross && block.builtCustomData) {
        block.builtCustomData.snapshot_type = resolvedCompareAcross;
        block.builtCustomData.selectedcompareacrossOption = resolvedCompareAcross;
      }
      return block.builtCustomData;
    }

    if (!data && analytical.getSnapshotOutput) {
      const snapshot = analytical.getSnapshotOutput;
      data = snapshot.response || snapshot;

      // If getSnapshotOutput is ACTUALLY a raw payload containing Data string!
      if (data && data.Data && typeof data.Data === 'string' && !data.widgetchart_name) {
        block.builtCustomData = this.buildHistoricalWidgetData(data, analytical);
        if (resolvedCompareAcross && block.builtCustomData) {
          block.builtCustomData.snapshot_type = resolvedCompareAcross;
          block.builtCustomData.selectedcompareacrossOption = resolvedCompareAcross;
        }
        return block.builtCustomData;
      }

      // Re-attach metadata needed by the output-popup component if missing from the response sub-object
      if (data && typeof data === 'object') {
        if (!data.metric) data.metric = [];
        if (!data.previewChartPostion) data.previewChartPostion = snapshot.Widget_ID || snapshot.widget_id || analytical.widget_id;
        if (!data.widgetchart_name) data.widgetchart_name = snapshot.widgetchart_name || snapshot.WidgetChartType || snapshot.widgetChartType;
        if (!data.widget_name) data.widget_name = snapshot.widget_name || snapshot.WidgetName;

        // Re-attach bundled trend/payload data for significance/trend support in history
        if (analytical.response_payload_trendline) data.response_payload_trendline = analytical.response_payload_trendline;
        if (analytical.trendline_response) data.trendline_response = analytical.trendline_response;
        if (analytical.customization_Properties_trendline) data.customization_Properties_trendline = analytical.customization_Properties_trendline;
        if (analytical.response_payload) data.response_payload = analytical.response_payload;

        // Ensure customizationProperties is available (it's often in getSnapshotOutput or GetCustomSnapshotWidget)
        if (!data.customizationProperties && snapshot.customization_Properties) {
          data.customizationProperties = snapshot.customization_Properties;
        }
      }
    }

    if (data && typeof data === 'object') {
      if (resolvedCompareAcross) {
        data.snapshot_type = resolvedCompareAcross;
        data.selectedcompareacrossOption = resolvedCompareAcross;
      }
    }

    return data || block.fullAnswer?.GetCustomSnapshotWidget || analytical || {};
  }

  buildHistoricalWidgetData(data: any, analytical?: any): any {
    if (!data || !data.Data) {
      console.warn('[buildHistoricalWidgetData] ⚠️ Missing Data property, returning raw data.');
      return data;
    }

    try {
      const opData = typeof data.Data === 'string' ? JSON.parse(data.Data) : data.Data;

      if (Array.isArray(opData) && opData.length > 0) {
        const uniqueWidgets = _.uniqBy(opData, 'widgetNumber');
        let selectedWidget: any = null;
        
        const snapConfigStr = analytical?.member_responses?.snapshot?.getSnapshotConfiguration || analytical?.getSnapshotConfiguration || data.getSnapshotConfiguration;
        let snapConfig: any = null;
        if (snapConfigStr) {
          try { snapConfig = typeof snapConfigStr === 'string' ? JSON.parse(snapConfigStr) : snapConfigStr; } catch(e) {}
        }
        
        const targetWidgetID = snapConfig?.Widget_ID || snapConfig?.widget_id
            || data.Widget_ID || data.widget_id || analytical?.Widget_ID || analytical?.widget_id 
            || analytical?.getSnapshotOutput?.Widget_ID || analytical?.getSnapshotOutput?.widget_id
            || analytical?.member_responses?.snapshot?.Widget_ID || analytical?.member_responses?.snapshot?.widget_id;
        
        if (targetWidgetID) {
          const idMatchedWidget: any = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
          if (idMatchedWidget) {
            selectedWidget = idMatchedWidget;
          }
        }
        
        if (!selectedWidget) {
          selectedWidget = uniqueWidgets[0];
        }

        const widgetFilteredData = opData.filter((item: any) => item.widgetNumber === selectedWidget.widgetNumber);
        const fallbackBase = widgetFilteredData.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

        const uniqueMetrics = _.uniqBy(widgetFilteredData, 'rowChild').map((item: any) => ({
          option: item.rowChild,
          selectOrder: 0,
          typeofmetric: 'METRIC',
          metric_group: '',
          data: widgetFilteredData
            .filter((row: any) => row.rowChild === item.rowChild)
            .map((row: any) => {
              const colParts = (row.colChild || '').split('|');
              const specificCol = colParts.pop() || row.colChild;
              const parentLabel = colParts.pop() || 'Market';
              const resolvedColChild = `${parentLabel}|${specificCol}`;

              return {
                data: row.answerWeightedShare,
                data2: row.answerWeightedShareIndex,
                lvl1Child: row.Level1ColChild,
                colChild: resolvedColChild,
                rowChild: row.rowChild,
                totalUnweightedBase: row.totalUnweightedBase,
                totalUnweightedShare: row.totalUnweightedShare,
                totalWeightedBase: row.totalWeightedBase,
                totalWeightedShare: row.totalWeightedShare,
                totalWeightedShareIndex: row.totalWeightedShareIndex,
                answerUnweightedBase: row.answerUnweightedBase,
                answerUnweightedShare: row.answerUnweightedShare,
                answerWeightedBase: row.answerWeightedBase,
                answerWeightedShare: row.answerWeightedShare,
                answerWeightedShareIndex: row.answerWeightedShareIndex,
                changeVsPY_Answer: row.changeVsPY_Answer,
                changeVsPY_Total: row.changeVsPY_Total,
                Level1ColResponseCode: row.Level1ColResponseCode,
                Level1NestColVariableCode: row.Level1NestColVariableCode,
                CalculationType: row.CalculationType || 'share',
                CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                changeVsPY: row.changeVsPY_Answer,
                Significance_Value: row.Significance_Answer
              };
            })
        }));

        uniqueMetrics.sort((a: any, b: any) => {
          const valA = a.data?.[0]?.data ?? 0;
          const valB = b.data?.[0]?.data ?? 0;
          return valB - valA;
        });

        const isBubbleChart = selectedWidget.widgetChartType?.toLowerCase().includes('bubble');

        const builtData = {
          widgetchart_name: selectedWidget.widgetChartType,
          widget_name: selectedWidget.widgetName,
          previewChartPostion: selectedWidget.widgetNumber,
          customizationProperties: this.getFormattedCustomProperties(selectedWidget.customization_Properties || data.customization_Properties, selectedWidget.widgetChartType),
          quadrantText: data.quadrantText ? JSON.stringify(data.quadrantText) : null,
          metric: isBubbleChart ? [
            { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
            { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
            { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
          ] : [{
            metric_option: 'Data',
            metric_group: '',
            metric_value: uniqueMetrics
          }],
          response_payload_trendline: data.response_payload_trendline,
          trendline_response: data.trendline_response,
          customization_Properties_trendline: data.customization_Properties_trendline,
          response_payload: data.response_payload
        };

        return builtData;
      } else {
        console.warn('[buildHistoricalWidgetData] ⚠️ opData is not a valid array or is empty.');
      }
    } catch (e) {
      console.error('[buildHistoricalWidgetData] ❌ Failed to build historical widget data:', e);
    }
    return data;
  }

  /**
   * Reconstructs historical table data from a raw Data payload.
   * Mirrors the logic of BindTableOutput but returns a scoped object instead of setting parent state.
   */
  buildHistoricalTableData(data: any): any {
    const output: any = { Column: [], Row: [] };
    try {
      const opData = typeof data.Data === 'string' ? JSON.parse(data.Data) : data.Data;

      // Store the flat array for TableOuputComponent to calculate cell values
      output.flatData = opData;

      if (Array.isArray(opData) && opData.length > 0) {
        const validData = opData.filter((a: any) => a.colChild !== null && a.rowChild !== null);
        validData.forEach((item: any) => {
          const selections = TableOutputProcessorHelper.createSelections(item);
          const parents = TableOutputProcessorHelper.createParentObjects(item, selections);
          TableOutputProcessorHelper.processParent(parents.row, output.Row, selections.nested.row);
          TableOutputProcessorHelper.processParent(parents.col, output.Column, selections.nested.col);
        });
      } else {
        console.warn('[buildHistoricalTableData] ⚠️ opData is not a valid array or is empty:', opData);
      }
    } catch (e) {
      console.error('[buildHistoricalTableData] ❌ Error reconstructing table data:', e);
    }
    return output;
  }

  getSnapshotConfig(block: any): any {
    const config = (block.messageId === this.selectedMessageId && this.selectedMessageId !== null)
      ? (this.snapshotConfiguration || {})
      : (block.fullAnswer?.getSnapshotConfiguration || block.analyticalData?.getSnapshotConfiguration || {});
    return config || {};
  }

  isTableVisible(block: any): boolean {
    if (this.isSnapshotVisible(block)) return false;

    // Isolated: If specific view property is set, respect it
    if (block.isTableClick === true) return true;
    if (block.isChartView === true) return false;

    // Historical fallback: Verify there is actual reconstructed data
    if (!block.analyticalData) return false;

    const data = this.getOutputData(block);
    const hasData = !!(data?.Row?.length > 0);

    // Default to table for non-chart agents
    return hasData && this.getMcode(block) !== 1;
  }

  isChartVisible(block: any): boolean {
    if (this.isSnapshotVisible(block)) return false;

    // Isolated: Check if any specific chart is selected on the block
    const anyChartSelected = !!(block.isVerticalGroupBarChartClick ||
      block.isVerticalBarChartClick ||
      block.isVerticalStackChartClick ||
      block.isLineChartClick);

    if (anyChartSelected) return true;

    // Fallback: mcode 1 usually means it SHOULD show a chart by default, unless table is explicitly clicked
    return this.getMcode(block) === 1 && block.isChartView !== false && !block.isTableClick;
  }

  isChartType(block: any, chartType: string): boolean {
    // Isolated: If a specific choice has been made on the block, honor it
    if (block.isVerticalGroupBarChartClick) return chartType === 'groupBar';
    if (block.isVerticalBarChartClick) return chartType === 'bar';
    if (block.isVerticalStackChartClick) return chartType === 'stack';
    if (block.isLineChartClick) return chartType === 'line';

    // Fallback: For historical/initial load, derive from payload
    const type = block.fullAnswer?.AgentPayload?.chartType?.toLowerCase() ||
      block.analyticalData?.AgentPayload?.chartType?.toLowerCase();

    if (!type && this.getMcode(block) === 1) return chartType === 'groupBar';

    switch (chartType) {
      case 'groupBar': return type === 'groupbar' || type === 'column' || !type;
      case 'bar': return type === 'bar';
      case 'stack': return type === 'stack' || type === 'stackedbar';
      case 'line': return type === 'line' || type === 'trend';
    }
    return false;
  }

  toggleStarred(chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('[toggleStarred] ❌ Missing messageId or selectedChatId');
      this.showToast('Cannot star: Message ID is not available', 'error');
      return;
    }

    const newStarredState = !chat.isStarred;
    this.apiService.updateChatStarred(chat.messageId, newStarredState).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          chat.isStarred = newStarredState;
          this.showToast(newStarredState ? 'Message starred successfully' : 'Message unstarred successfully', 'success');

          if (!newStarredState) {
            const beforeCount = this.starredMessages.length;
            // Handle both MessageId and messageId casing for robustness
            this.starredMessages = this.starredMessages.filter(m => {
              const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
              const targetId = (chat.messageId || '').toString().toLowerCase();
              return mId !== targetId;
            });
            this.onStarredSearch();
          } else {
            this.loadStarredMessages();
          }

          // Update the history list in memory so search results update immediately without reload
          if (chat.messageId && this.selectedChatId) {
            const chatInList = this.allChatList.find(c => c.ChatId === this.selectedChatId);
            if (chatInList && chatInList.ChatHistory) {
              const msg = chatInList.ChatHistory.find(h => h.MessageId === chat.messageId);
              if (msg) {
                msg.IsStarred = newStarredState;
                (msg as any).isStarred = newStarredState;
              }
            }
          }
        } else {
          this.showToast('Failed to update starred status', 'error');
        }
      },
      error: (err) => {
        this.showToast('Error while updating starred status', 'error');
      }
    });
  }

  chatToDelete: any = null;
  isDeletingChat: boolean = false;

  initiateDeleteChat(event: Event, chat: any): void {
    event.stopPropagation();
    this.chatToDelete = chat;
  }

  cancelDeleteChat(): void {
    if (this.isDeletingChat) return;
    this.chatToDelete = null;
  }

  confirmDeleteChatSession(): void {
    if (!this.chatToDelete || !this.chatToDelete.chatId || this.isDeletingChat) return;

    this.isDeletingChat = true;
    const chatId = this.chatToDelete.chatId;

    this.apiService.deleteChatSession(chatId).subscribe({
      next: (response) => {
        this.isDeletingChat = false;
        try {
          const apiResponse = JSON.parse(response);
          if (apiResponse.HasValidData) {
            // Remove from local list
            this.allChatList = this.allChatList.filter(c => c.ChatId !== chatId);
            
            // Re-render accordions
            const searchText = this.chatSearchText || '';
            const nestedSearchText = this.chatNestedSearchText || '';
            const filteredChats = ChatHistoryHelper.filterChatsBySearch(this.allChatList, searchText, nestedSearchText);
            this.chatAccordions = ChatHistoryHelper.mapChatsToAccordions(filteredChats);

            // If the deleted chat was the currently active one, clear the view
            if (this.guidChatId === chatId || this.selectedChatId === chatId) {
              this.currentView = 'landing';
              this.guidChatId = '';
              this.selectedChatId = null;
              this.chatPreviewBlocks = [];
            }

            this.showToast('Chat deleted successfully', 'success');
          } else {
            this.showToast(apiResponse.ExceptionMessage || 'Failed to delete chat', 'error');
          }
        } catch (e) {
          this.showToast('Invalid response from server', 'error');
        }
        this.chatToDelete = null;
      },
      error: (err) => {
        this.isDeletingChat = false;
        this.showToast('An error occurred while deleting the chat', 'error');
        this.chatToDelete = null;
      }
    });
  }

  onDeleteClick(chat: any) {
    if (!chat.messageId) {
      this.showToast('Cannot delete: Message ID is not available', 'error');
      return;
    }

    // Close all other popups
    this.chatPreviewBlocks.forEach(c => {
      if (c !== chat) {
        c.showDeleteConfirm = false;
        c.showLikeInput = false;
        c.showDislikeInput = false;
      }
    });

    // Toggle custom confirmation box
    chat.showDeleteConfirm = !chat.showDeleteConfirm;

    // Close feedback inputs if open
    if (chat.showDeleteConfirm) {
      chat.showLikeInput = false;
      chat.showDislikeInput = false;
    }
  }

  cancelDelete(chat: any) {
    chat.showDeleteConfirm = false;
  }

  confirmDelete(chat: any) {
    chat.showDeleteConfirm = false;
    const isDeletingSelectedMessage = chat.messageId === this.selectedMessageId;
    this.apiService.deleteChatMessage(chat.messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          const index = this.chatPreviewBlocks.indexOf(chat);
          if (index > -1) {
            this.chatPreviewBlocks.splice(index, 1);
          }
          if (isDeletingSelectedMessage || this.chatPreviewBlocks.length === 0) {
            this.selectedMessageId = null;
            this.displayTable = false;
            this.showSnapshot = false;
            this.isCreateBtnClick = false;
            this.CrossTabOutPutData = [];
            this.OutputData = [];
            this.clearOutputDataObject();
            this.insightsVal = [];
            this.insightsStreamingText = '';
            this.insightsStreamingPoints = [];
            this.isInsightspopupOpen = false;
            this.setFailedCaseState(false);
            this.isVerticalGroupBarChartClick = false;
            this.isVerticalBarChartClick = false;
            this.isVerticalStackChartClick = false;
            this.isLineChartClick = false;

            if (this.chatPreviewBlocks.length === 0) {
              setTimeout(() => {
                this.navigateToLanding();
              }, 100);
            }
          }
          this.showToast('Message deleted successfully', 'success');

          // [SYNC FIX] If it was starred, we should have also cleared that on server
          // but we do it optimistically here to match the dual-call strategy
          if (chat.isStarred && chat.messageId) {
            this.apiService.updateChatStarred(chat.messageId, false).subscribe();
          }

          // Optimistic local removal from saved list
          const beforeCount = this.starredMessages.length;
          this.starredMessages = this.starredMessages.filter(m => {
            const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
            const targetId = (chat.messageId || '').toString().toLowerCase();
            return mId !== targetId;
          });
          this.onStarredSearch();

          setTimeout(() => {
            console.log('[onDeleteClick] 🔄 Refreshing lists');
            this.getChatListData();
            this.loadStarredMessages(); // Still refresh from server as secondary measure
          }, 300);
        } else {
          this.showToast('Failed to delete message', 'error');
        }
      },
      error: (err) => {
        this.showToast('Error while deleting message', 'error');
      }
    });
  }

  onLikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    if (chat.isLiked === true) {
      chat.showLikeInput = false;
      chat.likeReason = '';
      this.saveFeedback(chat, null, '', '');
    } else {
      chat.showLikeInput = true;
      chat.showDislikeInput = false;
      (chat as any).showDeleteConfirm = false;
      chat.likeReason = '';
      chat.dislikeReason = '';
      setTimeout(() => {
        if (this.likeInput) {
          this.likeInput.nativeElement.focus();
        }
      }, 0);
    }
  }

  onDislikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    if (chat.isLiked === false) {
      chat.showDislikeInput = false;
      chat.dislikeReason = '';
      this.saveFeedback(chat, null, '', '');
    } else {
      chat.showDislikeInput = true;
      chat.showLikeInput = false;
      (chat as any).showDeleteConfirm = false; // Close delete confirm if open
      chat.likeReason = '';
      chat.dislikeReason = '';
      setTimeout(() => {
        if (this.dislikeInput) {
          this.dislikeInput.nativeElement.focus();
        }
      }, 0);
    }
  }

  submitLikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      return;
    }

    const reason = chat.likeReason?.trim() || '';
    this.saveFeedback(chat, true, reason, '');
    chat.showLikeInput = false;
  }

  cancelLikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string }) {
    chat.showLikeInput = false;
    chat.likeReason = '';
  }

  submitDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      return;
    }

    const reason = chat.dislikeReason?.trim() || '';
    this.saveFeedback(chat, false, '', reason);
    chat.showDislikeInput = false;
  }

  cancelDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    chat.showDislikeInput = false;
    chat.dislikeReason = '';
  }

  private saveFeedback(
    chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showLikeInput?: boolean; likeReason?: string; showDislikeInput?: boolean; dislikeReason?: string },
    isLiked: boolean | null,
    likeReason: string,
    dislikeReason: string
  ) {

    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    const previousIsLiked = chat.isLiked;
    const previousFeedbackSaved = chat.feedbackSaved;
    const previousLikeReason = chat.likeReason;
    const previousDislikeReason = chat.dislikeReason;

    chat.isLiked = isLiked;
    chat.feedbackSaved = (isLiked === true || isLiked === false);

    const feedbackRequest = {
      MessageId: chat.messageId,
      IsLiked: isLiked,
      LikeReason: likeReason || '',
      DislikeReason: dislikeReason || ''
    };

    this.apiService.saveChatFeedback(feedbackRequest).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          chat.likeReason = likeReason;
          chat.dislikeReason = dislikeReason;

          // Add toast message
          let toastMsg = '';
          if (isLiked === true) toastMsg = 'Feedback submitted';
          else if (isLiked === false) toastMsg = 'Feedback submitted';
          else toastMsg = 'Feedback removed';

          this.showToast(toastMsg, 'success');

          // Update the history list in memory
          if (chat.messageId && this.selectedChatId) {
            const chatInList = this.allChatList.find(c => c.ChatId === this.selectedChatId);
            if (chatInList && chatInList.ChatHistory) {
              const msg = chatInList.ChatHistory.find(h => h.MessageId === chat.messageId);
              if (msg) {
                msg.IsLiked = isLiked;
                (msg as any).LikeReason = likeReason;
                msg.DislikeReason = dislikeReason;
              }
            }
          }
        } else {
          // Revert on failure
          chat.isLiked = previousIsLiked;
          chat.feedbackSaved = previousFeedbackSaved;
          chat.likeReason = previousLikeReason;
          chat.dislikeReason = previousDislikeReason;
          this.showToast('Failed to save feedback on server', 'error');
        }
      },
      error: (err) => {
        // Revert on error
        chat.isLiked = previousIsLiked;
        chat.feedbackSaved = previousFeedbackSaved;
        chat.likeReason = previousLikeReason;
        chat.dislikeReason = previousDislikeReason;
        console.error('An error occurred while saving feedback:', err);
        this.showToast('Network error while saving feedback', 'error');
      }
    });
  }

  parseChatResponse(ChatResponse: any): {
    AgentPayload?: any;
    GetMcode?: any;
    getSnapshotConfiguration?: any;
    GetCustomSnapshotWidget?: any;
    GetQuery?: any;
    getSnapshotOutput?: any;
    getSnapshotLoadData?: any;
    getConfiguration?: any;
    getSnapshotInsights?: any;
    getSnapshotInsightsTrend?: any;
    getInsights?: any;
    getQnA?: any;
    trendline_response?: any;
    response_payload_trendline?: any;
    customization_Properties_trendline?: any;
    response_payload?: any;
    member_responses?: any;
  } {
    return ChatHistoryHelper.parseChatResponse(ChatResponse);
  }

  pushChatResponseEntry(key: string, value: any) {
    const entry = ChatHistoryHelper.formatChatResponseEntry(key, value);
    this.chatResponse.push(entry);
  }

  excelexportClicked() {
    ExportHandlerHelper.excelexportClicked(this);
  }

  handleExcelExportClick() {
    ExportHandlerHelper.handleExcelExportClick(this);
  }

  editablePPTClicked(isTredendDataRequired: boolean = false) {
    ExportHandlerHelper.editablePPTClicked(this, isTredendDataRequired);
  }

  onNewChatClick(): void {
    this.abandoningSessionId = this.guidChatId;
    this.isNewChatStarted = true;
    this.guidChatId = '';
    this.validatedSessionId = null;
    this.selectedChatId = null;
    this.inputValue = '';
    this.chatPreviewBlocks = [];
    this.insightsVal = '';
    this.displayTable = false;
    this.showSnapshot = false;
    this.setFailedCaseState(false);
    this.isInsightspopupOpen = false;
    this.OutputdataObject.Row = [];
    this.OutputdataObject.Column = [];
    this.CrossTabOutPutData = [];
    this.askMeLanding = true;
  }

  async clearCache(): Promise<void> {
    try {
      await this.indexedDBService.clearClientStudyCache();
    } catch (error) {
      console.error('Error clearing cache:', error);
      this.showToast('Error clearing cache', 'error');
    }
  }

  async getCacheStats(): Promise<void> {
    try {
      const stats = await this.indexedDBService.getStats();
    } catch (error) {
    }
  }


  showToast(message: string, type: 'success' | 'error' | 'info' = 'success') {
    this.toastMessage = message;
    this.toastType = type;
    this.showToastNotification = true;
    this.toastRemainingTime = 3000;
    this.isToastHovered = false;
    this.startToastTimer();
  }

  startToastTimer() {
    if (this.toastTimeoutId) {
      clearTimeout(this.toastTimeoutId);
    }
    this.toastStartTime = Date.now();
    this.toastTimeoutId = setTimeout(() => {
      this.showToastNotification = false;
    }, this.toastRemainingTime);
  }

  onToastMouseEnter() {
    this.isToastHovered = true;
    if (this.toastTimeoutId) {
      clearTimeout(this.toastTimeoutId);
      this.toastRemainingTime -= (Date.now() - this.toastStartTime);
    }
  }

  onToastMouseLeave() {
    this.isToastHovered = false;
    if (this.toastRemainingTime > 0) {
      this.startToastTimer();
    } else {
      this.showToastNotification = false;
    }
  }

  sendKeyQuestion(question: string): void {
    this.searchText = question;
    this.navigateToChat();
    this.onSendMessage();
  }

  getFirstTwoInsights(): any[] {
    if (!this.insightsVal || !Array.isArray(this.insightsVal)) {
      return [];
    }
    return this.insightsVal.slice(0, 2);
  }

  getFirstTwoInsightsAsPlainText(): string {
    const insights = this.getFirstTwoInsights();
    if (insights.length === 0) {
      return '';
    }

    return insights.map(insight => {
      let text = '';
      if (typeof insight === 'string') {
        text = insight;
      } else if (insight && typeof insight === 'object') {
        // Use extraction logic similar to formatInsightsIntoPoints
        text = insight.Value || (insight.insights && insight.insights.Value) || '';
        if (!text && Object.keys(insight).length > 0) {
          const firstValue = Object.values(insight)[0];
          text = typeof firstValue === 'string' ? firstValue : (typeof firstValue === 'object' && firstValue ? (firstValue as any).Value || '' : '');
        }
      }

      if (!text) return '';

      let cleaned = text;
      cleaned = cleaned.replace(/^[^:]+:\s*/, '');
      return cleaned.trim();
    }).filter(t => t).join(' ');
  }

  getCurrentQnAResponse(block?: any): string {
    const targetChat = block || (this.selectedMessageId
      ? this.chatPreviewBlocks.find(chat => chat.messageId === this.selectedMessageId)
      : this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1]);

    const msgId = targetChat?.messageId || 'current';
    const currentMcode = targetChat?.mcode || this.mcode;

    if (this.multiViewInsightsCache[msgId]?.[currentMcode]?.qnaText) {
      return this.multiViewInsightsCache[msgId][currentMcode].qnaText;
    }

    const response = targetChat?.QuestionAnswer || targetChat?.response || '';

    // Fallback if QnA is not available but insights are (only for the active/selected message)
    if (!block || block.messageId === this.selectedMessageId) {
      if ((!response || response === 'Answering question...' || response === 'No data Available') && this.insightsVal && Array.isArray(this.insightsVal) && this.insightsVal.length > 0) {
        return this.insightsVal.join('\n');
      }
    }

    return response;
  }

  getSelectedChat(block?: any): any {
    if (block) return block;
    if (this.chatPreviewBlocks.length === 0) return null;
    return this.selectedMessageId
      ? this.chatPreviewBlocks.find(chat => chat.messageId === this.selectedMessageId)
      : this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
  }

  isFailedCase(block: any): boolean {
    if (block && block.messageId === this.selectedMessageId) {
      return this.failedCase;
    }
    return block ? !!block.failedCase : this.failedCase;
  }

  setFailedCaseState(value: boolean, targetBlock?: any) {
    this.failedCase = value;
    const target = targetBlock || this.chatPreviewBlocks.find(b => b.messageId === this.selectedMessageId);
    if (target) {
      target.failedCase = value;
    }
  }

  getPostStreamMessage(): string {
    switch (this.mcode) {
      case 1: return 'Plotting Snapshot Visualization';
      case 2: return 'Building Brand Analysis Table';
      case 3: return 'Generating Crosstab Table';
      default: return 'Finalizing data analysis';
    }
  }

  updateQuestionAnswerForSelectedMessage(questionAnswerText: string): void {
    if (this.chatPreviewBlocks.length === 0) {
      return;
    }

    const targetChat = this.selectedMessageId
      ? this.chatPreviewBlocks.find(chat => chat.messageId === this.selectedMessageId)
      : this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];

    if (targetChat) {
      targetChat.QuestionAnswer = questionAnswerText;
    }
  }

  // ── AI Loader helpers ────────────────────────────────────────────────────
  startAiLoader(): void {
    this.arktabaccess = true;
  }

  stopAiLoader(): void {
    this.arktabaccess = false;
  }

  /**
   * Helper to ensure Funnel charts (and potentially others) have correct decimal precision
   * requested by the business to resolve data discrepancies in conversion calculations.
   */
  getFormattedCustomProperties(props: any, chartType: string): any {
    const isTable = chartType && chartType.toLowerCase().includes('table');
    const isFunnel = chartType && chartType.toLowerCase().includes('funnel');

    // Base defaults for stability
    const baseDefaults: any = {
      hideNA: true,
      datalabelProperty: 'default',
      datalabelStyle: 'default',
      datalabelFormat: 'percentage',
      decimalRoundOff: isFunnel ? 2 : 0,
      borderStyle: '1',
      borderColor: '#CAC4C4',
      ColumnHeaderAlignment: 'center',
      dataLabelAlignment: 'center',
      CalculationLogic: 'None',
      enableDataBars: true,
      ColumnHeaderSorting: true,
      legendPosition: 'bottom'
    };

    if (!props) return JSON.stringify(baseDefaults);

    let parsedProps: any;
    if (typeof props === 'string') {
      try {
        parsedProps = JSON.parse(props);
      } catch (e) {
        parsedProps = {};
      }
    } else {
      parsedProps = props;
    }

    if (!parsedProps || typeof parsedProps !== 'object') {
      parsedProps = {};
    }

    // Merge defaults into parsed props for any missing keys
    Object.keys(baseDefaults).forEach(key => {
      if (parsedProps[key] === undefined) {
        parsedProps[key] = baseDefaults[key];
      }
    });

    if (isFunnel && (parsedProps.decimalRoundOff === undefined || parsedProps.decimalRoundOff === 0)) {
      parsedProps.decimalRoundOff = 2;
    }

    const finalStr = JSON.stringify(parsedProps);
    return finalStr;
  }

  /**
   * Scrolls the insights container programmatically since native scrollbars are hidden.
   * @param direction 'up' or 'down'
   */
  scrollInsights(direction: 'up' | 'down', block: any, container: HTMLElement): void {
    if (container) {
      // Scroll by 75% of the visible container height to ensure overlap, or default to a reasonable fallback.
      const step = (container.clientHeight * 0.75) || 120;
      const scrollAmount = direction === 'up' ? -step : step;

      container.scrollBy({
        top: scrollAmount,
        behavior: 'smooth'
      });

      // Re-check overflow state after animation duration
      setTimeout(() => this.checkInsightsOverflow(block, container), 600);
    }
  }

  /**
   * Checks if the insights content is currently overflowing its container.
   */
  checkInsightsOverflow(block: any, container: HTMLElement): void {
    if (container) {
      const isOverflowing = container.scrollHeight > container.clientHeight + 5;

      block.isAtTop = container.scrollTop <= 5;
      block.isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 5;

      if (block.isInsightsOverflowing !== isOverflowing) {
        block.isInsightsOverflowing = isOverflowing;
      }
    }
  }

  private autoScrollInsightsToBottom(): void {
    const activeIndex = this.chatPreviewBlocks.findIndex(b => b.messageId === this.selectedMessageId);
    const activeContainer = this.insightsContainers?.toArray()[activeIndex];

    if (activeContainer && activeContainer.nativeElement) {
      const el = activeContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }

  private autoScrollPageToBottom(): void {
    if (this.outputArea && this.outputArea.nativeElement) {
      const el = this.outputArea.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }

  // Hook into AfterViewChecked to handle dynamic content updates
  ngAfterViewChecked(): void {
    if (this.isInsightspopupOpen && this.insightsContainers) {
      this.insightsContainers.forEach((container: ElementRef, index: number) => {
        const block = this.chatPreviewBlocks[index];
        if (block) {
          this.checkInsightsOverflow(block, container.nativeElement);

          // Only auto-scroll the ACTIVE message if it's currently streaming
          if (this.isInsightsStreaming && block.messageId === this.selectedMessageId) {
            container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
          }
        }
      });
    }
  }

  // --- Multi-View Logic ---

  constructSpecialized(code: number, res: any, rawData: any = this.orchestrationRawData) {
    const basePayload: any = {
      client_name: rawData?.client_name || this.selected_client,
      study: rawData?.study || this.selected_study,
      session_id: rawData?.session_id || this.guidChatId,
      bearer_token: this.currentOrchToken,
      significance: "None",
      confidence_level: "None",
      base: "ANSWER",
      weight: res?.weight || res?.Weight || this.selectedWeight || "Unweighted"
    };

    let p = { ...basePayload, mcode: code };
    if (code === 1) {
      return {
        ...p,
        snapshot_type: res.snapshot_type || res.Snapshot_Type,
        primary_brands: res.Primary_Brands || res.primary_brands,
        primary_metrics: res.Primary_Metrics || res.primary_metrics || res.primary_metircs,
        market: res.Markets || res.market,
        timeperiod: res.Time_Period || res.timeperiod,
        Filter_Audience: res.Filter_Audience || res.filter_audience,
        Metric_Filters: res.Metric_Filters || res.metric_filters,
        Snapshot_Name: res.Snapshot_Name || res.snapshot_name,
        Section: res.Section || res.section,
        Widget_ID: res.Widget_ID || res.widget_id,
        Widget_Name: res.Widget_Name || res.widget_name,
        selected_doc_id: res.selected_doc_id,
        snapshot_index: rawData?.snapshot_index,
        widget_snapshot_index: rawData?.widget_snapshot_index
      };
    } else if (code === 2) {
      return {
        ...p,
        brand_analysis_index: rawData?.brand_analysis_index,
        row: res.Row,
        column: res.Column,
        row_nesting: res.Row_Nesting,
        column_nesting: res.Column_Nesting,
        filters: res.Filters
      };
    } else if (code === 3) {
      return {
        ...p,
        crosstab_index: rawData?.crosstab_index,
        row: res.Row,
        column: res.Column,
        row_nesting: res.Row_Nesting,
        column_nesting: res.Column_Nesting,
        filters: res.Filters
      };
    }
    return p;
  }

  /**
   * Strictly validates that Summary and QnA streams succeed before allowing module in UI.
   * Required by user to ensure 200/Done response across all analytical sub-tasks.
   */
  private fetchInsightsAsObservable(mcode: number, opData: any, msgId: string, orchData?: any): Observable<any> {
    if (!opData) return throwError(() => new Error('No operation data provided'));

    return new Observable(obs => {
      // 1. Build Markdown for analytical agents with robust data resolution
      let markdown = '';
      try {
        const outputResponse = opData.response || opData;
        let dataArr: any[] | null = null;
        
        let targetData = outputResponse.Data || outputResponse.result?.Data || outputResponse;
        if (targetData) {
          if (typeof targetData === 'string') {
            try {
              dataArr = JSON.parse(targetData);
            } catch { }
          } else if (Array.isArray(targetData)) {
            dataArr = targetData;
          }
        }

        if (mcode === 1) {
          if (Array.isArray(dataArr)) {
            markdown = InsightsGeneratorHelper.buildSnapshotMarkdownForAPI(dataArr, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
          } else if (opData.metric || (opData.response && opData.response.metric)) {
            markdown = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(opData.response || opData);
          }
        } else {
          const crossTabData = dataArr || (opData.response || opData);
          if (Array.isArray(crossTabData)) {
            markdown = InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(crossTabData, this.isTotalBase, this.selectedWeight, Number(this.insufficientBase || 0));
          }
        }
      } catch (err) {
        console.error(`[FETCH-INSIGHTS] Markdown generation failed for mcode: ${mcode}`, err);
      }

      if (!markdown) {
        obs.error(`Markdown generation failed for mcode: ${mcode}`);
        return;
      }

      // Check if markdown has valid non-NA data
      if (!InsightsGeneratorHelper.hasValidDataInMarkdown(markdown)) {
        const dummyMsg = 'Metric values are zero or null for the selected criteria.';
        const dummyResponse = mcode === 1 ? {
          insightsVal: [dummyMsg],
          qnaText: dummyMsg,
          standard_insights: dummyMsg,
          trend_insights: dummyMsg,
          rawInsights: dummyMsg
        } : {
          insightsVal: [dummyMsg],
          qnaText: dummyMsg,
          rawInsights: dummyMsg
        };

        if (!this.multiViewInsightsCache[msgId]) this.multiViewInsightsCache[msgId] = {};
        this.multiViewInsightsCache[msgId][mcode] = dummyResponse;
        
        obs.next(dummyResponse);
        obs.complete();
        return;
      }

      // 2. Stream Accumulation Helper: Accumulates chunks and errors on any non-200/Done response
      const streamToObs = (stream$: Observable<any>) => new Observable<string>(sObs => {
        let text = '';
        let hasError = false;
        stream$.subscribe({
          next: (ev) => {
            if (ev.event === 'error') {
              hasError = true;
              console.error('[STREAM DEBUG] Stream error event:', ev.data);
              sObs.error(ev.data?.message || 'Stream error event');
            } else {
              const extracted = this.extractTextFromStreamEvent(ev);
              if (extracted && extracted !== 'done') {
                text += extracted;
              }
            }
          },
          complete: () => {
            if (hasError) return;
            if (!text.trim()) sObs.error('Empty stream response');
            else { sObs.next(text); sObs.complete(); }
          },
          error: (err) => sObs.error(err)
        });
      });

      // 3. Trigger Streams concurrently via forkJoin
      this.getBearerToken().then(token => {
        let basePayload: any = {
          client_name: this.selected_client || this.landingdata?.client_code || '',
          study: this.selected_study || this.landingdata?.study || '',
          session_id: this.guidChatId,
          bearer_token: token,
          mcode: mcode,
          markdown: markdown,
          query: this.currentQuestion || this.inputValue || 'Analyze data',
          widget_details: (mcode === 1) ? {
            widget_name: opData.widget_name || opData.Widget_Name || opData.result?.widget_name || opData.result?.Widget_Name || opData.response?.widget_name || opData.response?.Widget_Name || this.widget_Name || '',
            widget_id: opData.widget_id || opData.Widget_ID || opData.result?.widget_id || opData.result?.Widget_ID || opData.response?.widget_id || opData.response?.Widget_ID || this.widget_Id || ''
          } : null
        };

        if (orchData && mcode > 1) {
          basePayload = { ...orchData, ...basePayload };
        }

        const docId = orchData?.selected_doc_id || opData?.selected_doc_id || opData?.response?.selected_doc_id || this.promptData?.selected_doc_id;
        if (docId) basePayload.selected_doc_id = docId;

        // Ensure widget details are present for Snapshot
        if (mcode === 1 && !basePayload.widget_details?.widget_id) {
          basePayload.widget_details = {
            widget_name: orchData?.Widget_Name || orchData?.widget_name || opData?.Widget_Name || opData?.widget_name || this.widget_Name || '',
            widget_id: orchData?.Widget_ID || orchData?.widget_id || opData?.Widget_ID || opData?.widget_id || this.widget_Id || ''
          };
        }

        if (!this.inFlightInsights[msgId]) this.inFlightInsights[msgId] = new Set();
        this.inFlightInsights[msgId].add(mcode);

        const streamTasks: { [key: string]: Observable<string> } = {};

        if (mcode === 1) {
          streamTasks['standard'] = streamToObs(this.apiService.snapshotSummaryAgentStream({ ...basePayload, is_trend: false }));
          streamTasks['trend'] = streamToObs(this.apiService.snapshotSummaryAgentStream({ ...basePayload, is_trend: true }));
          streamTasks['qna'] = streamToObs(this.apiService.snapshotQaAgentStream(basePayload));
        } else {
          const summary$ = mcode === 2 ? this.apiService.brandAnalysisSummaryAgentStream(basePayload) : this.apiService.crosstabSummaryAgentStream(basePayload);
          const qna$ = mcode === 2 ? this.apiService.brandAnalysisQaAgentStream(basePayload) : this.apiService.crosstabQaAgentStream(basePayload);
          streamTasks['summary'] = streamToObs(summary$);
          streamTasks['qna'] = streamToObs(qna$);
        }

        forkJoin(streamTasks).subscribe({
          next: (results: any) => {
            if (!this.multiViewInsightsCache[msgId]) this.multiViewInsightsCache[msgId] = {};

            if (mcode === 1) {
              const combinedRaw = `${results.standard}[[[SPLIT]]]${results.trend}`;
              this.multiViewInsightsCache[msgId][mcode] = {
                insightsVal: this.formatInsightsIntoPoints(combinedRaw),
                qnaText: results.qna,
                standard_insights: results.standard,
                trend_insights: results.trend,
                rawInsights: combinedRaw
              };
            } else {
              this.multiViewInsightsCache[msgId][mcode] = {
                insightsVal: this.formatInsightsIntoPoints(results.summary),
                qnaText: results.qna,
                rawInsights: results.summary
              };
            }
            this.inFlightInsights[msgId].delete(mcode);
            obs.next(this.multiViewInsightsCache[msgId][mcode]);
            obs.complete();
          },
          error: (err) => {
            this.inFlightInsights[msgId].delete(mcode);
            obs.error(err);
          }
        });

      }).catch(err => {
        if (this.inFlightInsights[msgId]) this.inFlightInsights[msgId].delete(mcode);
        obs.error(err);
      });
    });
  }

  async switchAnalysisView(view: any, block?: any) {
    const targetBlock = block || this.chatPreviewBlocks.find(b => b.messageId === this.selectedMessageId);

    // Ensure we use the isolated historical payload if available
    const blockMemberResponses = targetBlock?.analyticalData?.member_responses || this.allMemberResponses;

    if (!blockMemberResponses) {
      console.warn('[MULTI-VIEW-DEEP-DEBUG] No responses available to switch.');
      return;
    }

    const currentMcode = targetBlock ? targetBlock.mcode : this.mcode;
    if (currentMcode === view.mcode) {
      return;
    }

    if (this.isHistorySaving) {
      this.showToast('Please wait while the current analysis is generating.', 'info');
      return;
    }

    if (targetBlock) {
      this.selectedMessageId = targetBlock.messageId;
      this.setFailedCaseState(false, targetBlock);
    }

    const msgId = targetBlock?.messageId || this.selectedMessageId || 'current';

    let result = blockMemberResponses[view.key];
    if (view.mcode === 2 && !result) {
      result = blockMemberResponses.brandanalysis || blockMemberResponses.brand_analysis;
    }

    // Try to pre-populate cache from history if it exists!
    const esKey = view.mcode === 1 ? 'getSnapshotOutput' : 'getConfiguration';

    if (result && result[esKey] && !this.multiViewDataCache[msgId]?.[view.mcode]) {
      const historyData = result[esKey];
      const parsedData = typeof historyData === 'string' ? JSON.parse(historyData) : historyData;

      // Safety check: Make sure we didn't accidentally save the corrupted OutputdataObject format in the past
      // Real API payload always has 'Data' wrapped or is an array.
      if (Array.isArray(parsedData) || parsedData.Data || parsedData.Row === undefined || view.mcode === 1) {

        // [FIX] Inject trendline data from siblings for Snapshot (mcode=1)
        if (view.mcode === 1) {
          const analyticalSource = targetBlock?.analyticalData || targetBlock?.parsedData;
          const sourceForTrend = result?.trendline_response ? result :
            (analyticalSource?.trendline_response ? analyticalSource :
              (targetBlock?.filteredWidgetData?.trendline_response ? targetBlock.filteredWidgetData :
                (targetBlock?.builtCustomData?.trendline_response ? targetBlock.builtCustomData :
                  (analyticalSource?.GetCustomSnapshotWidget?.trendline_response ? analyticalSource.GetCustomSnapshotWidget : null))));

          if (sourceForTrend?.trendline_response && !parsedData.trendline_response) {
            parsedData.trendline_response = sourceForTrend.trendline_response;
          } else if (this.currentTrendlineResponse && !parsedData.trendline_response) {
            parsedData.trendline_response = this.currentTrendlineResponse;
          }

          if (sourceForTrend?.response_payload_trendline && !parsedData.response_payload_trendline) {
            parsedData.response_payload_trendline = sourceForTrend.response_payload_trendline;
          } else if (this.currentRowPayloadTrendline && !parsedData.response_payload_trendline) {
            parsedData.response_payload_trendline = this.currentRowPayloadTrendline;
          }

          const sourceForPayload = result?.response_payload ? result :
            (analyticalSource?.response_payload ? analyticalSource :
              (targetBlock?.filteredWidgetData?.response_payload ? targetBlock.filteredWidgetData :
                (targetBlock?.builtCustomData?.response_payload ? targetBlock.builtCustomData :
                  (analyticalSource?.GetCustomSnapshotWidget?.response_payload ? analyticalSource.GetCustomSnapshotWidget : null))));

          if (sourceForPayload?.response_payload && !parsedData.response_payload) {
            parsedData.response_payload = sourceForPayload.response_payload;
          }
        }

        if (!this.multiViewDataCache[msgId]) this.multiViewDataCache[msgId] = {};
        this.multiViewDataCache[msgId][view.mcode] = parsedData;
      } else {
        console.warn(`[MULTI-VIEW] Discarded corrupted history data for mcode: ${view.mcode}`);
      }
    }

    const hasDataCached = !!this.multiViewDataCache[msgId]?.[view.mcode];
    const hasInsightsCached = !!(this.multiViewInsightsCache[msgId] || this.multiViewInsightsCache['current'])?.[view.mcode];

    // Only show global loader if we truly need to wait for Step 2 payload
    if (!hasDataCached) this._loaderService.showLoader();

    try {
      const prevMcode = this.mcode;
      if (targetBlock) {
        targetBlock.isAnalysisSwitching = true; // Trigger exit/reset
      } else {
        this.isAnalysisSwitching = true;
      }

      // 1. STATE RESET: Prevent overlap
      this.insightsVal = [];
      this.insightsStreamingText = '';
      this.isInsightsStreaming = false;
      this.updateMarkdownTextRealTime('');
      this.isInsightspopupOpen = false;

      this.activeView = view;
      this.mcode = view.mcode;
      if (targetBlock) {
        targetBlock.activeView = view;
        targetBlock.mcode = view.mcode;
        targetBlock.userSelectedMcode = true;
      }
      this.chatPreviewBlocks = [...this.chatPreviewBlocks];

      // Only show AI loader if insights aren't ready yet
      if (!hasInsightsCached) this.startAiLoader();

      if (!result) throw new Error(`Result not found for ${view.name}`);

      // Reconstruct payload and trigger Step 2 data fetch
      this.chatPayload = this.constructSpecialized(view.mcode, result);

      let opData: any;

      // Check for pre-fetched analytical data (Step 2 responses)
      const dataCache = this.multiViewDataCache[msgId] || this.multiViewDataCache['current'];

      if (dataCache && dataCache[this.mcode]) {
        opData = dataCache[this.mcode];
        if (targetBlock) {
          targetBlock.isAnalysisSwitching = false; // Trigger entrance animation
        } else {
          this.isAnalysisSwitching = false;
        }
      } else {
        console.log(`[MULTI-VIEW] Cache miss - Requesting analytical data for mcode: ${this.mcode}`);

        try {
          const freshToken = await this.getBearerToken();
          if (freshToken) {
            this.chatPayload.bearer_token = freshToken;
            this.currentOrchToken = freshToken;
          }
        } catch (e) {
          console.warn('[MULTI-VIEW] Failed to refresh token before fallback fetch', e);
        }

        if (this.mcode === 1) opData = await this.apiService.snapshotPayloadAPI(this.chatPayload).toPromise();
        else if (this.mcode === 2) opData = await this.apiService.brandAnalysisPayloadAPI(this.chatPayload).toPromise();
        else if (this.mcode === 3) opData = await this.apiService.crosstabPayloadAPI(this.chatPayload).toPromise();

        // Store in cache for future switches
        if (opData) {
          if (!this.multiViewDataCache[msgId]) this.multiViewDataCache[msgId] = {};
          this.multiViewDataCache[msgId][this.mcode] = opData;
        }
      }

      if (opData) {
        // [FIX] Ensure trendline data is ALWAYS present for Snapshot (mcode=1),
        // whether we pulled opData from cache (which might be missing it) or the API fallback.
        if (this.mcode === 1) {
          const analyticalSource = targetBlock?.analyticalData || targetBlock?.parsedData;
          const sourceForTrend = result?.trendline_response ? result :
            (analyticalSource?.trendline_response ? analyticalSource :
              (targetBlock?.filteredWidgetData?.trendline_response ? targetBlock.filteredWidgetData :
                (targetBlock?.builtCustomData?.trendline_response ? targetBlock.builtCustomData :
                  (analyticalSource?.GetCustomSnapshotWidget?.trendline_response ? analyticalSource.GetCustomSnapshotWidget : null))));

          if (sourceForTrend?.trendline_response && !opData.trendline_response) {
            opData.trendline_response = sourceForTrend.trendline_response;
          } else if (this.currentTrendlineResponse && !opData.trendline_response) {
            opData.trendline_response = this.currentTrendlineResponse;
          }

          if (sourceForTrend?.response_payload_trendline && !opData.response_payload_trendline) {
            opData.response_payload_trendline = sourceForTrend.response_payload_trendline;
          } else if (this.currentRowPayloadTrendline && !opData.response_payload_trendline) {
            opData.response_payload_trendline = this.currentRowPayloadTrendline;
          }

          const sourceForPayload = result?.response_payload ? result :
            (analyticalSource?.response_payload ? analyticalSource :
              (targetBlock?.filteredWidgetData?.response_payload ? targetBlock.filteredWidgetData :
                (targetBlock?.builtCustomData?.response_payload ? targetBlock.builtCustomData :
                  (analyticalSource?.GetCustomSnapshotWidget?.response_payload ? analyticalSource.GetCustomSnapshotWidget : null))));

          if (sourceForPayload?.response_payload && !opData.response_payload) {
            opData.response_payload = sourceForPayload.response_payload;
          }
        }

        this.processStep2Response(opData, result, true, targetBlock);
        this.chatPreviewBlocks = [...this.chatPreviewBlocks];

        const innerMsgId = targetBlock?.messageId || this.selectedMessageId || 'current';

        // 2. INSIGHT SYNCHRONIZATION: Wait if insights are currently being pre-fetched in background
        if (!this.multiViewInsightsCache[innerMsgId] || !this.multiViewInsightsCache[innerMsgId][this.mcode]) {
          let insAttempts = 0;
          while (insAttempts < 100 && (!this.multiViewInsightsCache[innerMsgId] || !this.multiViewInsightsCache[innerMsgId][this.mcode]) && (this.inFlightInsights[innerMsgId]?.has(this.mcode))) {
            await new Promise(r => setTimeout(r, 100)); // Wait 100ms
            insAttempts++;
          }
        }

        // Check cache for insights/QnA
        const insightsCache = this.multiViewInsightsCache[innerMsgId] || this.multiViewInsightsCache['current'];
        console.log(`[MULTI-VIEW DEBUG] Checking insights cache for mcode ${this.mcode}. Found:`, !!(insightsCache && insightsCache[this.mcode]));
        
        if (insightsCache && insightsCache[this.mcode]) {
          const cachedData = insightsCache[this.mcode];
          console.log(`[MULTI-VIEW DEBUG] Cached Data:`, {
            insightsVal: cachedData.insightsVal,
            qnaText: cachedData.qnaText,
            rawInsightsLength: cachedData.rawInsights?.length
          });

          // Apply insights
          this.insightsVal = cachedData.insightsVal || [];
          this.insightsStreamingText = ''; // Clear streaming to show completed state
          this.isInsightsStreaming = false;
          this.isInsightspopupOpen = true;

          // Special handling for Snapshot dual-view (Standard vs Trend)
          if (this.mcode === 1 && cachedData.rawInsights) {
            this.snapshotinsights_standard_text = cachedData.standard_insights || '';
            this.snapshotinsights_trendline_text = cachedData.trend_insights || '';

            if (!this.snapshotinsights_standard_text && cachedData.rawInsights.includes('[[[SPLIT]]]')) {
              const parts = cachedData.rawInsights.split('[[[SPLIT]]]');
              this.snapshotinsights_standard_text = parts[0];
              this.snapshotinsights_trendline_text = parts[1];
            }

            // Recalculate based on current trend toggle
            this.insightsVal = this.formatInsightsIntoPoints(cachedData.rawInsights);
          }

          this.stopAiLoader();

          // Update UI components
          this.updateInsightsPopupFinal();
          this.updateMarkdownTextRealTime(cachedData.qnaText);

          // Ensure the QnA area is visible
          this.isChatAreaVisible = false;

        } else {
          // If not in cache and not in-flight, it's a fallback scenario
          console.warn(`[MULTI-VIEW] No cached insights found for mcode: ${this.mcode}.`);
          const markdownData = this.mcode === 1 ? this.buildSnapshotMarkdownForAPI() : this.buildCrosstabMarkdownForAPI();
          const widget_details = this.mcode === 1 ? this.filteredWidgetData : {};
          this.callInsightsAPI(this.mcode, markdownData, this.currentQuestion, widget_details, targetBlock);
        }
      }
    } catch (err) {
      console.error('[MULTI-VIEW ERROR] Failed to switch view:', err);
      this.setFailedCaseState(true, targetBlock);
      this.errorHeader = 'Error: Failed to load module data';
    } finally {
      this.isAnalysisSwitching = false;
      if (targetBlock) targetBlock.isAnalysisSwitching = false;
      this.isInsightsStreaming = false;
      this._loaderService.hideLoader();
    }
  }

  private identifyAvailableViews(rawData: any, parsedMemberResponses?: any) {
    const resp = parsedMemberResponses || rawData?.member_responses || rawData;
    const views: any[] = [];
    if (resp) {
      const findKey = (search: string) => Object.keys(resp).find(k => k.toLowerCase() === search.toLowerCase());
      if (findKey('snapshot')) views.push({ name: 'Snapshot', mcode: 1, key: 'snapshot' });
      
      const baKey = findKey('brand_analysis') || findKey('brandanalysis');
      if (baKey) {
        const baData = resp[baKey];
        if (baData && baData.Row !== null && baData.Column !== null) {
          views.push({ name: 'Brand Analysis', mcode: 2, key: baKey });
        }
      }
      const ctKey = findKey('crosstab');
      if (ctKey) {
        const ctData = resp[ctKey];
        if (ctData && ctData.Row !== null && ctData.Column !== null) {
          views.push({ name: 'Crosstab', mcode: 3, key: ctKey });
        }
      }
    } else {
      console.warn('[MULTI-VIEW] No member_responses found in rawData');
    }
    return views;
  }


  processStep2Response(opData: any, promptResult: any, preventScroll: boolean = false, targetBlock?: any) {
    if (targetBlock) {
      targetBlock.isAnalysisSwitching = false;
    } else {
      this.isAnalysisSwitching = false;
    }

    // Update global state
    this.promptData = promptResult;
    this.isTotalBase = promptResult.isTotalBase ?? false;
    this.selectedWeight = promptResult.weight || promptResult.Weight || this.selectedWeight;
    if (this.WeightDropDownList && this.WeightDropDownList.length > 0) {
      const matchedWeight = this.WeightDropDownList.find(w => w.responseCode === this.selectedWeight);
      this.DefaultWeight = matchedWeight ? matchedWeight.Label : (this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight);
    } else {
      this.DefaultWeight = this.selectedWeight === 'Unweighted' ? 'Total Population' : this.selectedWeight;
    }
    this.isBrandAnalysis = (this.mcode === 2);
    this.is_sigtesting = (this.mcode === 2 || this.mcode === 3);
    this.isSig = (this.mcode === 2 || this.mcode === 3);
    this.arktabaccess = false;

    // Store payloads for persistence/sig-testing
    if (this.mcode === 3 && opData.crosstab_payload) {
      this.cleanBrandAnalysisChild(opData.crosstab_payload);
      this.lastCrosstabPayload = opData.crosstab_payload;
    } else if (this.mcode === 1 && opData.snapshot_payload) {
      this.lastSnapshotPayload = opData.snapshot_payload;
    } else if (this.mcode === 2) {
      const bPayload = opData.brand_analysis_payload || opData.brand_anlysis_payload || this.chatPayload;
      this.cleanBrandAnalysisChild(bPayload);
      this.lastBrandAnalysisPayload = bPayload;
    }

    // Bundle trendline/customization data
    if (opData.response_payload_trendline) this.currentRowPayloadTrendline = opData.response_payload_trendline;
    if (opData.trendline_response) this.currentTrendlineResponse = opData.trendline_response;
    if (opData.customization_Properties_trendline) this.currentCustomizationTrendline = opData.customization_Properties_trendline;

    // Trigger UI update through config service
    const outputResponse = opData.response || opData;
    this._configService.outputSnapshotData = outputResponse;

    // Ensure we capture the *correct* active block for fresh questions
    // Since selectedMessageId is not updated until AFTER saveChatResponse completes,
    // prioritizing `isTemp` guarantees we bind data to the new block instead of overwriting the previous one.
    if (!targetBlock) {
      targetBlock = this.chatPreviewBlocks.find(b => b.isTemp);
    }
    if (!targetBlock) {
      targetBlock = this.chatPreviewBlocks.find(b => b.messageId === this.selectedMessageId);
    }

    // Exact same process as normal flow:
    // 1. Reset states
    this.resetChartStates(this.mcode === 1 ? undefined : 'table');
    if (targetBlock) {
      this.resetChartStates(this.mcode === 1 ? undefined : 'table', targetBlock);
    }

    if (this.mcode === 1) {
      this.snapshotConfiguration = this.promptData;
      this.showSnapshot = true;
      this.displayTable = false;
      this.isDiagnostic = false;

      if (outputResponse.Data) {
        const opDataParsed = typeof outputResponse.Data === 'string' ? JSON.parse(outputResponse.Data) : outputResponse.Data;
        this.MainResult = opDataParsed;
        this.OutputData = opDataParsed.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
        this._configService.standardSnapOutputData = this.OutputData;

        // RECONSTRUCT FILTERED WIDGET DATA FOR POPUP COMPATIBILITY
        const sortedOPdata = this.OutputData;
        let selectedWidget: any = null;
        const currentQuestionText = (targetBlock?.question || this.currentQuestion || '').toLowerCase();
        const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');

        if (currentQuestionText) {
          selectedWidget = uniqueWidgets.find((widget: any) =>
            currentQuestionText.includes(widget.widgetName.toLowerCase())
          );
        }

        if (!selectedWidget) {
          const snapConfigStr = this.promptData?.getSnapshotConfiguration || targetBlock?.analyticalData?.member_responses?.snapshot?.getSnapshotConfiguration;
          let snapConfig: any = null;
          if (snapConfigStr) {
             try { snapConfig = typeof snapConfigStr === 'string' ? JSON.parse(snapConfigStr) : snapConfigStr; } catch(e) {}
          }
          
          const targetWidgetID = snapConfig?.Widget_ID || snapConfig?.widget_id 
            || this.promptData?.Widget_ID || this.promptData?.widget_id 
            || this.promptData?.getSnapshotOutput?.Widget_ID || this.promptData?.getSnapshotOutput?.widget_id 
            || targetBlock?.analyticalData?.Widget_ID || targetBlock?.analyticalData?.widget_id
            || targetBlock?.analyticalData?.GetCustomSnapshotWidget?.Widget_ID || targetBlock?.analyticalData?.GetCustomSnapshotWidget?.widget_id;
            
          if (targetWidgetID) {
            selectedWidget = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
          }
        }

        if (!selectedWidget) {
          selectedWidget = sortedOPdata[0];
        }

        if (selectedWidget) {
          const widgetFilteredRows = sortedOPdata.filter((item: any) => item.widgetNumber === selectedWidget.widgetNumber);
          const fallbackBaseValue = widgetFilteredRows.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

          const uniqueMetrics = _.uniqBy(widgetFilteredRows, 'rowChild').map((item: any) => ({
            option: item.rowChild,
            selectOrder: 0,
            typeofmetric: 'METRIC',
            metric_group: '',
            data: widgetFilteredRows
              .filter((row: any) => row.rowChild === item.rowChild)
              .map((row: any) => {
                const colParts = (row.colChild || '').split('|');
                const specificCol = colParts.pop() || row.colChild;
                const parentLabel = colParts.pop() || 'Market';
                return {
                  data: row.answerWeightedShare,
                  data2: row.answerWeightedShareIndex,
                  lvl1Child: row.Level1ColChild,
                  colChild: `${parentLabel}|${specificCol}`,
                  rowChild: row.rowChild,
                  answerUnweightedBase: row.answerUnweightedBase || fallbackBaseValue,
                  answerWeightedShare: row.answerWeightedShare,
                  answerWeightedShareIndex: row.answerWeightedShareIndex,
                  CalculationType: row.CalculationType || 'share',
                  CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                  Significance_Value: row.Significance_Answer || row.Significance_Total || row.Significance
                };
              })
          }));

          // Sort uniqueMetrics in descending order of values (matching normal flow behavior)
          uniqueMetrics.sort((a: any, b: any) => {
            const valA = a.data?.[0]?.data ?? 0;
            const valB = b.data?.[0]?.data ?? 0;
            return valB - valA; // Descending
          });

          const isBubble = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

          this.filteredWidgetData = {
            widgetchart_name: selectedWidget.widgetChartType,
            widget_name: selectedWidget.widgetName,
            previewChartPostion: selectedWidget.widgetNumber,
            customizationProperties: this.getFormattedCustomProperties(selectedWidget.customization_Properties || opData.customization_Properties, selectedWidget.widgetChartType),
            quadrantText: opData.quadrantText ? JSON.stringify(opData.quadrantText) : null,
            metric: isBubble ? [
              { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
              { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
              { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
            ] : [{
              metric_option: 'Data',
              metric_group: '',
              metric_value: uniqueMetrics
            }],
            response_payload_trendline: opData.response_payload_trendline,
            trendline_response: opData.trendline_response,
            response_payload: opData.response_payload
          };
          this.filteredWidgetID = selectedWidget.widgetNumber;
        }

        this.SelectionSummary();
        this.GenerateSelectionSummary();
        this.afterSubmit();
      }
    } else {
      this.showSnapshot = false;
      this.displayTable = true;
      this.isDiagnostic = true;

      this.LoadRibbonData(this.filteredlist);

      if (outputResponse.Data) {
        this.clearOutputDataObject(); // Reset table structure
        
        // Populate analytical context (dataObject) from metadata AFTER clearOutputDataObject to avoid wipeout
        this.syncDataObjectFromPrompt(promptResult);

        this.CrossTabOutPutEntireData = typeof outputResponse.Data === 'string' ? JSON.parse(outputResponse.Data) : outputResponse.Data;
        this.normalizeNestedChildFields(this.CrossTabOutPutEntireData);
        if (this.mcode == 2 || this.mcode == 3) {
          this.cleanBrandAnalysisChild(this.CrossTabOutPutEntireData);
          if (this.CrossTabOutPutData) {
            this.cleanBrandAnalysisChild(this.CrossTabOutPutData);
          }
        }
        this.isTranspose = false;

        if (!this.isTotal) {
          this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);
        } else {
          this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
        }

        this.BindTableOutput(this.CrossTabOutPutData);
        this.crossTabService.setCrossTabOuputData(this.CrossTabOutPutData); // Update table component
        this.sortOutputData();
        this.isCreateBtnClick = true;
        this.SelectionSummary();
        this.GenerateSelectionSummary();
      }
    }

    if (targetBlock) {
      targetBlock.CrossTabOutPutData = this.CrossTabOutPutData ? [...this.CrossTabOutPutData] : [];
      targetBlock.OutputdataObject = this.OutputdataObject ? JSON.parse(JSON.stringify(this.OutputdataObject)) : null;

      // Reset block.builtTableData so getOutputData does not return stale Priority 1 data!
      targetBlock.builtTableData = null;

      targetBlock.mcode = this.mcode;
      targetBlock.is_sigtesting = this.is_sigtesting;
      targetBlock.is_Time_Period_Present = this.is_Time_Period_Present;
      targetBlock.isIndex = this.isIndex;
      targetBlock.isSig = this.isSig;
      targetBlock.isTranspose = this.isTranspose;
      targetBlock.is_TransposeBtn = this.is_TransposeBtn;
      targetBlock.is_confidenceLevel = [...(this.is_confidenceLevel || [])];
      targetBlock.SignificanceVsReference = this.SignificanceVsReference;
      targetBlock.DefaultConfidenceLevel = this.DefaultConfidenceLevel;
      targetBlock.DefaultSampleSize = this.DefaultSampleSize;
      targetBlock.DefaultReferenceLevel = this.DefaultReferenceLevel;
      targetBlock.selectedWeight = this.selectedWeight;
      targetBlock.isTotalBase = this.isTotalBase;
      targetBlock.isAnswerBase = this.isAnswerBase;
      targetBlock.isSampleSize = this.isSampleSize;
      targetBlock.isWeightedLabel = this.isWeightedLabel;
      targetBlock.isTableClick = this.isTableClick;
      targetBlock.isChartView = this.isChartView;
      targetBlock.isVerticalGroupBarChartClick = this.isVerticalGroupBarChartClick;
      targetBlock.isVerticalBarChartClick = this.isVerticalBarChartClick;
      targetBlock.isVerticalStackChartClick = this.isVerticalStackChartClick;
      targetBlock.isLineChartClick = this.isLineChartClick;
      targetBlock.DefaultDataDropDown = this.DefaultDataDropDown || 'Data';
      targetBlock.disableStackChart = this.disableStackChart;
      targetBlock.disableLineChart = this.disableLineChart;
      
      // Sync Ribbon List Properties to Target Block to ensure dropdowns work
      targetBlock.SampleSizeList = [...(this.SampleSizeList || [])];
      targetBlock.WeightDropDownList = [...(this.WeightDropDownList || [])];
      targetBlock.showStackTooltip = this.showStackTooltip;
      targetBlock.showLineTooltip = this.showLineTooltip;
      targetBlock.showBarTooltip = this.showBarTooltip;
      targetBlock.showMainTooltip = this.showMainTooltip;

    }

    // Scroll to top of output area
    if (!preventScroll && this.outputArea && this.outputArea.nativeElement) {
      this.outputArea.nativeElement.scrollTop = 0;
    }
  }

  private transformToDataObject(arr: any, fallbackType: string): checkboxSelectionWithParent[] {
    let actualArr: string[] = [];
    if (Array.isArray(arr)) {
      actualArr = arr;
    } else if (typeof arr === 'string' && arr.trim() !== '') {
      actualArr = [arr];
    }

    if (actualArr.length === 0) return [];

    const groups: { [key: string]: string[] } = {};
    actualArr.forEach(item => {
      const parts = item.split('|');
      const parent = parts.length > 1 ? parts[0] : fallbackType;
      if (!groups[parent]) groups[parent] = [];
      groups[parent].push(item);
    });

    return Object.keys(groups).map(parent => ({
      Parent: parent,
      SortId: 0,
      Data: groups[parent].map((item, index): checkboxSelection => {
        const parts = item.split('|');
        let normalizedChild: string;
        if (parts.length >= 3 && parts[0] === parts[1]) {
          normalizedChild = parts.slice(1).join('|');
        } else if (parts.length >= 3 && parts[0] === parent) {
          normalizedChild = parts.slice(1).join('|');
        } else {
          normalizedChild = item;
        }
        return {
          CheckboxStatus: true,
          Child: normalizedChild,
          variablecode: '',
          responsecode: '',
          isDerviedVariable: false,
          CalculationType: 'share',
          sort_id: index + 1,
          year_response_code: '',
          year_variable_code: '',
          Date: '',
          isMultiPunch: 0,
          isTimePeriod: ['time', 'year', 'month', 'quarter', 'mma'].some(k => parent.toLowerCase().includes(k)),
          isMarket: parent.toLowerCase().includes('market'),
          multiPunchMetric: '',
          MultiPunchNumber: 0,
          isCustomGroup: false,
          kibanaFilterScript: '',
          customGroupId: '',
          isRolling: false,
          isCustomCalculation: false,
          customCalculationId: ''
        };
      }),
      isMultiPunch: false,
      MultiPunchNumber: 0,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: '',
      brandanalysisCode: (this.mcode === 2) ? 1 : 0,
      is_entrypoint: false
    }));
  }

  private syncDataObjectFromPrompt(res: any) {
    if (!res) return;

    const rowData = res.Row || res.row || [];
    const colData = res.Column || res.column || [];
    const colNestData = res.ColNesting || res.col_nesting || res.column_nesting || res.Column_Nesting || [];
    const rowNestData = res.RowNesting || res.row_nesting || res.Row_Nesting || [];
    const filters = res.Filter || res.filters || res.Filters || {};

    this.dataObject.Row = this.transformToDataObject(rowData, 'Row');
    this.dataObject.Column = this.transformToDataObject(colData, 'Column');
    this.dataObject.ColNesting = this.transformToDataObject(colNestData, 'ColNesting');
    this.dataObject.RowNesting = this.transformToDataObject(rowNestData, 'RowNesting');

    let filterList: string[] = [];
    if (Array.isArray(filters)) {
      filterList = filters;
    } else if (typeof filters === 'object' && filters !== null) {
      Object.values(filters).forEach((val: any) => {
        if (Array.isArray(val)) {
          filterList.push(...val);
        } else if (typeof val === 'string' && val.trim() !== '') {
          filterList.push(val);
        }
      });
    }
    this.dataObject.Filter = this.transformToDataObject(filterList, 'Filter');
    this.OutputdataObject = {
      ...(this.OutputdataObject || {}),
      Filter: this.dataObject.Filter,
      RowNesting: this.dataObject.RowNesting,
      ColNesting: this.dataObject.ColNesting
    } as any;
  }

  // --- Chat Search Logic ---
  setupSearchDebounce() {
    this.searchDebounce$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query) => {
      this.performSearch(query);
    });
  }

  toggleChatSearch() {
    this.isChatSearchOpen = !this.isChatSearchOpen;
    if (this.isChatSearchOpen) {
      this.chatSearchQuery = '';
      this.filteredSearchChats = [];
      this.searchSelectedIndex = -1;
      setTimeout(() => {
        const inputEl = document.getElementById('chat-search-input');
        if (inputEl) inputEl.focus();
      }, 0);
    }
  }

  closeChatSearch() {
    this.isChatSearchOpen = false;
  }

  onSearchInput(event: any) {
    this.chatSearchQuery = event.target.value;
    this.searchDebounce$.next(this.chatSearchQuery);
  }

  onSearchKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeChatSearch();
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.searchSelectedIndex < this.filteredSearchChats.length - 1) {
        this.searchSelectedIndex++;
        this.scrollSearchSelectionIntoView();
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.searchSelectedIndex > 0) {
        this.searchSelectedIndex--;
        this.scrollSearchSelectionIntoView();
      }
    } else if (event.key === 'Enter') {
      if (this.searchSelectedIndex >= 0 && this.searchSelectedIndex < this.filteredSearchChats.length) {
        this.selectSearchResult(this.filteredSearchChats[this.searchSelectedIndex]);
      }
    }
  }

  scrollSearchSelectionIntoView() {
    setTimeout(() => {
      const activeEl = document.querySelector('.search-result-item.active');
      if (activeEl) {
        activeEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }, 0);
  }

  performSearch(query: string) {
    const trimmed = query.trim().toLowerCase();
    if (!trimmed) {
      this.filteredSearchChats = [];
      this.searchSelectedIndex = -1;
      return;
    }

    const searchTokens = trimmed.split(/\s+/).filter(token => token.length > 0);
    const results = [];

    for (const chat of this.allChatList) {
      if (!chat.ChatHistory) continue;

      let matchedSnippet = '';
      let hasMatch = false;
      let matchedMsg: any = null;
      let relevanceScore = 0;

      const title = (chat.ChatTitle || '').toLowerCase();
      const titleMatch = searchTokens.every(token => title.includes(token));
      if (titleMatch) {
        relevanceScore = title.includes(trimmed) ? 100 : 50;
      }

      for (const msg of chat.ChatHistory) {
        const q = msg.Question?.toLowerCase() || '';
        const qna = msg.QuestionAnswer?.toLowerCase() || '';

        let insRaw = msg['Insights'] || msg['insights'];

        if (!insRaw && msg.QuestionAnswer) {
          try {
            const parsedQnA = JSON.parse(msg.QuestionAnswer);
            if (parsedQnA && typeof parsedQnA === 'object') {
              const extracted = Object.values(parsedQnA).map((v: any) => {
                return (v?.getSnapshotInsights || '') + ' ' + (v?.getInsights || '') + ' ' + (v?.getSnapshotInsights_Trend || '');
              });
              insRaw = extracted.join(' ');
            }
          } catch (e) {
            console.log(`[SEARCH DEBUG] Failed to parse QnA JSON for fallback.`);
          }
        }

        let insString = Array.isArray(insRaw) ? insRaw.join(' ') : String(insRaw || '');
        const ins = insString.toLowerCase();

        const isMsgMatch = searchTokens.every(token => {
          const inQ = q.includes(token);
          const inQna = qna.includes(token);
          const inIns = ins.includes(token);
          return inQ || inQna || inIns;
        });

        if (isMsgMatch) {
          hasMatch = true;
          matchedMsg = msg;
          if (q.includes(trimmed) || qna.includes(trimmed) || ins.includes(trimmed)) {
            relevanceScore = Math.max(relevanceScore, 100);
          } else {
            relevanceScore = Math.max(relevanceScore, 50);
          }

          const getSnippetWindow = (text: string, token: string) => {
            if (!text) return '';
            text = ChatHistoryHelper.createAnswerPreview(text);
            const lowerText = text.toLowerCase();
            const idx = lowerText.indexOf(token);
            if (idx === -1) return text.length > 200 ? text.substring(0, 200) + '...' : text;

            const start = Math.max(0, idx - 60);
            const end = Math.min(text.length, idx + token.length + 140);
            let result = text.substring(start, end);
            if (start > 0) result = '...' + result;
            if (end < text.length) result = result + '...';
            return result;
          };

          const scoreQ = searchTokens.filter(t => q.includes(t)).length;
          const scoreIns = searchTokens.filter(t => ins.includes(t)).length;
          const scoreQna = searchTokens.filter(t => qna.includes(t)).length;

          if (scoreIns >= scoreQna && scoreIns >= scoreQ && scoreIns > 0) {
            const matchToken = searchTokens.find(t => ins.includes(t) && !q.includes(t)) || searchTokens.find(t => ins.includes(t)) || searchTokens[0];
            matchedSnippet = getSnippetWindow(insString, matchToken);
          } else if (scoreQna >= scoreQ && scoreQna > 0) {
            const matchToken = searchTokens.find(t => qna.includes(t) && !q.includes(t)) || searchTokens.find(t => qna.includes(t)) || searchTokens[0];
            matchedSnippet = getSnippetWindow(msg.QuestionAnswer || '', matchToken);
          } else {
            matchedSnippet = msg.Question || '';
          }
          break;
        }
      }

      if (hasMatch || titleMatch) {
        const displayMsg = matchedMsg || (chat.ChatHistory.length > 0 ? chat.ChatHistory[0] : null);
        results.push({
          chat: chat,
          title: (displayMsg && displayMsg.Question) ? displayMsg.Question : (chat.ChatTitle || 'Untitled Chat'),
          snippet: matchedSnippet || 'Match found in chat history',
          date: chat.CreatedAt,
          isStarred: displayMsg ? (displayMsg.IsStarred === true || displayMsg.isStarred === true) : false,
          isLiked: displayMsg ? (displayMsg.IsLiked !== undefined ? displayMsg.IsLiked : displayMsg.isLiked) : null,
          targetMessageId: displayMsg ? displayMsg.MessageId : null,
          relevanceScore: relevanceScore
        });
      }
    }

    // Sort by Relevance first, then Badges (Starred > Liked/Disliked), then by date desc
    results.sort((a, b) => {
      if (a.relevanceScore !== b.relevanceScore) {
        return (b.relevanceScore || 0) - (a.relevanceScore || 0); // Higher relevance comes first
      }
      const getScore = (item: any) => {
        if (item.isStarred) return 3;
        if (item.isLiked === true) return 2;
        if (item.isLiked === false) return 1;
        return 0;
      };

      const scoreA = getScore(a);
      const scoreB = getScore(b);

      if (scoreA !== scoreB) {
        return scoreB - scoreA; // Higher score comes first
      }

      return new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime();
    });

    this.filteredSearchChats = results;
    this.searchSelectedIndex = results.length > 0 ? 0 : -1;
  }

  selectSearchResult(result: any) {
    this._loaderService.showLoader();
    this.closeChatSearch();
    this.loadChatDetails(result.chat.ChatId, result.targetMessageId);
  }

  loadChatDetails(chatId: string, targetMessageId?: string) {
    const chat = this.allChatList.find(c => c.ChatId === chatId);
    if (chat && chat.ChatId) {
      this.newChatId = chat.ChatId;
      this.guidChatId = chat.ChatId;
      this.selectedChatId = chat.ChatId;
      this.currentView = 'chat';

      if (chat.ChatHistory && chat.ChatHistory.length > 0) {
        const sortedHistory = ChatHistoryHelper.sortChatHistoryByIndex(chat.ChatHistory);
        this.chatPreviewBlocks = sortedHistory.map(msg =>
          ChatHistoryHelper.createChatPreviewBlock(msg, this.defaultQuestionAnswer, this.DefaultWeight, this.DefaultBase, this.selectedWeight)
        );
        
        let targetMsg = null;
        let targetIndex = -1;
        if (targetMessageId) {
          targetIndex = sortedHistory.findIndex((m: any) => m.MessageId === targetMessageId);
          if (targetIndex > -1) {
            targetMsg = sortedHistory[targetIndex];
          }
        }
        
        const messageToLoad = targetMsg || sortedHistory[sortedHistory.length - 1];

        if (messageToLoad && messageToLoad.MessageId) {
          this.getChatResponse(messageToLoad.MessageId, true, true);
          
          if (targetMessageId) {
            if (targetIndex > 0) {
              this.getChatResponse(sortedHistory[targetIndex - 1].MessageId, true, false);
            }
            if (targetIndex > -1 && targetIndex < sortedHistory.length - 1) {
              this.getChatResponse(sortedHistory[targetIndex + 1].MessageId, true, false);
            }
          }
        } else {
          this._loaderService.hideLoader();
        }
      }
    }
  }

  private playNotificationSound() {
    try {
      const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
      if (!AudioContext) return;
      const audioCtx = new AudioContext();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      // Sleek 'ding' sound
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(880, audioCtx.currentTime); // A5 note

      // Gentle fade out
      gainNode.gain.setValueAtTime(0.5, audioCtx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.4);

      oscillator.start(audioCtx.currentTime);
      oscillator.stop(audioCtx.currentTime + 0.4);
    } catch (e) {
      console.warn('Audio playback failed', e);
    }
  }
}
